
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8BGHz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3342dca9c10ff381$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3342dca9c10ff381$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("3YUwr", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.12.2';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = '';
        this.appliedFillStyle = ''; //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = ''; //
        this.currentLineWidth = '';
        this.appliedLineWidth = ''; //
        this.currentLineCap = '';
        this.appliedLineCap = ''; //
        this.currentLineJoin = '';
        this.appliedLineJoin = ''; //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof1(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer'); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("4nayr", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("bAMyk")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("bAMyk")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("bAMyk")).monitorForElements);

var $bAMyk = parcelRequire("bAMyk");

});
parcelRegister("bAMyk", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $945676380badb35c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $945676380badb35c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $945676380badb35c$export$c746a5152d4ba26c);

var $cBeZP = parcelRequire("cBeZP");

var $cbcqZ = parcelRequire("cbcqZ");

var $bl1yg = parcelRequire("bl1yg");

var $4lzkI = parcelRequire("4lzkI");

var $cGlU2 = parcelRequire("cGlU2");

var $joGlz = parcelRequire("joGlz");

var $igzgy = parcelRequire("igzgy");

var $cY5q9 = parcelRequire("cY5q9");



const $945676380badb35c$var$draggableRegistry = new WeakMap();
function $945676380badb35c$var$addToRegistry(args) {
    $945676380badb35c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $945676380badb35c$var$draggableRegistry.delete(args.element);
    };
}
const $945676380badb35c$var$honeyPotFix = (0, $bl1yg.makeHoneyPotFix)();
const $945676380badb35c$var$adapter = (0, $4lzkI.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $cGlU2.combine)($945676380badb35c$var$honeyPotFix.bindEvents(), (0, $cBeZP.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $945676380badb35c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $cY5q9.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $cbcqZ.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $igzgy.isAndroid)() && !event.dataTransfer.types.includes((0, $0f2008b98bd58844$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $40e784af71694931$export$4c44a460f123106))) event.dataTransfer.setData((0, $0f2008b98bd58844$export$fd3d00026297c0ad), (0, $igzgy.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $920cfea877448e3c$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $945676380badb35c$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $945676380badb35c$var$honeyPotFix.getOnPostDispatch()
});
const $945676380badb35c$export$e7140b68045b5036 = $945676380badb35c$var$adapter.dropTarget;
const $945676380badb35c$export$59a074bac4c54f54 = $945676380badb35c$var$adapter.monitor;
function $945676380badb35c$export$c746a5152d4ba26c(args) {
    return (0, $cGlU2.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $945676380badb35c$var$adapter.registerUsage(), $945676380badb35c$var$addToRegistry(args), (0, $joGlz.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("cbcqZ", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $29750a050af8179a$export$81d0353f25f5dd);

var $bIYKF = parcelRequire("bIYKF");
function $29750a050af8179a$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $bIYKF.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("bIYKF", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $fa17df5a4b08885d$export$821bdcd739a2706b);

function $fa17df5a4b08885d$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $708a603c09f02fba$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $708a603c09f02fba$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("bl1yg", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $4e61eebac56762e6$export$8ecad27c959e89e0);

var $cBeZP = parcelRequire("cBeZP");


const $4e61eebac56762e6$var$honeyPotSize = 2;
const $4e61eebac56762e6$var$halfHoneyPotSize = $4e61eebac56762e6$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $4e61eebac56762e6$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $4e61eebac56762e6$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $4e61eebac56762e6$var$halfHoneyPotSize,
        y: point.y - $4e61eebac56762e6$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4e61eebac56762e6$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4e61eebac56762e6$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $4e61eebac56762e6$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $4e61eebac56762e6$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $4e61eebac56762e6$var$getHoneyPotRectFor({ client: client }) {
    const point = $4e61eebac56762e6$var$preventGoingForwardsOffScreen($4e61eebac56762e6$var$preventGoingBackwardsOffScreen($4e61eebac56762e6$var$pullBackByHalfHoneyPotSize($4e61eebac56762e6$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $4e61eebac56762e6$var$honeyPotSize,
        height: $4e61eebac56762e6$var$honeyPotSize
    });
}
function $4e61eebac56762e6$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $4e61eebac56762e6$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $4e61eebac56762e6$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $708a603c09f02fba$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $4e61eebac56762e6$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$4e61eebac56762e6$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $56611718a37028ae$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $cBeZP.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $4e61eebac56762e6$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $4e61eebac56762e6$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($4e61eebac56762e6$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $cBeZP.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $4e61eebac56762e6$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $cBeZP.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $4e61eebac56762e6$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $56611718a37028ae$export$7d0a15ee70427305 = 2147483647;


parcelRegister("4lzkI", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $bcc18664b99e50db$export$2aa3a33160990d96);

var $dKhE8 = parcelRequire("dKhE8");

var $aYCv4 = parcelRequire("aYCv4");

var $6EEHD = parcelRequire("6EEHD");

var $6bxHo = parcelRequire("6bxHo");
function $bcc18664b99e50db$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $6bxHo.makeMonitor)();
    const dropTargetAPI = (0, $6EEHD.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $dKhE8.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $dKhE8.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $aYCv4.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("dKhE8", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $0c6b04a421901a24$export$3efdceeb8ca25c51);

var $cBeZP = parcelRequire("cBeZP");

var $cbcqZ = parcelRequire("cbcqZ");

var $bIYKF = parcelRequire("bIYKF");

var $bfEEo = parcelRequire("bfEEo");

var $iDg6w = parcelRequire("iDg6w");

var $cY5q9 = parcelRequire("cY5q9");

var $7w0eh = parcelRequire("7w0eh");
const $0c6b04a421901a24$var$globalState = {
    isActive: false
};
function $0c6b04a421901a24$var$canStart() {
    return !$0c6b04a421901a24$var$globalState.isActive;
}
function $0c6b04a421901a24$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $0c6b04a421901a24$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $0c6b04a421901a24$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$0c6b04a421901a24$var$canStart()) return;
    const initial = $0c6b04a421901a24$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $0c6b04a421901a24$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $0c6b04a421901a24$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $7w0eh.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $0c6b04a421901a24$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $cY5q9.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $bIYKF.isHoneyPotElement)(event.target) ? (0, $cbcqZ.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $0c6b04a421901a24$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $0c6b04a421901a24$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $bfEEo.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $cY5q9.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $0c6b04a421901a24$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $cY5q9.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $iDg6w.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $0c6b04a421901a24$var$getNativeSetDragImage(event)
    });
}
function $0c6b04a421901a24$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $0c6b04a421901a24$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $cY5q9.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $0c6b04a421901a24$export$3efdceeb8ca25c51 = {
    canStart: $0c6b04a421901a24$var$canStart,
    start: $0c6b04a421901a24$var$start
};

});
parcelRegister("bfEEo", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $fc00cd022ac0f6d7$export$57d220c74e84a273);

var $68Vbj = parcelRequire("68Vbj");

var $374Vm = parcelRequire("374Vm");

var $kMnDy = parcelRequire("kMnDy");

var $4UThT = parcelRequire("4UThT");
function $fc00cd022ac0f6d7$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $374Vm.isSafari)()) return (0, $kMnDy.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $68Vbj.isFirefox)()) return (0, $4UThT.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("68Vbj", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $4aa95472f1e6f4f6$export$b7d78993b74f766d);

var $glMwg = parcelRequire("glMwg");
const $4aa95472f1e6f4f6$export$b7d78993b74f766d = (0, $glMwg.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("glMwg", function(module, exports) {

$parcel$export(module.exports, "once", () => $26fcfbc51f8164e2$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $26fcfbc51f8164e2$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("374Vm", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $10d7328cccea1202$export$95df08bae54cb4df);

var $glMwg = parcelRequire("glMwg");
const $10d7328cccea1202$export$95df08bae54cb4df = (0, $glMwg.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("kMnDy", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $284e26fe6c6838ae$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $284e26fe6c6838ae$export$f21837c338005454);

var $cBeZP = parcelRequire("cBeZP");

var $374Vm = parcelRequire("374Vm");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $284e26fe6c6838ae$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $284e26fe6c6838ae$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $374Vm.isSafari)()) return false;
    return dragEnter.hasOwnProperty($284e26fe6c6838ae$var$symbols.isEnteringWindow);
}
function $284e26fe6c6838ae$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $374Vm.isSafari)()) return false;
    return dragLeave.hasOwnProperty($284e26fe6c6838ae$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $374Vm.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$284e26fe6c6838ae$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$284e26fe6c6838ae$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("4UThT", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $4a2ae6c105ce5505$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $4a2ae6c105ce5505$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $4a2ae6c105ce5505$export$e46810fef53b5b0e(eventTarget) {
    return $4a2ae6c105ce5505$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("iDg6w", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $1430bf31e1048af2$export$ac5e5b0daf997b2);
function $1430bf31e1048af2$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("cY5q9", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $77f9959d8c4415a4$export$7c112ceec8941e67);
function $77f9959d8c4415a4$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("7w0eh", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $b4aa3d0d220044b6$export$9f13ecc44e83d682);

var $7nRxN = parcelRequire("7nRxN");
const $b4aa3d0d220044b6$var$scheduleOnDrag = (0, $7nRxN.default)((fn)=>fn());
const $b4aa3d0d220044b6$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $b4aa3d0d220044b6$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $b4aa3d0d220044b6$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $b4aa3d0d220044b6$var$dragStart.flush();
            $b4aa3d0d220044b6$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $b4aa3d0d220044b6$var$scheduleOnDrag(()=>{
                $b4aa3d0d220044b6$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $b4aa3d0d220044b6$var$dragStart.flush();
            $b4aa3d0d220044b6$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("7nRxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $560437209e674614$export$2e2bcd8739ae039);
var $560437209e674614$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $560437209e674614$export$2e2bcd8739ae039 = $560437209e674614$var$rafSchd;

});



parcelRegister("aYCv4", function(module, exports) {

$parcel$export(module.exports, "register", () => $928823db7176189b$export$6503ec6e8aabbaf);
const $928823db7176189b$var$ledger = new Map();
function $928823db7176189b$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $928823db7176189b$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $928823db7176189b$var$ledger.set(typeKey, initial);
    return initial;
}
function $928823db7176189b$export$6503ec6e8aabbaf(args) {
    const entry = $928823db7176189b$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $928823db7176189b$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("6EEHD", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $e18aecfb87de978c$export$47d10e7bd9c81890);

var $cGlU2 = parcelRequire("cGlU2");

var $joGlz = parcelRequire("joGlz");
function $e18aecfb87de978c$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $e18aecfb87de978c$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $cGlU2.combine)((0, $joGlz.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $e18aecfb87de978c$var$copyReverse(current);
        const actualCaptureOrdered = $e18aecfb87de978c$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $e18aecfb87de978c$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("cGlU2", function(module, exports) {

$parcel$export(module.exports, "combine", () => $a358f92ab5fddc23$export$1be1fc439b849fdf);
function $a358f92ab5fddc23$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("joGlz", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $e2838e1803027e3c$export$5dcb5c23b6ba980a);
function $e2838e1803027e3c$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("6bxHo", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $d4d6a80b0670004e$export$5dd4ed888d5b12ca);
function $d4d6a80b0670004e$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("igzgy", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $0c84d06f4b4dba86$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $0c84d06f4b4dba86$export$aceb3ed8b7f7bd2c);

var $glMwg = parcelRequire("glMwg");
const $0c84d06f4b4dba86$export$a11b0059900ceec8 = (0, $glMwg.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $0c84d06f4b4dba86$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $0f2008b98bd58844$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $40e784af71694931$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $920cfea877448e3c$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("l5MhD", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("cGlU2")).combine);

var $cGlU2 = parcelRequire("cGlU2");

});

parcelRegister("22Gxp", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $17ccc3ce11c8a1a0$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f);

var $5uXOq = parcelRequire("5uXOq");

var $7aHWJ = parcelRequire("7aHWJ");
var $17ccc3ce11c8a1a0$var$generateUID = function(context) {
    var quartz = context || (0, $7aHWJ.counter);
    var prefix = (0, $7aHWJ.getPrefix)(quartz);
    var id = (0, $7aHWJ.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $17ccc3ce11c8a1a0$var$useUIDState = function() {
    // @ts-ignore
    return $5uXOq.useState($17ccc3ce11c8a1a0$var$generateUID($5uXOq.useContext((0, $7aHWJ.source))));
};
var $17ccc3ce11c8a1a0$export$87d05f07e65211f1 = function() {
    var uid = $17ccc3ce11c8a1a0$var$useUIDState()[0].uid;
    return uid;
};
var $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f = function() {
    var gen = $17ccc3ce11c8a1a0$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("7aHWJ", function(module, exports) {

$parcel$export(module.exports, "counter", () => $538b8e680858bf13$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $538b8e680858bf13$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $538b8e680858bf13$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $538b8e680858bf13$export$36e24695f02d4503);

var $5uXOq = parcelRequire("5uXOq");

var $8e3lA = parcelRequire("8e3lA");
var $538b8e680858bf13$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $8e3lA.generateUID)()
    };
};
var $538b8e680858bf13$export$e575061ef2a070eb = $538b8e680858bf13$export$1921362e86c73c88();
var $538b8e680858bf13$export$b4d5da5f34fb77ad = $5uXOq.createContext($538b8e680858bf13$export$1921362e86c73c88());
var $538b8e680858bf13$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $538b8e680858bf13$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("8e3lA", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $5fd23a338f882896$export$bdbb4cbb3078e58d);
$parcel$export(module.exports, "uid", () => $5fd23a338f882896$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $5fd23a338f882896$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $5fd23a338f882896$export$e2a22331486dcca0 = $5fd23a338f882896$export$bdbb4cbb3078e58d();

});



parcelRegister("7uUwQ", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ "use strict";
var $57572f31ed5f364f$var$i = module.exports;
// we only care about objects or arrays for now
function $57572f31ed5f364f$var$weCareAbout(val) {
    return null !== val && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $57572f31ed5f364f$var$isObjectLike(val));
}
function $57572f31ed5f364f$var$isObjectLike(val) {
    return typeof val === "object" && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
}
function $57572f31ed5f364f$var$arrayClone(arr) {
    var index = 0, length = arr.length, result = Array(length);
    for(; index < length; index += 1)result[index] = arr[index];
    return result;
}
function $57572f31ed5f364f$var$objClone(obj) {
    var index = 0, keys = Object.keys(obj), length = keys.length, key, result = {};
    for(; index < length; index += 1){
        key = keys[index];
        result[key] = obj[key];
    }
    return result;
}
function $57572f31ed5f364f$var$clone(coll) {
    if (Array.isArray(coll)) return $57572f31ed5f364f$var$arrayClone(coll);
    else return $57572f31ed5f364f$var$objClone(coll);
}
function $57572f31ed5f364f$var$freezeIfNeeded(coll) {
    $57572f31ed5f364f$var$weCareAbout(coll) && Object.isFrozen(coll);
    return coll;
}
function $57572f31ed5f364f$var$_freeze(coll) {
    return coll;
}
function $57572f31ed5f364f$var$baseFreeze(coll, prevNodes) {
    if (prevNodes.some(function(node) {
        return node === coll;
    })) throw new Error("object has a reference cycle");
    Object.freeze(coll);
    prevNodes.push(coll);
    Object.keys(coll).forEach(function(key) {
        var prop = coll[key];
        if ($57572f31ed5f364f$var$weCareAbout(prop)) $57572f31ed5f364f$var$baseFreeze(prop, prevNodes);
    });
    prevNodes.pop();
    return coll;
}
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = function freeze(coll) {
    return coll;
};
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if ($57572f31ed5f364f$var$weCareAbout(coll) && Object.isFrozen(coll)) {
        var newColl = $57572f31ed5f364f$var$clone(coll);
        Object.keys(newColl).forEach(function(key) {
            newColl[key] = thaw(newColl[key]);
        });
        return newColl;
    }
    return coll;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $57572f31ed5f364f$var$_freeze(coll);
    var newObj = $57572f31ed5f364f$var$clone(coll);
    newObj[key] = $57572f31ed5f364f$var$freezeIfNeeded(value);
    return $57572f31ed5f364f$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    var newObj = $57572f31ed5f364f$var$clone(coll);
    delete newObj[key];
    return $57572f31ed5f364f$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    var key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $57572f31ed5f364f$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $57572f31ed5f364f$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $57572f31ed5f364f$var$baseGet(coll, path) {
    return (path || []).reduce(function(curr, key) {
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $57572f31ed5f364f$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    var existingVal = $57572f31ed5f364f$var$baseGet(coll, path);
    return $57572f31ed5f364f$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    "push",
    "unshift",
    "pop",
    "shift",
    "reverse",
    "sort"
].forEach(function(methodName) {
    module.exports[methodName] = function(arr, val) {
        var newArr = $57572f31ed5f364f$var$arrayClone(arr);
        newArr[methodName]($57572f31ed5f364f$var$freezeIfNeeded(val));
        return $57572f31ed5f364f$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr /*, args*/ ) {
    var newArr = $57572f31ed5f364f$var$arrayClone(arr), args = $57572f31ed5f364f$var$rest(arguments).map($57572f31ed5f364f$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $57572f31ed5f364f$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    var newArr = arr.slice(arg1, arg2);
    return $57572f31ed5f364f$var$_freeze(newArr);
};
[
    "map",
    "filter"
].forEach(function(methodName) {
    module.exports[methodName] = function(fn, arr) {
        var newArr = arr[methodName](fn);
        return $57572f31ed5f364f$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
module.exports.extend = module.exports.assign = function assign() {
    var newObj = $57572f31ed5f364f$var$rest(arguments).reduce($57572f31ed5f364f$var$singleAssign, arguments[0]);
    return $57572f31ed5f364f$var$_freeze(newObj);
};
function $57572f31ed5f364f$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce(function(obj, key) {
        return $57572f31ed5f364f$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $57572f31ed5f364f$var$merge;
function $57572f31ed5f364f$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce(function(obj, key) {
        var sourceVal = source[key];
        var targetVal = obj[key];
        var resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($57572f31ed5f364f$var$weCareAbout(sourceVal) && $57572f31ed5f364f$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (Object.isFrozen(resolvedSourceVal) && Object.isFrozen(targetVal), resolvedSourceVal === targetVal) return obj;
            if (Array.isArray(sourceVal)) return $57572f31ed5f364f$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $57572f31ed5f364f$var$assocIfDifferent(obj, key, $57572f31ed5f364f$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $57572f31ed5f364f$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $57572f31ed5f364f$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $57572f31ed5f364f$var$i.assoc(target, key, value);
}
function $57572f31ed5f364f$var$_slice(array, start) {
    var begin = start || 0;
    var len = array.length;
    len -= begin;
    len = len < 0 ? 0 : len;
    var result = new Array(len);
    for(var i = 0; i < len; i += 1)result[i] = array[i + begin];
    return result;
}
function $57572f31ed5f364f$var$rest(args) {
    return $57572f31ed5f364f$var$_slice(args, 1);
}
var $57572f31ed5f364f$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $57572f31ed5f364f$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach(function(methodName) {
    $57572f31ed5f364f$var$chainProto[methodName] = function() {
        var args = $57572f31ed5f364f$var$_slice(arguments);
        args.unshift(this.val);
        this.val = module.exports[methodName].apply(null, args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    var wrapped = Object.create($57572f31ed5f364f$var$chainProto);
    wrapped.val = val;
    return wrapped;
};
// for testing
module.exports._weCareAbout = $57572f31ed5f364f$var$weCareAbout;
module.exports._slice = $57572f31ed5f364f$var$_slice;

});

parcelRegister("47QoQ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $d0b9a58ddcdc5aad$export$a7b0697657ed8bd0);

var $5uXOq = parcelRequire("5uXOq");
const $d0b9a58ddcdc5aad$export$a7b0697657ed8bd0 = (0, $5uXOq.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $c15b091f2dca7daa$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $c15b091f2dca7daa$export$55bce18df99af758);

var $6cAn5 = parcelRequire("6cAn5");
const $c15b091f2dca7daa$var$branchSlug = typeof $6cAn5 !== 'undefined' && $6cAn5.env ? undefined : undefined;
const $c15b091f2dca7daa$var$aggPathname = `/gateway/api/graphql${$c15b091f2dca7daa$var$branchSlug ? `/${$c15b091f2dca7daa$var$branchSlug}/graphql` : ''}`;
const $c15b091f2dca7daa$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $c15b091f2dca7daa$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $c15b091f2dca7daa$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("86YLA", function(module, exports) {

$parcel$export(module.exports, "startCapturingExtensions", () => $227719b581b7bf62$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $227719b581b7bf62$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $227719b581b7bf62$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $227719b581b7bf62$export$7c6ea4184129ef74);
const $227719b581b7bf62$var$OperationExtensionsMap = {};
const $227719b581b7bf62$export$8656ba3981c6f6c1 = (operationName)=>{
    $227719b581b7bf62$var$OperationExtensionsMap[operationName] = $227719b581b7bf62$var$OperationExtensionsMap[operationName] || [];
};
const $227719b581b7bf62$export$f16fa6040161f056 = (operationName)=>{
    $227719b581b7bf62$var$OperationExtensionsMap[operationName] = undefined;
};
const $227719b581b7bf62$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $227719b581b7bf62$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $227719b581b7bf62$export$7c6ea4184129ef74 = (operationName)=>$227719b581b7bf62$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("1u51R", function(module, exports) {

$parcel$export(module.exports, "startCapturingTraceIds", () => $9109bff42d6e667a$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $9109bff42d6e667a$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $9109bff42d6e667a$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $9109bff42d6e667a$export$5113e470f5c95670);
const $9109bff42d6e667a$var$OperationTraceIdMap = {};
const $9109bff42d6e667a$export$a2bcb2fac360646c = (operationName)=>{
    $9109bff42d6e667a$var$OperationTraceIdMap[operationName] = $9109bff42d6e667a$var$OperationTraceIdMap[operationName] || [];
};
const $9109bff42d6e667a$export$559128bdc4352001 = (operationName)=>{
    $9109bff42d6e667a$var$OperationTraceIdMap[operationName] = undefined;
};
const $9109bff42d6e667a$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $9109bff42d6e667a$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $9109bff42d6e667a$export$5113e470f5c95670 = (operationName)=>$9109bff42d6e667a$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("aB8eX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $7b73c06d66cb3e3d$var$batchActions;
module.exports.enableBatching = $7b73c06d66cb3e3d$var$enableBatching;
module.exports.batchDispatchMiddleware = $7b73c06d66cb3e3d$var$batchDispatchMiddleware;
var $7b73c06d66cb3e3d$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $7b73c06d66cb3e3d$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7b73c06d66cb3e3d$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $7b73c06d66cb3e3d$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $7b73c06d66cb3e3d$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("korqb", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("ifg6x", function(module, exports) {

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $d4861eb268113e50$var$partition = $4CZTG(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $d4861eb268113e50$var$partition;

});
parcelRegister("4CZTG", function(module, exports) {

var $hBvrS = parcelRequire("hBvrS");

var $fqzo0 = parcelRequire("fqzo0");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $35eab98708747af8$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $8LQ84(collection) ? $hBvrS : $fqzo0, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $bxDef(iteratee, 2), accumulator);
    };
}
module.exports = $35eab98708747af8$var$createAggregator;

});
parcelRegister("hBvrS", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $cd0e496a488f8bed$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $cd0e496a488f8bed$var$arrayAggregator;

});

parcelRegister("fqzo0", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $b3b4bba991f8eee5$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $e7pfQ(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $b3b4bba991f8eee5$var$baseAggregator;

});
parcelRegister("e7pfQ", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");

var $bogqY = parcelRequire("bogqY");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a4754f2fa2dabe99$var$baseEach = $bogqY($hDnyx);
module.exports = $a4754f2fa2dabe99$var$baseEach;

});
parcelRegister("hDnyx", function(module, exports) {

var $et7t4 = parcelRequire("et7t4");

var $66FNL = parcelRequire("66FNL");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $cd6859e7c62c7d41$var$baseForOwn(object, iteratee) {
    return object && $et7t4(object, iteratee, $66FNL);
}
module.exports = $cd6859e7c62c7d41$var$baseForOwn;

});

parcelRegister("bogqY", function(module, exports) {

var $hTJwX = parcelRequire("hTJwX");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $84aeaf14b55f70e4$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$hTJwX(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $84aeaf14b55f70e4$var$createBaseEach;

});





parcelRegister("2ys8y", function(module, exports) {

$parcel$export(module.exports, "getATLContextDomain", () => $4d180ec998d69aba$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $4d180ec998d69aba$export$45d6512913ef41b4);

var $iyZSS = parcelRequire("iyZSS");

var $fF3tT = parcelRequire("fF3tT");

var $jDFZ4 = parcelRequire("jDFZ4");
function $4d180ec998d69aba$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $4d180ec998d69aba$var$isValidDomainKey(domainKey) {
    if (!(0, $jDFZ4.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $4d180ec998d69aba$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$4d180ec998d69aba$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $jDFZ4.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $4d180ec998d69aba$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $fF3tT.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? // Fallback to mandatory commercial production
    override[0, $iyZSS.COMMERCIAL][0, $iyZSS.PRODUCTION]);
    // Third priority, join the subdomain
    const tld = (0, $fF3tT.domainMap)[perimeter]?.[env] ?? (0, $fF3tT.domainMap)[0, $iyZSS.COMMERCIAL][0, $iyZSS.PRODUCTION];
    const subdomain = (0, $fF3tT.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $4d180ec998d69aba$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$4d180ec998d69aba$export$b5ce351acdc48c2a(domain)}`;
}
function $4d180ec998d69aba$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $iyZSS.PRODUCTION),
        (0, $iyZSS.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $iyZSS.STAGING),
        (0, $iyZSS.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $iyZSS.STAGING),
        (0, $iyZSS.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $iyZSS.STAGING),
        (0, $iyZSS.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $iyZSS.PRODUCTION),
        (0, $iyZSS.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $iyZSS.STAGING),
        (0, $iyZSS.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $iyZSS.STAGING),
        (0, $iyZSS.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, $iyZSS.PRODUCTION),
        (0, $iyZSS.COMMERCIAL)
    ];
}

});
parcelRegister("fF3tT", function(module, exports) {

$parcel$export(module.exports, "domainMap", () => $0da9985e64257abf$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $0da9985e64257abf$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $0da9985e64257abf$export$4723232b625f823e);

var $iyZSS = parcelRequire("iyZSS");
const $0da9985e64257abf$export$6836b090dbaa813a = {
    [(0, $iyZSS.COMMERCIAL)]: {
        [(0, $iyZSS.STAGING)]: 'stg.atlassian.com',
        [(0, $iyZSS.PRODUCTION)]: 'atlassian.com'
    },
    [(0, $iyZSS.FEDRAMP_FEDEX)]: {
        [(0, $iyZSS.STAGING)]: 'atlassian-fex.com'
    },
    [(0, $iyZSS.FEDRAMP_MODERATE)]: {
        [(0, $iyZSS.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $iyZSS.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};
const $0da9985e64257abf$export$c6ab20d0ac4d06b2 = {};
const $0da9985e64257abf$export$4723232b625f823e = {
    analytics: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'start.atlassian.com',
            [(0, $iyZSS.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, $iyZSS.FEDRAMP_MODERATE)]: {
            [(0, $iyZSS.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, $iyZSS.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'id.atlassian.com',
            [(0, $iyZSS.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $iyZSS.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $iyZSS.FEDRAMP_MODERATE)]: {
            [(0, $iyZSS.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $iyZSS.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $iyZSS.COMMERCIAL)]: {
            [(0, $iyZSS.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("jDFZ4", function(module, exports) {

$parcel$export(module.exports, "AllowedDomains", () => $aac88dc6777f19f8$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $aac88dc6777f19f8$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});


parcelRegister("7LdpZ", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $c35b1c2b130821be$export$8bedcca5bbd73999);

var $2ys8y = parcelRequire("2ys8y");

var $7da7h = parcelRequire("7da7h");

var $eBQOo = parcelRequire("eBQOo");
const $c35b1c2b130821be$var$redirect = ()=>{
    const identity = (0, $2ys8y.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $c35b1c2b130821be$var$DEFAULT_ENDPOINT = '/gateway/api/session/heartbeat';
const $c35b1c2b130821be$var$DEFAULT_IDLE_TIME = 60000;
const $c35b1c2b130821be$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $c35b1c2b130821be$var$HeartbeatService = ()=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            const response = await (0, $eBQOo.postHeartbeat)($c35b1c2b130821be$var$DEFAULT_ENDPOINT, $c35b1c2b130821be$var$redirect);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($c35b1c2b130821be$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $c35b1c2b130821be$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, 10000);
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $7da7h.default)({
            idleTimeoutMs: $c35b1c2b130821be$var$DEFAULT_IDLE_TIME,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $c35b1c2b130821be$var$instance = null;
const $c35b1c2b130821be$export$8bedcca5bbd73999 = ()=>{
    if (!$c35b1c2b130821be$var$instance) {
        $c35b1c2b130821be$var$instance = $c35b1c2b130821be$var$HeartbeatService();
        $c35b1c2b130821be$var$instance.init();
    }
    return $c35b1c2b130821be$var$instance;
};

});
parcelRegister("7da7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2489addf989ea8f$export$2e2bcd8739ae039);

var $34ck9 = parcelRequire("34ck9");
const $e2489addf989ea8f$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $e2489addf989ea8f$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $e2489addf989ea8f$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $e2489addf989ea8f$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $e2489addf989ea8f$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $e2489addf989ea8f$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $e2489addf989ea8f$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("34ck9", function(module, exports) {

var $lFKmC = parcelRequire("lFKmC");

var $k0qYG = parcelRequire("k0qYG");
/** Error message constants. */ var $23bb4e171ff15bc1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $23bb4e171ff15bc1$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($23bb4e171ff15bc1$var$FUNC_ERROR_TEXT);
    if ($k0qYG(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $lFKmC(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $23bb4e171ff15bc1$var$throttle;

});


parcelRegister("eBQOo", function(module, exports) {

$parcel$export(module.exports, "postHeartbeat", () => $70626db8d73b461f$export$931f43089f67754c);
const $70626db8d73b461f$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $70626db8d73b461f$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $70626db8d73b461f$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $70626db8d73b461f$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $70626db8d73b461f$var$timeout(backoff);
        return await $70626db8d73b461f$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $70626db8d73b461f$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $70626db8d73b461f$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        if ($70626db8d73b461f$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Heartbeat: Retried 5x, stopped to call api');
    }
};

});


parcelRegister("4U1PW", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $391dd11e177a8b61$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $l7Jgj = parcelRequire("l7Jgj");

var $7Tywk = parcelRequire("7Tywk");
var $391dd11e177a8b61$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $391dd11e177a8b61$var$__await ? (this.v = v, this) : new $391dd11e177a8b61$var$__await(v);
};
var $391dd11e177a8b61$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $391dd11e177a8b61$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $391dd11e177a8b61$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $391dd11e177a8b61$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$391dd11e177a8b61$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $l7Jgj.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $l7Jgj.stringifyMessage)({
                                    type: (0, $l7Jgj.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $l7Jgj.stringifyMessage)(payload ? {
                            type: (0, $l7Jgj.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $l7Jgj.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $l7Jgj.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $l7Jgj.CloseCode).InternalClientError, (0, $7Tywk.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $l7Jgj.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $l7Jgj.stringifyMessage)(message.payload ? {
                                    type: (0, $l7Jgj.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $l7Jgj.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $l7Jgj.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $l7Jgj.CloseCode).BadResponse, (0, $7Tywk.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && ($391dd11e177a8b61$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $l7Jgj.CloseCode).InternalServerError,
            (0, $l7Jgj.CloseCode).InternalClientError,
            (0, $l7Jgj.CloseCode).BadRequest,
            (0, $l7Jgj.CloseCode).BadResponse,
            (0, $l7Jgj.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $l7Jgj.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $l7Jgj.CloseCode).SubscriberAlreadyExists,
            (0, $l7Jgj.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $l7Jgj.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $l7Jgj.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $l7Jgj.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $l7Jgj.stringifyMessage)({
                        id: id,
                        type: (0, $l7Jgj.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $l7Jgj.stringifyMessage)({
                            id: id,
                            type: (0, $l7Jgj.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $391dd11e177a8b61$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $391dd11e177a8b61$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $391dd11e177a8b61$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $391dd11e177a8b61$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $391dd11e177a8b61$var$isLikeCloseEvent(val) {
    return (0, $7Tywk.isObject)(val) && 'code' in val && 'reason' in val;
}
function $391dd11e177a8b61$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $391dd11e177a8b61$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("l7Jgj", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $f60d5c8886e0651e$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $f60d5c8886e0651e$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $f60d5c8886e0651e$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $f60d5c8886e0651e$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $f60d5c8886e0651e$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $7Tywk = parcelRequire("7Tywk");
const $f60d5c8886e0651e$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $f60d5c8886e0651e$export$ec743af8bb66f3be = 'graphql-ws';
var $f60d5c8886e0651e$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($f60d5c8886e0651e$export$777128f41f6616ec || ($f60d5c8886e0651e$export$777128f41f6616ec = {}));
var $f60d5c8886e0651e$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($f60d5c8886e0651e$export$80edbf15fa61a4db || ($f60d5c8886e0651e$export$80edbf15fa61a4db = {}));
function $f60d5c8886e0651e$export$c17861b159b1b673(val) {
    if (!(0, $7Tywk.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $7Tywk.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionInit:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionAck:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Ping:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $7Tywk.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $7Tywk.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $7Tywk.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $7Tywk.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $7Tywk.extendedTypeof)(val.payload)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $f60d5c8886e0651e$export$9e0e49e75fa7d548(val) {
    try {
        $f60d5c8886e0651e$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $f60d5c8886e0651e$export$f2f615077a189f21(data, reviver) {
    return $f60d5c8886e0651e$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $f60d5c8886e0651e$export$77896e5b47bfd50b(msg, replacer) {
    $f60d5c8886e0651e$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("7Tywk", function(module, exports) {

$parcel$export(module.exports, "extendedTypeof", () => $5bf872794d14d281$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $5bf872794d14d281$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $5bf872794d14d281$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $5bf872794d14d281$export$2937fa0c8dddae54);
/** @private */ function $5bf872794d14d281$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $5bf872794d14d281$export$a6cdc56e425d0d0a(val) {
    return $5bf872794d14d281$export$573326049e1b1c6b(val) === 'object';
}
function $5bf872794d14d281$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $5bf872794d14d281$export$92bd080471bc30f1(val) {
    return $5bf872794d14d281$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $5bf872794d14d281$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $5bf872794d14d281$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("ajdBN", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $21b7698568901edd$export$6c790f07f4ef6a59);

var $eiowN = parcelRequire("eiowN");

var $65GpI = parcelRequire("65GpI");

var $erN97 = parcelRequire("erN97");

var $dKSRQ = parcelRequire("dKSRQ");

var $kHwNZ = parcelRequire("kHwNZ");

var $hdvvy = parcelRequire("hdvvy");
const $21b7698568901edd$var$createStore = (source, options)=>{
    (0, $eiowN.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($65GpI)))(source, options);
};
const $21b7698568901edd$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $kHwNZ.network),
        store: $21b7698568901edd$var$createStore(new (0, $eiowN.RecordSource)(), {
            log: log ?? undefined,
            getDataID: (0, $erN97.default)
        }),
        log: log,
        requiredFieldLogger: requiredFieldLogger,
        // Renamed https://github.com/facebook/relay/commit/914794c4ddba6f7c8d2469ecdc5aa42eb112a6bb
        // @ts-expect-error Object literal may only specify known properties, and 'relayFieldLogger' does not exist in type 'EnvironmentConfig'
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $erN97.default),
        scheduler: (0, $hdvvy.default),
        missingFieldHandlers: (0, $dKSRQ.default)
    });

});
parcelRegister("65GpI", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $46f41c2f1ec2be63$var$_interopRequireDefault = $7gV6J.default;

var $46f41c2f1ec2be63$var$_createForOfIteratorHelper2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("8utPl")));

var $46f41c2f1ec2be63$var$_defineProperty2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $g6Qtb = parcelRequire("g6Qtb");
var $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $g6Qtb.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $46f41c2f1ec2be63$var$assertInternalActorIdentifier = $g6Qtb.assertInternalActorIdentifier;
parcelRequire("259Mc");

var $1zFTi = parcelRequire("1zFTi");

var $h7JIX = parcelRequire("h7JIX");

var $4FKGD = parcelRequire("4FKGD");

var $jeujn = parcelRequire("jeujn");

var $ja41X = parcelRequire("ja41X");

var $9miei = parcelRequire("9miei");

var $5DcbW = parcelRequire("5DcbW");

var $hWkm3 = parcelRequire("hWkm3");

var $dfBRB = parcelRequire("dfBRB");

var $dfBRB = parcelRequire("dfBRB");
var $46f41c2f1ec2be63$var$ROOT_ID = $dfBRB.ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE = $dfBRB.ROOT_TYPE;

var $edMta = parcelRequire("edMta");
var $46f41c2f1ec2be63$var$LiveResolverCache = $edMta.LiveResolverCache, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $edMta.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $46f41c2f1ec2be63$var$getUpdatedDataIDs = $edMta.getUpdatedDataIDs;

var $aE1Lc = parcelRequire("aE1Lc");
var $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $46f41c2f1ec2be63$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $46f41c2f1ec2be63$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1zFTi;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $4FKGD;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $46f41c2f1ec2be63$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $hWkm3(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $46f41c2f1ec2be63$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $h7JIX.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $9miei.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $jeujn.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $ja41X.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $ja41X.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $5DcbW.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $jeujn.getValue(record, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $46f41c2f1ec2be63$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $46f41c2f1ec2be63$var$initializeRecordSource(target) {
    if (!target.has($46f41c2f1ec2be63$var$ROOT_ID)) {
        var rootRecord = $jeujn.create($46f41c2f1ec2be63$var$ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE);
        target.set($46f41c2f1ec2be63$var$ROOT_ID, rootRecord);
    }
}
function $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $jeujn.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $jeujn.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $jeujn.setValue(nextRecord, $dfBRB.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $jeujn.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $46f41c2f1ec2be63$var$LiveResolverStore;

});
parcelRegister("edMta", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $a5a7e09f792afd36$var$_interopRequireDefault = $7gV6J.default;

var $a5a7e09f792afd36$var$_createForOfIteratorHelper2 = $a5a7e09f792afd36$var$_interopRequireDefault((parcelRequire("8utPl")));

var $b2CqU = parcelRequire("b2CqU");

var $7AO8k = parcelRequire("7AO8k");
var $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER;

var $brVAm = parcelRequire("brVAm");

var $dFCzs = parcelRequire("dFCzs");

var $dgkLD = parcelRequire("dgkLD");
var $a5a7e09f792afd36$var$generateClientID = $dgkLD.generateClientID, $a5a7e09f792afd36$var$generateClientObjectClientID = $dgkLD.generateClientObjectClientID;

var $jeujn = parcelRequire("jeujn");

var $hqAuM = parcelRequire("hqAuM");
var $a5a7e09f792afd36$var$createNormalizationSelector = $hqAuM.createNormalizationSelector;

var $67IX0 = parcelRequire("67IX0");

var $ggNiN = parcelRequire("ggNiN");
var $a5a7e09f792afd36$var$normalize = $ggNiN.normalize;

var $dfBRB = parcelRequire("dfBRB");
var $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY = $dfBRB.RELAY_RESOLVER_ERROR_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY = $dfBRB.RELAY_RESOLVER_INVALIDATION_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $dfBRB.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY = $dfBRB.RELAY_RESOLVER_SNAPSHOT_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY = $dfBRB.RELAY_RESOLVER_VALUE_KEY, $a5a7e09f792afd36$var$getStorageKey = $dfBRB.getStorageKey;

var $24A8O = parcelRequire("24A8O");

var $1ct6Z = parcelRequire("1ct6Z");

var $9a00R = parcelRequire("9a00R");
var $a5a7e09f792afd36$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel;

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $a5a7e09f792afd36$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $a5a7e09f792afd36$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
        var storageKey = $a5a7e09f792afd36$var$getStorageKey(field, variables);
        var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.create(linkedID, $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $aE1Lc(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $a5a7e09f792afd36$var$getStorageKey(field.fragment, variables);
                var resolverID = $a5a7e09f792afd36$var$generateClientID(recordID, fragmentStorageKey);
                $a5a7e09f792afd36$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER && $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.clone(linkedRecord);
            var _liveState = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$1ct6Z(_liveState)) $aE1Lc(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($a5a7e09f792afd36$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $aE1Lc(false);
        var liveState = $jeujn.getValue(liveStateRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$jeujn.hasValue(currentRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $67IX0.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $67IX0.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $aE1Lc(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$a5a7e09f792afd36$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $24A8O(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $aE1Lc(false);
                resolverValue = [];
                var nextSource = $67IX0.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $aE1Lc(false);
                    var typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(typename, $jeujn.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $a5a7e09f792afd36$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $aE1Lc(false);
                var _typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(_typename, $jeujn.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $dFCzs(resolverValue);
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $dFCzs(value);
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $jeujn.getValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $a5a7e09f792afd36$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $b2CqU(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($brVAm.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $jeujn.clone(record);
            $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($jeujn.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $67IX0.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $jeujn.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $a5a7e09f792afd36$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $a5a7e09f792afd36$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $jeujn.create(outputTypeDataID, typename);
                $jeujn.setValue(_record, $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $aE1Lc(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $a5a7e09f792afd36$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $jeujn.create(key, typeName);
            $jeujn.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $a5a7e09f792afd36$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $a5a7e09f792afd36$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $jeujn.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $a5a7e09f792afd36$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $jeujn.getFields(record).forEach(function(field) {
        if ($jeujn.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $jeujn.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($jeujn.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $jeujn.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $a5a7e09f792afd36$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $jeujn.clone(record);
    $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $a5a7e09f792afd36$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $a5a7e09f792afd36$var$isResolverRecord(_record2)) $a5a7e09f792afd36$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $a5a7e09f792afd36$var$isResolverRecord(record) {
    return $jeujn.getType(record) === $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $a5a7e09f792afd36$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $aE1Lc(false);
    return record;
}
function $a5a7e09f792afd36$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $aE1Lc(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $a5a7e09f792afd36$var$LiveResolverCache,
    getUpdatedDataIDs: $a5a7e09f792afd36$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("1ct6Z", function(module, exports) {
'use strict';
function $0dfd7e67afc3bafd$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $0dfd7e67afc3bafd$var$isLiveStateValue;

});



parcelRegister("erN97", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f3e2bd87b9ab24$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $PV6Lp = parcelRequire("PV6Lp");
const $11f3e2bd87b9ab24$var$idTypeMap = new Map();
function $11f3e2bd87b9ab24$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $fHpHg.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($11f3e2bd87b9ab24$var$idTypeMap.has(idString)) {
            const entry = $11f3e2bd87b9ab24$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $PV6Lp.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $11f3e2bd87b9ab24$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("PV6Lp", function(module, exports) {

$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $4b4e589380e0d32c$export$b8c037155fd57aaf);
const $4b4e589380e0d32c$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $4b4e589380e0d32c$var$isProduction = ()=>true;
const $4b4e589380e0d32c$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $4b4e589380e0d32c$var$INTERVAL_MS = 1000;
let $4b4e589380e0d32c$var$requestQueue = [];
let $4b4e589380e0d32c$var$isProcessingQueue = false;
const $4b4e589380e0d32c$var$processQueue = ()=>{
    if ($4b4e589380e0d32c$var$isProcessingQueue) return;
    $4b4e589380e0d32c$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($4b4e589380e0d32c$var$requestQueue.length === 0) {
            $4b4e589380e0d32c$var$isProcessingQueue = false;
            return;
        }
        const batch = $4b4e589380e0d32c$var$requestQueue.splice(0, $4b4e589380e0d32c$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$4b4e589380e0d32c$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $4b4e589380e0d32c$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $4b4e589380e0d32c$var$sendToServerBatched = (body, endpoint)=>{
    $4b4e589380e0d32c$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $4b4e589380e0d32c$var$processQueue();
};
const $4b4e589380e0d32c$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$4b4e589380e0d32c$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $4b4e589380e0d32c$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $4b4e589380e0d32c$var$sendData = (level, location, message, event = {})=>{
    const data = $4b4e589380e0d32c$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($4b4e589380e0d32c$var$isProduction()) return $4b4e589380e0d32c$var$sendToServerBatched(body, endpoint);
    return $4b4e589380e0d32c$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $4b4e589380e0d32c$export$b8c037155fd57aaf = (location, message, event)=>{
    $4b4e589380e0d32c$var$sendData('warn', location, message, event);
};

});


parcelRegister("dKSRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9714463289de62a9$export$2e2bcd8739ae039);

var $gbLWS = parcelRequire("gbLWS");

var $erN97 = parcelRequire("erN97");
const $9714463289de62a9$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $9714463289de62a9$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $9714463289de62a9$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $gbLWS.JiraFilterAri).parse(id).filterId;
            if ($9714463289de62a9$var$isCustomFilter(filterId)) return (0, $erN97.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($9714463289de62a9$var$isSystemFilter(filterId)) return (0, $erN97.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $9714463289de62a9$var$MissingFieldHandlers = [
    $9714463289de62a9$export$77232ec02db7a24a
];
var $9714463289de62a9$export$2e2bcd8739ae039 = $9714463289de62a9$var$MissingFieldHandlers;

});
parcelRegister("gbLWS", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAri", () => $bc92de03879804aa$export$3cfb6cc809e835bd);

var $TjnT5 = parcelRequire("TjnT5");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/filter/manifest.ts
var $bc92de03879804aa$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $TjnT5.JiraFilterAriResourceOwner),
    resourceType: (0, $TjnT5.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $bc92de03879804aa$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bc92de03879804aa$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $bc92de03879804aa$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bc92de03879804aa$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $bc92de03879804aa$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $bc92de03879804aa$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $bc92de03879804aa$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("TjnT5", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $0a642c7bb6f094f8$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $0a642c7bb6f094f8$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $0a642c7bb6f094f8$export$e6199848f52f1119 = "jira", $0a642c7bb6f094f8$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("9KGzW", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $71997031dd676429$export$579ee78b1dcf0a11);

var $1Jl81 = parcelRequire("1Jl81");
// src/core/registered-ari.ts
var $71997031dd676429$export$579ee78b1dcf0a11 = class extends (0, $1Jl81.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $1Jl81.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("1Jl81", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $142a620f899fb689$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $142a620f899fb689$export$44a7af7122933d6b);

var $1C2Ux = parcelRequire("1C2Ux");
// src/core/ari.ts
var $142a620f899fb689$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $1C2Ux.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $142a620f899fb689$export$44a7af7122933d6b = class _AnyAri extends $142a620f899fb689$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $1C2Ux.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $1C2Ux.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("1C2Ux", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $12cb9916f0aaeeed$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $12cb9916f0aaeeed$export$ab4b293d0121b8ee);

var $fo7u7 = parcelRequire("fo7u7");

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/cloud-id.ts
function $12cb9916f0aaeeed$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $ed4UU.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $12cb9916f0aaeeed$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $ed4UU.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $12cb9916f0aaeeed$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $12cb9916f0aaeeed$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $ed4UU.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $12cb9916f0aaeeed$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $ed4UU.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS = 5, $12cb9916f0aaeeed$export$4c3a8cde7a55740b = class extends (0, $fo7u7.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $fo7u7.validateAriQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $ed4UU.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $ed4UU.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS = 4, $12cb9916f0aaeeed$var$AtiParser = class extends (0, $fo7u7.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $12cb9916f0aaeeed$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $12cb9916f0aaeeed$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("fo7u7", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $b33ee73cfb749d69$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $b33ee73cfb749d69$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $b33ee73cfb749d69$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $b33ee73cfb749d69$export$3d09a5c28ff3e040);

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/platform-qualifier.ts
function $b33ee73cfb749d69$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $ed4UU.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $b33ee73cfb749d69$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $ed4UU.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $ed4UU.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $ed4UU.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS = 5, $b33ee73cfb749d69$var$SEGMENT_SEPARATOR = ":", $b33ee73cfb749d69$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($b33ee73cfb749d69$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $ed4UU.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($b33ee73cfb749d69$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("ed4UU", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $a58617fff8cdca9e$export$2191b9da168c6cf0);
// src/errors.ts
var $a58617fff8cdca9e$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("kHwNZ", function(module, exports) {

$parcel$export(module.exports, "network", () => $5a5047770084b3c7$export$21fcfd9d5c6ebbd4);

var $eiowN = parcelRequire("eiowN");

var $gxvzd = parcelRequire("gxvzd");

var $eEK47 = parcelRequire("eEK47");
function $5a5047770084b3c7$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $gxvzd.getAggEndpoint)(request, cacheConfig);
    const body = (0, $gxvzd.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $eEK47.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $5a5047770084b3c7$export$21fcfd9d5c6ebbd4 = (0, $eiowN.Network).create($5a5047770084b3c7$var$fetchQuery);

});
parcelRegister("eEK47", function(module, exports) {

$parcel$export(module.exports, "RelayExperimentalApis", () => $56a5d861dcbf4bab$export$ebe3a775ce3053a5);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $56a5d861dcbf4bab$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});


parcelRegister("hdvvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b5fd7559593302$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$96b5fd7559593302$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $7nsd3.version) === 'undefined' || (0, $7nsd3.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).startTransition === 'function') // @ts-ignore-error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});


parcelRegister("eyWK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0033b2c42d4ea6cc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $0033b2c42d4ea6cc$export$d12f56a472cdbe6c);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $ex6Pq = parcelRequire("ex6Pq");
function $0033b2c42d4ea6cc$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $aatTc.default));
    (0, $5uXOq.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
const $0033b2c42d4ea6cc$export$d12f56a472cdbe6c = (0, $ex6Pq.withProfiling)(function addUFOCustomData(data) {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $lAOer.addCustomData)(currentInteractionId, [], data);
});

});

parcelRegister("j5G08", function(module, exports) {

$parcel$export(module.exports, "useUFOTransitionCompleter", () => $9d2dbf483eb61554$export$369f0ded13ce6c50);
$parcel$export(module.exports, "default", () => $9d2dbf483eb61554$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $lEdH9 = parcelRequire("lEdH9");

var $7u3rk = parcelRequire("7u3rk");

var $7xBz2 = parcelRequire("7xBz2");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $cb0MQ = parcelRequire("cb0MQ");

var $ex6Pq = parcelRequire("ex6Pq");

var $cxRh5 = parcelRequire("cxRh5");
const $9d2dbf483eb61554$var$traceUFOTransition = (0, $ex6Pq.withProfiling)(function traceUFOTransition(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $7u3rk.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $lAOer.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $lAOer.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $cb0MQ.default).current = ufoName;
        const rate = (0, $7u3rk.getInteractionRate)(ufoName, 'transition');
        if ((0, $lEdH9.default)(rate)) {
            const newId = (0, $7Jxgt.v4)();
            (0, $cxRh5.setInteractionActiveTrace)(newId);
            (0, $32M8E.DefaultInteractionID).current = newId;
            (0, $lAOer.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $7xBz2.getActiveTrace)());
        }
    }
});
function $9d2dbf483eb61554$export$369f0ded13ce6c50() {
    const interactionId = (0, $5uXOq.useContext)((0, $32M8E.default));
    const capturedInteractionId = interactionId.current;
    (0, $5uXOq.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $lAOer.tryComplete)(capturedInteractionId);
                });
            });
            (0, $lAOer.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $9d2dbf483eb61554$export$2e2bcd8739ae039 = $9d2dbf483eb61554$var$traceUFOTransition;

});
parcelRegister("cb0MQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd7c475ae1a02bb9$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $cd7c475ae1a02bb9$var$UFORouteName = {
    current: null
};
var $cd7c475ae1a02bb9$export$2e2bcd8739ae039 = $cd7c475ae1a02bb9$var$UFORouteName;

});

parcelRegister("cxRh5", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $c5e74cca7f451297$export$f2e521e495a88544);

var $7xBz2 = parcelRequire("7xBz2");

var $ex6Pq = parcelRequire("ex6Pq");

var $exhjK = parcelRequire("exhjK");
const $c5e74cca7f451297$export$f2e521e495a88544 = (0, $ex6Pq.withProfiling)(function setInteractionActiveTrace(newId) {
    (0, $7xBz2.setActiveTrace)(newId.replace(/-/g, ''), (0, $exhjK.generateSpanId)(), 'transition');
});

});
parcelRegister("exhjK", function(module, exports) {

$parcel$export(module.exports, "generateSpanId", () => $b1125b122b9e5b41$export$295213bc4d0c54ad);

var $ex6Pq = parcelRequire("ex6Pq");
const $b1125b122b9e5b41$export$295213bc4d0c54ad = (0, $ex6Pq.withProfiling)(function generateSpanId() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
});

});



parcelRegister("iLrcb", function(module, exports) {

$parcel$export(module.exports, "GlobalPageLoadExperience", () => $507dbb55d5fdc127$export$bf7c1e56255f1467);

var $16Yvd = parcelRequire("16Yvd");

var $28t7g = parcelRequire("28t7g");

var $lrUJ4 = parcelRequire("lrUJ4");

var $auayM = parcelRequire("auayM");
class $507dbb55d5fdc127$var$UFOGlobalPageLoadExperience extends (0, $28t7g.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $28t7g.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, $lrUJ4.ExperienceTypes).Load, this.performanceType = (0, $lrUJ4.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const $507dbb55d5fdc127$export$bf7c1e56255f1467 = new $507dbb55d5fdc127$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $16Yvd.untilAll)([
        {
            category: (0, $auayM.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("16Yvd", function(module, exports) {

$parcel$export(module.exports, "untilAll", () => $751a06df251ca1fa$export$44695628831598be);

var $2eEra = parcelRequire("2eEra");

var $9eTHR = parcelRequire("9eTHR");
const $751a06df251ca1fa$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $751a06df251ca1fa$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $751a06df251ca1fa$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($751a06df251ca1fa$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($751a06df251ca1fa$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $9eTHR.UFOExperienceState).ABORTED || data.state === (0, $9eTHR.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $2eEra.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $9eTHR.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});
parcelRegister("9eTHR", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $031be7232025bafb$export$81b70111112841a0);
const $031be7232025bafb$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});


parcelRegister("28t7g", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $88c04e42f8749567$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $88c04e42f8749567$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $bSySl = parcelRequire("bSySl");

var $fF86E = parcelRequire("fF86E");

var $2eEra = parcelRequire("2eEra");

var $3raRx = parcelRequire("3raRx");

var $cpoCM = parcelRequire("cpoCM");

var $9e96b = parcelRequire("9e96b");

var $9eTHR = parcelRequire("9eTHR");

var $hOAzf = parcelRequire("hOAzf");

var $lrUJ4 = parcelRequire("lrUJ4");
const $88c04e42f8749567$var$getPageVisibleState = ()=>{
    return !(0, $bSySl.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $cpoCM.PageVisibleState).VISIBLE : (0, $cpoCM.PageVisibleState).HIDDEN;
};
const $88c04e42f8749567$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9e96b.roundPerfNow)();
};
class $88c04e42f8749567$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $9eTHR.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $cpoCM.PageVisibleState).MIXED;
            (0, $3raRx.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $88c04e42f8749567$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $lrUJ4.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $2eEra.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hOAzf.canTransition)(this.state, newState)) {
            (0, $2eEra.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $9eTHR.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $88c04e42f8749567$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $88c04e42f8749567$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $fF86E.getGlobalEventStream)().push((0, $fF86E.unsubscribeEvent)((0, $cpoCM.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $2eEra.ufolog)('this.parent', this.parent);
                (0, $fF86E.getGlobalEventStream)().push((0, $fF86E.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $2eEra.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $2eEra.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $9eTHR.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $88c04e42f8749567$var$getPageVisibleState();
            (0, $3raRx.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $2eEra.ufolog)('subscribed', this.id);
                (0, $fF86E.getGlobalEventStream)().push((0, $fF86E.subscribeEvent)((0, $cpoCM.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $cpoCM.FMP_MARK) && name !== (0, $cpoCM.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $2eEra.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $88c04e42f8749567$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $9eTHR.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $cpoCM.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $cpoCM.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $2eEra.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $3raRx.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $9eTHR.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $9eTHR.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $9eTHR.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $2eEra.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $8e653975459f5402$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $8e653975459f5402$export$2295b861f318254a = '0.1.5';

parcelRegister("9e96b", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $0ca1e3ab2c03df91$export$5f490af6b2b115cf);
const $0ca1e3ab2c03df91$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("hOAzf", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $c12edfbd9a0b0c54$export$178881f329fdb81f);

var $9eTHR = parcelRequire("9eTHR");
const $c12edfbd9a0b0c54$var$UFOStateAvailableTransitions = {
    [(0, $9eTHR.UFOExperienceState).NOT_STARTED.id]: [
        (0, $9eTHR.UFOExperienceState).STARTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).STARTED.id]: [
        (0, $9eTHR.UFOExperienceState).IN_PROGRESS.id,
        (0, $9eTHR.UFOExperienceState).BLOCKED.id,
        (0, $9eTHR.UFOExperienceState).SUCCEEDED.id,
        (0, $9eTHR.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $9eTHR.UFOExperienceState).FAILED.id,
        (0, $9eTHR.UFOExperienceState).ABORTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $9eTHR.UFOExperienceState).BLOCKED.id,
        (0, $9eTHR.UFOExperienceState).SUCCEEDED.id,
        (0, $9eTHR.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $9eTHR.UFOExperienceState).FAILED.id,
        (0, $9eTHR.UFOExperienceState).ABORTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).BLOCKED.id]: [
        (0, $9eTHR.UFOExperienceState).RECOVERED.id,
        (0, $9eTHR.UFOExperienceState).ABORTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).RECOVERED.id]: [
        (0, $9eTHR.UFOExperienceState).STARTED.id,
        (0, $9eTHR.UFOExperienceState).SUCCEEDED.id,
        (0, $9eTHR.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $9eTHR.UFOExperienceState).FAILED.id,
        (0, $9eTHR.UFOExperienceState).ABORTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).SUCCEEDED.id]: [
        (0, $9eTHR.UFOExperienceState).STARTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $9eTHR.UFOExperienceState).SUCCEEDED.id,
        (0, $9eTHR.UFOExperienceState).FAILED.id,
        (0, $9eTHR.UFOExperienceState).ABORTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).FAILED.id]: [
        (0, $9eTHR.UFOExperienceState).STARTED.id
    ],
    [(0, $9eTHR.UFOExperienceState).ABORTED.id]: [
        (0, $9eTHR.UFOExperienceState).STARTED.id
    ]
};
const $c12edfbd9a0b0c54$export$178881f329fdb81f = (state1, state2)=>{
    return $c12edfbd9a0b0c54$var$UFOStateAvailableTransitions[state1.id] && $c12edfbd9a0b0c54$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});


parcelRegister("auayM", function(module, exports) {

$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $564dfe7a64a30bf3$export$17d97452062ccf73);
const $564dfe7a64a30bf3$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("2nKjG", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $e00758c548bb2ff3$export$b0c5c2fac8144e54);

var $lMyQr = parcelRequire("lMyQr");

var $gOgRf = parcelRequire("gOgRf");
const $e00758c548bb2ff3$export$b0c5c2fac8144e54 = {
    pageLoad: $gOgRf.pageLoad,
    pageSegmentLoad: $gOgRf.pageSegmentLoad,
    interaction: $gOgRf.interaction,
    custom: $gOgRf.custom,
    concurrent: $lMyQr.concurrent
};

});
parcelRegister("lMyQr", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $31f5b3cc8b0cff91$export$370df09ecc3de059);

var $1xIUR = parcelRequire("1xIUR");

var $gOgRf = parcelRequire("gOgRf");
const $31f5b3cc8b0cff91$var$concurrentMetrics = {};
const $31f5b3cc8b0cff91$var$getKey = (config, type)=>`${type}--${config.key}`;
const $31f5b3cc8b0cff91$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $31f5b3cc8b0cff91$var$ensurePath = (config, type)=>{
    const key = $31f5b3cc8b0cff91$var$getKey(config, type);
    if (!(key in $31f5b3cc8b0cff91$var$concurrentMetrics)) $31f5b3cc8b0cff91$var$concurrentMetrics[key] = {};
};
const $31f5b3cc8b0cff91$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $31f5b3cc8b0cff91$var$getKey(config, type);
    if (concurrentKey in $31f5b3cc8b0cff91$var$concurrentMetrics && $31f5b3cc8b0cff91$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $31f5b3cc8b0cff91$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $31f5b3cc8b0cff91$var$concurrentMetrics)) $31f5b3cc8b0cff91$var$concurrentMetrics[concurrentKey] = {};
};
const $31f5b3cc8b0cff91$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $31f5b3cc8b0cff91$var$validateConfig(config);
    $31f5b3cc8b0cff91$var$ensurePath(config, type);
    const metricFromCache = $31f5b3cc8b0cff91$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $1xIUR.BMEventsType).INLINE_RESULT ? (0, $gOgRf.interaction) : (0, $gOgRf.custom);
    const metric = metricFactory(config);
    $31f5b3cc8b0cff91$var$concurrentMetrics[$31f5b3cc8b0cff91$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $31f5b3cc8b0cff91$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$31f5b3cc8b0cff91$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $1xIUR.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$31f5b3cc8b0cff91$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $1xIUR.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$31f5b3cc8b0cff91$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $1xIUR.BMEventsType).CUSTOM)
};

});
parcelRegister("gOgRf", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $2a62e32bf7b02304$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $2a62e32bf7b02304$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $2a62e32bf7b02304$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $2a62e32bf7b02304$export$4c00f665f0d4b443);

var $iHyd8 = parcelRequire("iHyd8");

var $3CKAh = parcelRequire("3CKAh");

var $8gW0P = parcelRequire("8gW0P");

var $1xIUR = parcelRequire("1xIUR");
const $2a62e32bf7b02304$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3CKAh.PageLoadMetric)({
        ...config,
        type: (0, $1xIUR.BMEventsType).PAGE_LOAD
    });
};
const $2a62e32bf7b02304$export$94114666844d5f66 = (config)=>{
    return new (0, $8gW0P.PageSegmentLoadMetric)({
        ...config,
        type: (0, $1xIUR.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $2a62e32bf7b02304$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iHyd8.Metric)({
        ...config,
        type: (0, $1xIUR.BMEventsType).INLINE_RESULT
    });
};
const $2a62e32bf7b02304$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iHyd8.Metric)({
        ...config,
        type: (0, $1xIUR.BMEventsType).CUSTOM
    });
};

});
parcelRegister("iHyd8", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $ef4c0181adcbaefc$export$efdd3e096bc27746);

var $hmsy5 = parcelRequire("hmsy5");

var $5rsg3 = parcelRequire("5rsg3");

var $3YMDZ = parcelRequire("3YMDZ");
class $ef4c0181adcbaefc$export$efdd3e096bc27746 extends (0, $3YMDZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hmsy5.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $5rsg3.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("3CKAh", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $4d3d50c0ded7332f$export$3c51073271a9eac3);

var $4q4os = parcelRequire("4q4os");

var $jV88Z = parcelRequire("jV88Z");

var $hmsy5 = parcelRequire("hmsy5");

var $5rsg3 = parcelRequire("5rsg3");

var $1xIUR = parcelRequire("1xIUR");

var $8XSwx = parcelRequire("8XSwx");

var $6bBJz = parcelRequire("6bBJz");

var $3Pbas = parcelRequire("3Pbas");
class $4d3d50c0ded7332f$export$3c51073271a9eac3 extends (0, $8XSwx.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $6bBJz.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $6bBJz.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $6bBJz.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $8XSwx.BasePageLoadMetric).FMP]) {
                const mark = (0, $4q4os.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $6bBJz.pageLoadMetaMetric).markFMP(mark);
            } else (0, $6bBJz.pageLoadMetaMetric).markFMP(this.marks[(0, $8XSwx.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hmsy5.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $5rsg3.submitter).queue(data);
        (0, $jV88Z.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $6bBJz.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $6bBJz.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $6bBJz.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $5rsg3.submitter).config.configChunk;
        if (!configChunk?.[(0, $1xIUR.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $3Pbas.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $5rsg3.submitter).queue(webVitalMetric.getData());
        (0, $jV88Z.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("3Pbas", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $b5c8f0f251fd45a1$export$dc0d85d4d6503cd7);

var $1xIUR = parcelRequire("1xIUR");

var $3YMDZ = parcelRequire("3YMDZ");
class $b5c8f0f251fd45a1$export$dc0d85d4d6503cd7 extends (0, $3YMDZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $1xIUR.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $3YMDZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("8gW0P", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $b6f5ddda7830b4e4$export$24c8bfcd77494cc1);

var $4q4os = parcelRequire("4q4os");

var $1xIUR = parcelRequire("1xIUR");

var $3YMDZ = parcelRequire("3YMDZ");

var $iHyd8 = parcelRequire("iHyd8");

var $6bBJz = parcelRequire("6bBJz");
class $b6f5ddda7830b4e4$export$24c8bfcd77494cc1 extends (0, $iHyd8.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $6bBJz.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $b6f5ddda7830b4e4$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($b6f5ddda7830b4e4$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $6bBJz.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$b6f5ddda7830b4e4$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $4q4os.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $1xIUR.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $3YMDZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $3YMDZ.MetricState).STARTED) (0, $6bBJz.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("dGvGJ", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $9f67c73d64e1d92a$export$281bff7f05488aa2, (v) => $9f67c73d64e1d92a$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $9f67c73d64e1d92a$export$5943f4447f6ef248, (v) => $9f67c73d64e1d92a$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $9f67c73d64e1d92a$export$75979cfcd91bf38f, (v) => $9f67c73d64e1d92a$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $9f67c73d64e1d92a$export$595d22ed68ca2841, (v) => $9f67c73d64e1d92a$export$595d22ed68ca2841 = v);
var $9f67c73d64e1d92a$export$1e511d4a378977f5;
var $9f67c73d64e1d92a$export$281bff7f05488aa2;
var $9f67c73d64e1d92a$export$5943f4447f6ef248;
var $9f67c73d64e1d92a$export$75979cfcd91bf38f;
var $9f67c73d64e1d92a$export$595d22ed68ca2841;
'use strict';
$9f67c73d64e1d92a$export$1e511d4a378977f5 = true;
$9f67c73d64e1d92a$export$281bff7f05488aa2 = $9f67c73d64e1d92a$var$defaultMemoize;
$9f67c73d64e1d92a$export$5943f4447f6ef248 = $9f67c73d64e1d92a$var$createSelectorCreator;
$9f67c73d64e1d92a$export$75979cfcd91bf38f = $9f67c73d64e1d92a$var$createStructuredSelector;
function $9f67c73d64e1d92a$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $9f67c73d64e1d92a$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $9f67c73d64e1d92a$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $9f67c73d64e1d92a$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $9f67c73d64e1d92a$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $9f67c73d64e1d92a$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $9f67c73d64e1d92a$var$createSelector = $9f67c73d64e1d92a$export$595d22ed68ca2841 = $9f67c73d64e1d92a$var$createSelectorCreator($9f67c73d64e1d92a$var$defaultMemoize);
function $9f67c73d64e1d92a$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("3fRWr", function(module, exports) {

$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $56e797de1a23ddd7$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $56e797de1a23ddd7$export$6d488733a547304);

var $ex6Pq = parcelRequire("ex6Pq");
const $56e797de1a23ddd7$var$timings = [];
const $56e797de1a23ddd7$export$758b9a33800fa436 = (0, $ex6Pq.withProfiling)(function addTimingFromPerformanceMark(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $56e797de1a23ddd7$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
});
const $56e797de1a23ddd7$export$6d488733a547304 = (0, $ex6Pq.withProfiling)(function getTimings() {
    const reportedTimingsObj = {};
    $56e797de1a23ddd7$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
});

});

parcelRegister("fKgem", function(module, exports) {
module.exports = $b767bdf46d56eeb2$var$defaultsPlugin;
function $b767bdf46d56eeb2$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("1ohWS", function(module, exports) {

$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $abb32bac636631fb$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $abb32bac636631fb$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $abb32bac636631fb$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("dNu24")).WebStorageType);

var $6ZTqw = parcelRequire("6ZTqw");
var $6zXMV = parcelRequire("6zXMV");

var $4TktD = parcelRequire("4TktD");

var $3liKs = parcelRequire("3liKs");

var $9mFsD = parcelRequire("9mFsD");

var $dNu24 = parcelRequire("dNu24");

var $7TRYH = parcelRequire("7TRYH");
var $3NjyE = parcelRequire("3NjyE");
var $3c0lx = parcelRequire("3c0lx");
class $abb32bac636631fb$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $9mFsD.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $4TktD.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $6ZTqw.getBscGlobalState)().webStorageEnabled) return true;
        (0, $4TktD.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $4TktD.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $7TRYH.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $4TktD.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $6ZTqw.getBscGlobalState)().product;
        const itemSetStatus = await (0, $3NjyE.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $4TktD.Logger).debug(`${itemSetStatus === (0, $3liKs.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $4TktD.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $3c0lx.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $4TktD.Logger).debug(`${itemSetStatus === (0, $3liKs.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $4TktD.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $6zXMV.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $abb32bac636631fb$export$c8cc3ffd3f2c1d2f = new $abb32bac636631fb$export$8e4a3cf07a10930b(window?.localStorage, (0, $dNu24.WebStorageType).LocalStorage);
const $abb32bac636631fb$export$edbae459bdf957a5 = new $abb32bac636631fb$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $dNu24.WebStorageType).SessionStorage);
const $abb32bac636631fb$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $dNu24.WebStorageType).LocalStorage]: $abb32bac636631fb$export$c8cc3ffd3f2c1d2f,
        [(0, $dNu24.WebStorageType).SessionStorage]: $abb32bac636631fb$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("6ZTqw", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $2b813662e5988b3c$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $2b813662e5988b3c$export$882c4530c58781d8);

var $eYli8 = parcelRequire("eYli8");

var $fHpHg = parcelRequire("fHpHg");

var $3liKs = parcelRequire("3liKs");

var $gvs2I = parcelRequire("gvs2I");

var $4TktD = parcelRequire("4TktD");
let $2b813662e5988b3c$var$analyticsEnabledGlobalState;
let $2b813662e5988b3c$var$productGlobalState;
let $2b813662e5988b3c$var$webStorageControlsEnabledGlobalState;
let $2b813662e5988b3c$var$localConsentModeGlobalState;
let $2b813662e5988b3c$var$packageDebugModeEnabledGlobalState;
let $2b813662e5988b3c$var$allowUncategorizedCookiesInOverridesGlobalState;
let $2b813662e5988b3c$var$hasInitialized = false;
let $2b813662e5988b3c$var$cookiesCacheLoader;
let $2b813662e5988b3c$var$localStorageCacheLoader;
let $2b813662e5988b3c$var$sessionStorageCacheLoader;
let $2b813662e5988b3c$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $3liKs.CategoryStorageType).Cookies:
            return await $2b813662e5988b3c$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $3liKs.CategoryStorageType).LocalStorage:
            return await $2b813662e5988b3c$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $3liKs.CategoryStorageType).SessionStorage:
            return await $2b813662e5988b3c$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $2b813662e5988b3c$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $2b813662e5988b3c$var$analyticsEnabledGlobalState ?? true,
        product: $2b813662e5988b3c$var$productGlobalState,
        webStorageEnabled: $2b813662e5988b3c$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $2b813662e5988b3c$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $2b813662e5988b3c$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $2b813662e5988b3c$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $2b813662e5988b3c$var$cookiesCacheLoader,
        localStorageCacheLoader: $2b813662e5988b3c$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $2b813662e5988b3c$var$sessionStorageCacheLoader,
        loadCache: $2b813662e5988b3c$var$loadCache,
        hasInitialized: $2b813662e5988b3c$var$hasInitialized
    };
};
const $2b813662e5988b3c$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $4TktD.Logger).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$2b813662e5988b3c$var$productGlobalState || $2b813662e5988b3c$var$productGlobalState == null || $2b813662e5988b3c$var$productGlobalState === 'all') && product) $2b813662e5988b3c$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $2b813662e5988b3c$var$webStorageControlsEnabledGlobalState === undefined) $2b813662e5988b3c$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $fHpHg.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $fHpHg.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $2b813662e5988b3c$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $2b813662e5988b3c$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($2b813662e5988b3c$var$hasInitialized) return;
    $2b813662e5988b3c$var$localConsentModeGlobalState = localConsentMode;
    $2b813662e5988b3c$var$analyticsEnabledGlobalState = analyticsEnabled;
    $2b813662e5988b3c$var$cookiesCacheLoader = new (0, $gvs2I.CacheLoader)((0, $3liKs.CategoryStorageType).Cookies);
    $2b813662e5988b3c$var$localStorageCacheLoader = new (0, $gvs2I.CacheLoader)((0, $3liKs.CategoryStorageType).LocalStorage);
    $2b813662e5988b3c$var$sessionStorageCacheLoader = new (0, $gvs2I.CacheLoader)((0, $3liKs.CategoryStorageType).SessionStorage);
    if ((0, $fHpHg.fg)('platform_moonjelly_bsc_debug_mode')) $2b813662e5988b3c$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get('atl-bsc-debug-mode'));
    $2b813662e5988b3c$var$hasInitialized = true;
};
const $2b813662e5988b3c$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $2b813662e5988b3c$var$loadCache = overrideLoadCache;
    if (overrideProduct) $2b813662e5988b3c$var$productGlobalState = overrideProduct;
};
const $2b813662e5988b3c$export$ac7c2edd09656c05 = ()=>{
    $2b813662e5988b3c$var$analyticsEnabledGlobalState = undefined;
    $2b813662e5988b3c$var$productGlobalState = undefined;
    $2b813662e5988b3c$var$webStorageControlsEnabledGlobalState = undefined;
    $2b813662e5988b3c$var$localConsentModeGlobalState = undefined;
    $2b813662e5988b3c$var$packageDebugModeEnabledGlobalState = undefined;
    $2b813662e5988b3c$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $2b813662e5988b3c$var$cookiesCacheLoader = undefined;
    $2b813662e5988b3c$var$localStorageCacheLoader = undefined;
    $2b813662e5988b3c$var$sessionStorageCacheLoader = undefined;
    $2b813662e5988b3c$var$hasInitialized = false;
};

});
parcelRegister("3liKs", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $9700bf24a7648a14$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $9700bf24a7648a14$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $9700bf24a7648a14$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $9700bf24a7648a14$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $9700bf24a7648a14$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $9700bf24a7648a14$export$96e9906d6d93a972);
var $9700bf24a7648a14$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $9700bf24a7648a14$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $9700bf24a7648a14$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $9700bf24a7648a14$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $9700bf24a7648a14$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $9700bf24a7648a14$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $9700bf24a7648a14$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $9700bf24a7648a14$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("gvs2I", function(module, exports) {

$parcel$export(module.exports, "CacheLoader", () => $85af88135c4c1066$export$e479342c697b82a9);

var $3liKs = parcelRequire("3liKs");

var $4TktD = parcelRequire("4TktD");

class $85af88135c4c1066$export$e479342c697b82a9 {
    constructor(storageType){
        switch(storageType){
            case (0, $3liKs.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $d3a2f2edbec4cc73$export$ab0619f627170401);
                break;
            case (0, $3liKs.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $d3a2f2edbec4cc73$export$38bed9fd9923fef3);
                break;
            case (0, $3liKs.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $d3a2f2edbec4cc73$export$4f73a4b5fdb7ed6c);
                break;
            default:
                this.cacheUrl = (0, $d3a2f2edbec4cc73$export$194c34963e6f0bc6);
        }
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $4TktD.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $4TktD.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("4TktD", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $53840e3e7b1a574f$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $fHpHg = parcelRequire("fHpHg");

var $2MdED = parcelRequire("2MdED");

var $6ZTqw = parcelRequire("6ZTqw");
const $53840e3e7b1a574f$var$LOG_PREFIX = '[browser-storage-controls]';
class $53840e3e7b1a574f$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$53840e3e7b1a574f$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$53840e3e7b1a574f$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $2MdED.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$53840e3e7b1a574f$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
	 * Logger for additional debugging of the package. Debug logs are only sent when the
	 * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
	 */ static debug(message, metadata) {
        if ((0, $6ZTqw.getBscGlobalState)().packageDebugMode && (0, $fHpHg.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$53840e3e7b1a574f$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("2MdED", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $dbe8b93c10379fae$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $dbe8b93c10379fae$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $dbe8b93c10379fae$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $dbe8b93c10379fae$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $dbe8b93c10379fae$export$1ba525b8a711eaac);

var $aT5yh = parcelRequire("aT5yh");
var $9etNK = parcelRequire("9etNK");

var $6ZTqw = parcelRequire("6ZTqw");

var $4TktD = parcelRequire("4TktD");

var $35NY9 = parcelRequire("35NY9");

var $L5Rki = parcelRequire("L5Rki");
const $dbe8b93c10379fae$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $9etNK.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $9etNK.envType).DEV;
    return (0, $9etNK.envType).PROD;
};
const $dbe8b93c10379fae$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $dbe8b93c10379fae$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $dbe8b93c10379fae$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $dbe8b93c10379fae$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $dbe8b93c10379fae$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $dbe8b93c10379fae$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $dbe8b93c10379fae$export$fce3dd735e04d566();
    return {
        packageName: $35NY9.packageName,
        packageVersion: $35NY9.packageVersion,
        domain: domain,
        product: (0, $6ZTqw.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $dbe8b93c10379fae$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $6ZTqw.getBscGlobalState)().analyticsEnabled) instance = new (0, $aT5yh.default)({
                env: $dbe8b93c10379fae$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $4TktD.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $6ZTqw.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $dbe8b93c10379fae$export$5bfe55348e7aebc1(properties) {
    (0, $L5Rki.withAnalyticsEventSampling)(properties.action, ()=>$dbe8b93c10379fae$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $dbe8b93c10379fae$var$decorateEventAttributes(properties.attributes)
        }));
}
function $dbe8b93c10379fae$export$1aecf263098db667(properties) {
    $dbe8b93c10379fae$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $dbe8b93c10379fae$var$decorateEventAttributes(properties.attributes)
    });
}
function $dbe8b93c10379fae$export$22a3b1671f38a193(properties) {
    $dbe8b93c10379fae$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $dbe8b93c10379fae$var$decorateEventAttributes(properties.attributes)
    });
}
function $dbe8b93c10379fae$export$1ba525b8a711eaac(properties) {
    $dbe8b93c10379fae$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $dbe8b93c10379fae$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("35NY9", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $c453f6d12f585202$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $c453f6d12f585202$export$91546b032799aa40);

var $6cAn5 = parcelRequire("6cAn5");
const $c453f6d12f585202$export$9345d7360ffe0722 = $6cAn5?.env._PACKAGE_NAME_ ?? '';
const $c453f6d12f585202$export$91546b032799aa40 = $6cAn5?.env._PACKAGE_VERSION_ ?? '';

});

parcelRegister("L5Rki", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $768846d76cbd6718$export$67b6e87f323cb6ad);

var $3liKs = parcelRequire("3liKs");

var $6ZTqw = parcelRequire("6ZTqw");

var $iMn9U = parcelRequire("iMn9U");

var $6zXMV = parcelRequire("6zXMV");
const $768846d76cbd6718$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $768846d76cbd6718$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $768846d76cbd6718$var$loadSamplingConfig() {
    if ((0, $iMn9U.cache).cachedSamplingConfig) return (0, $iMn9U.cache).cachedSamplingConfig;
    if ((0, $6zXMV.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $6ZTqw.getBscGlobalState)();
    const controlsData = await loadCache((0, $3liKs.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $iMn9U.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $768846d76cbd6718$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($768846d76cbd6718$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $768846d76cbd6718$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $768846d76cbd6718$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $768846d76cbd6718$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $768846d76cbd6718$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $768846d76cbd6718$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $768846d76cbd6718$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $768846d76cbd6718$export$b286f5e8716d11ad(analyticsEventKey);
    $768846d76cbd6718$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("iMn9U", function(module, exports) {

$parcel$export(module.exports, "cache", () => $943760d7b41bb4ed$export$69a3209f1a06c04d);

var $4D0Bj = parcelRequire("4D0Bj");
const $943760d7b41bb4ed$export$69a3209f1a06c04d = new (0, $4D0Bj.CachedSamplingConfig)();

});
parcelRegister("4D0Bj", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $9cf03c81d817ea51$export$b886edaf6623554a);
class $9cf03c81d817ea51$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("6zXMV", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $5bde4d3e959ec833$export$48d7c418edadb60c);

var $aT5yh = parcelRequire("aT5yh");

var $fHpHg = parcelRequire("fHpHg");

var $4TktD = parcelRequire("4TktD");
const $5bde4d3e959ec833$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $fHpHg.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $aT5yh.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $4TktD.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $4TktD.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $aT5yh.default)) (0, $4TktD.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});




const $d3a2f2edbec4cc73$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $d3a2f2edbec4cc73$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $d3a2f2edbec4cc73$export$38bed9fd9923fef3 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $d3a2f2edbec4cc73$export$4f73a4b5fdb7ed6c = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';



parcelRegister("9mFsD", function(module, exports) {

$parcel$export(module.exports, "BSCIndexedDB", () => $b6ab48a3335a7eac$export$36328b3bcbe4623a);

var $6zXMV = parcelRequire("6zXMV");

var $4TktD = parcelRequire("4TktD");
class $b6ab48a3335a7eac$export$fde2a4e0e57f47e {
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $4TktD.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $4TktD.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $4TktD.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $4TktD.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $4TktD.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $6zXMV.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $4TktD.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $4TktD.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $b6ab48a3335a7eac$export$36328b3bcbe4623a = new $b6ab48a3335a7eac$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("dNu24", function(module, exports) {

$parcel$export(module.exports, "WebStorageType", () => $a39bff915f6c0db1$export$259e3a861f28589b);
var $a39bff915f6c0db1$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("7TRYH", function(module, exports) {

$parcel$export(module.exports, "getStorageItem", () => $f53412091aa36185$export$e612bb1301d659de);

var $2MdED = parcelRequire("2MdED");

var $4TktD = parcelRequire("4TktD");
const $f53412091aa36185$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("3NjyE", function(module, exports) {

$parcel$export(module.exports, "setStorageItem", () => $10c09c96afbeaf9a$export$5ee8760f703d9d62);

var $2MdED = parcelRequire("2MdED");

var $7B39G = parcelRequire("7B39G");

var $4TktD = parcelRequire("4TktD");

var $9mFsD = parcelRequire("9mFsD");

var $3liKs = parcelRequire("3liKs");

var $dNu24 = parcelRequire("dNu24");
const $10c09c96afbeaf9a$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $7B39G.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $dNu24.WebStorageType).LocalStorage ? (0, $3liKs.CategoryStorageType).LocalStorage : (0, $3liKs.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $9mFsD.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $3liKs.Status).SUCCESS;
        } else return (0, $3liKs.Status).BLOCKED;
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $3liKs.Status).BLOCKED;
    }
};

});
parcelRegister("7B39G", function(module, exports) {

$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $5c2c483b02b78794$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $fgVKK = parcelRequire("fgVKK");

var $3liKs = parcelRequire("3liKs");

var $6ZTqw = parcelRequire("6ZTqw");
const $5c2c483b02b78794$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $5c2c483b02b78794$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $5c2c483b02b78794$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $5c2c483b02b78794$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $5c2c483b02b78794$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $3liKs.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $3liKs.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $3liKs.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $3liKs.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $3liKs.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $5c2c483b02b78794$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $6ZTqw.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $5c2c483b02b78794$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $5c2c483b02b78794$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $5c2c483b02b78794$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $3liKs.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $fgVKK.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};

});
parcelRegister("fgVKK", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $18e6c85138262cb4$export$1de6a888ae076ff8);

var $6ZTqw = parcelRequire("6ZTqw");

var $2TWGo = parcelRequire("2TWGo");

var $4GHDx = parcelRequire("4GHDx");

var $cyHbi = parcelRequire("cyHbi");

var $2JZQn = parcelRequire("2JZQn");
async function $18e6c85138262cb4$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $6ZTqw.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $cyHbi.getCookie)((0, $2TWGo.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $2JZQn.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $cyHbi.getCookie)((0, $2TWGo.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $4GHDx.getConsentToken)();
            return consentToken ? (0, $2JZQn.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $2JZQn.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("2TWGo", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $5ab7937f24b8e831$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $5ab7937f24b8e831$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $5ab7937f24b8e831$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", () => $5ab7937f24b8e831$export$f57af01b64fc97b8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $5ab7937f24b8e831$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $5ab7937f24b8e831$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $5ab7937f24b8e831$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $5ab7937f24b8e831$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $5ab7937f24b8e831$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $5ab7937f24b8e831$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $5ab7937f24b8e831$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $5ab7937f24b8e831$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $5ab7937f24b8e831$export$31deaeaebce525bb);

var $3liKs = parcelRequire("3liKs");
const $5ab7937f24b8e831$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $5ab7937f24b8e831$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $5ab7937f24b8e831$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $5ab7937f24b8e831$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $5ab7937f24b8e831$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $5ab7937f24b8e831$export$37073d560ecebada = 'atl-testing-consents';
const $5ab7937f24b8e831$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $5ab7937f24b8e831$export$b28b5d760fe14a21 = {
    [(0, $3liKs.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $3liKs.PreferenceCategory).Functional]: true,
    [(0, $3liKs.PreferenceCategory).Marketing]: true,
    [(0, $3liKs.PreferenceCategory).Analytics]: true,
    [(0, $3liKs.PreferenceCategory).Unknown]: true
};
const $5ab7937f24b8e831$export$4a12f9e99971760a = {
    [(0, $3liKs.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $3liKs.PreferenceCategory).Functional]: false,
    [(0, $3liKs.PreferenceCategory).Marketing]: false,
    [(0, $3liKs.PreferenceCategory).Analytics]: false,
    [(0, $3liKs.PreferenceCategory).Unknown]: false
};
const $5ab7937f24b8e831$export$f0fd1d13ec1d48f2 = {
    ...$5ab7937f24b8e831$export$4a12f9e99971760a,
    [(0, $3liKs.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $3liKs.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $5ab7937f24b8e831$export$f95182b7aa141c57 = '001';
const $5ab7937f24b8e831$export$1f25427b34f9c405 = '002';
const $5ab7937f24b8e831$export$31deaeaebce525bb = '003';

});

parcelRegister("4GHDx", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $75aeb9ed536646ce$export$f1b8f2ca713fca08);

var $2TWGo = parcelRequire("2TWGo");

var $cyHbi = parcelRequire("cyHbi");

var $amytT = parcelRequire("amytT");

var $dgJlA = parcelRequire("dgJlA");

var $7seRs = parcelRequire("7seRs");
const $75aeb9ed536646ce$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $cyHbi.getCookie)((0, $2TWGo.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $7seRs.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $amytT.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $cyHbi.getCookie)((0, $2TWGo.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $dgJlA.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $dgJlA.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $dgJlA.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("cyHbi", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $1232507b58b74250$export$4be65e66cfa2648a);

var $eYli8 = parcelRequire("eYli8");

var $fHpHg = parcelRequire("fHpHg");

var $2MdED = parcelRequire("2MdED");

var $4TktD = parcelRequire("4TktD");
function $1232507b58b74250$export$4be65e66cfa2648a(key) {
    if ((0, $fHpHg.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("amytT", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $f8c8bbe4f415145c$export$b5282052fc15e1ae);

var $2TWGo = parcelRequire("2TWGo");

var $cyHbi = parcelRequire("cyHbi");
const $f8c8bbe4f415145c$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $cyHbi.getCookie)((0, $2TWGo.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("dgJlA", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", () => $8f3a6c82a06fa1bb$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $8f3a6c82a06fa1bb$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $8f3a6c82a06fa1bb$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $8f3a6c82a06fa1bb$export$b3365240280cb3c3);

var $dG3tH = parcelRequire("dG3tH");
var $4TktD = parcelRequire("4TktD");

var $2TWGo = parcelRequire("2TWGo");

var $j15Uc = parcelRequire("j15Uc");

var $eb1mj = parcelRequire("eb1mj");
const $8f3a6c82a06fa1bb$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $eb1mj.setStrictlyNecessaryCookie)((0, $2TWGo.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $4TktD.Logger).debug(`Set Consent Token ${(0, $2TWGo.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $8f3a6c82a06fa1bb$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $eb1mj.setStrictlyNecessaryCookie)((0, $2TWGo.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $4TktD.Logger).debug(`set fallback consent token: ${(0, $2TWGo.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $8f3a6c82a06fa1bb$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $j15Uc.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $dG3tH.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $eb1mj.setStrictlyNecessaryCookie)((0, $2TWGo.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $4TktD.Logger).debug(`set shouldShowBannerCookie: ${(0, $2TWGo.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $8f3a6c82a06fa1bb$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $8f3a6c82a06fa1bb$export$8e560d0760f733a2(consentToken);
    $8f3a6c82a06fa1bb$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("dG3tH", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $eb6b89a21282f2a6$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $eb6b89a21282f2a6$export$27647458f3cf29d2);
const $eb6b89a21282f2a6$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $eb6b89a21282f2a6$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("j15Uc", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", () => $6c109de042abf668$export$bfdb9f82a9194c1e);

var $6zXMV = parcelRequire("6zXMV");

var $dG3tH = parcelRequire("dG3tH");

var $2TWGo = parcelRequire("2TWGo");

var $lvSIG = parcelRequire("lvSIG");

var $cyHbi = parcelRequire("cyHbi");

var $2JZQn = parcelRequire("2JZQn");
const $6c109de042abf668$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $2JZQn.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $6c109de042abf668$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $6c109de042abf668$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $dG3tH.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $lvSIG.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $6c109de042abf668$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $lvSIG.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $6c109de042abf668$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $lvSIG.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $6c109de042abf668$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $6c109de042abf668$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $dG3tH.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $lvSIG.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $6c109de042abf668$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $lvSIG.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $6c109de042abf668$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $lvSIG.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $6c109de042abf668$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    const fallbackConsentToken = (0, $6zXMV.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $cyHbi.getCookie)((0, $2TWGo.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $6c109de042abf668$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $dG3tH.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $6c109de042abf668$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $6c109de042abf668$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("lvSIG", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $c9061d3b952a6c9e$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $c9061d3b952a6c9e$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $c9061d3b952a6c9e$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $c9061d3b952a6c9e$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $c9061d3b952a6c9e$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $c9061d3b952a6c9e$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $c9061d3b952a6c9e$export$a79c0ea3d7c2444a);

var $dG3tH = parcelRequire("dG3tH");

var $2TWGo = parcelRequire("2TWGo");

var $cyHbi = parcelRequire("cyHbi");

var $3liKs = parcelRequire("3liKs");

var $9wcKT = parcelRequire("9wcKT");
const $c9061d3b952a6c9e$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $2TWGo.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $c9061d3b952a6c9e$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $2TWGo.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $c9061d3b952a6c9e$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($c9061d3b952a6c9e$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $c9061d3b952a6c9e$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $c9061d3b952a6c9e$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $c9061d3b952a6c9e$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $c9061d3b952a6c9e$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $dG3tH.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $c9061d3b952a6c9e$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $2TWGo.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $2TWGo.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $3liKs.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $3liKs.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $dG3tH.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $dG3tH.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $dG3tH.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $c9061d3b952a6c9e$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $2TWGo.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $dG3tH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $9wcKT.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $dG3tH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $9wcKT.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $dG3tH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $9wcKT.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $dG3tH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $9wcKT.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $c9061d3b952a6c9e$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $cyHbi.getCookie)((0, $2TWGo.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $c9061d3b952a6c9e$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $c9061d3b952a6c9e$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $c9061d3b952a6c9e$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $c9061d3b952a6c9e$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $3liKs.PreferenceCategory).StrictlyNecessary,
        (0, $3liKs.PreferenceCategory).Functional,
        (0, $3liKs.PreferenceCategory).Analytics,
        (0, $3liKs.PreferenceCategory).Marketing,
        (0, $3liKs.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $3liKs.PreferenceCategory).StrictlyNecessary]: (0, $9wcKT.ConsentHubKey).StrictlyNecessary,
        [(0, $3liKs.PreferenceCategory).Functional]: (0, $9wcKT.ConsentHubKey).Functional,
        [(0, $3liKs.PreferenceCategory).Analytics]: (0, $9wcKT.ConsentHubKey).Analytics,
        [(0, $3liKs.PreferenceCategory).Marketing]: (0, $9wcKT.ConsentHubKey).Marketing,
        [(0, $3liKs.PreferenceCategory).Unknown]: (0, $9wcKT.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $c9061d3b952a6c9e$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $c9061d3b952a6c9e$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $c9061d3b952a6c9e$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $c9061d3b952a6c9e$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c9061d3b952a6c9e$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("9wcKT", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $89c1536baac8cfc4$export$31140359b1e505cf);
var $89c1536baac8cfc4$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("2JZQn", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", () => $1ba27e0728afe312$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $1ba27e0728afe312$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $1ba27e0728afe312$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $1ba27e0728afe312$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $1ba27e0728afe312$export$7962405c3ca274b1);

var $6ZTqw = parcelRequire("6ZTqw");

var $dG3tH = parcelRequire("dG3tH");

var $2TWGo = parcelRequire("2TWGo");

var $lvSIG = parcelRequire("lvSIG");

var $3liKs = parcelRequire("3liKs");
const $1ba27e0728afe312$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $2TWGo.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $2TWGo.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $2TWGo.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $2TWGo.V001_SCHEMA_KEY),
        (0, $2TWGo.V002_SCHEMA_KEY),
        (0, $2TWGo.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $1ba27e0728afe312$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $2TWGo.V001_SCHEMA_KEY);
    return [
        version,
        (0, $dG3tH.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $dG3tH.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $dG3tH.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $dG3tH.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $1ba27e0728afe312$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $3liKs.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $3liKs.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $3liKs.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $3liKs.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $3liKs.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $1ba27e0728afe312$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $2TWGo.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $3liKs.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $3liKs.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $3liKs.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $3liKs.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Functional]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Analytics]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Marketing]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Unknown]),
        (0, $dG3tH.getBitValueFromBool)(isDefaultConsentBit),
        (0, $dG3tH.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $dG3tH.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $1ba27e0728afe312$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $lvSIG.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$1ba27e0728afe312$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $3liKs.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $3liKs.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $1ba27e0728afe312$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $2TWGo.V003_SCHEMA_KEY);
    return [
        version,
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Functional]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Analytics]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Marketing]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.PreferenceCategory).Unknown]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $dG3tH.getBitValueFromBool)(userPreferences[(0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $1ba27e0728afe312$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $3liKs.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $3liKs.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $3liKs.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $3liKs.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $3liKs.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $3liKs.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $3liKs.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $1ba27e0728afe312$var$V002SpecificBitKeys = [
    (0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $3liKs.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $3liKs.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $3liKs.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $3liKs.ConsentPreferenceV2).ConsentedUnderFADP
];
const $1ba27e0728afe312$var$V003SpecificBitKeys = [
    (0, $3liKs.ContextualConsentProperty).ConsentsAreDefault,
    (0, $3liKs.ContextualConsentProperty).UserIsAuthenticated,
    (0, $3liKs.ContextualConsentProperty).ConsentDataUnavailable
];
function $1ba27e0728afe312$export$3199823fec979bd1(userPreferences) {
    if ((0, $6ZTqw.getBscGlobalState)().localConsentMode) return $1ba27e0728afe312$var$packPrefsVersion001(userPreferences);
    const isV002 = $1ba27e0728afe312$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $1ba27e0728afe312$var$packPrefsVersion002(userPreferences);
    const isV003 = $1ba27e0728afe312$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $1ba27e0728afe312$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $1ba27e0728afe312$var$packPrefsVersion001(userPreferences);
}
function $1ba27e0728afe312$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $6ZTqw.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $2TWGo.V001_SCHEMA_KEY)) return $1ba27e0728afe312$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $1ba27e0728afe312$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $1ba27e0728afe312$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $1ba27e0728afe312$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $1ba27e0728afe312$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $1ba27e0728afe312$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $1ba27e0728afe312$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $3liKs.PrefetchedPreferenceState).INTERNAL) {
        if ($1ba27e0728afe312$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $1ba27e0728afe312$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $lvSIG.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $1ba27e0728afe312$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $3liKs.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("eb1mj", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $124835ff2a4fe7c2$export$93509ff9a62ee022);

var $eYli8 = parcelRequire("eYli8");

var $fHpHg = parcelRequire("fHpHg");

var $2MdED = parcelRequire("2MdED");

var $4TktD = parcelRequire("4TktD");
const $124835ff2a4fe7c2$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $fHpHg.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("7seRs", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $4805ff36e8b8b0bb$export$c515de1cc9cebc71);

var $fHpHg = parcelRequire("fHpHg");

var $2TWGo = parcelRequire("2TWGo");

var $b6Vi9 = parcelRequire("b6Vi9");

var $2JZQn = parcelRequire("2JZQn");
const $4805ff36e8b8b0bb$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $b6Vi9.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $2JZQn.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $fHpHg.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $2TWGo.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("b6Vi9", function(module, exports) {

$parcel$export(module.exports, "buildConsentPreferences", () => $4061872f4932d4d3$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $4061872f4932d4d3$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $4061872f4932d4d3$export$f8422650c3dec8b2);

var $4TktD = parcelRequire("4TktD");

var $lvSIG = parcelRequire("lvSIG");
const $4061872f4932d4d3$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $4061872f4932d4d3$var$POST_CONSENTS_URL = `${$4061872f4932d4d3$var$BASE_CONSENTS_URL}/user`;
const $4061872f4932d4d3$var$GET_CONSENTS_URL = `${$4061872f4932d4d3$var$POST_CONSENTS_URL}/consents/cookies`;
const $4061872f4932d4d3$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $lvSIG.serializeConsents)(consentData);
        const consentTimestamp = (0, $lvSIG.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $lvSIG.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $4061872f4932d4d3$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$4061872f4932d4d3$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $4061872f4932d4d3$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $4061872f4932d4d3$export$bd9f5bcbf9cd947c();
    }
};
const $4061872f4932d4d3$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $lvSIG.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $4061872f4932d4d3$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$4061872f4932d4d3$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $4061872f4932d4d3$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $lvSIG.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});






parcelRegister("3c0lx", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $721cff9168fb9150$export$f1b0c189562aa9fd);

var $2MdED = parcelRequire("2MdED");

var $4TktD = parcelRequire("4TktD");

var $3liKs = parcelRequire("3liKs");

var $9mFsD = parcelRequire("9mFsD");
const $721cff9168fb9150$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $9mFsD.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $3liKs.Status).SUCCESS;
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $3liKs.Status).FAILED;
    }
};

});


parcelRegister("kzObv", function(module, exports) {
var $efae012046e18468$var$namespace = 'expire_mixin';
module.exports = $efae012046e18468$var$expirePlugin;
function $efae012046e18468$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $efae012046e18468$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("c4CII", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $8ca3e4c5fdf5089f$var$slice = $dgvY6.slice;
var $8ca3e4c5fdf5089f$var$pluck = $dgvY6.pluck;
var $8ca3e4c5fdf5089f$var$each = $dgvY6.each;
var $8ca3e4c5fdf5089f$var$bind = $dgvY6.bind;
var $8ca3e4c5fdf5089f$var$create = $dgvY6.create;
var $8ca3e4c5fdf5089f$var$isList = $dgvY6.isList;
var $8ca3e4c5fdf5089f$var$isFunction = $dgvY6.isFunction;
var $8ca3e4c5fdf5089f$var$isObject = $dgvY6.isObject;
module.exports = {
    createStore: $8ca3e4c5fdf5089f$var$createStore
};
var $8ca3e4c5fdf5089f$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $8ca3e4c5fdf5089f$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $8ca3e4c5fdf5089f$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $8ca3e4c5fdf5089f$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $8ca3e4c5fdf5089f$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$8ca3e4c5fdf5089f$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$8ca3e4c5fdf5089f$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $8ca3e4c5fdf5089f$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $8ca3e4c5fdf5089f$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($8ca3e4c5fdf5089f$var$isList(plugin)) {
                $8ca3e4c5fdf5089f$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $8ca3e4c5fdf5089f$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$8ca3e4c5fdf5089f$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$8ca3e4c5fdf5089f$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $8ca3e4c5fdf5089f$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$8ca3e4c5fdf5089f$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $8ca3e4c5fdf5089f$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $8ca3e4c5fdf5089f$var$create(_privateStoreProps, $8ca3e4c5fdf5089f$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $8ca3e4c5fdf5089f$var$each(store, function(prop, propName) {
        if ($8ca3e4c5fdf5089f$var$isFunction(prop)) store.raw[propName] = $8ca3e4c5fdf5089f$var$bind(store, prop);
    });
    $8ca3e4c5fdf5089f$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $8ca3e4c5fdf5089f$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("dgvY6", function(module, exports) {
var $9a85913e079cf886$var$assign = $9a85913e079cf886$var$make_assign();
var $9a85913e079cf886$var$create = $9a85913e079cf886$var$make_create();
var $9a85913e079cf886$var$trim = $9a85913e079cf886$var$make_trim();
var $9a85913e079cf886$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $9a85913e079cf886$var$assign,
    create: $9a85913e079cf886$var$create,
    trim: $9a85913e079cf886$var$trim,
    bind: $9a85913e079cf886$var$bind,
    slice: $9a85913e079cf886$var$slice,
    each: $9a85913e079cf886$var$each,
    map: $9a85913e079cf886$var$map,
    pluck: $9a85913e079cf886$var$pluck,
    isList: $9a85913e079cf886$var$isList,
    isFunction: $9a85913e079cf886$var$isFunction,
    isObject: $9a85913e079cf886$var$isObject,
    Global: $9a85913e079cf886$var$Global
};
function $9a85913e079cf886$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$9a85913e079cf886$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $9a85913e079cf886$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
        return $9a85913e079cf886$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
            F.prototype = obj;
            return $9a85913e079cf886$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $9a85913e079cf886$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $9a85913e079cf886$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $9a85913e079cf886$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $9a85913e079cf886$var$each(obj, fn) {
    $9a85913e079cf886$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $9a85913e079cf886$var$map(obj, fn) {
    var res = $9a85913e079cf886$var$isList(obj) ? [] : {};
    $9a85913e079cf886$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $9a85913e079cf886$var$pluck(obj, fn) {
    if ($9a85913e079cf886$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $9a85913e079cf886$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $9a85913e079cf886$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $9a85913e079cf886$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("4Zgux", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $3a19a6cea530455f$var$Global = $dgvY6.Global;
module.exports = {
    name: 'localStorage',
    read: $3a19a6cea530455f$var$read,
    write: $3a19a6cea530455f$var$write,
    each: $3a19a6cea530455f$var$each,
    remove: $3a19a6cea530455f$var$remove,
    clearAll: $3a19a6cea530455f$var$clearAll
};
function $3a19a6cea530455f$var$localStorage() {
    return $3a19a6cea530455f$var$Global.localStorage;
}
function $3a19a6cea530455f$var$read(key) {
    return $3a19a6cea530455f$var$localStorage().getItem(key);
}
function $3a19a6cea530455f$var$write(key, data) {
    return $3a19a6cea530455f$var$localStorage().setItem(key, data);
}
function $3a19a6cea530455f$var$each(fn) {
    for(var i = $3a19a6cea530455f$var$localStorage().length - 1; i >= 0; i--){
        var key = $3a19a6cea530455f$var$localStorage().key(i);
        fn($3a19a6cea530455f$var$read(key), key);
    }
}
function $3a19a6cea530455f$var$remove(key) {
    return $3a19a6cea530455f$var$localStorage().removeItem(key);
}
function $3a19a6cea530455f$var$clearAll() {
    return $3a19a6cea530455f$var$localStorage().clear();
}

});

parcelRegister("2NjNT", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $208f84ff41bcb720$var$read,
    write: $208f84ff41bcb720$var$write,
    each: $208f84ff41bcb720$var$each,
    remove: $208f84ff41bcb720$var$remove,
    clearAll: $208f84ff41bcb720$var$clearAll
};
var $208f84ff41bcb720$var$memoryStorage = {};
function $208f84ff41bcb720$var$read(key) {
    return $208f84ff41bcb720$var$memoryStorage[key];
}
function $208f84ff41bcb720$var$write(key, data) {
    $208f84ff41bcb720$var$memoryStorage[key] = data;
}
function $208f84ff41bcb720$var$each(callback) {
    for(var key in $208f84ff41bcb720$var$memoryStorage)if ($208f84ff41bcb720$var$memoryStorage.hasOwnProperty(key)) callback($208f84ff41bcb720$var$memoryStorage[key], key);
}
function $208f84ff41bcb720$var$remove(key) {
    delete $208f84ff41bcb720$var$memoryStorage[key];
}
function $208f84ff41bcb720$var$clearAll(key) {
    $208f84ff41bcb720$var$memoryStorage = {};
}

});

parcelRegister("561FV", function(module, exports) {

var $kBZUL = parcelRequire("kBZUL");

var $abMfl = parcelRequire("abMfl");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $3b5ecfeebeaba989$var$has(object, path) {
    return object != null && $abMfl(object, path, $kBZUL);
}
module.exports = $3b5ecfeebeaba989$var$has;

});
parcelRegister("kBZUL", function(module, exports) {
/** Used for built-in method references. */ var $f0174a4434851129$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0174a4434851129$var$hasOwnProperty = $f0174a4434851129$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f0174a4434851129$var$baseHas(object, key) {
    return object != null && $f0174a4434851129$var$hasOwnProperty.call(object, key);
}
module.exports = $f0174a4434851129$var$baseHas;

});


parcelRegister("9SRAA", function(module, exports) {

var $183uB = parcelRequire("183uB");

var $e0aIo = parcelRequire("e0aIo");

var $8pgNR = parcelRequire("8pgNR");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $7322b9dc1e5079b9$var$flatRest(func) {
    return $8pgNR($e0aIo(func, undefined, $183uB), func + '');
}
module.exports = $7322b9dc1e5079b9$var$flatRest;

});

parcelRegister("84Tib", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $5e19965b98ae8a50$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $5e19965b98ae8a50$var$isBoolean(value) {
    return value === true || value === false || $fC1Kz(value) && $beQoo(value) == $5e19965b98ae8a50$var$boolTag;
}
module.exports = $5e19965b98ae8a50$var$isBoolean;

});

parcelRegister("kkzI0", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $89362e0dcef39052$export$c00d22927c60484a);

var $28t7g = parcelRequire("28t7g");
class $89362e0dcef39052$export$c00d22927c60484a extends (0, $28t7g.UFOAbstractExperience) {
}

});

parcelRegister("dMEgP", function(module, exports) {

var $2MIs9 = parcelRequire("2MIs9");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $a08efee9347d14dc$var$values(object) {
    return object == null ? [] : $2MIs9(object, $66FNL(object));
}
module.exports = $a08efee9347d14dc$var$values;

});
parcelRegister("2MIs9", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $20728bee5205c23b$var$baseValues(object, props) {
    return $1nIHN(props, function(key) {
        return object[key];
    });
}
module.exports = $20728bee5205c23b$var$baseValues;

});


parcelRegister("ebyGx", function(module, exports) {

$parcel$export(module.exports, "extract", () => $a53cff7e93c16c2c$export$f9380c9a627682d3, (v) => $a53cff7e93c16c2c$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $a53cff7e93c16c2c$export$98e6a39c04603d36, (v) => $a53cff7e93c16c2c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $a53cff7e93c16c2c$export$fac44ee5b035f737, (v) => $a53cff7e93c16c2c$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $a53cff7e93c16c2c$export$7a5253c0f62e0150, (v) => $a53cff7e93c16c2c$export$7a5253c0f62e0150 = v);
var $a53cff7e93c16c2c$export$f9380c9a627682d3;
var $a53cff7e93c16c2c$export$98e6a39c04603d36;
var $a53cff7e93c16c2c$export$fac44ee5b035f737;
var $a53cff7e93c16c2c$export$7a5253c0f62e0150;
'use strict';

var $b8k6Y = parcelRequire("b8k6Y");

var $9rcQv = parcelRequire("9rcQv");

var $aCrRe = parcelRequire("aCrRe");
function $a53cff7e93c16c2c$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[',
                    $a53cff7e93c16c2c$var$encode(index, opts),
                    ']=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[]=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
    }
}
function $a53cff7e93c16c2c$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $a53cff7e93c16c2c$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $b8k6Y(value) : encodeURIComponent(value);
    return value;
}
function $a53cff7e93c16c2c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $a53cff7e93c16c2c$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $a53cff7e93c16c2c$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $a53cff7e93c16c2c$var$parse(str, opts) {
    opts = $9rcQv({
        arrayFormat: 'none'
    }, opts);
    var formatter = $a53cff7e93c16c2c$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $aCrRe(val);
        formatter($aCrRe(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $a53cff7e93c16c2c$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$a53cff7e93c16c2c$export$f9380c9a627682d3 = $a53cff7e93c16c2c$var$extract;
$a53cff7e93c16c2c$export$98e6a39c04603d36 = $a53cff7e93c16c2c$var$parse;
$a53cff7e93c16c2c$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $9rcQv(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $a53cff7e93c16c2c$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $a53cff7e93c16c2c$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $a53cff7e93c16c2c$var$encode(key, opts) + '=' + $a53cff7e93c16c2c$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$a53cff7e93c16c2c$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $a53cff7e93c16c2c$var$parse($a53cff7e93c16c2c$var$extract(str), opts)
    };
};

});
parcelRegister("b8k6Y", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("9rcQv", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $6df099941a738cfd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6df099941a738cfd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6df099941a738cfd$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $6df099941a738cfd$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $6df099941a738cfd$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $6df099941a738cfd$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $6df099941a738cfd$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($6df099941a738cfd$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($6df099941a738cfd$var$getOwnPropertySymbols) {
            symbols = $6df099941a738cfd$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($6df099941a738cfd$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("21iT5", function(module, exports) {

$parcel$export(module.exports, "choreographerFactory", () => $b2a8b58cd6fe6123$export$55d2aeb17c4cfbe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g3Ayl = parcelRequire("g3Ayl");

var $jMp4p = parcelRequire("jMp4p");

var $8wLMn = parcelRequire("8wLMn");
var $bIQzQ = parcelRequire("bIQzQ");
var $i6lYe = parcelRequire("i6lYe");
var $3dnb0 = parcelRequire("3dnb0");
var $4BgYm = parcelRequire("4BgYm");
var $kVWxi = parcelRequire("kVWxi");
var $kC8XP = parcelRequire("kC8XP");
var $2GVqa = parcelRequire("2GVqa");
var $amcTE = parcelRequire("amcTE");
function $b2a8b58cd6fe6123$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $jMp4p.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $g3Ayl.MessageEventType).START]: startCallback, [(0, $g3Ayl.MessageEventType).STOP]: stopCallback } = {})=>{
        const isMessageStarted = (0, $5uXOq.useRef)(false);
        const startRef = (0, $5uXOq.useRef)(startCallback);
        const stopRef = (0, $5uXOq.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $5uXOq.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId,
            startMessageCallback
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $5uXOq.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $g3Ayl.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $5uXOq.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $5uXOq.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $5uXOq.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $g3Ayl.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $g3Ayl.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $5uXOq.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props)=>{
        return (0, $2GVqa.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $5uXOq.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $8wLMn.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $bIQzQ.Banner));
    const Flag = wrapWithFactoryFunctions((0, $i6lYe.Flag));
    const Modal = wrapWithFactoryFunctions((0, $4BgYm.Modal));
    const Popper = wrapWithFactoryFunctions((0, $kVWxi.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $amcTE.Spotlight));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $3dnb0.InlineDialog));
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kC8XP.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $kC8XP.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight
    };
}

});
parcelRegister("jMp4p", function(module, exports) {

$parcel$export(module.exports, "ProductChoreographerPlugin", () => $b50013a37a9be1a7$export$44bee9c9373d59fb);

var $iJYA2 = parcelRequire("iJYA2");
class $b50013a37a9be1a7$export$44bee9c9373d59fb extends (0, $iJYA2.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("8wLMn", function(module, exports) {

$parcel$export(module.exports, "AutoDismissFlag", () => $d6ba718ffaa9225c$export$9879a8e0db317538);

var $1D5Rp = parcelRequire("1D5Rp");

var $2GVqa = parcelRequire("2GVqa");
const $d6ba718ffaa9225c$export$9879a8e0db317538 = (0, $2GVqa.wrapComponentForChoreographer)((0, $1D5Rp.default));

});

parcelRegister("bIQzQ", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $7bf74dd447369a6d$export$3b4e64e77073e307);

var $9eEJv = parcelRequire("9eEJv");

var $2GVqa = parcelRequire("2GVqa");
const $7bf74dd447369a6d$export$3b4e64e77073e307 = (0, $2GVqa.wrapComponentForChoreographer)((0, $9eEJv.default));

});

parcelRegister("i6lYe", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $8d1db0fb4204717d$export$48ea269755562084);

var $9WdAg = parcelRequire("9WdAg");

var $2GVqa = parcelRequire("2GVqa");
const $8d1db0fb4204717d$export$48ea269755562084 = (0, $2GVqa.wrapComponentForChoreographer)((0, $9WdAg.default));

});

parcelRegister("3dnb0", function(module, exports) {

$parcel$export(module.exports, "InlineDialog", () => $a90224030cd1c5c5$export$c7313f750e9cbc9d);

var $55tuP = parcelRequire("55tuP");

var $2GVqa = parcelRequire("2GVqa");
const $a90224030cd1c5c5$export$c7313f750e9cbc9d = (0, $2GVqa.wrapToggleableComponentForChoreographer)((0, $55tuP.default), 'isOpen');

});

parcelRegister("4BgYm", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $7908807f6d4eab34$export$2b77a92f1a5ad772);

var $hordk = parcelRequire("hordk");

var $2GVqa = parcelRequire("2GVqa");
const $7908807f6d4eab34$export$2b77a92f1a5ad772 = (0, $2GVqa.wrapComponentForChoreographer)((0, $hordk.default));

});

parcelRegister("kVWxi", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $f34265e81fb814bc$export$badac9ada3a0bdf9);

var $e5neF = parcelRequire("e5neF");

var $2GVqa = parcelRequire("2GVqa");
const $f34265e81fb814bc$export$badac9ada3a0bdf9 = (0, $2GVqa.wrapComponentForChoreographer)((0, $e5neF.Popper));

});

parcelRegister("kC8XP", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $f3350dd772dc1c10$export$129a32eedafa97c5);

var $vCqQa = parcelRequire("vCqQa");

var $2GVqa = parcelRequire("2GVqa");
const $f3350dd772dc1c10$export$129a32eedafa97c5 = (0, $2GVqa.wrapToggleableComponentForChoreographer)((0, $vCqQa.Popup), 'isOpen');

});

parcelRegister("amcTE", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $5bc534d216bfb30d$export$1033c28b5e1c2deb);

var $bkS4F = parcelRequire("bkS4F");

var $2GVqa = parcelRequire("2GVqa");
const $5bc534d216bfb30d$export$1033c28b5e1c2deb = (0, $2GVqa.wrapComponentForChoreographer)((0, $bkS4F.default));

});


parcelRegister("dI393", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1o9RP = parcelRequire("1o9RP");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $9fb1d2f148532de5$var$_interopRequireDefault($1o9RP).default;
    }
});
function $9fb1d2f148532de5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("1o9RP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $102fafc31c1e58cf$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
function $102fafc31c1e58cf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $102fafc31c1e58cf$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $102fafc31c1e58cf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $102fafc31c1e58cf$var$NodeResolver = function(_Component) {
    $102fafc31c1e58cf$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $102fafc31c1e58cf$var$_classCallCheck(this, NodeResolver);
        return $102fafc31c1e58cf$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $102fafc31c1e58cf$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $7nsd3.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($5uXOq.Component);
module.exports.default = $102fafc31c1e58cf$var$NodeResolver;

});


parcelRegister("ao4Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ffda35a3cd2a5c$export$2e2bcd8739ae039);

var $cIaXu = parcelRequire("cIaXu");

var $78ffda35a3cd2a5c$export$2e2bcd8739ae039 = (0, $cIaXu.default);

});
parcelRegister("cIaXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9412183d03dc0dc5$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $iK0nX = parcelRequire("iK0nX");

var $1jdvF = parcelRequire("1jdvF");
var $9412183d03dc0dc5$var$FocusLockCombination = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $iK0nX.default), (0, $bS32t.default)({
        sideCar: (0, $1jdvF.default),
        ref: ref
    }, props));
});
var $9412183d03dc0dc5$var$_ref = (0, $iK0nX.default).propTypes || {}, $9412183d03dc0dc5$var$sideCar = $9412183d03dc0dc5$var$_ref.sideCar, $9412183d03dc0dc5$var$propTypes = (0, $ddEsc.default)($9412183d03dc0dc5$var$_ref, [
    "sideCar"
]);
$9412183d03dc0dc5$var$FocusLockCombination.propTypes = {};
var $9412183d03dc0dc5$export$2e2bcd8739ae039 = $9412183d03dc0dc5$var$FocusLockCombination;

});
parcelRegister("iK0nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4cd26ce8b7c545$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");


var $26Cgu = parcelRequire("26Cgu");

var $3Du7S = parcelRequire("3Du7S");

var $hs7HE = parcelRequire("hs7HE");

var $i2hbO = parcelRequire("i2hbO");

var $lTS5V = parcelRequire("lTS5V");
var $da4cd26ce8b7c545$var$emptyArray = [];
var $da4cd26ce8b7c545$var$FocusLock = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $5uXOq.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $5uXOq.useRef();
    var isActive = $5uXOq.useRef(false);
    var originalFocusedElement = $5uXOq.useRef(null);
    var _React$useState2 = $5uXOq.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $da4cd26ce8b7c545$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $5uXOq.useState({}), id = _React$useState3[0];
    var onActivation = $5uXOq.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $5uXOq.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $5uXOq.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $5uXOq.useCallback(function(event) {
        if (isActive.current) (0, $i2hbO.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $i2hbO.mediumBlur).useMedium;
    var setObserveNode = $5uXOq.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $bS32t.default)((_extends2 = {}, _extends2[$26Cgu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$26Cgu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3Du7S.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $5uXOq.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $hs7HE.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $hs7HE.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $5uXOq.createElement(SideCar, {
        id: id,
        sideCar: (0, $i2hbO.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $5uXOq.createElement(Container, (0, $bS32t.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lTS5V.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $hs7HE.hiddenGuard)
    }));
});
$da4cd26ce8b7c545$var$FocusLock.propTypes = {};
var $da4cd26ce8b7c545$export$2e2bcd8739ae039 = $da4cd26ce8b7c545$var$FocusLock;

});
parcelRegister("26Cgu", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $1889d2ef999b3988$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $1889d2ef999b3988$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $1889d2ef999b3988$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $1889d2ef999b3988$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $1889d2ef999b3988$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $1889d2ef999b3988$export$4f9a06cb7441a087 = 'data-focus-lock';
var $1889d2ef999b3988$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $1889d2ef999b3988$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $1889d2ef999b3988$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $1889d2ef999b3988$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("3Du7S", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $2a5c6201d8713c67$export$74665b213cb5c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $dv0OY = parcelRequire("dv0OY");

var $5Gf1j = parcelRequire("5Gf1j");
const $2a5c6201d8713c67$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
const $2a5c6201d8713c67$var$currentValues = new WeakMap();
function $2a5c6201d8713c67$export$74665b213cb5c4cf(refs, defaultValue) {
    const callbackRef = (0, $5Gf1j.useCallbackRef)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
    // handle refs changes - added or removed
    $2a5c6201d8713c67$var$useIsomorphicLayoutEffect(()=>{
        const oldValue = $2a5c6201d8713c67$var$currentValues.get(callbackRef);
        if (oldValue) {
            const prevRefs = new Set(oldValue);
            const nextRefs = new Set(refs);
            const current = callbackRef.current;
            prevRefs.forEach((ref)=>{
                if (!nextRefs.has(ref)) (0, $dv0OY.assignRef)(ref, null);
            });
            nextRefs.forEach((ref)=>{
                if (!prevRefs.has(ref)) (0, $dv0OY.assignRef)(ref, current);
            });
        }
        $2a5c6201d8713c67$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dv0OY", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9d3eceb3bd1bde87$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9d3eceb3bd1bde87$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("5Gf1j", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $422c86adb7367c4f$export$25bec8c6f54ee79a);

var $5uXOq = parcelRequire("5uXOq");
function $422c86adb7367c4f$export$25bec8c6f54ee79a(initialValue, callback) {
    const [ref] = (0, $5uXOq.useState)(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("hs7HE", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $cb4b06d97dec25c1$export$b8c7b07253306600);

var $5uXOq = parcelRequire("5uXOq");

var $cb4b06d97dec25c1$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $cb4b06d97dec25c1$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cb4b06d97dec25c1$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cb4b06d97dec25c1$export$b8c7b07253306600
    }));
};
$cb4b06d97dec25c1$var$InFocusGuard.propTypes = {};
var $cb4b06d97dec25c1$export$2e2bcd8739ae039 = $cb4b06d97dec25c1$var$InFocusGuard;

});

parcelRegister("i2hbO", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $d215bf5dba6c52c4$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $d215bf5dba6c52c4$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $d215bf5dba6c52c4$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $d215bf5dba6c52c4$export$892cbf28e5518020);

var $bzFTo = parcelRequire("bzFTo");
var $d215bf5dba6c52c4$export$5733e022b1d538cb = (0, $bzFTo.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $d215bf5dba6c52c4$export$b3e9a9312f73723c = (0, $bzFTo.createMedium)();
var $d215bf5dba6c52c4$export$3a1d52767cbc07b8 = (0, $bzFTo.createMedium)();
var $d215bf5dba6c52c4$export$892cbf28e5518020 = (0, $bzFTo.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("bzFTo", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $86d3758a1af7e127$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $86d3758a1af7e127$export$e13ec7dd7a14088d);
function $86d3758a1af7e127$var$ItoI(a) {
    return a;
}
function $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
    let buffer = [];
    let assigned = false;
    const medium = {
        read () {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium (data) {
            const item = middleware(data, assigned);
            buffer.push(item);
            return ()=>{
                buffer = buffer.filter((x)=>x !== item);
            };
        },
        assignSyncMedium (cb) {
            assigned = true;
            while(buffer.length){
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: (x)=>cb(x),
                filter: ()=>buffer
            };
        },
        assignMedium (cb) {
            assigned = true;
            let pendingQueue = [];
            if (buffer.length) {
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            const executeQueue = ()=>{
                const cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            const cycle = ()=>Promise.resolve().then(executeQueue);
            cycle();
            buffer = {
                push: (x)=>{
                    pendingQueue.push(x);
                    cycle();
                },
                filter: (filter)=>{
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $86d3758a1af7e127$export$9ffbfcaf067b02c6(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
    return $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware);
}
function $86d3758a1af7e127$export$e13ec7dd7a14088d(options = {}) {
    const medium = $86d3758a1af7e127$var$innerCreateMedium(null);
    medium.options = {
        async: true,
        ssr: false,
        ...options
    };
    return medium;
}

});


parcelRegister("lTS5V", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $ff18b21b414ba800$export$f5272e9b1168239c);

var $5uXOq = parcelRequire("5uXOq");
var $ff18b21b414ba800$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("1jdvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f420b8ec0f9848e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $6mqio = parcelRequire("6mqio");

var $j4988 = parcelRequire("j4988");
var $2RQOj = parcelRequire("2RQOj");
var $1q0r0 = parcelRequire("1q0r0");
var $5x9g9 = parcelRequire("5x9g9");
var $jl7aa = parcelRequire("jl7aa");parcelRequire("cCk2L");
var $9wlSW = parcelRequire("9wlSW");

var $1mLS6 = parcelRequire("1mLS6");

var $i2hbO = parcelRequire("i2hbO");
var $0f420b8ec0f9848e$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $0f420b8ec0f9848e$var$isFreeFocus = function isFreeFocus() {
    return $0f420b8ec0f9848e$var$focusOnBody() || (0, $jl7aa.focusIsHidden)();
};
var $0f420b8ec0f9848e$var$lastActiveTrap = null;
var $0f420b8ec0f9848e$var$lastActiveFocus = null;
var $0f420b8ec0f9848e$var$lastPortaledElement = null;
var $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
var $0f420b8ec0f9848e$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $0f420b8ec0f9848e$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($0f420b8ec0f9848e$var$lastActiveTrap.whiteList || $0f420b8ec0f9848e$var$defaultWhitelist)(activeElement);
};
var $0f420b8ec0f9848e$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $0f420b8ec0f9848e$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $0f420b8ec0f9848e$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement === element;
};
function $0f420b8ec0f9848e$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $0f420b8ec0f9848e$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($0f420b8ec0f9848e$var$focusWasOutsideWindow);
    return $0f420b8ec0f9848e$var$focusWasOutsideWindow === 'meanwhile';
};
var $0f420b8ec0f9848e$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $0f420b8ec0f9848e$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $0f420b8ec0f9848e$var$checkInHost(activeElement, area, area);
    });
};
var $0f420b8ec0f9848e$var$activateTrap = function activateTrap() {
    var result = false;
    if ($0f420b8ec0f9848e$var$lastActiveTrap) {
        var _lastActiveTrap = $0f420b8ec0f9848e$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $1mLS6.extractRef)).filter(Boolean));
            if (!activeElement || $0f420b8ec0f9848e$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $0f420b8ec0f9848e$var$focusWasOutside(crossFrame) || !$0f420b8ec0f9848e$var$isFreeFocus() || !$0f420b8ec0f9848e$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $5x9g9.focusInside)(workingArea) || activeElement && $0f420b8ec0f9848e$var$withinHost(activeElement, workingArea) || $0f420b8ec0f9848e$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$0f420b8ec0f9848e$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9wlSW.moveFocusInside)(workingArea, $0f420b8ec0f9848e$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $0f420b8ec0f9848e$var$lastPortaledElement = {};
                        }
                    }
                    $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
                    $0f420b8ec0f9848e$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2RQOj.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $0f420b8ec0f9848e$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $0f420b8ec0f9848e$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $0f420b8ec0f9848e$var$onTrap = function onTrap(event) {
    if ($0f420b8ec0f9848e$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $0f420b8ec0f9848e$var$onBlur = function onBlur() {
    return (0, $1mLS6.deferAction)($0f420b8ec0f9848e$var$activateTrap);
};
var $0f420b8ec0f9848e$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $0f420b8ec0f9848e$var$recordPortal(currentNode, source);
};
var $0f420b8ec0f9848e$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $0f420b8ec0f9848e$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        onBlur: $0f420b8ec0f9848e$var$onBlur,
        onFocus: $0f420b8ec0f9848e$var$onFocus
    }, children);
};
$0f420b8ec0f9848e$var$FocusTrap.propTypes = {};
var $0f420b8ec0f9848e$var$onWindowBlur = function onWindowBlur() {
    $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'just';
    (0, $1mLS6.deferAction)(function() {
        $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $0f420b8ec0f9848e$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
    document.addEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
    window.addEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
};
var $0f420b8ec0f9848e$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
    document.removeEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
    window.removeEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
};
function $0f420b8ec0f9848e$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $0f420b8ec0f9848e$var$focusLockAPI = {
    moveFocusInside: (0, $9wlSW.moveFocusInside),
    focusInside: (0, $5x9g9.focusInside),
    focusNextElement: (0, $1q0r0.focusNextElement),
    focusPrevElement: (0, $1q0r0.focusPrevElement),
    focusFirstElement: (0, $1q0r0.focusFirstElement),
    focusLastElement: (0, $1q0r0.focusLastElement),
    captureFocusRestore: (0, $j4988.captureFocusRestore)
};
function $0f420b8ec0f9848e$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$0f420b8ec0f9848e$var$lastActiveTrap) $0f420b8ec0f9848e$var$attachHandler();
    var lastTrap = $0f420b8ec0f9848e$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $0f420b8ec0f9848e$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $0f420b8ec0f9848e$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($0f420b8ec0f9848e$var$focusLockAPI);
        $0f420b8ec0f9848e$var$activateTrap(true);
        (0, $1mLS6.deferAction)($0f420b8ec0f9848e$var$activateTrap);
    } else {
        $0f420b8ec0f9848e$var$detachHandler();
        $0f420b8ec0f9848e$var$lastActiveFocus = null;
    }
}
(0, $i2hbO.mediumFocus).assignSyncMedium($0f420b8ec0f9848e$var$onFocus);
(0, $i2hbO.mediumBlur).assignMedium($0f420b8ec0f9848e$var$onBlur);
(0, $i2hbO.mediumEffect).assignMedium(function(cb) {
    return cb($0f420b8ec0f9848e$var$focusLockAPI);
});
var $0f420b8ec0f9848e$export$2e2bcd8739ae039 = (0, $6mqio.default)($0f420b8ec0f9848e$var$reducePropsToState, $0f420b8ec0f9848e$var$handleStateChangeOnClient)($0f420b8ec0f9848e$var$FocusWatcher);

});
parcelRegister("6mqio", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1931e6e98edb22$export$2e2bcd8739ae039);

var $2jS8g = parcelRequire("2jS8g");

var $eHiP8 = parcelRequire("eHiP8");

var $5uXOq = parcelRequire("5uXOq");
function $4a1931e6e98edb22$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $2jS8g.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $5uXOq.PureComponent));
        (0, $eHiP8.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $4a1931e6e98edb22$export$2e2bcd8739ae039 = $4a1931e6e98edb22$var$withSideEffect;

});
parcelRegister("eHiP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab33aeddc06e5aed$export$2e2bcd8739ae039);

var $586Rz = parcelRequire("586Rz");
function $ab33aeddc06e5aed$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $586Rz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("586Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc305fa7a392472$export$2e2bcd8739ae039);

var $eKtAb = parcelRequire("eKtAb");

var $kGKYI = parcelRequire("kGKYI");
function $3bc305fa7a392472$export$2e2bcd8739ae039(t) {
    var i = (0, $kGKYI.default)(t, "string");
    return "symbol" == (0, $eKtAb.default)(i) ? i : i + "";
}

});
parcelRegister("eKtAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcc4f12e9e8c580$export$2e2bcd8739ae039);
function $abcc4f12e9e8c580$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $abcc4f12e9e8c580$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $abcc4f12e9e8c580$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kGKYI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0fc2bce6211f5a4$export$2e2bcd8739ae039);

var $eKtAb = parcelRequire("eKtAb");
function $f0fc2bce6211f5a4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $eKtAb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $eKtAb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("j4988", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", () => $de15791afd27bb83$export$d357db6e554ff59a);

var $l1lpg = parcelRequire("l1lpg");
function $de15791afd27bb83$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $de15791afd27bb83$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $de15791afd27bb83$var$weakRef(currentElement),
            parent: $de15791afd27bb83$var$weakRef(currentElement.parentElement),
            left: $de15791afd27bb83$var$weakRef(currentElement.previousElementSibling),
            right: $de15791afd27bb83$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $de15791afd27bb83$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $de15791afd27bb83$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $l1lpg.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $de15791afd27bb83$export$d357db6e554ff59a = function(targetElement) {
    var location = $de15791afd27bb83$export$5061a7725be48ff9(targetElement);
    return function() {
        return $de15791afd27bb83$var$restoreFocusTo(location);
    };
};

});
parcelRegister("l1lpg", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $03f3013918b31c29$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $03f3013918b31c29$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $03f3013918b31c29$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $03f3013918b31c29$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $03f3013918b31c29$export$2344b14b097df817);

var $649lM = parcelRequire("649lM");

var $jlIIa = parcelRequire("jlIIa");

var $hPwd3 = parcelRequire("hPwd3");

var $detSP = parcelRequire("detSP");
var $03f3013918b31c29$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $649lM.toArray)(nodes).filter(function(node) {
        return (0, $jlIIa.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $jlIIa.notHiddenInput)(node);
    });
};
var $03f3013918b31c29$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $649lM.toArray)(nodes).filter(function(node) {
        return (0, $jlIIa.isAutoFocusAllowedCached)(cache, node);
    });
};
var $03f3013918b31c29$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $hPwd3.orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $03f3013918b31c29$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $hPwd3.orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getFocusables)(topNodes), visibilityCache), false);
};
var $03f3013918b31c29$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getParentAutofocusables)(topNode), visibilityCache);
};
var $03f3013918b31c29$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $03f3013918b31c29$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $649lM.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $03f3013918b31c29$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $03f3013918b31c29$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("649lM", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $46aa5e8f7fb698d8$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $46aa5e8f7fb698d8$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $46aa5e8f7fb698d8$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $46aa5e8f7fb698d8$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $46aa5e8f7fb698d8$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $46aa5e8f7fb698d8$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("jlIIa", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $e162a936fc2d012a$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $e162a936fc2d012a$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $e162a936fc2d012a$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $e162a936fc2d012a$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $e162a936fc2d012a$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $e162a936fc2d012a$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $e162a936fc2d012a$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $e162a936fc2d012a$export$4e62c701997796c1);

var $26Cgu = parcelRequire("26Cgu");
var $e162a936fc2d012a$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $e162a936fc2d012a$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $e162a936fc2d012a$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $e162a936fc2d012a$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $e162a936fc2d012a$var$isVisibleUncached = function(node, checkParent) {
    return !node || $e162a936fc2d012a$var$isTopNode(node) || !$e162a936fc2d012a$var$isElementHidden(node) && !$e162a936fc2d012a$var$isInert(node) && checkParent($e162a936fc2d012a$var$getParentNode(node));
};
var $e162a936fc2d012a$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $e162a936fc2d012a$var$isVisibleUncached(node, $e162a936fc2d012a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $e162a936fc2d012a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$e162a936fc2d012a$var$isTopNode(node) ? $e162a936fc2d012a$export$b8550e27de209d85(node) ? checkParent($e162a936fc2d012a$var$getParentNode(node)) : false : true;
};
var $e162a936fc2d012a$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $e162a936fc2d012a$var$isAutoFocusAllowedUncached(node, $e162a936fc2d012a$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $e162a936fc2d012a$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $e162a936fc2d012a$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $e162a936fc2d012a$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $e162a936fc2d012a$export$9d74f6fbc6f469d0 = function(node) {
    return $e162a936fc2d012a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $e162a936fc2d012a$export$8197b0ea56b3b055 = function(node) {
    return !(($e162a936fc2d012a$export$88a6ceeed5737ba3(node) || $e162a936fc2d012a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $e162a936fc2d012a$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $26Cgu.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $e162a936fc2d012a$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $e162a936fc2d012a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $e162a936fc2d012a$export$602e5a0d338d7750 = function(node) {
    return !$e162a936fc2d012a$export$d94b8b58ec2f30eb(node);
};
var $e162a936fc2d012a$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("hPwd3", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $cfb02f3dbbab37c3$export$cb40ee071f0d5226);

var $649lM = parcelRequire("649lM");
var $cfb02f3dbbab37c3$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $cfb02f3dbbab37c3$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $cfb02f3dbbab37c3$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $649lM.toArray)(nodes).map(function(node, index) {
        var tabIndex = $cfb02f3dbbab37c3$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($cfb02f3dbbab37c3$export$350ee6c095d98996);
};

});

parcelRegister("detSP", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $9a23c35cb23add47$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $9a23c35cb23add47$export$853fa94d922e78b9);

var $26Cgu = parcelRequire("26Cgu");

var $649lM = parcelRequire("649lM");

var $h8JFa = parcelRequire("h8JFa");
var $9a23c35cb23add47$var$queryTabbables = (0, $h8JFa.tabbables).join(',');
var $9a23c35cb23add47$var$queryGuardTabbables = "".concat($9a23c35cb23add47$var$queryTabbables, ", [data-focus-guard]");
var $9a23c35cb23add47$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $649lM.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $9a23c35cb23add47$var$queryGuardTabbables : $9a23c35cb23add47$var$queryTabbables) ? [
            child
        ] : [], $9a23c35cb23add47$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $9a23c35cb23add47$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $9a23c35cb23add47$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $9a23c35cb23add47$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $9a23c35cb23add47$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $9a23c35cb23add47$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $649lM.toArray)(parent.parentNode.querySelectorAll($9a23c35cb23add47$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $9a23c35cb23add47$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $26Cgu.FOCUS_AUTO), "]"));
    return (0, $649lM.toArray)(parentFocus).map(function(node) {
        return $9a23c35cb23add47$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("h8JFa", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $c7a69abaf19a3f41$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $c7a69abaf19a3f41$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("2RQOj", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", () => $21697f119bba8faa$export$f89ac71e91767111);

var $1kBVR = parcelRequire("1kBVR");

var $jlIIa = parcelRequire("jlIIa");

var $3jtrL = parcelRequire("3jtrL");

var $hPwd3 = parcelRequire("hPwd3");

var $detSP = parcelRequire("detSP");
var $21697f119bba8faa$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $1kBVR.getAllAffectedNodes)(topNode).filter((0, $jlIIa.isNotAGuard));
    var commonParent = (0, $3jtrL.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $hPwd3.orderByTabIndex)((0, $detSP.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $detSP.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $jlIIa.isGuard)(node)
        };
    });
};

});
parcelRegister("1kBVR", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $0f851546d68da0ab$export$7e87c4720b9b279b);

var $26Cgu = parcelRequire("26Cgu");

var $649lM = parcelRequire("649lM");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $0f851546d68da0ab$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $0f851546d68da0ab$var$getTopParent = function(node) {
    return node.parentNode ? $0f851546d68da0ab$var$getTopParent(node.parentNode) : node;
};
var $0f851546d68da0ab$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $649lM.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $26Cgu.FOCUS_GROUP));
        acc.push.apply(acc, group ? $0f851546d68da0ab$var$filterNested((0, $649lM.toArray)($0f851546d68da0ab$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $26Cgu.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $26Cgu.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("3jtrL", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $2699fcfa1a3b19bb$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $2699fcfa1a3b19bb$export$8f99714c70a37db1);

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");
var $2699fcfa1a3b19bb$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $2699fcfa1a3b19bb$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $2699fcfa1a3b19bb$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $2699fcfa1a3b19bb$var$getParents(nodeA);
    var parentsB = $2699fcfa1a3b19bb$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $2699fcfa1a3b19bb$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $649lM.asArray)(baseActiveElement);
    var leftEntries = (0, $649lM.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $2699fcfa1a3b19bb$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $l1lpg.contains)(common, topCommon)) topCommon = common;
                else topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $2699fcfa1a3b19bb$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $l1lpg.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("1q0r0", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", () => $10888e6d50ae918b$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $10888e6d50ae918b$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $10888e6d50ae918b$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $10888e6d50ae918b$export$6a79073ddabfd6c3);

var $jfQb7 = parcelRequire("jfQb7");

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");
var $10888e6d50ae918b$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $649lM.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $l1lpg.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $l1lpg.getTabbableNodes)(shards, new Map()) : (0, $l1lpg.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $10888e6d50ae918b$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $l1lpg.getTabbableNodes)((0, $649lM.asArray)(shards), new Map()) : (0, $l1lpg.getFocusableNodes)((0, $649lM.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $10888e6d50ae918b$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $10888e6d50ae918b$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $10888e6d50ae918b$var$defaultOptions(options);
    var solution = $10888e6d50ae918b$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $jfQb7.focusOn)(target.node, newOptions.focusOptions);
};
var $10888e6d50ae918b$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $10888e6d50ae918b$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $10888e6d50ae918b$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $10888e6d50ae918b$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $jfQb7.focusOn)(node.node, options.focusOptions);
};
var $10888e6d50ae918b$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$pickBoundary(scope, options, 'first');
};
var $10888e6d50ae918b$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("jfQb7", function(module, exports) {

$parcel$export(module.exports, "focusOn", () => $e047e48fcca0b3b0$export$c12b3da842c43a8);
var $e047e48fcca0b3b0$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("5x9g9", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $4077379349d4c74a$export$20115f8da7baa6fa);

var $l1lpg = parcelRequire("l1lpg");

var $1kBVR = parcelRequire("1kBVR");

var $649lM = parcelRequire("649lM");

var $33cOt = parcelRequire("33cOt");
var $4077379349d4c74a$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $4077379349d4c74a$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $649lM.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $4077379349d4c74a$var$focusInFrame(node, activeElement);
    }));
};
var $4077379349d4c74a$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $33cOt.getActiveElement)((0, $649lM.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $1kBVR.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $l1lpg.contains)(node, activeElement) || $4077379349d4c74a$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("33cOt", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $238b9756ed43b48b$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $513Q1 = parcelRequire("513Q1");
var $238b9756ed43b48b$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $513Q1.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("513Q1", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $3a7005e711f25367$export$78d20aae35adef88);
var $3a7005e711f25367$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("jl7aa", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $e14588ebb2dd3a92$export$be6b21806d3fd485);

var $26Cgu = parcelRequire("26Cgu");

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");

var $33cOt = parcelRequire("33cOt");
var $e14588ebb2dd3a92$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $33cOt.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $649lM.toArray)(inDocument.querySelectorAll("[".concat((0, $26Cgu.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $l1lpg.contains)(node, activeElement);
    });
};

});

parcelRegister("cCk2L", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("9wlSW")).moveFocusInside);

var $26Cgu = parcelRequire("26Cgu");

var $5x9g9 = parcelRequire("5x9g9");

var $jl7aa = parcelRequire("jl7aa");


var $2RQOj = parcelRequire("2RQOj");

var $9wlSW = parcelRequire("9wlSW");

var $j4988 = parcelRequire("j4988");

var $1q0r0 = parcelRequire("1q0r0");

var $l1lpg = parcelRequire("l1lpg");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $92f894e236277f1c$export$1a988e7317c65621 = $26Cgu;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $92f894e236277f1c$var$deprecated_default_moveFocusInside = (0, $9wlSW.moveFocusInside);
var $92f894e236277f1c$export$2e2bcd8739ae039 //
 = $92f894e236277f1c$var$deprecated_default_moveFocusInside;

});
parcelRegister("9wlSW", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => $6ee8142619db9ef1$export$cd599851e879a025);

var $jfQb7 = parcelRequire("jfQb7");

var $kKJqK = parcelRequire("kKJqK");
var $6ee8142619db9ef1$var$guardCount = 0;
var $6ee8142619db9ef1$var$lockDisabled = false;
var $6ee8142619db9ef1$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $kKJqK.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($6ee8142619db9ef1$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($6ee8142619db9ef1$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $6ee8142619db9ef1$var$lockDisabled = true;
            setTimeout(function() {
                $6ee8142619db9ef1$var$lockDisabled = false;
            }, 1);
            return;
        }
        $6ee8142619db9ef1$var$guardCount++;
        (0, $jfQb7.focusOn)(focusable.node, options.focusOptions);
        $6ee8142619db9ef1$var$guardCount--;
    }
};

});
parcelRegister("kKJqK", function(module, exports) {

$parcel$export(module.exports, "focusSolver", () => $f1bb580dea56dbbd$export$305758c744b57f6f);

var $6e7nq = parcelRequire("6e7nq");

var $l1lpg = parcelRequire("l1lpg");

var $1kBVR = parcelRequire("1kBVR");

var $649lM = parcelRequire("649lM");

var $6QUqp = parcelRequire("6QUqp");

var $33cOt = parcelRequire("33cOt");

var $jlIIa = parcelRequire("jlIIa");

var $3jtrL = parcelRequire("3jtrL");
var $f1bb580dea56dbbd$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $jlIIa.isDefined));
};
var $f1bb580dea56dbbd$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $33cOt.getActiveElement)((0, $649lM.asArray)(topNode).length > 0 ? document : (0, $649lM.getFirst)(topNode).ownerDocument);
    var entries = (0, $1kBVR.getAllAffectedNodes)(topNode).filter((0, $jlIIa.isNotAGuard));
    var commonParent = (0, $3jtrL.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $l1lpg.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $jlIIa.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $l1lpg.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $f1bb580dea56dbbd$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $6e7nq.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $6e7nq.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $6QUqp.pickAutofocus)(anyFocusable, innerTabbable, (0, $3jtrL.allParentAutofocusables)(entries, visibilityCache)) || (0, $6QUqp.pickAutofocus)(anyFocusable, innerFocusables, (0, $3jtrL.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("6e7nq", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $4889c5c91be25c0a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $4889c5c91be25c0a$export$65842178e9bb4205);

var $2aoIt = parcelRequire("2aoIt");

var $ee0vg = parcelRequire("ee0vg");

var $jlIIa = parcelRequire("jlIIa");
var $4889c5c91be25c0a$export$85710b12cf912438 = 'NEW_FOCUS';
var $4889c5c91be25c0a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $jlIIa.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $4889c5c91be25c0a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $4889c5c91be25c0a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $2aoIt.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $ee0vg.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $ee0vg.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("2aoIt", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $193fb011be33b1b6$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $193fb011be33b1b6$export$4a5a72a7124e45f9);

var $jlIIa = parcelRequire("jlIIa");
var $193fb011be33b1b6$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $jlIIa.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $193fb011be33b1b6$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $jlIIa.isRadioElement)(node) && node.name) return $193fb011be33b1b6$var$findSelectedRadio(node, nodes);
    return node;
};
var $193fb011be33b1b6$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($193fb011be33b1b6$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("ee0vg", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $a5b2c367f9c3daa0$export$e06728ee87c96122);

var $2aoIt = parcelRequire("2aoIt");
var $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $2aoIt.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $a5b2c367f9c3daa0$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $2aoIt.correctNode)(node, nodes));
};

});


parcelRegister("6QUqp", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $4fd35e3fd3ef884c$export$cfb742983e257555);

var $l1lpg = parcelRequire("l1lpg");

var $ee0vg = parcelRequire("ee0vg");

var $jlIIa = parcelRequire("jlIIa");
var $4fd35e3fd3ef884c$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $jlIIa.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $4fd35e3fd3ef884c$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $l1lpg.filterAutoFocusable)(nodes.filter($4fd35e3fd3ef884c$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $ee0vg.pickFirstFocus)(autoFocusable);
    return (0, $ee0vg.pickFirstFocus)((0, $l1lpg.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("1mLS6", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $0fecfad02351d8b0$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $0fecfad02351d8b0$export$c613fed06e332533);
function $0fecfad02351d8b0$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $0fecfad02351d8b0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $0fecfad02351d8b0$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("cwc7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $91d1df2d50ef438b$export$2e2bcd8739ae039);

var $iK0nX = parcelRequire("iK0nX");






var $91d1df2d50ef438b$export$2e2bcd8739ae039 = (0, $iK0nX.default);

});

parcelRegister("2alJM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dejU7 = parcelRequire("dejU7");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $193d608c8a4c8c43$var$_interopRequireDefault($dejU7).default;
    }
});

var $fUXdf = parcelRequire("fUXdf");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $fUXdf.TouchScrollable;
    }
});
function $193d608c8a4c8c43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("dejU7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9a1c05b159231ce4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $9a1c05b159231ce4$var$_react2 = $9a1c05b159231ce4$var$_interopRequireDefault($5uXOq);

var $lv4Ny = parcelRequire("lv4Ny");

var $fUXdf = parcelRequire("fUXdf");

var $bdRWg = parcelRequire("bdRWg");
var $9a1c05b159231ce4$var$_withLockSheet2 = $9a1c05b159231ce4$var$_interopRequireDefault($bdRWg);

var $fjsmD = parcelRequire("fjsmD");
var $9a1c05b159231ce4$var$_withTouchListeners2 = $9a1c05b159231ce4$var$_interopRequireDefault($fjsmD);

var $1sALq = parcelRequire("1sALq");
function $9a1c05b159231ce4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a1c05b159231ce4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a1c05b159231ce4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9a1c05b159231ce4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9a1c05b159231ce4$var$ScrollLock = function(_PureComponent) {
    $9a1c05b159231ce4$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $9a1c05b159231ce4$var$_classCallCheck(this, ScrollLock);
        return $9a1c05b159231ce4$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $9a1c05b159231ce4$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lv4Ny.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $9a1c05b159231ce4$var$_react2.default.createElement($fUXdf.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($5uXOq.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $9a1c05b159231ce4$var$compose = (0, $1sALq.pipe)($9a1c05b159231ce4$var$_withTouchListeners2.default, $9a1c05b159231ce4$var$_withLockSheet2.default);
var $9a1c05b159231ce4$var$SheetLock = $9a1c05b159231ce4$var$compose($9a1c05b159231ce4$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $9a1c05b159231ce4$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $9a1c05b159231ce4$var$_react2.default.createElement($9a1c05b159231ce4$var$SheetLock, props) : props.children;
};
$9a1c05b159231ce4$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $9a1c05b159231ce4$var$LockToggle;

});
parcelRegister("lv4Ny", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("fUXdf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $b96a046705879057$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b96a046705879057$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $1sALq = parcelRequire("1sALq");
function $b96a046705879057$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $b96a046705879057$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b96a046705879057$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b96a046705879057$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b96a046705879057$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $b96a046705879057$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $b96a046705879057$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b96a046705879057$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $b96a046705879057$var$_possibleConstructorReturn(_this, _ret);
    }
    $b96a046705879057$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lv4Ny.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$lv4Ny.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $b96a046705879057$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $5uXOq.cloneElement)(children, $b96a046705879057$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($5uXOq.PureComponent);

});
parcelRegister("1sALq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $1104ec85449a533c$var$preventTouchMove;
module.exports.allowTouchMove = $1104ec85449a533c$var$allowTouchMove;
module.exports.preventInertiaScroll = $1104ec85449a533c$var$preventInertiaScroll;
module.exports.isTouchDevice = $1104ec85449a533c$var$isTouchDevice;
module.exports.camelToKebab = $1104ec85449a533c$var$camelToKebab;
module.exports.parse = $1104ec85449a533c$var$parse;
module.exports.getPadding = $1104ec85449a533c$var$getPadding;
module.exports.getWindowHeight = $1104ec85449a533c$var$getWindowHeight;
module.exports.getDocumentHeight = $1104ec85449a533c$var$getDocumentHeight;
module.exports.makeStyleTag = $1104ec85449a533c$var$makeStyleTag;
module.exports.injectStyles = $1104ec85449a533c$var$injectStyles;
module.exports.insertStyleTag = $1104ec85449a533c$var$insertStyleTag;

var $lv4Ny = parcelRequire("lv4Ny");
var $1104ec85449a533c$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $1104ec85449a533c$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $1104ec85449a533c$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $1104ec85449a533c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $1104ec85449a533c$var$isTouchDevice() {
    if (!$lv4Ny.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $1104ec85449a533c$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $1104ec85449a533c$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $1104ec85449a533c$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $1104ec85449a533c$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($1104ec85449a533c$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $1104ec85449a533c$var$getPadding() {
    if (!$lv4Ny.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $1104ec85449a533c$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($lv4Ny.canUseDOM) return window.innerHeight * multiplier;
}
function $1104ec85449a533c$var$getDocumentHeight() {
    if ($lv4Ny.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $1104ec85449a533c$var$makeStyleTag() {
    if (!$lv4Ny.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $1104ec85449a533c$var$injectStyles(tag, css) {
    if (!$lv4Ny.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $1104ec85449a533c$var$insertStyleTag(tag) {
    if (!$lv4Ny.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("bdRWg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $82babfbe1d9118db$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $82babfbe1d9118db$var$withLockSheet;

var $5uXOq = parcelRequire("5uXOq");
var $82babfbe1d9118db$var$_react2 = $82babfbe1d9118db$var$_interopRequireDefault($5uXOq);

var $1sALq = parcelRequire("1sALq");
function $82babfbe1d9118db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82babfbe1d9118db$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82babfbe1d9118db$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $82babfbe1d9118db$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $82babfbe1d9118db$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $82babfbe1d9118db$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $82babfbe1d9118db$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $82babfbe1d9118db$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $1sALq.makeStyleTag)();
                if (!sheet) return;
                (0, $1sALq.injectStyles)(sheet, styles);
                (0, $1sALq.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $1sALq.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $1sALq.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $82babfbe1d9118db$var$_possibleConstructorReturn(_this, _ret);
        }
        $82babfbe1d9118db$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $82babfbe1d9118db$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($5uXOq.PureComponent);
}

});

parcelRegister("fjsmD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b25ea1e2c8dc8373$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $b25ea1e2c8dc8373$var$withTouchListeners;

var $5uXOq = parcelRequire("5uXOq");
var $b25ea1e2c8dc8373$var$_react2 = $b25ea1e2c8dc8373$var$_interopRequireDefault($5uXOq);

var $lv4Ny = parcelRequire("lv4Ny");

var $1sALq = parcelRequire("1sALq");
function $b25ea1e2c8dc8373$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b25ea1e2c8dc8373$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b25ea1e2c8dc8373$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b25ea1e2c8dc8373$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $b25ea1e2c8dc8373$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $b25ea1e2c8dc8373$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $b25ea1e2c8dc8373$var$_classCallCheck(this, TouchProvider);
            return $b25ea1e2c8dc8373$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $b25ea1e2c8dc8373$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $b25ea1e2c8dc8373$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($5uXOq.PureComponent);
}

});



parcelRegister("aSMdt", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("bwkeO")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("bwkeO")).dropTargetForExternal);

var $bwkeO = parcelRequire("bwkeO");

});
parcelRegister("bwkeO", function(module, exports) {

$parcel$export(module.exports, "dropTargetForExternal", () => $a5acf0b21110e72b$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $a5acf0b21110e72b$export$bb1740f3194979c1);

var $cBeZP = parcelRequire("cBeZP");

var $4lzkI = parcelRequire("4lzkI");

var $igzgy = parcelRequire("igzgy");

var $mdAYv = parcelRequire("mdAYv");

var $iDg6w = parcelRequire("iDg6w");


function $a5acf0b21110e72b$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $920cfea877448e3c$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $0f2008b98bd58844$export$fd3d00026297c0ad) && value === (0, $igzgy.androidFallbackText)) return false;
    return true;
}
function $a5acf0b21110e72b$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$a5acf0b21110e72b$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $a5acf0b21110e72b$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $a5acf0b21110e72b$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $a5acf0b21110e72b$var$didDragStartLocally = false;
const $a5acf0b21110e72b$var$adapter = (0, $4lzkI.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $cBeZP.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($a5acf0b21110e72b$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $mdAYv.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $a5acf0b21110e72b$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $a5acf0b21110e72b$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$a5acf0b21110e72b$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $a5acf0b21110e72b$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $a5acf0b21110e72b$var$adapter.dropTarget(args);
}
function $a5acf0b21110e72b$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $a5acf0b21110e72b$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $a5acf0b21110e72b$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $a5acf0b21110e72b$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $cBeZP.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $iDg6w.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $cBeZP.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $a5acf0b21110e72b$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("mdAYv", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", () => $f7579bfd67bbf413$export$d1c6f249e893cdf4);

var $68Vbj = parcelRequire("68Vbj");

var $374Vm = parcelRequire("374Vm");

var $kMnDy = parcelRequire("kMnDy");

var $4UThT = parcelRequire("4UThT");
function $f7579bfd67bbf413$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $374Vm.isSafari)()) return (0, $kMnDy.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $68Vbj.isFirefox)()) return (0, $4UThT.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("8L8Lw", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("cIa9D")).monitorForTextSelection);

var $cIa9D = parcelRequire("cIa9D");

});
parcelRegister("cIa9D", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => $a00766281f80972b$export$2e178e3647f5e6e9);

var $cBeZP = parcelRequire("cBeZP");

var $bl1yg = parcelRequire("bl1yg");

var $4lzkI = parcelRequire("4lzkI");

var $cGlU2 = parcelRequire("cGlU2");

var $374Vm = parcelRequire("374Vm");



function $a00766281f80972b$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $374Vm.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $0f2008b98bd58844$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $a00766281f80972b$var$honeyPotFix = (0, $bl1yg.makeHoneyPotFix)();
const $a00766281f80972b$var$adapter = (0, $4lzkI.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $cGlU2.combine)($a00766281f80972b$var$honeyPotFix.bindEvents(), (0, $cBeZP.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $920cfea877448e3c$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $0f2008b98bd58844$export$fd3d00026297c0ad))) return;
                const target = $a00766281f80972b$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $0f2008b98bd58844$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $71da65bb220371b0$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $a00766281f80972b$var$honeyPotFix.getOnPostDispatch()
});
function $a00766281f80972b$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $a00766281f80972b$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $a00766281f80972b$var$adapter.registerUsage();
})();
function $a00766281f80972b$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $a00766281f80972b$var$adapter.monitor(args);
}

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $71da65bb220371b0$export$338a9f6c7a1f02b0 = 'text/html';



parcelRegister("fGOj2", function(module, exports) {

var $ku1fk = parcelRequire("ku1fk");
var $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
function $b6c1ccfb8fc1be45$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $b6c1ccfb8fc1be45$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($b6c1ccfb8fc1be45$var$listeningFocusTrap) $b6c1ccfb8fc1be45$var$listeningFocusTrap.pause();
        $b6c1ccfb8fc1be45$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $b6c1ccfb8fc1be45$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $b6c1ccfb8fc1be45$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $b6c1ccfb8fc1be45$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
            return $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
        $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $ku1fk(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
        $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
    }
}
function $b6c1ccfb8fc1be45$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $b6c1ccfb8fc1be45$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $b6c1ccfb8fc1be45$var$focusTrap;

});
parcelRegister("ku1fk", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $ee97937178da774c$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $ee97937178da774c$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("k9tnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabb711d482d792e$export$2e2bcd8739ae039);

var $5pMPR = parcelRequire("5pMPR");
function $eabb711d482d792e$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $eabb711d482d792e$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $eabb711d482d792e$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($eabb711d482d792e$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $eabb711d482d792e$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($eabb711d482d792e$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $5pMPR.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $eabb711d482d792e$var$getOptions(options);
    return $eabb711d482d792e$var$defaultBehavior((0, $5pMPR.default)(target, computeOptions), computeOptions.behavior);
}
var $eabb711d482d792e$export$2e2bcd8739ae039 = $eabb711d482d792e$var$scrollIntoView;

});
parcelRegister("5pMPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f152b3d7b173718$export$2e2bcd8739ae039);
function $3f152b3d7b173718$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $3f152b3d7b173718$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $3f152b3d7b173718$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $3f152b3d7b173718$var$isHiddenByFrame(el) {
    var frame = $3f152b3d7b173718$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $3f152b3d7b173718$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $3f152b3d7b173718$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $3f152b3d7b173718$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $3f152b3d7b173718$var$isHiddenByFrame(el);
    }
    return false;
}
function $3f152b3d7b173718$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $3f152b3d7b173718$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$3f152b3d7b173718$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($3f152b3d7b173718$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $3f152b3d7b173718$var$isScrollable(cursor) && !$3f152b3d7b173718$var$isScrollable(document.documentElement)) continue;
        if ($3f152b3d7b173718$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $3f152b3d7b173718$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $3f152b3d7b173718$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("1T9zJ", function(module, exports) {

$parcel$export(module.exports, "PendoChoreographerPlugin", () => $873aab2cc8300302$export$3390a677f4025523);

var $g3Ayl = parcelRequire("g3Ayl");

var $iJYA2 = parcelRequire("iJYA2");
class $873aab2cc8300302$export$3390a677f4025523 extends (0, $iJYA2.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $g3Ayl.ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("lD23V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbeed703bb1aba42$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $fbeed703bb1aba42$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("5tDD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a229c58023b2692$export$2e2bcd8739ae039);

var $dV5wX = parcelRequire("dV5wX");
var $8a229c58023b2692$export$2e2bcd8739ae039 = (0, $dV5wX.default);

});
parcelRegister("dV5wX", function(module, exports) {

$parcel$export(module.exports, "default", () => $be407477fe354628$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gg6CF = parcelRequire("gg6CF");

var $7Jxgt = parcelRequire("7Jxgt");

var $fHpHg = parcelRequire("fHpHg");

var $lEdH9 = parcelRequire("lEdH9");

var $7u3rk = parcelRequire("7u3rk");

var $7xBz2 = parcelRequire("7xBz2");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $cb0MQ = parcelRequire("cb0MQ");

var $ex6Pq = parcelRequire("ex6Pq");

var $ckqjm = parcelRequire("ckqjm");

var $kD1BA = parcelRequire("kD1BA");
let $be407477fe354628$var$tryCompleteHandle;

const $be407477fe354628$var$AsyncSegmentHighlight = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("4jcMI")).then((module)=>({
            default: module.SegmentHighlight
        })));
const $be407477fe354628$var$noopIdMap = new Map();
function $be407477fe354628$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    const parentContext = (0, $5uXOq.useContext)((0, $aatTc.default));
    const segmentIdMap = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $fHpHg.fg)('platform_ufo_segment_list_mode')) // just in case we cause rerender issues, use noop map
        return $be407477fe354628$var$noopIdMap;
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $fHpHg.fg)('platform_ufo_segment_list_mode')) return (0, $ckqjm.default)();
        if (mode === 'single') return (0, $ckqjm.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $ckqjm.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $5uXOq.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ], [
        parentContext,
        segmentName,
        segmentId
    ]);
    const interactionId = (0, $5uXOq.useContext)((0, $32M8E.default));
    const interactionContext = (0, $5uXOq.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        const complete = (0, $ex6Pq.withProfiling)(function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($be407477fe354628$var$tryCompleteHandle) cancelAnimationFrame?.($be407477fe354628$var$tryCompleteHandle);
                    const onComplete = (0, $ex6Pq.withProfiling)(function onComplete() {
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $be407477fe354628$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $be407477fe354628$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $lAOer.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $lAOer.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    });
                    (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_NormalPriority), onComplete);
                }
            }
        });
        function _internalHold(labelStack, name, experimental = false) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $lAOer.addHold)(interactionId.current, labelStack, name, experimental);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $lAOer.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $lAOer.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental (name = 'unknown') {
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                if (interactionId.current != null) (0, $lAOer.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $7u3rk.getInteractionRate)(name, 'press');
                if ((0, $lEdH9.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    const newId = (0, $7Jxgt.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $7xBz2.setInteractionActiveTrace)(newId, 'press');
                    (0, $lAOer.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $cb0MQ.default).current, (0, $7xBz2.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $lAOer.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $lAOer.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $lAOer.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $lAOer.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $lAOer.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $lAOer.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $lAOer.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $lAOer.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    if ((0, $fHpHg.fg)('platform_ufo_vc_ttai_on_paint')) (0, $kD1BA.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                    else this.complete(commitTime);
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $5uXOq.useRef)(false);
    const onRender = (0, $5uXOq.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $7u3rk.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $lAOer.addSegment)(labelStack);
        return ()=>{
            (0, $lAOer.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $5uXOq.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    const enableSegmentHighlighting = (0, $7u3rk.getConfig)()?.enableSegmentHighlighting;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aatTc.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: [
                children,
                enableSegmentHighlighting && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($be407477fe354628$var$AsyncSegmentHighlight, {
                        segmentName: segmentName
                    })
                })
            ]
        })
    });
}

});
parcelRegister("ckqjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $40da5901742e0689$export$2e2bcd8739ae039);

var $ex6Pq = parcelRequire("ex6Pq");
const $40da5901742e0689$var$generateId = (0, $ex6Pq.withProfiling)(function generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
});
var $40da5901742e0689$export$2e2bcd8739ae039 = $40da5901742e0689$var$generateId;

});

parcelRegister("kD1BA", function(module, exports) {

$parcel$export(module.exports, "default", () => $77b034cd484b971b$export$2e2bcd8739ae039);

var $ex6Pq = parcelRequire("ex6Pq");
const $77b034cd484b971b$var$scheduleOnPaint = (0, $ex6Pq.withProfiling)(function scheduleOnPaint(_callback) {
    const callback = (0, $ex6Pq.withProfiling)(_callback);
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
});
var $77b034cd484b971b$export$2e2bcd8739ae039 = $77b034cd484b971b$var$scheduleOnPaint;

});

parcelRegister("4jcMI", function(module, exports) {

let $3232da8dbf7c3d45$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3232da8dbf7c3d45$var$load("7WPUc").then(()=>parcelRequire('2Vz5U'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});





parcelRegister("basmW", function(module, exports) {

var $2cFTm = parcelRequire("2cFTm");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $8216a25e54656007$var$flow = $2cFTm();
module.exports = $8216a25e54656007$var$flow;

});
parcelRegister("2cFTm", function(module, exports) {

var $1WNhJ = parcelRequire("1WNhJ");

var $9SRAA = parcelRequire("9SRAA");

var $dzqxs = parcelRequire("dzqxs");

var $dJhFY = parcelRequire("dJhFY");

var $8LQ84 = parcelRequire("8LQ84");

var $2dCKt = parcelRequire("2dCKt");
/** Error message constants. */ var $19ad329dbed10597$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $19ad329dbed10597$var$WRAP_CURRY_FLAG = 8, $19ad329dbed10597$var$WRAP_PARTIAL_FLAG = 32, $19ad329dbed10597$var$WRAP_ARY_FLAG = 128, $19ad329dbed10597$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $19ad329dbed10597$var$createFlow(fromRight) {
    return $9SRAA(function(funcs) {
        var length = funcs.length, index = length, prereq = $1WNhJ.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($19ad329dbed10597$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $dJhFY(func) == 'wrapper') var wrapper = new $1WNhJ([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $dJhFY(func), data = funcName == 'wrapper' ? $dzqxs(func) : undefined;
            if (data && $2dCKt(data[0]) && data[1] == ($19ad329dbed10597$var$WRAP_ARY_FLAG | $19ad329dbed10597$var$WRAP_CURRY_FLAG | $19ad329dbed10597$var$WRAP_PARTIAL_FLAG | $19ad329dbed10597$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$dJhFY(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $2dCKt(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $8LQ84(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $19ad329dbed10597$var$createFlow;

});
parcelRegister("1WNhJ", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $dtL2K = parcelRequire("dtL2K");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $16b170343299e90c$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$16b170343299e90c$var$LodashWrapper.prototype = $ady43($dtL2K.prototype);
$16b170343299e90c$var$LodashWrapper.prototype.constructor = $16b170343299e90c$var$LodashWrapper;
module.exports = $16b170343299e90c$var$LodashWrapper;

});
parcelRegister("dtL2K", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $9d02799e26f2befc$var$baseLodash() {
// No operation performed.
}
module.exports = $9d02799e26f2befc$var$baseLodash;

});


parcelRegister("dzqxs", function(module, exports) {

var $hQCy5 = parcelRequire("hQCy5");

var $8Rkzz = parcelRequire("8Rkzz");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $9e13214619654b13$var$getData = !$hQCy5 ? $8Rkzz : function(func) {
    return $hQCy5.get(func);
};
module.exports = $9e13214619654b13$var$getData;

});
parcelRegister("hQCy5", function(module, exports) {

var $kUWNo = parcelRequire("kUWNo");
/** Used to store function metadata. */ var $cfe531f816dee27d$var$metaMap = $kUWNo && new $kUWNo;
module.exports = $cfe531f816dee27d$var$metaMap;

});


parcelRegister("dJhFY", function(module, exports) {

var $b34cU = parcelRequire("b34cU");
/** Used for built-in method references. */ var $9fed306476bd143b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fed306476bd143b$var$hasOwnProperty = $9fed306476bd143b$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $9fed306476bd143b$var$getFuncName(func) {
    var result = func.name + '', array = $b34cU[result], length = $9fed306476bd143b$var$hasOwnProperty.call($b34cU, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $9fed306476bd143b$var$getFuncName;

});
parcelRegister("b34cU", function(module, exports) {
/** Used to lookup unminified function names. */ var $80b33cfa5c78e39a$var$realNames = {};
module.exports = $80b33cfa5c78e39a$var$realNames;

});


parcelRegister("2dCKt", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $dzqxs = parcelRequire("dzqxs");

var $dJhFY = parcelRequire("dJhFY");

var $h4Vl3 = parcelRequire("h4Vl3");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $19dada4f3cc4c77d$var$isLaziable(func) {
    var funcName = $dJhFY(func), other = $h4Vl3[funcName];
    if (typeof other != 'function' || !(funcName in $gXHdK.prototype)) return false;
    if (func === other) return true;
    var data = $dzqxs(other);
    return !!data && func === data[0];
}
module.exports = $19dada4f3cc4c77d$var$isLaziable;

});
parcelRegister("gXHdK", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $dtL2K = parcelRequire("dtL2K");
/** Used as references for the maximum length and index of an array. */ var $c593aec8028eae80$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $c593aec8028eae80$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $c593aec8028eae80$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$c593aec8028eae80$var$LazyWrapper.prototype = $ady43($dtL2K.prototype);
$c593aec8028eae80$var$LazyWrapper.prototype.constructor = $c593aec8028eae80$var$LazyWrapper;
module.exports = $c593aec8028eae80$var$LazyWrapper;

});

parcelRegister("h4Vl3", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $1WNhJ = parcelRequire("1WNhJ");

var $dtL2K = parcelRequire("dtL2K");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");

var $6e2jm = parcelRequire("6e2jm");
/** Used for built-in method references. */ var $c6ef49a1bd112766$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6ef49a1bd112766$var$hasOwnProperty = $c6ef49a1bd112766$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $c6ef49a1bd112766$var$lodash(value) {
    if ($fC1Kz(value) && !$8LQ84(value) && !(value instanceof $gXHdK)) {
        if (value instanceof $1WNhJ) return value;
        if ($c6ef49a1bd112766$var$hasOwnProperty.call(value, '__wrapped__')) return $6e2jm(value);
    }
    return new $1WNhJ(value);
}
// Ensure wrappers are instances of `baseLodash`.
$c6ef49a1bd112766$var$lodash.prototype = $dtL2K.prototype;
$c6ef49a1bd112766$var$lodash.prototype.constructor = $c6ef49a1bd112766$var$lodash;
module.exports = $c6ef49a1bd112766$var$lodash;

});
parcelRegister("6e2jm", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $1WNhJ = parcelRequire("1WNhJ");

var $jHlUS = parcelRequire("jHlUS");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $4885d7df48eb0605$var$wrapperClone(wrapper) {
    if (wrapper instanceof $gXHdK) return wrapper.clone();
    var result = new $1WNhJ(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $jHlUS(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $4885d7df48eb0605$var$wrapperClone;

});





parcelRegister("80pg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0036412be3249c8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");
var $0036412be3249c8b$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $5uXOq.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $3TR0I.default)()(EngagementEventsWrapper);
};

});

parcelRegister("iro8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f7eee2a25cd7b5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $f1f7eee2a25cd7b5$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $5uXOq.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
            };
        }
        UNSAFE_componentWillMount() {
            if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
            if (this.canSetConfig()) this.removeConfig = this.setChoreographerConfig();
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props?.engagementId !== nextProps?.engagementId && this.removeConfig && this.canSetConfig()) {
                this.removeConfig();
                this.removeConfig = this.setChoreographerConfig(nextProps);
            } else if ((this.props?.messageType !== nextProps?.messageType || this.props?.onMessageDisposition !== nextProps?.onMessageDisposition) && this.canSetConfig()) this.setChoreographerConfig(nextProps);
        }
        componentWillUnmount() {
            if (this.unsubscribe) this.unsubscribe();
            if (this.removeConfig) this.removeConfig();
        }
        canSetConfig() {
            return this.context && this.context.setComponentConfig;
        }
        setChoreographerConfig(props = this.props) {
            return this.context.setComponentConfig(getComponentType(), {
                messageType: props.messageType,
                onMessageDisposition: props.onMessageDisposition
            }, props.engagementId);
        }
        canSubscribe() {
            return this.context && this.context.subscribeEngagementState;
        }
        subscribeToStore() {
            return this.context.subscribeEngagementState(this.onStoreChange);
        }
        render() {
            const { children: children, engagementId: engagementId } = this.props;
            const { message: message } = this.state;
            if (!message) {
                if (componentType === 'inlineDialog') return children || null;
                return null;
            }
            if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
            const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
            // Key is useful here to make sure that when the currently active
            // messages changes, the old component is unmounted (therefore
            // firing an analytic event for hiding the component) and mounting
            // a new component for the new message (firing a shown event for
            // the new message). Not using key would allow React to apply an
            // optimization that would reuse the current component for a new
            // message which would not call the normal mount and unmount
            // lifecycle methods.
            return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
                ...this.props,
                ...message
            }, messageKey);
        }
        constructor(...args){
            super(...args), this.state = {
                message: null
            }, this.onStoreChange = (state)=>{
                this.setState(computeNewState(state));
            };
        }
    }
    return StoreWrapper;
};

});

parcelRegister("emcPf", function(module, exports) {

$parcel$export(module.exports, "buttonActionTypes", () => $02665a3818ac4c85$export$e7d79186651244da);
const $02665a3818ac4c85$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("e2jLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $db20e435a6ffc6f2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $db20e435a6ffc6f2$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("1c8Um", function(module, exports) {

$parcel$export(module.exports, "print", () => $0dedd2672864572f$export$c2d084dc44961371);

var $12QNw = parcelRequire("12QNw");

var $541Mz = parcelRequire("541Mz");
function $0dedd2672864572f$export$c2d084dc44961371(ast) {
    return (0, $12QNw.visit)(ast, {
        leave: $0dedd2672864572f$var$printDocASTReducer
    });
}
var $0dedd2672864572f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $0dedd2672864572f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $0dedd2672864572f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $0dedd2672864572f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $0dedd2672864572f$var$join([
            op,
            $0dedd2672864572f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $0dedd2672864572f$var$wrap(' = ', defaultValue) + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $0dedd2672864572f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $0dedd2672864572f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
        if (argsLine.length > $0dedd2672864572f$var$MAX_LINE_LENGTH) argsLine = prefix + $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)');
        return $0dedd2672864572f$var$join([
            argsLine,
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $0dedd2672864572f$var$join([
            '...',
            $0dedd2672864572f$var$wrap('on ', typeCondition),
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($0dedd2672864572f$var$wrap('', $0dedd2672864572f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $541Mz.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $0dedd2672864572f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $0dedd2672864572f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $0dedd2672864572f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $0dedd2672864572f$var$join([
            'schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $0dedd2672864572f$var$join([
            'scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $0dedd2672864572f$var$join([
            'type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $0dedd2672864572f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + ': ' + type + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    }),
    InputValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $0dedd2672864572f$var$join([
            name + ': ' + type,
            $0dedd2672864572f$var$wrap('= ', defaultValue),
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $0dedd2672864572f$var$join([
            'interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $0dedd2672864572f$var$join([
            'union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $0dedd2672864572f$var$join([
            'enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $0dedd2672864572f$var$join([
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $0dedd2672864572f$var$join([
            'input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $0dedd2672864572f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $0dedd2672864572f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $0dedd2672864572f$var$join([
            'extend schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $0dedd2672864572f$var$join([
            'extend scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $0dedd2672864572f$var$join([
            'extend type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $0dedd2672864572f$var$join([
            'extend interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $0dedd2672864572f$var$join([
            'extend union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $0dedd2672864572f$var$join([
            'extend enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $0dedd2672864572f$var$join([
            'extend input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }
};
function $0dedd2672864572f$var$addDescription(cb) {
    return function(node) {
        return $0dedd2672864572f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $0dedd2672864572f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $0dedd2672864572f$var$block(array) {
    return $0dedd2672864572f$var$wrap('{\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $0dedd2672864572f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $0dedd2672864572f$var$indent(str) {
    return $0dedd2672864572f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $0dedd2672864572f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $0dedd2672864572f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($0dedd2672864572f$var$isMultiline);
}

});
parcelRegister("12QNw", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $0c2eeee3dc68c900$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $0c2eeee3dc68c900$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $0c2eeee3dc68c900$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $0c2eeee3dc68c900$export$728beebeea393478);

var $yEDl8 = parcelRequire("yEDl8");

var $98oUl = parcelRequire("98oUl");
var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $98oUl.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $yEDl8.default)(node), "."));
            var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $98oUl.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("yEDl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0682b20f61c706c4$export$2e2bcd8739ae039);

var $7NbHY = parcelRequire("7NbHY");
function $0682b20f61c706c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0682b20f61c706c4$var$_typeof(obj);
}
var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
    return $0682b20f61c706c4$var$formatValue(value, []);
}
function $0682b20f61c706c4$var$formatValue(value, seenValues) {
    switch($0682b20f61c706c4$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
    return $0682b20f61c706c4$var$formatObject(value, seenValues);
}
function $0682b20f61c706c4$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0682b20f61c706c4$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0682b20f61c706c4$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7NbHY.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0682b20f61c706c4$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("7NbHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac63109fd04dae2$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;

});


parcelRegister("98oUl", function(module, exports) {

$parcel$export(module.exports, "Location", () => $6a682e985d2af3c5$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $6a682e985d2af3c5$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $6a682e985d2af3c5$export$8ee0fc9ee280b4ee);

var $520Pd = parcelRequire("520Pd");
var $6a682e985d2af3c5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$18a2be9195644f38);
var $6a682e985d2af3c5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$50792b0e93539fde);
function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("520Pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9dc77a0e8a6949$export$2e2bcd8739ae039);

var $fM9AB = parcelRequire("fM9AB");

var $7NbHY = parcelRequire("7NbHY");
function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fM9AB.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7NbHY.default) classObject.prototype[0, $7NbHY.default] = fn;
}

});
parcelRegister("fM9AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c2c6f03066157d$export$2e2bcd8739ae039);
function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("541Mz", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $3afeb56b3b6851c5$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $3afeb56b3b6851c5$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3afeb56b3b6851c5$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3afeb56b3b6851c5$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3afeb56b3b6851c5$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3afeb56b3b6851c5$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3afeb56b3b6851c5$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $3afeb56b3b6851c5$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $3afeb56b3b6851c5$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("5cllN", function(module, exports) {

$parcel$export(module.exports, "gql", () => $3c8ea2810a9abcde$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $3c8ea2810a9abcde$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $8uUC9 = parcelRequire("8uUC9");
var $3c8ea2810a9abcde$var$docCache = new Map();
var $3c8ea2810a9abcde$var$fragmentSourceMap = new Map();
var $3c8ea2810a9abcde$var$printFragmentWarnings = true;
var $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
function $3c8ea2810a9abcde$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $3c8ea2810a9abcde$var$cacheKeyFromLoc(loc) {
    return $3c8ea2810a9abcde$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $3c8ea2810a9abcde$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $3c8ea2810a9abcde$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $3c8ea2810a9abcde$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($3c8ea2810a9abcde$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $3c8ea2810a9abcde$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, ast), {
        definitions: definitions
    });
}
function $3c8ea2810a9abcde$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $3c8ea2810a9abcde$var$parseDocument(source) {
    var cacheKey = $3c8ea2810a9abcde$var$normalize(source);
    if (!$3c8ea2810a9abcde$var$docCache.has(cacheKey)) {
        var parsed = (0, $8uUC9.parse)(source, {
            experimentalFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $3c8ea2810a9abcde$var$docCache.set(cacheKey, $3c8ea2810a9abcde$var$stripLoc($3c8ea2810a9abcde$var$processFragments(parsed)));
    }
    return $3c8ea2810a9abcde$var$docCache.get(cacheKey);
}
function $3c8ea2810a9abcde$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $3c8ea2810a9abcde$var$parseDocument(result);
}
function $3c8ea2810a9abcde$export$657554ef4dc7ac2d() {
    $3c8ea2810a9abcde$var$docCache.clear();
    $3c8ea2810a9abcde$var$fragmentSourceMap.clear();
}
function $3c8ea2810a9abcde$export$e4294e638636c6ab() {
    $3c8ea2810a9abcde$var$printFragmentWarnings = false;
}
function $3c8ea2810a9abcde$export$78cf889af350c840() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = true;
}
function $3c8ea2810a9abcde$export$5290df9bbbd3cfa() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
}
var $3c8ea2810a9abcde$var$extras = {
    gql: $3c8ea2810a9abcde$export$72e4926bf8358653,
    resetCaches: $3c8ea2810a9abcde$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $3c8ea2810a9abcde$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $3c8ea2810a9abcde$var$extras.gql, gql_1.resetCaches = $3c8ea2810a9abcde$var$extras.resetCaches, gql_1.disableFragmentWarnings = $3c8ea2810a9abcde$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.disableExperimentalFragmentVariables;
})($3c8ea2810a9abcde$export$72e4926bf8358653 || ($3c8ea2810a9abcde$export$72e4926bf8358653 = {}));
$3c8ea2810a9abcde$export$72e4926bf8358653["default"] = $3c8ea2810a9abcde$export$72e4926bf8358653;
var $3c8ea2810a9abcde$export$2e2bcd8739ae039 = $3c8ea2810a9abcde$export$72e4926bf8358653;

});
parcelRegister("8uUC9", function(module, exports) {

$parcel$export(module.exports, "parse", () => $62fd0a8327627af8$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $62fd0a8327627af8$export$5303528d1070ff6f);

var $7ZXKi = parcelRequire("7ZXKi");

var $bzIlO = parcelRequire("bzIlO");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $6vk4Q = parcelRequire("6vk4Q");

var $jADQJ = parcelRequire("jADQJ");

var $jkcJk = parcelRequire("jkcJk");
function $62fd0a8327627af8$export$98e6a39c04603d36(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $62fd0a8327627af8$export$5303528d1070ff6f(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return value;
}
function $62fd0a8327627af8$export$28b8f402ccc88182(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return type;
}
var $62fd0a8327627af8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6vk4Q.isSource)(source) ? source : new (0, $6vk4Q.Source)(source);
        this._lexer = new (0, $jkcJk.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $2z7TS.TokenKind).NAME);
        return {
            kind: (0, $bzIlO.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).DOCUMENT,
            definitions: this.many((0, $2z7TS.TokenKind).SOF, this.parseDefinition, (0, $2z7TS.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $2z7TS.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $2z7TS.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $2z7TS.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).DOLLAR);
        return {
            kind: (0, $bzIlO.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).SELECTION_SET,
            selections: this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseSelection, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $2z7TS.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $bzIlO.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $2z7TS.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, item, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $2z7TS.TokenKind).NAME)) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $2z7TS.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $2z7TS.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $2z7TS.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).STRING:
            case (0, $2z7TS.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $2z7TS.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $bzIlO.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $bzIlO.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $2z7TS.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $bzIlO.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $2z7TS.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).LIST,
            values: this.any((0, $2z7TS.TokenKind).BRACKET_L, item, (0, $2z7TS.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).OBJECT,
            fields: this.any((0, $2z7TS.TokenKind).BRACE_L, item, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $2z7TS.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).AT);
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $2z7TS.TokenKind).BRACKET_R);
            type = {
                kind: (0, $bzIlO.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BANG)) return {
            kind: (0, $bzIlO.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $2z7TS.TokenKind).STRING) || this.peek((0, $2z7TS.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $2z7TS.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $2z7TS.TokenKind).AMP) || this.peek((0, $2z7TS.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $2z7TS.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $2z7TS.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $2z7TS.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $2z7TS.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $jADQJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $98oUl.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected ".concat($62fd0a8327627af8$var$getTokenKindDesc(kind), ", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenDesc(token) {
    var value = token.value;
    return $62fd0a8327627af8$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenKindDesc(kind) {
    return (0, $jkcJk.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("7ZXKi", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $5d2c9324f08528ec$export$bbee0c6176c019d4);

var $g5yZB = parcelRequire("g5yZB");
function $5d2c9324f08528ec$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $g5yZB.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("g5yZB", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $bb6841c873fb42f5$export$92d6ed0888e7cb7f);

var $a1qmV = parcelRequire("a1qmV");

var $cJPdE = parcelRequire("cJPdE");

var $6DBwa = parcelRequire("6DBwa");

var $3DTMg = parcelRequire("3DTMg");

var $4Zjco = parcelRequire("4Zjco");
function $bb6841c873fb42f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bb6841c873fb42f5$var$_typeof(obj);
}
function $bb6841c873fb42f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bb6841c873fb42f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bb6841c873fb42f5$var$ownKeys(Object(source), true).forEach(function(key) {
            $bb6841c873fb42f5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bb6841c873fb42f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bb6841c873fb42f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bb6841c873fb42f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bb6841c873fb42f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bb6841c873fb42f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bb6841c873fb42f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bb6841c873fb42f5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bb6841c873fb42f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bb6841c873fb42f5$var$_setPrototypeOf(subClass, superClass);
}
function $bb6841c873fb42f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bb6841c873fb42f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bb6841c873fb42f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bb6841c873fb42f5$var$_possibleConstructorReturn(this, result);
    };
}
function $bb6841c873fb42f5$var$_possibleConstructorReturn(self, call) {
    if (call && ($bb6841c873fb42f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bb6841c873fb42f5$var$_assertThisInitialized(self);
}
function $bb6841c873fb42f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bb6841c873fb42f5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb6841c873fb42f5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb6841c873fb42f5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb6841c873fb42f5$var$_construct(Class, arguments, $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb6841c873fb42f5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb6841c873fb42f5$var$_wrapNativeSuper(Class);
}
function $bb6841c873fb42f5$var$_construct(Parent, args, Class) {
    if ($bb6841c873fb42f5$var$_isNativeReflectConstruct()) $bb6841c873fb42f5$var$_construct = Reflect.construct;
    else $bb6841c873fb42f5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb6841c873fb42f5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb6841c873fb42f5$var$_construct.apply(null, arguments);
}
function $bb6841c873fb42f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb6841c873fb42f5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb6841c873fb42f5$var$_setPrototypeOf(o, p) {
    $bb6841c873fb42f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb6841c873fb42f5$var$_setPrototypeOf(o, p);
}
function $bb6841c873fb42f5$var$_getPrototypeOf(o) {
    $bb6841c873fb42f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb6841c873fb42f5$var$_getPrototypeOf(o);
}
var $bb6841c873fb42f5$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $bb6841c873fb42f5$var$_inherits(GraphQLError, _Error);
    var _super = $bb6841c873fb42f5$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $bb6841c873fb42f5$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $bb6841c873fb42f5$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $bb6841c873fb42f5$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $3DTMg.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $3DTMg.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cJPdE.default)(originalExtensions)) _this.extensions = $bb6841c873fb42f5$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($bb6841c873fb42f5$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $bb6841c873fb42f5$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($bb6841c873fb42f5$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $bb6841c873fb42f5$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $bb6841c873fb42f5$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $bb6841c873fb42f5$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $bb6841c873fb42f5$var$_wrapNativeSuper(Error));
function $bb6841c873fb42f5$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $bb6841c873fb42f5$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $4Zjco.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $4Zjco.printSourceLocation)(error.source, location);
    }
    return output;
}
function $bb6841c873fb42f5$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $a1qmV.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("a1qmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $74be73ae076c40a2$export$2e2bcd8739ae039);
function $74be73ae076c40a2$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cJPdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $94616b0c7295e50a$export$2e2bcd8739ae039);
function $94616b0c7295e50a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $94616b0c7295e50a$var$_typeof(obj);
}
function $94616b0c7295e50a$export$2e2bcd8739ae039(value) {
    return $94616b0c7295e50a$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("6DBwa", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $4d537cd703fb8e64$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $4d537cd703fb8e64$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $4d537cd703fb8e64$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $4d537cd703fb8e64$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("3DTMg", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("4Zjco", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $3a1bc06740b7fb42$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $3a1bc06740b7fb42$export$867940333fd9f869);

var $3DTMg = parcelRequire("3DTMg");
function $3a1bc06740b7fb42$export$96a9681e539deed(location) {
    return $3a1bc06740b7fb42$export$867940333fd9f869(location.source, (0, $3DTMg.getLocation)(location.source, location.start));
}
function $3a1bc06740b7fb42$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $3a1bc06740b7fb42$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $3a1bc06740b7fb42$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $3a1bc06740b7fb42$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $3a1bc06740b7fb42$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $3a1bc06740b7fb42$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $3a1bc06740b7fb42$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $3a1bc06740b7fb42$var$leftPad(len, str) {
    return $3a1bc06740b7fb42$var$whitespace(len - str.length) + str;
}

});



parcelRegister("bzIlO", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $86d55dbd37d1d598$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $86d55dbd37d1d598$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("2z7TS", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $1de4fa7b8080613f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $1de4fa7b8080613f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6vk4Q", function(module, exports) {

$parcel$export(module.exports, "Source", () => $4bc536350d5671b9$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $4bc536350d5671b9$export$75135ee9ed6e435b);

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");
function $4bc536350d5671b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4bc536350d5671b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4bc536350d5671b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4bc536350d5671b9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4bc536350d5671b9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $a1qmV.default)(0, "Body must be a string. Received: ".concat((0, $yEDl8.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $a1qmV.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $a1qmV.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $4bc536350d5671b9$var$_createClass(Source, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $4bc536350d5671b9$export$75135ee9ed6e435b(source) {
    return (0, $6B4dU.default)(source, $4bc536350d5671b9$export$1d2df86270c81ecb);
}

});
parcelRegister("6B4dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd9796d6ab57d14$export$2e2bcd8739ae039);

function $4cd9796d6ab57d14$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cd9796d6ab57d14$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$4cd9796d6ab57d14$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("jADQJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $e4304a67ae3cac6f$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $e4304a67ae3cac6f$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("jkcJk", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $e119c27db9a87f5b$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $e119c27db9a87f5b$export$59ac0f4da287406a);

var $7ZXKi = parcelRequire("7ZXKi");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $541Mz = parcelRequire("541Mz");
var $e119c27db9a87f5b$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $2z7TS.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e119c27db9a87f5b$var$readToken(this, token);
        }while (token.kind === (0, $2z7TS.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $e119c27db9a87f5b$export$59ac0f4da287406a(kind) {
    return kind === (0, $2z7TS.TokenKind).BANG || kind === (0, $2z7TS.TokenKind).DOLLAR || kind === (0, $2z7TS.TokenKind).AMP || kind === (0, $2z7TS.TokenKind).PAREN_L || kind === (0, $2z7TS.TokenKind).PAREN_R || kind === (0, $2z7TS.TokenKind).SPREAD || kind === (0, $2z7TS.TokenKind).COLON || kind === (0, $2z7TS.TokenKind).EQUALS || kind === (0, $2z7TS.TokenKind).AT || kind === (0, $2z7TS.TokenKind).BRACKET_L || kind === (0, $2z7TS.TokenKind).BRACKET_R || kind === (0, $2z7TS.TokenKind).BRACE_L || kind === (0, $2z7TS.TokenKind).PIPE || kind === (0, $2z7TS.TokenKind).BRACE_R;
}
function $e119c27db9a87f5b$var$printCharCode(code) {
    return isNaN(code) ? (0, $2z7TS.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $e119c27db9a87f5b$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $e119c27db9a87f5b$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e119c27db9a87f5b$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $e119c27db9a87f5b$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $e119c27db9a87f5b$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $e119c27db9a87f5b$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $7ZXKi.syntaxError)(source, pos, $e119c27db9a87f5b$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $e119c27db9a87f5b$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $e119c27db9a87f5b$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $e119c27db9a87f5b$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    } else {
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $e119c27db9a87f5b$var$isNameStart(code)) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    return new (0, $98oUl.Token)(isFloat ? (0, $2z7TS.TokenKind).FLOAT : (0, $2z7TS.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $e119c27db9a87f5b$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $e119c27db9a87f5b$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $e119c27db9a87f5b$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $e119c27db9a87f5b$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $541Mz.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $e119c27db9a87f5b$var$uniCharCode(a, b, c, d) {
    return $e119c27db9a87f5b$var$char2hex(a) << 12 | $e119c27db9a87f5b$var$char2hex(b) << 8 | $e119c27db9a87f5b$var$char2hex(c) << 4 | $e119c27db9a87f5b$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $e119c27db9a87f5b$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $e119c27db9a87f5b$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $e119c27db9a87f5b$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("fwbX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4c31d9870379ac2$var$cloneObject;

var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
    return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("cpl5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90882d6ff669df4d$var$assign;
function $90882d6ff669df4d$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("aR9Qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e767cfeba790ebe$var$format;

var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));

var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));

var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));

var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));

var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));

var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));

var $5qguX = parcelRequire("5qguX");

var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));

var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
    if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
    var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
        var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $5qguX.isProtectedWeekYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $5qguX.isProtectedDayOfYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $7e767cfeba790ebe$var$cleanEscapedString(input) {
    return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ck8JK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f8e2146dfa1d727$var$isValid;

var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
    (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
    var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("2pWQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c2b912e6615b0b5$var$toDate;

var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $1c2b912e6615b0b5$var$toDate(argument) {
    (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("6eBfj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
function $48a0f126c2293ab3$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("kvNR5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));

var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));

var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));

var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));

var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
function $eeed6020e120f946$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $eeed6020e120f946$var$locale = {
    code: 'en-US',
    formatDistance: $eeed6020e120f946$var$_index.default,
    formatLong: $eeed6020e120f946$var$_index2.default,
    formatRelative: $eeed6020e120f946$var$_index3.default,
    localize: $eeed6020e120f946$var$_index4.default,
    match: $eeed6020e120f946$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
module.exports.default = $eeed6020e120f946$var$_default;
module.exports = module.exports.default;

});
parcelRegister("5u9TK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
    else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
    else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("e7AgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a47ddb0366100c31$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a47ddb0366100c31$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a47ddb0366100c31$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a47ddb0366100c31$var$formatLong = {
    date: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
module.exports.default = $a47ddb0366100c31$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4raqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("8U2eY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
var $67b54aa1e07b4b42$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
    return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("b9d75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
function $81dab50370972ecd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81dab50370972ecd$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $81dab50370972ecd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $81dab50370972ecd$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $81dab50370972ecd$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $81dab50370972ecd$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $81dab50370972ecd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $81dab50370972ecd$var$localize = {
    ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
    era: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
module.exports.default = $81dab50370972ecd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("llBmH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("hHwuU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));

var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
var $ce2fa922bf4a591b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ce2fa922bf4a591b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ce2fa922bf4a591b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ce2fa922bf4a591b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ce2fa922bf4a591b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ce2fa922bf4a591b$var$match = {
    ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
        matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
        parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
module.exports.default = $ce2fa922bf4a591b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1IY7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
function $141888fa04c95812$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("liduU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("bQkcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;

var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));

var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));

var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
    var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
    return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("aSksP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("7f9OM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;

var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));

var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
    var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("3ckvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));

var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));

var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));

var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));

var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2542672a600cd2b8$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2542672a600cd2b8$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $2542672a600cd2b8$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date); // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $2542672a600cd2b8$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $2542672a600cd2b8$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $2542672a600cd2b8$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $2542672a600cd2b8$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $2542672a600cd2b8$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $2542672a600cd2b8$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $2542672a600cd2b8$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    }
};
function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
}
function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
}
function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
module.exports.default = $2542672a600cd2b8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kFGp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $f0c88744bd108133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $f0c88744bd108133$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
module.exports.default = $f0c88744bd108133$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bQ2eo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("3xdEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;

var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
    (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
    var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("6Falt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;

var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));

var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
    (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
    var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
    var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("6nDqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;

var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4a53796a96b58804$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
    (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("hI2kM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;

var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $ce485b424b643216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $ce485b424b643216$var$_index3.default)(1, arguments);
    var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("gUvh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;

var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
    (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
    var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("46m4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;

var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));

var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));

var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
    (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
    var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
    var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("clhRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;

var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cbqvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;

var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));

var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("3ihh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;

var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));

var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));

var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
    var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("awKAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
}
var $7aa109506ceedd4b$var$longFormatters = {
    p: $7aa109506ceedd4b$var$timeLongFormatter,
    P: $7aa109506ceedd4b$var$dateTimeLongFormatter
};
var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
module.exports.default = $7aa109506ceedd4b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("jGQTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("5qguX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
    return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
    return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("cFwjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $973f8364f5717a4a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");


var $f4nMm = parcelRequire("f4nMm");

var $cXkXs = parcelRequire("cXkXs");
const $973f8364f5717a4a$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $973f8364f5717a4a$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;
function $973f8364f5717a4a$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
        appearance: (0, $cXkXs.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4nMm.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
// Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';

parcelRegister("f4nMm", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $b28126fa63b634a4$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7a4uG = parcelRequire("7a4uG");
var $cnu9t = parcelRequire("cnu9t");

var $gfxSS = parcelRequire("gfxSS");

var $GLupd = parcelRequire("GLupd");

var $fHpHg = parcelRequire("fHpHg");


var $lJ7P3 = parcelRequire("lJ7P3");

var $5pE2f = parcelRequire("5pE2f");
function $b28126fa63b634a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b28126fa63b634a4$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $b28126fa63b634a4$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $b28126fa63b634a4$var$ICON_PADDING = 4;
const $b28126fa63b634a4$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: $b28126fa63b634a4$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $b28126fa63b634a4$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $b28126fa63b634a4$var$nestedAvatarStyles = Object.entries((0, $7a4uG.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $b28126fa63b634a4$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $b28126fa63b634a4$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $b28126fa63b634a4$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $b28126fa63b634a4$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $fHpHg.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lJ7P3.FallbackAvatar), {
            "aria-label": alt,
            width: $b28126fa63b634a4$var$SIZES[size],
            height: $b28126fa63b634a4$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: [
                $b28126fa63b634a4$var$avatarDefaultIconStyles,
                $b28126fa63b634a4$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gfxSS))), {
            label: alt,
            color: $b28126fa63b634a4$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $b28126fa63b634a4$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($GLupd)))
        }));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnu9t.AvatarContent), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $b28126fa63b634a4$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $b28126fa63b634a4$export$ac3673635a5387be = (props)=>{
    if ((0, $fHpHg.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pE2f.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($b28126fa63b634a4$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("lJ7P3", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $458bbf5fc9d0c47b$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $458bbf5fc9d0c47b$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $458bbf5fc9d0c47b$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $458bbf5fc9d0c47b$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("5pE2f", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $666a3f196e39429b$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ba3Vv = parcelRequire("ba3Vv");
const $666a3f196e39429b$var$boxShadowCssVar = '--avatar-box-shadow';
const $666a3f196e39429b$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $666a3f196e39429b$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $666a3f196e39429b$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $666a3f196e39429b$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $666a3f196e39429b$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $666a3f196e39429b$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $666a3f196e39429b$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $666a3f196e39429b$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ba3Vv.FallbackAvatar), {
        "aria-label": alt,
        width: $666a3f196e39429b$var$SIZES[size],
        height: $666a3f196e39429b$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $bwpsq.default)([
            $666a3f196e39429b$var$unboundStyles.root,
            $666a3f196e39429b$var$containerStyles.root,
            $666a3f196e39429b$var$borderRadiusMap[size],
            $666a3f196e39429b$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $bwpsq.default)([
                $666a3f196e39429b$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("ba3Vv", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $aa17d5d454be5715$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $aa17d5d454be5715$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $aa17d5d454be5715$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $aa17d5d454be5715$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("cXkXs", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $5c51a57e7fd42e03$export$d5a05ffb65695bc0);

var $fHpHg = parcelRequire("fHpHg");
function $5c51a57e7fd42e03$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $fHpHg.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});


parcelRegister("kc9vJ", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("8DfXF")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("8DfXF")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("8DfXF")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("ihijj")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("7j6wR")).useLazyPhase);
parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $bh45B = parcelRequire("bh45B");

var $8DfXF = parcelRequire("8DfXF");
parcelRequire("3iU61");
var $8gCAq = parcelRequire("8gCAq");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("41yqT");
var $ihijj = parcelRequire("ihijj");
parcelRequire("1Cn7k");
var $7j6wR = parcelRequire("7j6wR");

var $lUR7e = parcelRequire("lUR7e");

});
parcelRegister("9tT5O", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $6e718ebf0a3d5ffc$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $6e718ebf0a3d5ffc$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("0431B")).MODE);

var $0431B = parcelRequire("0431B");
const $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN = undefined;
const $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $6e718ebf0a3d5ffc$var$DEFAULT_MODE = (0, $0431B.MODE).HYDRATE;
const $6e718ebf0a3d5ffc$var$DEFAULT_RETRY = 2;
const $6e718ebf0a3d5ffc$var$config = {
    crossOrigin: $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN,
    manifest: $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST,
    mode: $6e718ebf0a3d5ffc$var$DEFAULT_MODE,
    retry: $6e718ebf0a3d5ffc$var$DEFAULT_RETRY
};
const $6e718ebf0a3d5ffc$export$44487a86467333c3 = ()=>$6e718ebf0a3d5ffc$var$config;
const $6e718ebf0a3d5ffc$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $6e718ebf0a3d5ffc$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN;
    $6e718ebf0a3d5ffc$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST;
    $6e718ebf0a3d5ffc$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $6e718ebf0a3d5ffc$var$DEFAULT_MODE;
    $6e718ebf0a3d5ffc$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $6e718ebf0a3d5ffc$var$DEFAULT_RETRY;
};

});
parcelRegister("0431B", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $00c2b881b8fbcee5$export$e48589d9e4824227);
const $00c2b881b8fbcee5$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("bh45B", function(module, exports) {

var $PZ2tE = parcelRequire("PZ2tE");

var $9tT5O = parcelRequire("9tT5O");
parcelRequire("1Cn7k");
var $7BvXL = parcelRequire("7BvXL");
var $7j6wR = parcelRequire("7j6wR");

var $fEDkH = parcelRequire("fEDkH");
const $83547451e376d6d0$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $9tT5O.setConfig)(config);
        (0, $7BvXL.LISTENERS).length = 0;
        (0, $7j6wR.setCurrent)(0);
        if (!(0, $fEDkH.isNodeEnvironment)()) (0, $PZ2tE.collect)();
    }
};

});
parcelRegister("PZ2tE", function(module, exports) {

$parcel$export(module.exports, "collect", () => $09c41c99821e965e$export$bb44f104e3c54dae);

var $9tT5O = parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $gRvGe = parcelRequire("gRvGe");

var $cIwb8 = parcelRequire("cIwb8");

var $916oJ = parcelRequire("916oJ");
const $09c41c99821e965e$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $9tT5O.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $0431B.MODE).RENDER ? (0, $cIwb8.cloneElements)(markers[i], lazyBegin) : (0, $916oJ.refElements)(markers[i], lazyBegin);
        if ((0, $gRvGe.COLLECTED).has(lazyBegin)) (0, $gRvGe.COLLECTED).get(lazyBegin).push(value);
        else (0, $gRvGe.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("gRvGe", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $c46a2b9a383e79ee$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $c46a2b9a383e79ee$export$4831ef3968ea94ef);
const $c46a2b9a383e79ee$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c46a2b9a383e79ee$export$4831ef3968ea94ef = new Map();

});

parcelRegister("cIwb8", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $94228e13ffd964de$export$c42217d53a7ebafb);
const $94228e13ffd964de$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("916oJ", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $69092b84bd4d8839$export$c69443129766a7fc);
const $69092b84bd4d8839$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1Cn7k", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("7j6wR")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("7j6wR")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("7j6wR")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("7BvXL")).LISTENERS);

var $7j6wR = parcelRequire("7j6wR");

var $7BvXL = parcelRequire("7BvXL");

var $hLAzE = parcelRequire("hLAzE");

});
parcelRegister("7j6wR", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $551f5f4ab1e13682$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $551f5f4ab1e13682$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $551f5f4ab1e13682$export$1dc361b277327f88);

var $5uXOq = parcelRequire("5uXOq");

var $gRvGe = parcelRequire("gRvGe");

var $7BvXL = parcelRequire("7BvXL");

var $hLAzE = parcelRequire("hLAzE");
let $551f5f4ab1e13682$var$CURRENT_PHASE = (0, $gRvGe.PHASE).PAINT;
const $551f5f4ab1e13682$export$5f80f094fd31fffd = (phase)=>{
    $551f5f4ab1e13682$var$CURRENT_PHASE = phase;
    (0, $7BvXL.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $551f5f4ab1e13682$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: (0, $hLAzE.createSubscribe)((0, $7BvXL.LISTENERS)),
    currentValue: ()=>$551f5f4ab1e13682$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).PAINT)
    }
});
const $551f5f4ab1e13682$export$1dc361b277327f88 = ()=>{
    const v = (0, $5uXOq.useContext)($551f5f4ab1e13682$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("7BvXL", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $5894c846af183bf2$export$81b9c458a026d68f);
const $5894c846af183bf2$export$81b9c458a026d68f = [];

});

parcelRegister("hLAzE", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $cef3324da336be99$export$364097d812234b3f);
const $cef3324da336be99$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("fEDkH", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $b6591a2169faf79a$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $b6591a2169faf79a$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $b6591a2169faf79a$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $b6591a2169faf79a$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("i0Mqq")).default);

var $i0Mqq = parcelRequire("i0Mqq");
const $b6591a2169faf79a$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $b6591a2169faf79a$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $b6591a2169faf79a$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $b6591a2169faf79a$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("i0Mqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("8DfXF", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $648e58dc5a799d99$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $648e58dc5a799d99$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $648e58dc5a799d99$export$488013bae63b21da);

var $3aJOa = parcelRequire("3aJOa");

var $9tT5O = parcelRequire("9tT5O");

var $gRvGe = parcelRequire("gRvGe");

var $fEDkH = parcelRequire("fEDkH");
var $i0Mqq = parcelRequire("i0Mqq");

var $9Ww7D = parcelRequire("9Ww7D");

var $eqm16 = parcelRequire("eqm16");

var $3ro9P = parcelRequire("3ro9P");

var $5pJCH = parcelRequire("5pJCH");

var $2LsHW = parcelRequire("2LsHW");

var $gNYzn = parcelRequire("gNYzn");

var $gI8wo = parcelRequire("gI8wo");
function $648e58dc5a799d99$var$_extends() {
    $648e58dc5a799d99$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $648e58dc5a799d99$var$_extends.apply(this, arguments);
}
function $648e58dc5a799d99$var$lazyProxy(_loader, { defer: defer = (0, $gRvGe.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $fEDkH.isNodeEnvironment)();
    const dataLazyId = (0, $i0Mqq.default)(moduleId);
    const LazyInternal = isServer ? (0, $3ro9P.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $eqm16.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $5pJCH.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $9tT5O.getConfig)();
                return (0, $gNYzn.retry)(_loader, {
                    delay: (0, $9Ww7D.RETRY_DELAY),
                    factor: (0, $9Ww7D.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $fEDkH.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $9tT5O.getConfig)();
        return (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gRvGe.PHASE).PAINT ? (0, $9Ww7D.PRIORITY).HIGH : (0, $9Ww7D.PRIORITY).LOW;
        return (0, $2LsHW.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $648e58dc5a799d99$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gRvGe.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gRvGe.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gRvGe.PHASE).LAZY
    }
};
function $648e58dc5a799d99$export$c952e5f94576010e(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $648e58dc5a799d99$export$291dd592399bdafa(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $648e58dc5a799d99$export$488013bae63b21da(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("3aJOa", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $24f5d6cbe7374307$export$303f43e55cf1ef2f);
const $24f5d6cbe7374307$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("9Ww7D", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $73d2729ff937408e$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $73d2729ff937408e$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $73d2729ff937408e$export$ba64c908e55507fe);
const $73d2729ff937408e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $73d2729ff937408e$export$a339266ad71b2447 = 300;
const $73d2729ff937408e$export$ba64c908e55507fe = 1;

});

parcelRegister("eqm16", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $a804927df56ebdb2$export$6898b5504b58699a);

var $5uXOq = parcelRequire("5uXOq");

var $9tT5O = parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $gRvGe = parcelRequire("gRvGe");
parcelRequire("3iU61");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("1Cn7k");
var $7j6wR = parcelRequire("7j6wR");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");

var $gI8wo = parcelRequire("gI8wo");

var $b1mtW = parcelRequire("b1mtW");

var $2uJW6 = parcelRequire("2uJW6");

var $lUR7e = parcelRequire("lUR7e");

var $k8XtJ = parcelRequire("k8XtJ");
function $a804927df56ebdb2$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $gI8wo.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $k8XtJ.useSubscription)({
            context: (0, $hxt6y.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gRvGe.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $k8XtJ.useSubscription)({
            context: (0, $7j6wR.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        (0, $5uXOq.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gRvGe.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $9tT5O.getConfig)().mode === (0, $0431B.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1mtW.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2uJW6.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("3iU61", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("hxt6y")).WaitContext);

var $hxt6y = parcelRequire("hxt6y");

var $8gCAq = parcelRequire("8gCAq");

});
parcelRegister("hxt6y", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $cc4c1850a13fcdaa$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");

var $3Sq3c = parcelRequire("3Sq3c");
const $cc4c1850a13fcdaa$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: ()=>(0, $3Sq3c.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("3Sq3c", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $2d2a9f5ddab5681f$export$276c7dbda7675aec);
const $2d2a9f5ddab5681f$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("8gCAq", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");

var $hxt6y = parcelRequire("hxt6y");
const $604dbfd3e71469c9$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
    const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $5uXOq.useRef)(new Set());
    const api = (0, $5uXOq.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $5uXOq.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxt6y.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("41yqT", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("ihijj")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("7t9v5")).LazySuspenseContext);

var $ihijj = parcelRequire("ihijj");

var $7t9v5 = parcelRequire("7t9v5");

});
parcelRegister("ihijj", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $d4e8049b2be3a01c$export$256c542058532d6f);

var $5uXOq = parcelRequire("5uXOq");

var $fEDkH = parcelRequire("fEDkH");

var $7t9v5 = parcelRequire("7t9v5");
class $d4e8049b2be3a01c$export$256c542058532d6f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $fEDkH.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("7t9v5", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $57029c6f61e78061$export$c33990e84065970c);

var $5uXOq = parcelRequire("5uXOq");
const $57029c6f61e78061$export$c33990e84065970c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("gI8wo", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425);
const $c2a75d9d2b1d4ac6$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$c2a75d9d2b1d4ac6$export$6aa69c1258005366]: true
    });
    return error;
};
const $c2a75d9d2b1d4ac6$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($c2a75d9d2b1d4ac6$export$6aa69c1258005366);

});

parcelRegister("b1mtW", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $80613a2b6be8c4b1$export$d55db778a3e1446b);

var $5uXOq = parcelRequire("5uXOq");

var $lUR7e = parcelRequire("lUR7e");
parcelRequire("3iU61");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");
function $80613a2b6be8c4b1$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $80613a2b6be8c4b1$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $5uXOq.useRef)(null);
    const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
    const profilerContext = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
    const waitContext = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
    const suspenseContext = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($80613a2b6be8c4b1$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $80613a2b6be8c4b1$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $80613a2b6be8c4b1$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("lUR7e", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $ff4807977d1ff541$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $ff4807977d1ff541$export$8146ab57a3f7a7cb);

var $5uXOq = parcelRequire("5uXOq");
const $ff4807977d1ff541$export$e2d53c0cbedd2710 = {
    current: null
};
const $ff4807977d1ff541$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $5uXOq.createContext)($ff4807977d1ff541$export$e2d53c0cbedd2710);

});


parcelRegister("2uJW6", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $1d1204150993c3dd$export$ca5b8fbc835d95e4);

var $5uXOq = parcelRequire("5uXOq");

var $fEDkH = parcelRequire("fEDkH");
function $1d1204150993c3dd$var$_extends() {
    $1d1204150993c3dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d1204150993c3dd$var$_extends.apply(this, arguments);
}
const $1d1204150993c3dd$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $fEDkH.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), $1d1204150993c3dd$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("k8XtJ", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $eaa2b1340dc6db34$export$368b4214baeb914c);

var $5uXOq = parcelRequire("5uXOq");
function $eaa2b1340dc6db34$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
    (0, $5uXOq.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("3ro9P", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $2816a1dec93a8449$export$eb2e4b04351cdd9e);

var $3aJOa = parcelRequire("3aJOa");

var $5uXOq = parcelRequire("5uXOq");

var $9tT5O = parcelRequire("9tT5O");

var $gRvGe = parcelRequire("gRvGe");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");

var $fEDkH = parcelRequire("fEDkH");

var $gI8wo = parcelRequire("gI8wo");
function $2816a1dec93a8449$var$load(moduleId, loader) {
    try {
        return (0, $fEDkH.getExport)(loader());
    } catch (err) {
        throw (0, $gI8wo.createLoaderError)(err);
    }
}
function $2816a1dec93a8449$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $2816a1dec93a8449$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $9tT5O.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gRvGe.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
                key: url,
                rel: defer === (0, $gRvGe.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("5pJCH", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $3f12ad617063b5b1$export$e673efccd97e4223);
const $3f12ad617063b5b1$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("2LsHW", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $20363d4ed5cd2af1$export$25bad4aa00c45355);

var $3aJOa = parcelRequire("3aJOa");

var $3Sq3c = parcelRequire("3Sq3c");

var $9tT5O = parcelRequire("9tT5O");

var $fEDkH = parcelRequire("fEDkH");

var $9Ww7D = parcelRequire("9Ww7D");

var $6MxP6 = parcelRequire("6MxP6");

var $lUR7e = parcelRequire("lUR7e");
function $20363d4ed5cd2af1$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $9tT5O.getConfig)();
    const assets = (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $6MxP6.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $20363d4ed5cd2af1$var$fakePromise = {
    then: ()=>$20363d4ed5cd2af1$var$fakePromise,
    catch: ()=>$20363d4ed5cd2af1$var$fakePromise,
    finally: ()=>$20363d4ed5cd2af1$var$fakePromise
};
function $20363d4ed5cd2af1$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $6MxP6.insertLinkTag)(href, rel));
        return $20363d4ed5cd2af1$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $20363d4ed5cd2af1$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $3Sq3c.noopCleanup;
}
function $20363d4ed5cd2af1$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $fEDkH.isNodeEnvironment)()) return 0, $3Sq3c.noopCleanup;
    (_GlobalReactLooselyLa = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $9Ww7D.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $20363d4ed5cd2af1$export$3af04dbcb01bad4d,
        $20363d4ed5cd2af1$export$1046fd6a49d5e7a,
        $20363d4ed5cd2af1$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $3Sq3c.noopCleanup;
}

});
parcelRegister("6MxP6", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $4f01765b3d259822$export$6610512821c8a4ce);

var $lUR7e = parcelRequire("lUR7e");

var $3Sq3c = parcelRequire("3Sq3c");

var $9tT5O = parcelRequire("9tT5O");
function $4f01765b3d259822$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $3Sq3c.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $9tT5O.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("gNYzn", function(module, exports) {

$parcel$export(module.exports, "retry", () => $032842ea9e8e4a24$export$9369b12211e1fce4);
const $032842ea9e8e4a24$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $032842ea9e8e4a24$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $032842ea9e8e4a24$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $032842ea9e8e4a24$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $032842ea9e8e4a24$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $032842ea9e8e4a24$var$calculateDelay(context, policy);
        if (delay) await $032842ea9e8e4a24$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("dKrqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9dd90bcea7196e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $5ZsT9 = parcelRequire("5ZsT9");

var $cyTVX = parcelRequire("cyTVX");
function $da9dd90bcea7196e$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $cyTVX.useSafeIntl)();
    const messages = (0, $5ZsT9.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the context and pass them downstream
	 * This prevents the missing messages error
	 */ const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("5ZsT9", function(module, exports) {

$parcel$export(module.exports, "useMessages", () => $eced4354151bdbe6$export$4d17e2d9c5348842);

var $5uXOq = parcelRequire("5uXOq");

var $lm5gL = parcelRequire("lm5gL");
const $eced4354151bdbe6$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $5uXOq.useState)((0, $lm5gL.DEFAULT_LOCALE_STATE));
    (0, $5uXOq.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("lm5gL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $18e2d216a52652b5$export$79618bef82c02d4c);
const $18e2d216a52652b5$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("cyTVX", function(module, exports) {

$parcel$export(module.exports, "useSafeIntl", () => $fc4595870cc94217$export$f752ac21ea3960a5);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $hTtGr = parcelRequire("hTtGr");
var $8RXs9 = parcelRequire("8RXs9");

var $lm5gL = parcelRequire("lm5gL");
// Prevents memory leaks
const $fc4595870cc94217$var$cache = (0, $hTtGr.createIntlCache)();
const $fc4595870cc94217$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $8RXs9.Context));
    if (!context) return (0, $i5FdW.createIntl)((0, $lm5gL.DEFAULT_LOCALE_STATE), $fc4595870cc94217$var$cache);
    return context;
};

});


parcelRegister("bWGt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b260dd1704e65ee$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $bS0aY = parcelRequire("bS0aY");

var $f8Sb3 = parcelRequire("f8Sb3");

var $l9ACI = parcelRequire("l9ACI");

var $7PpcK = parcelRequire("7PpcK");

var $lDKn9 = parcelRequire("lDKn9");
var $8b260dd1704e65ee$var$testOmitPropsOnStringTag = (0, $bS0aY.default);
var $8b260dd1704e65ee$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8b260dd1704e65ee$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8b260dd1704e65ee$var$testOmitPropsOnStringTag : $8b260dd1704e65ee$var$testOmitPropsOnComponent;
};
var $8b260dd1704e65ee$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8b260dd1704e65ee$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8b260dd1704e65ee$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $l9ACI.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $lDKn9.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $l9ACI.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8b260dd1704e65ee$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8b260dd1704e65ee$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8b260dd1704e65ee$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $f8Sb3.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $5uXOq.useContext)((0, $f8Sb3.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $l9ACI.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $7PpcK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8b260dd1704e65ee$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $5uXOq.createElement)($8b260dd1704e65ee$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $5uXOq.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $bS32t.default)({}, options, nextOptions, {
                shouldForwardProp: $8b260dd1704e65ee$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $8b260dd1704e65ee$export$2e2bcd8739ae039 = $8b260dd1704e65ee$var$createStyled;

});
parcelRegister("bS0aY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a44dfccbb21331d$export$2e2bcd8739ae039);

var $73DH6 = parcelRequire("73DH6");
var $8a44dfccbb21331d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8a44dfccbb21331d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $73DH6.default)(function(prop) {
    return $8a44dfccbb21331d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("73DH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $52379aa2a5cd30cc$export$2e2bcd8739ae039);
function $52379aa2a5cd30cc$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("l9ACI", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $f666d8e4d96dcdd3$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $f666d8e4d96dcdd3$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $f666d8e4d96dcdd3$export$6f077d94b33a01aa);
var $f666d8e4d96dcdd3$var$isBrowser = true;
function $f666d8e4d96dcdd3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $f666d8e4d96dcdd3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f666d8e4d96dcdd3$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $f666d8e4d96dcdd3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $f666d8e4d96dcdd3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});


parcelRegister("hh1dC", function(module, exports) {

$parcel$export(module.exports, "RovoPostMessagePubsubListener", () => $465bbd2eabc97313$export$e5e1a9c59c299631);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $465bbd2eabc97313$export$5340cc94dd0ecbea);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $9KIkq = parcelRequire("9KIkq");
const $465bbd2eabc97313$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $465bbd2eabc97313$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $465bbd2eabc97313$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $465bbd2eabc97313$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $465bbd2eabc97313$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($465bbd2eabc97313$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $465bbd2eabc97313$var$allowedOrigins.includes(hostname));
};
const $465bbd2eabc97313$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $9KIkq.usePublish)('ai-mate');
    (0, $5uXOq.useEffect)(()=>{
        const handlerUnbind = (0, $cBeZP.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$465bbd2eabc97313$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $465bbd2eabc97313$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $465bbd2eabc97313$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $465bbd2eabc97313$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $465bbd2eabc97313$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $5uXOq.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const handlerUnbind = (0, $cBeZP.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$465bbd2eabc97313$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $465bbd2eabc97313$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $5uXOq.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $465bbd2eabc97313$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $465bbd2eabc97313$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("9KIkq", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $b6479f38c469062a$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $b6479f38c469062a$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $b6479f38c469062a$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $b6479f38c469062a$export$60959659b2c22881);

var $5uXOq = parcelRequire("5uXOq");
const $b6479f38c469062a$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $b6479f38c469062a$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = events.length.toString();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$b6479f38c469062a$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $b6479f38c469062a$var$pubSub = $b6479f38c469062a$var$createPubSub();
const $b6479f38c469062a$var$usePubSub = ()=>{
    return $b6479f38c469062a$var$pubSub;
};
const $b6479f38c469062a$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $b6479f38c469062a$var$usePubSub();
    const callbackRef = (0, $5uXOq.useRef)(callback);
    callbackRef.current = callback;
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $b6479f38c469062a$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $b6479f38c469062a$var$usePubSub();
    const callbackRef = (0, $5uXOq.useRef)(callback);
    callbackRef.current = callback;
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $b6479f38c469062a$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $b6479f38c469062a$var$usePubSub();
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $b6479f38c469062a$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $b6479f38c469062a$var$usePubSub();
    const publishFn = (0, $5uXOq.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $b6479f38c469062a$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $b6479f38c469062a$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $b6479f38c469062a$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("8X8ig", function(module, exports) {

$parcel$export(module.exports, "createCache", () => $083ee18522961350$export$cf6fa0bbcc94b912);
function $083ee18522961350$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("6FeX8", function(module, exports) {

$parcel$export(module.exports, "PreloadableJSResource", () => $c5a728ec49331fc8$export$4fe5fba5bb1d3c09);

var $3cQ3X = parcelRequire("3cQ3X");
function $c5a728ec49331fc8$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $3cQ3X.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("3cQ3X", function(module, exports) {

$parcel$export(module.exports, "JSResource", () => $ea40327a7abfc06d$export$148e45a6d4b4d65);

var $kqNct = parcelRequire("kqNct");

var $ij7D5 = parcelRequire("ij7D5");

var $5j9na = parcelRequire("5j9na");
function $ea40327a7abfc06d$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $ij7D5.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $ij7D5.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $kqNct.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $ij7D5.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $5j9na.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("kqNct", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $7cf284f37486f503$export$567fc7097e064344);
let $7cf284f37486f503$var$id = 100000;
function $7cf284f37486f503$export$567fc7097e064344() {
    $7cf284f37486f503$var$id += 1;
    return $7cf284f37486f503$var$id.toString();
}

});

parcelRegister("ij7D5", function(module, exports) {

$parcel$export(module.exports, "eventEmitter", () => $41efe490077d3c54$export$10dc3edfc20c8ff);
function $41efe490077d3c54$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $41efe490077d3c54$export$10dc3edfc20c8ff = $41efe490077d3c54$var$createEventEmitter();

});

parcelRegister("5j9na", function(module, exports) {

$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $fbca99b99894b52f$export$3b514faac3ba993c);
function $fbca99b99894b52f$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("d9Cgl", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $2d6dfd9326429cb4$export$212b9c60150b5a0a);

var $lAOer = parcelRequire("lAOer");

var $ig9cG = parcelRequire("ig9cG");

var $he0mL = parcelRequire("he0mL");
const $2d6dfd9326429cb4$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') input = (0, $he0mL.withPrefix)(input, init);
    else input = {
        ...input,
        url: (0, $he0mL.withPrefix)(input.url, init)
    };
    const errorTransformer = init?.errorTransformer ?? (0, $he0mL.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $ig9cG.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $ig9cG.HTTPError)(response);
        const sanitizedUrl = (0, $he0mL.sanitizeUrlString)((0, $he0mL.getRequestUrl)(input));
        (0, $lAOer.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $ig9cG.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("ig9cG", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $320ea165c142ad12$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $320ea165c142ad12$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $320ea165c142ad12$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $320ea165c142ad12$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $320ea165c142ad12$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $320ea165c142ad12$export$4f52fcea95c8f97d);

var $i1RGB = parcelRequire("i1RGB");
class $320ea165c142ad12$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $320ea165c142ad12$export$aa9d629c530f62a7 extends $320ea165c142ad12$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $i1RGB.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $320ea165c142ad12$export$c30b5b02747d791c extends $320ea165c142ad12$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $i1RGB.ERROR_NAMES).StreamedHTTPError;
    }
}
const $320ea165c142ad12$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $320ea165c142ad12$export$aa9d629c530f62a7 || [
        (0, $i1RGB.ERROR_NAMES).HTTPError,
        (0, $i1RGB.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $320ea165c142ad12$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $320ea165c142ad12$export$bae979e68e4dc802 || [
        (0, $i1RGB.ERROR_NAMES).NetworkError,
        (0, $i1RGB.ERROR_NAMES).HTTPError,
        (0, $i1RGB.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $320ea165c142ad12$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $320ea165c142ad12$export$c30b5b02747d791c || candidate?.name === (0, $i1RGB.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("i1RGB", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $6123ad5d355eac71$export$daceac3b97803ce1);
var $6123ad5d355eac71$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("he0mL", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $4ffc5900c8f39c0d$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $4ffc5900c8f39c0d$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $4ffc5900c8f39c0d$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $4ffc5900c8f39c0d$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $4ffc5900c8f39c0d$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $4ffc5900c8f39c0d$export$ceb09b958e605eff);

var $aVPby = parcelRequire("aVPby");

var $ig9cG = parcelRequire("ig9cG");

let $4ffc5900c8f39c0d$var$metaCloudId;
let $4ffc5900c8f39c0d$var$isJSMAvailable = true;
function $4ffc5900c8f39c0d$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $aVPby.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($4ffc5900c8f39c0d$var$metaCloudId) return $4ffc5900c8f39c0d$var$metaCloudId;
    if ($4ffc5900c8f39c0d$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $4ffc5900c8f39c0d$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $4ffc5900c8f39c0d$var$isJSMAvailable = !!$4ffc5900c8f39c0d$var$metaCloudId;
    }
    return $4ffc5900c8f39c0d$var$metaCloudId;
}
function $4ffc5900c8f39c0d$export$5a75f4aeb58ba80f(id) {
    $4ffc5900c8f39c0d$var$metaCloudId = id;
}
function $4ffc5900c8f39c0d$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $4ffc5900c8f39c0d$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $3aee2ec4200fc5ec$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $4ffc5900c8f39c0d$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $4ffc5900c8f39c0d$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $ig9cG.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $4ffc5900c8f39c0d$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $ig9cG.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $ig9cG.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $4ffc5900c8f39c0d$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $ig9cG.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $4ffc5900c8f39c0d$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $ig9cG.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $ig9cG.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $4ffc5900c8f39c0d$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $4ffc5900c8f39c0d$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("aVPby", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $445f512b243c1a8f$export$6acf61af03e62db);
const $445f512b243c1a8f$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $3aee2ec4200fc5ec$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("9glig", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");
/** Error message constants. */ var $6be62026d39b34ea$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */ function $6be62026d39b34ea$var$cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = $bxDef;
    pairs = !length ? [] : $1nIHN(pairs, function(pair) {
        if (typeof pair[1] != 'function') throw new TypeError($6be62026d39b34ea$var$FUNC_ERROR_TEXT);
        return [
            toIteratee(pair[0]),
            pair[1]
        ];
    });
    return $g7i7g(function(args) {
        var index = -1;
        while(++index < length){
            var pair = pairs[index];
            if ($hlchF(pair[0], this, args)) return $hlchF(pair[1], this, args);
        }
    });
}
module.exports = $6be62026d39b34ea$var$cond;

});

parcelRegister("hMlwW", function(module, exports) {
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */ function $cf179ed6624748c2$var$stubTrue() {
    return true;
}
module.exports = $cf179ed6624748c2$var$stubTrue;

});

parcelRegister("bqwqE", function(module, exports) {

$parcel$export(module.exports, "AssetsIcon", () => $8e28ab780e03a94a$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2c95521e78bee1973ee46b2b7a225679>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8e28ab780e03a94a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#ffc716" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" fill-rule="evenodd" d="M8.75 11.569a3.25 3.25 0 0 0 2.82-2.819h2.056V7.125h-2.267a3.251 3.251 0 1 0-4.233 4.233v2.267H8.75zm-.406-2.007a1.219 1.219 0 1 0 0-2.437 1.219 1.219 0 0 0 0 2.438" clip-rule="evenodd"/>
    <path fill="#101214" d="M18.5 7.94a2.03 2.03 0 1 1-4.06 0 2.03 2.03 0 0 1 4.06 0M7.94 18.5a2.03 2.03 0 1 0 0-4.06 2.03 2.03 0 0 0 0 4.06m8.53 0a2.03 2.03 0 1 0 0-4.06 2.03 2.03 0 0 0 0 4.06m-2.84-2.84h-2.84v1.63h2.84zm2.03-4.88v2.84h1.63v-2.84z"/>
</svg>
`;
function $8e28ab780e03a94a$export$d89497e7f33ca6f5({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $8e28ab780e03a94a$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Assets',
        testId: testId
    });
}

});
parcelRegister("eTliY", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $d3e6bd5b38185bf1$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $d3e6bd5b38185bf1$var$styles = {
    root: "_1e0c1o8l"
};
const $d3e6bd5b38185bf1$var$sizeMap = {
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    '32': "_4t3izwfg"
};
function $d3e6bd5b38185bf1$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: iconColor }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && iconColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            // The 'legacy' appearance replaces icon colors with a blue tile and white icon, controlled via CSS variables
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $c680f909cd2c0a82$export$4a6fae78114c6824)]: appearance === 'legacy' ? 'white' : 'initial',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $c680f909cd2c0a82$export$c59811a1f25e6288)]: appearance === 'legacy' ? '#1868DB' : 'initial',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $c680f909cd2c0a82$export$582e20fccfce3089)]: iconColor || 'initial'
        },
        // In some icons (such as the app switcher specific icons), the label is a consumer prop.
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $bwpsq.default)([
            $d3e6bd5b38185bf1$var$styles.root,
            $d3e6bd5b38185bf1$var$sizeMap[size]
        ])
    });
}

});
const $c680f909cd2c0a82$export$4a6fae78114c6824 = '--icon-color';
const $c680f909cd2c0a82$export$c59811a1f25e6288 = '--tile-color';
const $c680f909cd2c0a82$export$582e20fccfce3089 = '--themed-icon-color';
const $c680f909cd2c0a82$export$8344f093f1e14646 = '--themed-text-color';



parcelRegister("ab1Yt", function(module, exports) {

$parcel$export(module.exports, "GoalsIcon", () => $2ae74a2f44972650$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eedf2aef3262f658e6bdefb92d4a046b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2ae74a2f44972650$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#dddee1" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M14.52 12a2.52 2.52 0 1 1-5.04 0 2.52 2.52 0 0 1 5.04 0"/>
    <path fill="#101214" fill-rule="evenodd" d="M12 19.031A7.031 7.031 0 1 0 12 4.97a7.031 7.031 0 0 0 0 14.062M16.395 12a4.395 4.395 0 1 1-8.79 0 4.395 4.395 0 0 1 8.79 0" clip-rule="evenodd"/>
</svg>
`;
function $2ae74a2f44972650$export$9eb74917ea768ed4({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $2ae74a2f44972650$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Goals',
        testId: testId
    });
}

});

parcelRegister("hfZl4", function(module, exports) {

$parcel$export(module.exports, "AccountNav3", () => $14b22e50817de50f$export$75dc45130eee4ebb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cbmHg = parcelRequire("cbmHg");

var $5qQCr = parcelRequire("5qQCr");
const $14b22e50817de50f$export$75dc45130eee4ebb = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qQCr.AccountInternal), {
        ...props,
        AccountMenu: (0, $cbmHg.AccountMenuNav3)
    });
};

});
parcelRegister("cbmHg", function(module, exports) {

$parcel$export(module.exports, "AccountMenuNav3", () => $9397474086fe9c1e$export$4ff56e5cf713dc64);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4e1uB = parcelRequire("4e1uB");

var $fR8PR = parcelRequire("fR8PR");

var $k5UrB = parcelRequire("k5UrB");
const $9397474086fe9c1e$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5UrB.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $4e1uB.AccountMenuLoggedOutStateNav3),
        AccountMenuTrigger: (0, $fR8PR.AccountMenuTriggerNav3)
    });
};

});
parcelRegister("4e1uB", function(module, exports) {

$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $ab68c6277daf09a1$export$5e6158d2118ae4aa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Xq9Q = parcelRequire("2Xq9Q");

var $1ASTt = parcelRequire("1ASTt");

var $bQzaw = parcelRequire("bQzaw");

var $bXAyW = parcelRequire("bXAyW");

var $2aGr1 = parcelRequire("2aGr1");
const $ab68c6277daf09a1$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Xq9Q.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $bXAyW.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $2aGr1.logInTooltip),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ASTt))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bQzaw)))
        })
    });

});
parcelRegister("bXAyW", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $0e17ca74af9a837d$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $0e17ca74af9a837d$export$3cbe56a0cabcff38);
const $0e17ca74af9a837d$export$515664faa1398f37 = 'navigation';
const $0e17ca74af9a837d$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("2aGr1", function(module, exports) {

$parcel$export(module.exports, "logInTooltip", () => $c7e490f496489274$export$b495e6c63a3a03c1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $c7e490f496489274$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("fR8PR", function(module, exports) {

$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $208ab2127c6d0b59$export$89d857133932d6aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $2Xq9Q = parcelRequire("2Xq9Q");

var $etfHb = parcelRequire("etfHb");

var $39qIY = parcelRequire("39qIY");

var $d4S2m = parcelRequire("d4S2m");
function $208ab2127c6d0b59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $208ab2127c6d0b59$var$imgStyles = {
    name: "qlds6h",
    styles: "border-radius:50%;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $208ab2127c6d0b59$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $koVbs.default)();
    const state = (0, $39qIY.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $d4S2m.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Xq9Q.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
            css: $208ab2127c6d0b59$var$imgStyles,
            src: picture,
            alt: tooltip
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($etfHb))), {
            color: "currentColor",
            label: tooltip,
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
});

});
parcelRegister("39qIY", function(module, exports) {

$parcel$export(module.exports, "useImageState", () => $7911fc18a0ac53ae$export$2c1df3428fc3264c);

var $5uXOq = parcelRequire("5uXOq");
const $7911fc18a0ac53ae$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $5uXOq.useState)('pending');
    const imgRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("d4S2m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $134960bbde95bc8b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $134960bbde95bc8b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});


parcelRegister("k5UrB", function(module, exports) {

$parcel$export(module.exports, "AccountMenu", () => $a28c17c7293119b9$export$ff20d75d5eda4388);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cnhic = parcelRequire("cnhic");

var $bXAyW = parcelRequire("bXAyW");

var $gdXAG = parcelRequire("gdXAG");

var $jplDq = parcelRequire("jplDq");

var $dDgGe = parcelRequire("dDgGe");
const $a28c17c7293119b9$export$ff20d75d5eda4388 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.NavigationAnalyticsContext), {
        data: (0, $bXAyW.ANALYTICS_CONTEXT),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jplDq.AccountMenuIntlProvider), {
            children: logInLink ? /*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenuLoggedOutState, {
                testId: testId && `${testId}--logged-out-state`,
                logInLink: logInLink
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDgGe.AccountMenuPopup), {
                testId: testId,
                picture: picture,
                trustPicture: trustPicture,
                email: email,
                AccountMenuTrigger: AccountMenuTrigger,
                content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gdXAG.AccountMenuContent), {
                        testId: testId && `${testId}--content`,
                        closePopup: closePopup,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy,
                        manageProfileLink: manageProfileLink,
                        viewProfileLink: viewProfileLink,
                        onViewProfileClick: onViewProfileClick,
                        switchAccountLink: switchAccountLink,
                        logOutLink: logOutLink,
                        onThemeChange: onThemeChange,
                        currentTheme: currentTheme,
                        extraMenuItems: extraMenuItems
                    })
            })
        })
    });

});
parcelRegister("gdXAG", function(module, exports) {

$parcel$export(module.exports, "AccountMenuContent", () => $ba66d91cfa4f7c18$export$49c2771125e1e9f1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");


var $bngFq = parcelRequire("bngFq");

var $8vMe2 = parcelRequire("8vMe2");

var $dnGcR = parcelRequire("dnGcR");

var $gfxSS = parcelRequire("gfxSS");

var $3cwUp = parcelRequire("3cwUp");

var $gnVb6 = parcelRequire("gnVb6");

var $iEqeu = parcelRequire("iEqeu");

var $9pMJy = parcelRequire("9pMJy");

var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $b4a3S = parcelRequire("b4a3S");

var $bXAyW = parcelRequire("bXAyW");

var $2fP1Y = parcelRequire("2fP1Y");

var $1TUNw = parcelRequire("1TUNw");

var $bWGt6 = parcelRequire("bWGt6");
const $ba66d91cfa4f7c18$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems = null })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aOrxC.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $70rf1.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2fP1Y.AccountDetails), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $70rf1.default), null, viewProfileLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1TUNw.ThemeSwitcher), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
    })), extraMenuItems, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $70rf1.default), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba66d91cfa4f7c18$var$Container = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "evherry0"
})({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: (0, $b4a3S.gridSize)() * 38
});
const $ba66d91cfa4f7c18$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cwUp))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $iEqeu.default)
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
const $ba66d91cfa4f7c18$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium"
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
const $ba66d91cfa4f7c18$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gfxSS))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $gnVb6.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
const $ba66d91cfa4f7c18$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($ba66d91cfa4f7c18$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8vMe2))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $9pMJy.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
const $ba66d91cfa4f7c18$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $bXAyW.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $44qT7.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';

parcelRegister("2fP1Y", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $94400e0c1e7af938$export$66e04d0aacdb3b2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $3cwUp = parcelRequire("3cwUp");

var $iEqeu = parcelRequire("iEqeu");

var $k9nuy = parcelRequire("k9nuy");


var $b4a3S = parcelRequire("b4a3S");

var $g0CY0 = parcelRequire("g0CY0");

var $kFQou = parcelRequire("kFQou");

var $bWGt6 = parcelRequire("bWGt6");
function $94400e0c1e7af938$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $94400e0c1e7af938$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$ManagedBy, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$PersonIconWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cwUp))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $iEqeu.default)
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: (text)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k9nuy.default), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$Container = /*#__PURE__*/ (0, $bWGt6.default)("section", {
    target: "e3lis067"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$ManagedBy = /*#__PURE__*/ (0, $bWGt6.default)("small", {
    target: "e3lis066"
})({
    display: 'box',
    margin: '0px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $b4a3S.borderRadius)()}px ${(0, $b4a3S.borderRadius)()}px 0 0`,
    background: `var(--ds-background-information, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
    color: "var(--ds-text-subtle, #44546F)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$PersonIconWrapper = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e3lis065"
})({
    name: "1d1sf9j",
    styles: "margin-right:var(--ds-space-050, 4px);& > span{width:12px;height:12px;}"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$Content = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis064"
})({
    display: 'flex',
    flexDirection: 'column',
    background: `var(--ds-surface-sunken, ${(0, $a7f8c6b391092279$export$8d43898f60b96a82)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ hasHeader: hasHeader })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: hasHeader ? `0 0 ${(0, $b4a3S.borderRadius)()}px ${(0, $b4a3S.borderRadius)()}px` : `${(0, $b4a3S.borderRadius)()}px`
    }));
const $94400e0c1e7af938$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$ProfileWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g0CY0.ProfilePicture), {
        src: picture,
        size: (0, $b4a3S.gridSize)() * 8,
        testId: testId && `${testId}--picture`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$NameAndEmail, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$DisplayName, {
        "data-testid": testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kFQou.SkeletonText), {
        length: "6em"
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)($94400e0c1e7af938$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kFQou.SkeletonText), {
        length: "10em"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$ProfileWrapper = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis063"
})({
    display: 'flex',
    flexDirection: 'row',
    margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$NameAndEmail = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis062"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `auto 0 auto ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$DisplayName = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "e3lis061"
})({
    color: `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`,
    margin: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94400e0c1e7af938$var$EmailAddress = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e3lis060"
})({
    name: "1e1erj1",
    styles: "margin-top:var(--ds-space-025, 2px);color:var(--ds-text-subtlest, #626F86);font-weight:var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("g0CY0", function(module, exports) {

$parcel$export(module.exports, "ProfilePicture", () => $a32e54cbc92dc854$export$2d75367b6e042d67);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $etfHb = parcelRequire("etfHb");


var $39qIY = parcelRequire("39qIY");
function $a32e54cbc92dc854$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a32e54cbc92dc854$var$imgStyles = {
    name: "1b6qxg",
    styles: "display:block;border-radius:50%"
};
const $a32e54cbc92dc854$export$2d75367b6e042d67 = ({ testId: testId, src: src, size: size, className: className })=>{
    const state = (0, $39qIY.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)({
            width: size,
            height: size,
            ...displaySkeleton && {
                borderRadius: '50%',
                backgroundColor: `var(--ds-background-neutral, ${0, $a7f8c6b391092279$export$8d43898f60b96a82})`
            },
            '& svg, & img': {
                width: size,
                height: size
            }
        })
    }, displayImage && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        "data-testid": testId && `${testId}--img`,
        src: src,
        css: $a32e54cbc92dc854$var$imgStyles
    }), displayFallback && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($etfHb))), {
        spacing: "spacious",
        testId: testId && `${testId}--fallback`,
        label: "",
        color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`,
        LEGACY_secondaryColor: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`
    }));
};

});

parcelRegister("kFQou", function(module, exports) {

$parcel$export(module.exports, "SkeletonText", () => $aa4a69918decb9b4$export$cb6ddd830302c2a8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $aa4a69918decb9b4$export$cb6ddd830302c2a8 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ej73sxo0"
})({
    display: 'inline-block',
    height: '1em',
    borderRadius: '0.5em',
    backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$8d43898f60b96a82)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
({ length: length })=>({
        width: length
    }));

});


parcelRegister("1TUNw", function(module, exports) {

$parcel$export(module.exports, "ThemeSwitcher", () => $3a7a0ada5e881b52$export$9d63163ee2173b37);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $j7m8K = parcelRequire("j7m8K");
var $e7iqc = parcelRequire("e7iqc");

var $jAyL0 = parcelRequire("jAyL0");

var $cwX8H = parcelRequire("cwX8H");

var $f0xyT = parcelRequire("f0xyT");

var $7H980 = parcelRequire("7H980");

var $9sjFu = parcelRequire("9sjFu");

var $4hl09 = parcelRequire("4hl09");

var $3S0W4 = parcelRequire("3S0W4");

var $bWGt6 = parcelRequire("bWGt6");
function $3a7a0ada5e881b52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3a7a0ada5e881b52$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7m8K.default), {
        testId: testId,
        placement: "auto-start",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jAyL0))), {
                    color: "currentColor",
                    label: "",
                    LEGACY_fallbackIcon: (0, $f0xyT.default)
                }),
                iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
                    color: "currentColor",
                    label: ""
                }),
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    id: "identity.account-menu.theme-switcher.theme-button",
                    defaultMessage: "Theme",
                    description: "Label for button in the account menu to switch to a different theme"
                })
            }),
        children: $3a7a0ada5e881b52$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $e7iqc.default), {
                testId: `${testId}--radio-${value}`,
                id: value,
                onClick: ()=>onThemeChange(value),
                isSelected: currentTheme === value,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)($3a7a0ada5e881b52$var$RadioLabelContainer, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                            src: thumbnail,
                            width: 64,
                            height: 48,
                            alt: ""
                        }),
                        label
                    ]
                })
            }, value))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a7a0ada5e881b52$var$RadioLabelContainer = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1q43w0o0"
})({
    name: "ql53ha",
    styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px)"
});
const $3a7a0ada5e881b52$var$messages = (0, $7VHMR.defineMessages)({
    light: {
        id: 'identity.account-menu.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'identity.account-menu.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'identity.account-menu.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    }
});
const $3a7a0ada5e881b52$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$3a7a0ada5e881b52$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($4hl09)))
    },
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$3a7a0ada5e881b52$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($9sjFu)))
    },
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$3a7a0ada5e881b52$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($3S0W4)))
    }
];

});
parcelRegister("9sjFu", function(module, exports) {
module.exports = new URL("dark-mode.fd95cecc.svg", import.meta.url).toString();

});

parcelRegister("4hl09", function(module, exports) {
module.exports = new URL("light-mode.9ae6186d.svg", import.meta.url).toString();

});

parcelRegister("3S0W4", function(module, exports) {
module.exports = new URL("match-browser.defc82cb.svg", import.meta.url).toString();

});



parcelRegister("jplDq", function(module, exports) {

$parcel$export(module.exports, "AccountMenuIntlProvider", () => $4bc9c03df1d74061$export$6c1f1571e3dd1b34);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $eJrbL = parcelRequire("eJrbL");
const $4bc9c03df1d74061$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    const messages = $4bc9c03df1d74061$var$useMessages(locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: children
    });
};
const $4bc9c03df1d74061$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $4bc9c03df1d74061$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $4bc9c03df1d74061$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $eJrbL.default)[`${language}_${region}`] || (0, $eJrbL.default)[language])?.())?.default;
};

});
parcelRegister("eJrbL", function(module, exports) {

$parcel$export(module.exports, "default", () => $255feb6fe8f48ea2$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $255feb6fe8f48ea2$var$lazyMessages = {
    cs: ()=>(parcelRequire("kkhJS")),
    cs_CZ: ()=>(parcelRequire("a21IP")),
    da: ()=>(parcelRequire("97BRr")),
    da_DK: ()=>(parcelRequire("M5Qe2")),
    de: ()=>(parcelRequire("i0cNq")),
    de_DE: ()=>(parcelRequire("dmaIN")),
    en_GB: ()=>(parcelRequire("87E98")),
    en_ZZ: ()=>(parcelRequire("uLgJI")),
    es: ()=>(parcelRequire("93t2G")),
    fi: ()=>(parcelRequire("2dNwL")),
    fi_FI: ()=>(parcelRequire("cL0NF")),
    fr: ()=>(parcelRequire("7E3Xn")),
    fr_FR: ()=>(parcelRequire("dMeCS")),
    hu: ()=>(parcelRequire("7nBUG")),
    hu_HU: ()=>(parcelRequire("6iCB3")),
    it: ()=>(parcelRequire("7ZZFL")),
    it_IT: ()=>(parcelRequire("agcyc")),
    ja: ()=>(parcelRequire("9tg0z")),
    ja_JP: ()=>(parcelRequire("ecoor")),
    ko: ()=>(parcelRequire("7IdgT")),
    ko_KR: ()=>(parcelRequire("hN8La")),
    nb: ()=>(parcelRequire("2F9v3")),
    nb_NO: ()=>(parcelRequire("5vvmQ")),
    nl: ()=>(parcelRequire("j6bqo")),
    nl_NL: ()=>(parcelRequire("2QXZA")),
    pl: ()=>(parcelRequire("kirzW")),
    pl_PL: ()=>(parcelRequire("lGPM3")),
    pt_BR: ()=>(parcelRequire("2MVxj")),
    ru: ()=>(parcelRequire("ffQ54")),
    ru_RU: ()=>(parcelRequire("2hiAA")),
    sv: ()=>(parcelRequire("erAia")),
    sv_SE: ()=>(parcelRequire("d9ovi")),
    th: ()=>(parcelRequire("31owZ")),
    th_TH: ()=>(parcelRequire("gGLB9")),
    tr: ()=>(parcelRequire("bk96X")),
    tr_TR: ()=>(parcelRequire("higA4")),
    uk: ()=>(parcelRequire("aJWLr")),
    uk_UA: ()=>(parcelRequire("am78P")),
    vi: ()=>(parcelRequire("gYJA3")),
    vi_VN: ()=>(parcelRequire("9O48G")),
    zh: ()=>(parcelRequire("jwhn8")),
    zh_CN: ()=>(parcelRequire("aO8n7")),
    zh_TW: ()=>(parcelRequire("8itXn"))
};
var $255feb6fe8f48ea2$export$2e2bcd8739ae039 = $255feb6fe8f48ea2$var$lazyMessages;

});
parcelRegister("kkhJS", function(module, exports) {

let $ecc36f8131744e7d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ecc36f8131744e7d$var$load("7hYT3").then(()=>parcelRequire('7xYMQ'));

});

parcelRegister("a21IP", function(module, exports) {

let $74db6d39da9a3e70$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74db6d39da9a3e70$var$load("9sWmO").then(()=>parcelRequire('dN9Tq'));

});

parcelRegister("97BRr", function(module, exports) {

let $6a4222ec6652ab96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a4222ec6652ab96$var$load("irDce").then(()=>parcelRequire('bCYBU'));

});

parcelRegister("M5Qe2", function(module, exports) {

let $090903c764015256$var$load = (parcelRequire("28QjX"))(4);
module.exports = $090903c764015256$var$load("10rWN").then(()=>parcelRequire('6ypiB'));

});

parcelRegister("i0cNq", function(module, exports) {

let $d1b227295719e554$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d1b227295719e554$var$load("ev2cz").then(()=>parcelRequire('8uE46'));

});

parcelRegister("dmaIN", function(module, exports) {

let $9b95a57f5e35fb52$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b95a57f5e35fb52$var$load("50sv3").then(()=>parcelRequire('lGISy'));

});

parcelRegister("87E98", function(module, exports) {

let $5e9e1e6d34fdb4cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e9e1e6d34fdb4cc$var$load("aG4XR").then(()=>parcelRequire('fO6rO'));

});

parcelRegister("uLgJI", function(module, exports) {

let $05c778155bde7661$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05c778155bde7661$var$load("aMJbw").then(()=>parcelRequire('f3Ciy'));

});

parcelRegister("93t2G", function(module, exports) {

let $697aec13f9e14ecf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $697aec13f9e14ecf$var$load("ZA2of").then(()=>parcelRequire('jtNSE'));

});

parcelRegister("2dNwL", function(module, exports) {

let $19e336cdc1aecf88$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19e336cdc1aecf88$var$load("78YQ9").then(()=>parcelRequire('gkmyw'));

});

parcelRegister("cL0NF", function(module, exports) {

let $949a7eb07b63124c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $949a7eb07b63124c$var$load("dPhsv").then(()=>parcelRequire('kdG7Q'));

});

parcelRegister("7E3Xn", function(module, exports) {

let $590f56871ea1be8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $590f56871ea1be8c$var$load("hEoL4").then(()=>parcelRequire('dKjmK'));

});

parcelRegister("dMeCS", function(module, exports) {

let $a07b1a77c955d1b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a07b1a77c955d1b1$var$load("aFqgq").then(()=>parcelRequire('eUa6y'));

});

parcelRegister("7nBUG", function(module, exports) {

let $55f8172c18d7c7ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55f8172c18d7c7ee$var$load("3G0Ex").then(()=>parcelRequire('2hCDJ'));

});

parcelRegister("6iCB3", function(module, exports) {

let $49625d012bfdf5db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49625d012bfdf5db$var$load("8HMcY").then(()=>parcelRequire('jdwQn'));

});

parcelRegister("7ZZFL", function(module, exports) {

let $5d2e11d37ad8b4d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d2e11d37ad8b4d7$var$load("hXBoC").then(()=>parcelRequire('9BDyQ'));

});

parcelRegister("agcyc", function(module, exports) {

let $77852248b79461b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77852248b79461b9$var$load("2BUMg").then(()=>parcelRequire('4TQKa'));

});

parcelRegister("9tg0z", function(module, exports) {

let $6e533d628e15d239$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e533d628e15d239$var$load("axDgf").then(()=>parcelRequire('hd979'));

});

parcelRegister("ecoor", function(module, exports) {

let $a5651ba7938cb08a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5651ba7938cb08a$var$load("e6Cmk").then(()=>parcelRequire('54hwz'));

});

parcelRegister("7IdgT", function(module, exports) {

let $59d6efe5255ff87b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59d6efe5255ff87b$var$load("cu2ju").then(()=>parcelRequire('e1yEa'));

});

parcelRegister("hN8La", function(module, exports) {

let $cf3dcec93f50bc38$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf3dcec93f50bc38$var$load("jzAmO").then(()=>parcelRequire('baA7V'));

});

parcelRegister("2F9v3", function(module, exports) {

let $1f06c79740a1c0f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f06c79740a1c0f3$var$load("iU7zU").then(()=>parcelRequire('546Gu'));

});

parcelRegister("5vvmQ", function(module, exports) {

let $40282df2241a5950$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40282df2241a5950$var$load("4hIRK").then(()=>parcelRequire('8QkLV'));

});

parcelRegister("j6bqo", function(module, exports) {

let $de777090dfec3011$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de777090dfec3011$var$load("25KvW").then(()=>parcelRequire('ksvQC'));

});

parcelRegister("2QXZA", function(module, exports) {

let $213ef9553a4acaa8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $213ef9553a4acaa8$var$load("kFeJ8").then(()=>parcelRequire('lHHNn'));

});

parcelRegister("kirzW", function(module, exports) {

let $ec6ae1a143a81ef6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec6ae1a143a81ef6$var$load("5HMcy").then(()=>parcelRequire('cVDsI'));

});

parcelRegister("lGPM3", function(module, exports) {

let $fca5ae770a904b74$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fca5ae770a904b74$var$load("eN1pc").then(()=>parcelRequire('e4v2M'));

});

parcelRegister("2MVxj", function(module, exports) {

let $207cb1f7607029b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $207cb1f7607029b0$var$load("8dMLl").then(()=>parcelRequire('6ctaP'));

});

parcelRegister("ffQ54", function(module, exports) {

let $b1b0a7e4debcfbcd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1b0a7e4debcfbcd$var$load("iEPOB").then(()=>parcelRequire('diXNc'));

});

parcelRegister("2hiAA", function(module, exports) {

let $1a8b96b7e1b49395$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a8b96b7e1b49395$var$load("cIKm9").then(()=>parcelRequire('anTYv'));

});

parcelRegister("erAia", function(module, exports) {

let $a83fbd28715db727$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a83fbd28715db727$var$load("h6g5S").then(()=>parcelRequire('cIFb3'));

});

parcelRegister("d9ovi", function(module, exports) {

let $992f1f8c6b0e2371$var$load = (parcelRequire("28QjX"))(4);
module.exports = $992f1f8c6b0e2371$var$load("7jq09").then(()=>parcelRequire('b7ttG'));

});

parcelRegister("31owZ", function(module, exports) {

let $23347e75791773b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23347e75791773b4$var$load("1pAQ4").then(()=>parcelRequire('9MIrj'));

});

parcelRegister("gGLB9", function(module, exports) {

let $c2657d975c47be3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2657d975c47be3f$var$load("84VB5").then(()=>parcelRequire('9q2ZI'));

});

parcelRegister("bk96X", function(module, exports) {

let $83e8a1471611ac81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83e8a1471611ac81$var$load("as8Ee").then(()=>parcelRequire('3kg4o'));

});

parcelRegister("higA4", function(module, exports) {

let $c970fab7dee875f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c970fab7dee875f0$var$load("6QfXL").then(()=>parcelRequire('02GAx'));

});

parcelRegister("aJWLr", function(module, exports) {

let $7d1bb0ad71bb3483$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d1bb0ad71bb3483$var$load("h036H").then(()=>parcelRequire('8Mn6e'));

});

parcelRegister("am78P", function(module, exports) {

let $78a17f98102b1d73$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78a17f98102b1d73$var$load("i8iIZ").then(()=>parcelRequire('jq7Rw'));

});

parcelRegister("gYJA3", function(module, exports) {

let $c5c59b41adc44484$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5c59b41adc44484$var$load("2zdi9").then(()=>parcelRequire('2dAnj'));

});

parcelRegister("9O48G", function(module, exports) {

let $723bfe825ce4aad0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $723bfe825ce4aad0$var$load("dAmF7").then(()=>parcelRequire('cB6X1'));

});

parcelRegister("jwhn8", function(module, exports) {

let $e35e7b3cf9be937c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e35e7b3cf9be937c$var$load("gKQek").then(()=>parcelRequire('lh96c'));

});

parcelRegister("aO8n7", function(module, exports) {

let $7de5115f2e470e56$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7de5115f2e470e56$var$load("eRW6F").then(()=>parcelRequire('6DXBz'));

});

parcelRegister("8itXn", function(module, exports) {

let $60a73df1ed41c812$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60a73df1ed41c812$var$load("horKK").then(()=>parcelRequire('7p2Os'));

});



parcelRegister("dDgGe", function(module, exports) {

$parcel$export(module.exports, "AccountMenuPopup", () => $5012f1f34a0d0c32$export$473cb05bf335b0e1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $jJRcn = parcelRequire("jJRcn");

var $vCqQa = parcelRequire("vCqQa");

var $bXAyW = parcelRequire("bXAyW");
const $5012f1f34a0d0c32$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const close = (0, $jJRcn.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $bXAyW.NAVIGATION_CHANNEL));
    const open = (0, $jJRcn.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $bXAyW.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content
    });
};

});



parcelRegister("5qQCr", function(module, exports) {

$parcel$export(module.exports, "AccountInternal", () => $37e6cbb4f81c36d4$export$df97669773647652);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1VOot = parcelRequire("1VOot");
const $37e6cbb4f81c36d4$export$df97669773647652 = ({ identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, AccountMenu: AccountMenu, ...props })=>{
    const links = (0, $1VOot.useAccountLinks)({
        email: props.email,
        identityEnvironment: identityEnvironment,
        application: application,
        continueUrl: continueUrl,
        logOutContinueUrl: logOutContinueUrl,
        isLoggedOut: isLoggedOut,
        disableSwitchAccountLink: disableSwitchAccountLink
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenu, {
        ...props,
        ...links
    });
};

});
parcelRegister("1VOot", function(module, exports) {

$parcel$export(module.exports, "useAccountLinks", () => $3b7b70b0bbf305ad$export$2afde6c526be23b9);

var $7mlNJ = parcelRequire("7mlNJ");
function $3b7b70b0bbf305ad$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink }) {
    const { baseUrl: baseUrl } = (0, $7mlNJ.resolveEnvironment)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileUrl = `${baseUrl}/manage-profile`;
    const manageProfileLink = email ? `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(manageProfileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}` : manageProfileUrl;
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}` : undefined
    };
}

});
parcelRegister("7mlNJ", function(module, exports) {

$parcel$export(module.exports, "resolveEnvironment", () => $a1275d3c212cd93a$export$eabfcea451f48b90);
/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $a1275d3c212cd93a$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $a1275d3c212cd93a$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $a1275d3c212cd93a$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}

});




parcelRegister("dBl98", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6f224f96f6af0c$export$2e2bcd8739ae039);
function $9e6f224f96f6af0c$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $9e6f224f96f6af0c$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $9e6f224f96f6af0c$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9e6f224f96f6af0c$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9e6f224f96f6af0c$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9e6f224f96f6af0c$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9e6f224f96f6af0c$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $9e6f224f96f6af0c$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $9e6f224f96f6af0c$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9e6f224f96f6af0c$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9e6f224f96f6af0c$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $9e6f224f96f6af0c$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $9e6f224f96f6af0c$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $9e6f224f96f6af0c$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $9e6f224f96f6af0c$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $9e6f224f96f6af0c$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $9e6f224f96f6af0c$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $9e6f224f96f6af0c$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $9e6f224f96f6af0c$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $9e6f224f96f6af0c$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $9e6f224f96f6af0c$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $9e6f224f96f6af0c$var$fromHex_1 = $9e6f224f96f6af0c$var$fromHex, $9e6f224f96f6af0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $9e6f224f96f6af0c$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $9e6f224f96f6af0c$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $9e6f224f96f6af0c$var$fromRgb_1 = $9e6f224f96f6af0c$var$fromRgb, $9e6f224f96f6af0c$var$fromCssRgb_1 = $9e6f224f96f6af0c$var$fromCssRgb, $9e6f224f96f6af0c$var$fromHsl_1 = $9e6f224f96f6af0c$var$fromHsl, $9e6f224f96f6af0c$var$fromCssHsl_1 = $9e6f224f96f6af0c$var$fromCssHsl, $9e6f224f96f6af0c$var$fromHsv_1 = $9e6f224f96f6af0c$var$fromHsv, $9e6f224f96f6af0c$var$fromCmyk_1 = $9e6f224f96f6af0c$var$fromCmyk, $9e6f224f96f6af0c$var$fromYiq_1 = $9e6f224f96f6af0c$var$fromYiq, $9e6f224f96f6af0c$var$fromXYZ_1 = $9e6f224f96f6af0c$var$fromXYZ, $9e6f224f96f6af0c$var$fromxyY_1 = $9e6f224f96f6af0c$var$fromxyY, $9e6f224f96f6af0c$var$fromLms_1 = $9e6f224f96f6af0c$var$fromLms, $9e6f224f96f6af0c$var$fromCieLab_1 = $9e6f224f96f6af0c$var$fromCieLab, $9e6f224f96f6af0c$var$fromCieLuv_1 = $9e6f224f96f6af0c$var$fromCieLuv, $9e6f224f96f6af0c$var$fromCieLch_1 = $9e6f224f96f6af0c$var$fromCieLch, $9e6f224f96f6af0c$var$fromHsluv = $9e6f224f96f6af0c$var$fromCieLch$1, $9e6f224f96f6af0c$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $9e6f224f96f6af0c$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $9e6f224f96f6af0c$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $9e6f224f96f6af0c$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsluv
    }
}, $9e6f224f96f6af0c$var$adapt_1 = $9e6f224f96f6af0c$var$adapt, $9e6f224f96f6af0c$var$adjacent_1 = $9e6f224f96f6af0c$var$adjacent, $9e6f224f96f6af0c$var$brightness_1 = $9e6f224f96f6af0c$var$brightness, $9e6f224f96f6af0c$var$complementary_1 = $9e6f224f96f6af0c$var$complementary, $9e6f224f96f6af0c$var$contrast_1 = $9e6f224f96f6af0c$var$contrast, $9e6f224f96f6af0c$var$contrastRatio_1 = $9e6f224f96f6af0c$var$contrastRatio, $9e6f224f96f6af0c$var$convert_1 = $9e6f224f96f6af0c$var$convert, $9e6f224f96f6af0c$var$difference_1 = $9e6f224f96f6af0c$var$difference, $9e6f224f96f6af0c$var$fade_1 = $9e6f224f96f6af0c$var$fade, $9e6f224f96f6af0c$var$greyscale_1 = $9e6f224f96f6af0c$var$greyscale, $9e6f224f96f6af0c$var$hue_1 = $9e6f224f96f6af0c$var$hue, $9e6f224f96f6af0c$var$invert_1 = $9e6f224f96f6af0c$var$invert, $9e6f224f96f6af0c$var$invertLightness_1 = $9e6f224f96f6af0c$var$invertLightness, $9e6f224f96f6af0c$var$mid_1 = $9e6f224f96f6af0c$var$mid, $9e6f224f96f6af0c$var$multiply_1 = $9e6f224f96f6af0c$var$multiply, $9e6f224f96f6af0c$var$saturation_1 = $9e6f224f96f6af0c$var$saturation, $9e6f224f96f6af0c$var$sepia_1 = $9e6f224f96f6af0c$var$sepia, $9e6f224f96f6af0c$var$shade_1 = $9e6f224f96f6af0c$var$shade, $9e6f224f96f6af0c$var$temperature_1 = $9e6f224f96f6af0c$var$temperature, $9e6f224f96f6af0c$var$tetrad_1 = $9e6f224f96f6af0c$var$tetrad, $9e6f224f96f6af0c$var$triad_1 = $9e6f224f96f6af0c$var$triad, $9e6f224f96f6af0c$var$index$2 = {
    adapt: $9e6f224f96f6af0c$var$adapt_1,
    adjacent: $9e6f224f96f6af0c$var$adjacent_1,
    brightness: $9e6f224f96f6af0c$var$brightness_1,
    complementary: $9e6f224f96f6af0c$var$complementary_1,
    contrast: $9e6f224f96f6af0c$var$contrast_1,
    contrastRatio: $9e6f224f96f6af0c$var$contrastRatio_1,
    convert: $9e6f224f96f6af0c$var$convert_1,
    difference: $9e6f224f96f6af0c$var$difference_1,
    fade: $9e6f224f96f6af0c$var$fade_1,
    greyscale: $9e6f224f96f6af0c$var$greyscale_1,
    hue: $9e6f224f96f6af0c$var$hue_1,
    invert: $9e6f224f96f6af0c$var$invert_1,
    invertLightness: $9e6f224f96f6af0c$var$invertLightness_1,
    mid: $9e6f224f96f6af0c$var$mid_1,
    multiply: $9e6f224f96f6af0c$var$multiply_1,
    saturation: $9e6f224f96f6af0c$var$saturation_1,
    sepia: $9e6f224f96f6af0c$var$sepia_1,
    shade: $9e6f224f96f6af0c$var$shade_1,
    temperature: $9e6f224f96f6af0c$var$temperature_1,
    tetrad: $9e6f224f96f6af0c$var$tetrad_1,
    triad: $9e6f224f96f6af0c$var$triad_1
}, $9e6f224f96f6af0c$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $9e6f224f96f6af0c$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $9e6f224f96f6af0c$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $9e6f224f96f6af0c$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $9e6f224f96f6af0c$var$api_1 = $9e6f224f96f6af0c$var$api, $9e6f224f96f6af0c$var$helpers = {
    getIlluminant: function(r) {
        return $9e6f224f96f6af0c$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $9e6f224f96f6af0c$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $9e6f224f96f6af0c$var$index)if ($9e6f224f96f6af0c$var$index.hasOwnProperty(e) && $9e6f224f96f6af0c$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9e6f224f96f6af0c$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9e6f224f96f6af0c$var$constants, s));
            default:
                return null;
        }
    }
}, $9e6f224f96f6af0c$var$helpers_1 = $9e6f224f96f6af0c$var$helpers, $9e6f224f96f6af0c$var$dependencies = {
    conversions: $9e6f224f96f6af0c$var$index,
    operations: $9e6f224f96f6af0c$var$index$2,
    helpers: $9e6f224f96f6af0c$var$helpers_1
}, $9e6f224f96f6af0c$var$entry = $9e6f224f96f6af0c$var$api_1($9e6f224f96f6af0c$var$dependencies, $9e6f224f96f6af0c$var$constants);
var $9e6f224f96f6af0c$export$2e2bcd8739ae039 = $9e6f224f96f6af0c$var$entry;

});

parcelRegister("kkd2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb9d223b0b7cf891$export$2e2bcd8739ae039);

var $6oxGg = parcelRequire("6oxGg");
var $eb9d223b0b7cf891$export$2e2bcd8739ae039 = (0, $6oxGg.default);

});
parcelRegister("6oxGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ba0ab9c28ed4e99$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8iquX = parcelRequire("8iquX");

var $5MdhH = parcelRequire("5MdhH");
var $9Z342 = parcelRequire("9Z342");
function $0ba0ab9c28ed4e99$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $5uXOq.useContext)((0, $9Z342.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5MdhH.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8iquX.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("8iquX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f751e0b9646d6f0$export$2e2bcd8739ae039);

var $1NXo2 = parcelRequire("1NXo2");
var $9f751e0b9646d6f0$export$2e2bcd8739ae039 = (0, $1NXo2.default);

});
parcelRegister("1NXo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $163625b1dd4167d0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");
const $163625b1dd4167d0$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
function $163625b1dd4167d0$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    // react-18: useId instead
    const context = (0, $5uXOq.useContext)((0, $aatTc.default));
    $163625b1dd4167d0$var$useLayoutEffectSAFE(()=>{
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("5MdhH", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $c97413029b7a2107$export$256c542058532d6f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $c97413029b7a2107$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $c97413029b7a2107$var$LazySuspenseContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $c97413029b7a2107$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($c97413029b7a2107$var$LazySuspenseContext);
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$c97413029b7a2107$var$DynamicFallback.displayName = 'DynamicFallback';
const $c97413029b7a2107$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $5uXOq.useState)(null);
    const mountedRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $2OMIu.jsx)($c97413029b7a2107$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c97413029b7a2107$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $c97413029b7a2107$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$c97413029b7a2107$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("9Z342", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $42d6262fe02cf1a1$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");
const $42d6262fe02cf1a1$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});



parcelRegister("lbWm4", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $e7pfQ = parcelRequire("e7pfQ");

var $2KOtB = parcelRequire("2KOtB");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $f6d7e42845d7fe59$var$forEach(collection, iteratee) {
    var func = $8LQ84(collection) ? $fmP8r : $e7pfQ;
    return func(collection, $2KOtB(iteratee));
}
module.exports = $f6d7e42845d7fe59$var$forEach;

});
parcelRegister("2KOtB", function(module, exports) {

var $etyzk = parcelRequire("etyzk");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $20170833518d35fe$var$castFunction(value) {
    return typeof value == 'function' ? value : $etyzk;
}
module.exports = $20170833518d35fe$var$castFunction;

});


parcelRegister("3T6Xo", function(module, exports) {

var $gDRiW = parcelRequire("gDRiW");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $2d4be7a7064f22f9$var$kebabCase = $gDRiW(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $2d4be7a7064f22f9$var$kebabCase;

});

parcelRegister("c74za", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $8d19ae39f7480d44$var$Global = $dgvY6.Global;
module.exports = {
    name: 'sessionStorage',
    read: $8d19ae39f7480d44$var$read,
    write: $8d19ae39f7480d44$var$write,
    each: $8d19ae39f7480d44$var$each,
    remove: $8d19ae39f7480d44$var$remove,
    clearAll: $8d19ae39f7480d44$var$clearAll
};
function $8d19ae39f7480d44$var$sessionStorage() {
    return $8d19ae39f7480d44$var$Global.sessionStorage;
}
function $8d19ae39f7480d44$var$read(key) {
    return $8d19ae39f7480d44$var$sessionStorage().getItem(key);
}
function $8d19ae39f7480d44$var$write(key, data) {
    return $8d19ae39f7480d44$var$sessionStorage().setItem(key, data);
}
function $8d19ae39f7480d44$var$each(fn) {
    for(var i = $8d19ae39f7480d44$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $8d19ae39f7480d44$var$sessionStorage().key(i);
        fn($8d19ae39f7480d44$var$read(key), key);
    }
}
function $8d19ae39f7480d44$var$remove(key) {
    return $8d19ae39f7480d44$var$sessionStorage().removeItem(key);
}
function $8d19ae39f7480d44$var$clearAll() {
    return $8d19ae39f7480d44$var$sessionStorage().clear();
}

});

parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});
parcelRegister("55pzo", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/** Used as the size to enable large array optimizations. */ var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
    if (comparator) {
        includes = $dA3tP;
        isCommon = false;
    } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
        includes = $40I25;
        isCommon = false;
        values = new $ijRUK(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $3b41410a547f22d2$var$baseDifference;

});


parcelRegister("f4cXA", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("5uXOq")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("2AQVt", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("jc0Aq")).blockDraggingToIFrames);

var $jc0Aq = parcelRequire("jc0Aq");

});
parcelRegister("jc0Aq", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $375245b8c8d856a3$export$6ae1d8fab001518c);

var $bAMyk = parcelRequire("bAMyk");

var $cGlU2 = parcelRequire("cGlU2");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $375245b8c8d856a3$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $375245b8c8d856a3$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $375245b8c8d856a3$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($375245b8c8d856a3$var$isActive) return;
    $375245b8c8d856a3$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$375245b8c8d856a3$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $cGlU2.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $bAMyk.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $375245b8c8d856a3$var$isActive = false;
    });
}
function $375245b8c8d856a3$export$6ae1d8fab001518c({ element: element }) {
    return (0, $bAMyk.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $375245b8c8d856a3$var$tryStart();
        }
    });
}

});


parcelRegister("lRCxc", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("7Kos0")).disableNativeDragPreview);

var $7Kos0 = parcelRequire("7Kos0");

});
parcelRegister("7Kos0", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $83c84ebf8511989e$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $83c84ebf8511989e$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $83c84ebf8511989e$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $83c84ebf8511989e$var$tinyTransparentImage) nativeSetDragImage($83c84ebf8511989e$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("6YRGu", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("iuy0r")).preventUnhandled);

var $iuy0r = parcelRequire("iuy0r");

});
parcelRegister("iuy0r", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $8b57e76cff7b558c$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $iDg6w = parcelRequire("iDg6w");
function $8b57e76cff7b558c$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $8b57e76cff7b558c$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $8b57e76cff7b558c$var$start() {
    $8b57e76cff7b558c$var$cleanup();
    $8b57e76cff7b558c$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $8b57e76cff7b558c$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $8b57e76cff7b558c$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $8b57e76cff7b558c$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $8b57e76cff7b558c$var$cleanup
        },
        ...(0, $iDg6w.getBindingsForBrokenDrags)({
            onDragEnd: $8b57e76cff7b558c$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $8b57e76cff7b558c$var$cleanup() {
    $8b57e76cff7b558c$var$unbindEvents?.();
    $8b57e76cff7b558c$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $8b57e76cff7b558c$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $8b57e76cff7b558c$var$cleanup();
}
const $8b57e76cff7b558c$export$453c0582481cc59d = {
    start: $8b57e76cff7b558c$var$start,
    stop: $8b57e76cff7b558c$var$stop
};

});


parcelRegister("aNsVT", function(module, exports) {

$parcel$export(module.exports, "JSResourceForInteraction", () => $aa85837b83da6cb3$export$e83743682263315a);

var $8X8ig = parcelRequire("8X8ig");

var $6FeX8 = parcelRequire("6FeX8");

var $fpppF = parcelRequire("fpppF");
const $aa85837b83da6cb3$var$cache = (0, $8X8ig.createCache)(new Map());
function $aa85837b83da6cb3$export$e83743682263315a(loader, opts) {
    return $aa85837b83da6cb3$var$cache.get(opts.moduleId, ()=>(0, $6FeX8.PreloadableJSResource)(()=>(0, $fpppF.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});

parcelRegister("3rdd7", function(module, exports) {

$parcel$export(module.exports, "createEntryPoint", () => $9d0fcfb26088d34e$export$fa00dd5c1a75592f);
function $9d0fcfb26088d34e$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("izip4", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $38afde7b6f2a5971$export$5b689ca7b019e89f);

var $lAOer = parcelRequire("lAOer");

var $ex6Pq = parcelRequire("ex6Pq");
const $38afde7b6f2a5971$export$5b689ca7b019e89f = (0, $ex6Pq.withProfiling)(function setInteractionError(interactionName, error) {
    const interaction = (0, $lAOer.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $lAOer.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
});

});

parcelRegister("8yVxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $af02359fbb3193a5$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $lEdH9 = parcelRequire("lEdH9");

var $7u3rk = parcelRequire("7u3rk");

var $7xBz2 = parcelRequire("7xBz2");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $cb0MQ = parcelRequire("cb0MQ");

var $ex6Pq = parcelRequire("ex6Pq");
const $af02359fbb3193a5$var$traceUFOPress = (0, $ex6Pq.withProfiling)(function traceUFOPress(name, timestamp) {
    const rate = (0, $7u3rk.getInteractionRate)(name, 'press');
    const pressInteractionsList = (0, $7u3rk.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $lAOer.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $lEdH9.default)(rate)) {
        (0, $lAOer.abortAll)('new_interaction', name);
        const startTimestamp = timestamp ?? performance.now();
        const newId = (0, $7Jxgt.v4)();
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $7xBz2.setInteractionActiveTrace)(newId, 'press');
        (0, $32M8E.DefaultInteractionID).current = newId;
        (0, $lAOer.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $cb0MQ.default).current, (0, $7xBz2.getActiveTrace)());
    }
});
var $af02359fbb3193a5$export$2e2bcd8739ae039 = $af02359fbb3193a5$var$traceUFOPress;

});

parcelRegister("3RTQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a791e66289e5ae8b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9ewsv = parcelRequire("9ewsv");
function $a791e66289e5ae8b$export$2e2bcd8739ae039(name) {
    const context = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("bWn3s", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $8b16fea90e636ddb$export$c9058316764c140e);

var $dv0OY = parcelRequire("dv0OY");

var $3XwZB = parcelRequire("3XwZB");
function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
    return (0, $3XwZB.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
}

});
parcelRegister("3XwZB", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $2e2079715de82b22$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("FISJv", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $5wIsF = parcelRequire("5wIsF");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $07d6a509d0c9362c$var$pull = $g7i7g($5wIsF);
module.exports = $07d6a509d0c9362c$var$pull;

});
parcelRegister("5wIsF", function(module, exports) {

var $anVYT = parcelRequire("anVYT");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $40626e026fe1545a$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $anVYT(array, values) : array;
}
module.exports = $40626e026fe1545a$var$pullAll;

});
parcelRegister("anVYT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $2wwA6 = parcelRequire("2wwA6");

var $jA03V = parcelRequire("jA03V");

var $cW28x = parcelRequire("cW28x");

var $jHlUS = parcelRequire("jHlUS");
/** Used for built-in method references. */ var $78f90735d44c9d27$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $78f90735d44c9d27$var$splice = $78f90735d44c9d27$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $78f90735d44c9d27$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $jA03V : $2wwA6, index = -1, length = values.length, seen = array;
    if (array === values) values = $jHlUS(values);
    if (iteratee) seen = $1nIHN(array, $cW28x(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $78f90735d44c9d27$var$splice.call(seen, fromIndex, 1);
            $78f90735d44c9d27$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $78f90735d44c9d27$var$basePullAll;

});
parcelRegister("jA03V", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e4116d7d57d0dfb7$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $e4116d7d57d0dfb7$var$baseIndexOfWith;

});




parcelRegister("aBnek", function(module, exports) {

$parcel$export(module.exports, "default", () => $94e5835fd8866d6d$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dnFM9 = parcelRequire("dnFM9");


var $eZVAh = parcelRequire("eZVAh");

var $8RXs9 = parcelRequire("8RXs9");

var $dAK4M = parcelRequire("dAK4M");

var $aO6RD = parcelRequire("aO6RD");

var $gANiX = parcelRequire("gANiX");

var $cNW3X = parcelRequire("cNW3X");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");
const $94e5835fd8866d6d$var$sucessWrapperStyles = (0, $2s57o.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    // @ts-ignore --https://product-fabric.atlassian.net/browse/DSP-20920
    backgroundColor: "var(--ds-icon-success, #22A06B)",
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94e5835fd8866d6d$var$discoveryWrapperStyles = (0, $2s57o.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    // @ts-ignore --https://product-fabric.atlassian.net/browse/DSP-20920
    backgroundColor: "var(--ds-icon-discovery, #8270DB)",
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
var $94e5835fd8866d6d$export$2e2bcd8739ae039 = (0, $8RXs9.default)(({ isOpen: isOpen, title: title, completed: completed, onClick: onClick, onDismiss: onDismiss, intl: intl })=>{
    const hasDismissButton = typeof onDismiss === 'function';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eZVAh.ChecklistButtonWrapper), {
        isOpen: isOpen,
        hasDismissButton: hasDismissButton,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eZVAh.ChecklistButton), {
                completed: Boolean(completed),
                onClick: onClick,
                hasDismissButton: hasDismissButton,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dnFM9))), {
                        LEGACY_size: "medium",
                        color: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`,
                        spacing: "spacious",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZVAh.ButtonTitle), {
                        children: title
                    })
                ]
            }),
            hasDismissButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                onClick: onDismiss,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: (0, $eZVAh.dismissButtonInlineStyles),
                "aria-label": intl.formatMessage((0, $dAK4M.default).dismissButtonAria, {
                    title: title
                }),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    children: (0, $fHpHg.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
                        xcss: completed ? $94e5835fd8866d6d$var$sucessWrapperStyles : $94e5835fd8866d6d$var$discoveryWrapperStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
                            color: "currentColor",
                            label: ''
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aO6RD))), {
                        label: "",
                        LEGACY_size: "large",
                        color: completed ? `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G500})` : `var(--ds-icon-discovery, ${(0, $a7f8c6b391092279$exports).P500})`,
                        LEGACY_secondaryColor: completed ? `var(--ds-background-accent-green-subtlest, ${(0, $a7f8c6b391092279$exports).G50})` : `var(--ds-background-accent-purple-subtlest, ${(0, $a7f8c6b391092279$exports).P50})`,
                        "aria-hidden": "true"
                    })
                }),
                testId: 'checklist-button--dismiss-button'
            })
        ]
    });
});

});
parcelRegister("eZVAh", function(module, exports) {

$parcel$export(module.exports, "ChecklistButton", () => $fe175755414e3a73$export$39831ffcddfb39de);
$parcel$export(module.exports, "ButtonTitle", () => $fe175755414e3a73$export$c72d460b11e49d5c);
$parcel$export(module.exports, "ChecklistButtonWrapper", () => $fe175755414e3a73$export$728120c5a1ef2e80);
$parcel$export(module.exports, "dismissButtonInlineStyles", () => $fe175755414e3a73$export$a66679212d4257fd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

function $fe175755414e3a73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fe175755414e3a73$var$buttonTitleStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.inverse',
    margin: '0',
    paddingLeft: 'space.050',
    paddingRight: 'space.100'
});
const $fe175755414e3a73$export$39831ffcddfb39de = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        onClick: props.onClick,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)({
            borderRadius: '24px',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            border: 'none',
            outline: 'none',
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: props.completed ? `var(--ds-background-success-bold, ${(0, $a7f8c6b391092279$exports).G400})` : `var(--ds-background-discovery-bold, ${(0, $a7f8c6b391092279$exports).P300})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: props.hasDismissButton ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-500, 40px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
            boxShadow: `var(--ds-shadow-overlay, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `0 8px 16px -4px ${(0, $a7f8c6b391092279$exports).N50A}, 0 0 1px ${(0, $a7f8c6b391092279$exports).N60A}`})`,
            transition: 'all 0.8s ease-in-out',
            display: 'inline-flex',
            alignItems: 'center',
            overflow: 'hidden',
            '&:hover': {
                cursor: 'pointer'
            }
        })
    }, children);
const $fe175755414e3a73$export$c72d460b11e49d5c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
        as: "h3",
        xcss: $fe175755414e3a73$var$buttonTitleStyles
    }, children);
const $fe175755414e3a73$var$fade = {
    name: "74uqaf",
    styles: "from{opacity:0;}to{opacity:1;}@keyframes fade{from{opacity:0;}to{opacity:1;}}animation:fade 0.6s ease-in-out"
};
const $fe175755414e3a73$var$getChecklistButtonWrapperDisplay = (props)=>{
    if (props.isOpen) {
        if (props.hasDismissButton) return 'inline-block';
        else // TODO: Check if we can simplify this logic, and have inline-block always
        // need to check confluence
        return 'block';
    } else return 'none';
};
const $fe175755414e3a73$export$728120c5a1ef2e80 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.hasDismissButton && `position: relative;`, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: $fe175755414e3a73$var$getChecklistButtonWrapperDisplay(props)
        }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $fe175755414e3a73$var$fade)
    }, children);
const $fe175755414e3a73$export$a66679212d4257fd = {
    position: 'absolute',
    right: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: '50%',
    width: '34px',
    height: '34px'
};

});

parcelRegister("dAK4M", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd70368d4f88dc7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bdd70368d4f88dc7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismissButtonAria: {
        id: 'growth-checklist.dismissButtonAria',
        defaultMessage: 'Dismiss {title}',
        description: 'Text for screen readers only to describe that this will dismiss the button.'
    }
});

});


parcelRegister("bdDiz", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("4YnVl", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessStandardPubTouchpoint", () => $5e81257452cea13f$export$bf5f4133d9c358a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $bngFq = parcelRequire("bngFq");

var $eOat1 = parcelRequire("eOat1");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");
const $5e81257452cea13f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: 'persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label',
        defaultMessage: 'Try the Premium plan',
        description: 'Account profile menu item label for free plan.'
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: 'persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge',
        defaultMessage: 'FREE 30-DAY TRIAL',
        description: 'Account profile menu item lozenge for free plan'
    }
});
const $5e81257452cea13f$var$menuItemContentStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $5e81257452cea13f$var$lozengeContainerStyles = (0, $2s57o.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $5e81257452cea13f$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eWkgo.default), {
        xcss: $5e81257452cea13f$var$menuItemContentStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$5e81257452cea13f$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $5e81257452cea13f$var$lozengeContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
                    appearance: "new",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...$5e81257452cea13f$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment
                    })
                })
            })
        ]
    });
}
function $5e81257452cea13f$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleOnError = (0, $5uXOq.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5e81257452cea13f$var$EditionAwarenessStandardPubTouchpointImpl, {
            ...props
        })
    });
}

});

parcelRegister("esLaG", function(module, exports) {

$parcel$export(module.exports, "getHamsKey", () => $548604a6d0397041$export$291d012eb0744b34);
const $548604a6d0397041$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $548604a6d0397041$export$291d012eb0744b34 = (product)=>{
    return $548604a6d0397041$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("6Csk1", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $4NkAS = parcelRequire("4NkAS");

var $9MM2g = parcelRequire("9MM2g");

var $hTJwX = parcelRequire("hTJwX");

var $evszO = parcelRequire("evszO");

var $66FNL = parcelRequire("66FNL");
/** Used for built-in method references. */ var $4d1c42d4f14298ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4d1c42d4f14298ee$var$hasOwnProperty = $4d1c42d4f14298ee$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $4d1c42d4f14298ee$var$assign = $9MM2g(function(object, source) {
    if ($evszO(source) || $hTJwX(source)) {
        $4NkAS(source, $66FNL(source), object);
        return;
    }
    for(var key in source)if ($4d1c42d4f14298ee$var$hasOwnProperty.call(source, key)) $hsOo6(object, key, source[key]);
});
module.exports = $4d1c42d4f14298ee$var$assign;

});

parcelRegister("3gy1Y", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => (parcelRequire("3JQ2X")).Behaviours);
$parcel$export(module.exports, "TargetTabs", () => (parcelRequire("3JQ2X")).TargetTabs);
$parcel$export(module.exports, "Prompts", () => (parcelRequire("3JQ2X")).Prompts);
$parcel$export(module.exports, "createProvisioningPageExtensions", () => (parcelRequire("4zCZO")).createProvisioningPageExtensions);
$parcel$export(module.exports, "createProvisioningApiExtensions", () => (parcelRequire("hscFL")).createProvisioningApiExtensions);
$parcel$export(module.exports, "createRecommendationContextExtensions", () => (parcelRequire("8isdv")).createRecommendationContextExtensions);

var $3JQ2X = parcelRequire("3JQ2X");

var $3b4m9 = parcelRequire("3b4m9");

var $02cqA = parcelRequire("02cqA");

var $6d81p = parcelRequire("6d81p");

var $4zCZO = parcelRequire("4zCZO");

var $hscFL = parcelRequire("hscFL");

var $8isdv = parcelRequire("8isdv");

var $e3qFF = parcelRequire("e3qFF");

});
parcelRegister("3JQ2X", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => $cead2e6c3b9275dc$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $cead2e6c3b9275dc$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $cead2e6c3b9275dc$export$d1609d6291f3d60d);
const $cead2e6c3b9275dc$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $cead2e6c3b9275dc$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $cead2e6c3b9275dc$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $cead2e6c3b9275dc$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});

parcelRegister("3b4m9", function(module, exports) {

var $e3qFF = parcelRequire("e3qFF");

var $3JQ2X = parcelRequire("3JQ2X");
const $d3bc30d7c15c2da0$export$196a138f6d49c2bb = [
    'edition'
];
const $d3bc30d7c15c2da0$export$28c762e8047316d8 = (0, $e3qFF.createProductExtensions)($d3bc30d7c15c2da0$export$196a138f6d49c2bb);

});
parcelRegister("e3qFF", function(module, exports) {

$parcel$export(module.exports, "createProductExtensions", () => $60d1924059600f01$export$42e62ee12e8ced48);
parcelRequire("bBrJC");
var $eloN0 = parcelRequire("eloN0");
const $60d1924059600f01$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $60d1924059600f01$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $60d1924059600f01$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $eloN0.CrossFlowExtensions)(filteredOptions);
    };
const $60d1924059600f01$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $eloN0.CrossFlowExtensions)(combinedOptions);
};

});
parcelRegister("bBrJC", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("eloN0")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("e2eQU")).Targets);

var $eloN0 = parcelRequire("eloN0");

var $e2eQU = parcelRequire("e2eQU");

});
parcelRegister("eloN0", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => $2fe4638960909bc8$export$a5e53d1dcbd6eb61);
class $2fe4638960909bc8$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("e2eQU", function(module, exports) {

$parcel$export(module.exports, "Targets", () => $882bc574cddb5b98$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $882bc574cddb5b98$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand'
};

});




parcelRegister("02cqA", function(module, exports) {

var $e3qFF = parcelRequire("e3qFF");

var $3JQ2X = parcelRequire("3JQ2X");
const $2c841fc79bb02c6c$export$390f3b1f433f2095 = [
    'edition',
    'migrationSourceUuid',
    'grantAccessTo'
];
const $2c841fc79bb02c6c$export$386012fe624cad4 = (0, $e3qFF.createProductExtensions)($2c841fc79bb02c6c$export$390f3b1f433f2095);

});

parcelRegister("6d81p", function(module, exports) {

var $e3qFF = parcelRequire("e3qFF");

var $3JQ2X = parcelRequire("3JQ2X");
const $a1841d79a9668050$export$c41268b4369999ed = [
    'edition',
    'migrationSourceUuid'
];
const $a1841d79a9668050$export$a60e4abab2cc3b2b = (0, $e3qFF.createProductExtensions)($a1841d79a9668050$export$c41268b4369999ed);

});

parcelRegister("4zCZO", function(module, exports) {

$parcel$export(module.exports, "createProvisioningPageExtensions", () => $f21ca417ccb0b780$export$f05508383d0ca130);

var $e3qFF = parcelRequire("e3qFF");
const $f21ca417ccb0b780$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $f21ca417ccb0b780$export$f05508383d0ca130 = (options)=>(0, $e3qFF.createProductExtensions)($f21ca417ccb0b780$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});

parcelRegister("hscFL", function(module, exports) {

$parcel$export(module.exports, "createProvisioningApiExtensions", () => $e7de5b02a9cbe4ac$export$530ae557c94159b9);

var $e3qFF = parcelRequire("e3qFF");
const $e7de5b02a9cbe4ac$export$bba48927994d7f26 = [
    'provisioningApiParams'
];
const $e7de5b02a9cbe4ac$export$530ae557c94159b9 = (options)=>(0, $e3qFF.createProductExtensions)($e7de5b02a9cbe4ac$export$bba48927994d7f26)({
        provisioningApiParams: options
    });

});

parcelRegister("8isdv", function(module, exports) {

$parcel$export(module.exports, "createRecommendationContextExtensions", () => $9ea6c8bd95590701$export$d1baeed0bd0517aa);

var $e3qFF = parcelRequire("e3qFF");
const $9ea6c8bd95590701$export$4227e3a27cbd377 = [
    'recommendationContext'
];
const $9ea6c8bd95590701$export$d1baeed0bd0517aa = (options)=>(0, $e3qFF.createProductExtensions)($9ea6c8bd95590701$export$4227e3a27cbd377)({
        recommendationContext: options
    });

});


parcelRegister("Q9DHJ", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("bpIpv")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("bpIpv")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("bpIpv")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("1uvtc")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("1uvtc")).Reasons);

var $bpIpv = parcelRequire("bpIpv");

var $1uvtc = parcelRequire("1uvtc");

});
parcelRegister("bpIpv", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $ecc0c693714e063c$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $ecc0c693714e063c$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $ecc0c693714e063c$export$655b6c19a0daddb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iTqxD = parcelRequire("iTqxD");

var $3FM4S = parcelRequire("3FM4S");

var $1uvtc = parcelRequire("1uvtc");
const $ecc0c693714e063c$var$LATEST_VERSION = (0, $3FM4S.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $ecc0c693714e063c$var$CrossFlowContext = /*#__PURE__*/ (0, $5uXOq.createContext)(()=>({
        isEnabled: false,
        reason: (0, $1uvtc.Reasons).NO_PROVIDER
    }));
const $ecc0c693714e063c$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $3FM4S.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $iTqxD.createAPIv0)(onOpen),
                    apiV1: (0, $3FM4S.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $1uvtc.Reasons).NO_API_SUPPORT
                };
        }
    };
const $ecc0c693714e063c$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $5uXOq.useMemo)(()=>$ecc0c693714e063c$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ecc0c693714e063c$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $ecc0c693714e063c$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $5uXOq.useContext)($ecc0c693714e063c$var$CrossFlowContext);
    return (0, $5uXOq.useMemo)(()=>negotiateApi($ecc0c693714e063c$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $ecc0c693714e063c$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $ecc0c693714e063c$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("iTqxD", function(module, exports) {

$parcel$export(module.exports, "createAPIv0", () => $6af45ca84e83a1e8$export$9ff7368ac93fcf2d);
const $6af45ca84e83a1e8$export$a4ad2735b021c132 = 0;
const $6af45ca84e83a1e8$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("3FM4S", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $16712312997f9a12$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv1", () => $16712312997f9a12$export$8fd5792fc468459f);
const $16712312997f9a12$export$a4ad2735b021c132 = 1;
const $16712312997f9a12$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("1uvtc", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $378dcc21de017ee8$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $378dcc21de017ee8$export$da2d4f2f250d6f84);
const $378dcc21de017ee8$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $378dcc21de017ee8$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("aRT0u", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $b6e48dd1dbfe28cb$export$c2095165ae2bdcda);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $7HXPn = parcelRequire("7HXPn");

var $7VQFv = parcelRequire("7VQFv");
function $b6e48dd1dbfe28cb$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $5uXOq.useRef)();
    const firedViewedUIEventId = (0, $5uXOq.useRef)();
    const mapToCcpProductKeys = (0, $5uXOq.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $7HXPn.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $7HXPn.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $5uXOq.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $7VQFv.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $7VQFv.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $7VQFv.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $7VQFv.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $7VQFv.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $7VQFv.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("7HXPn", function(module, exports) {

$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $229143f74ca0ee76$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $229143f74ca0ee76$export$54e3fc09a2a3347a);
const $229143f74ca0ee76$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $229143f74ca0ee76$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $229143f74ca0ee76$export$6c053e1694ef181c = {
    prod: $229143f74ca0ee76$export$31048cb2a0753b12,
    staging: $229143f74ca0ee76$export$9d8f18312db80469
};
const $229143f74ca0ee76$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("7VQFv", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $31c898fe6f7eb580$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $31c898fe6f7eb580$export$285f3d0989f9023f);
const $31c898fe6f7eb580$export$c536a7e29a0739b8 = 'crossFlow';
var $31c898fe6f7eb580$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});


parcelRegister("s7Ri8", function(module, exports) {

var $ck5fJ = parcelRequire("ck5fJ");

var $a1YLW = parcelRequire("a1YLW");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $0548b62ea127d690$var$shuffle(collection) {
    var func = $8LQ84(collection) ? $ck5fJ : $a1YLW;
    return func(collection);
}
module.exports = $0548b62ea127d690$var$shuffle;

});
parcelRegister("ck5fJ", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $ifvdh = parcelRequire("ifvdh");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $8f8b6d61b1553b58$var$arrayShuffle(array) {
    return $ifvdh($jHlUS(array));
}
module.exports = $8f8b6d61b1553b58$var$arrayShuffle;

});
parcelRegister("ifvdh", function(module, exports) {

var $diicZ = parcelRequire("diicZ");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $d491d6fac47da618$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $diicZ(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = $d491d6fac47da618$var$shuffleSelf;

});
parcelRegister("diicZ", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9adb14a65c3f9737$var$nativeFloor = Math.floor, $9adb14a65c3f9737$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $9adb14a65c3f9737$var$baseRandom(lower, upper) {
    return lower + $9adb14a65c3f9737$var$nativeFloor($9adb14a65c3f9737$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $9adb14a65c3f9737$var$baseRandom;

});



parcelRegister("a1YLW", function(module, exports) {

var $ifvdh = parcelRequire("ifvdh");

var $dMEgP = parcelRequire("dMEgP");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $74d923783422b512$var$baseShuffle(collection) {
    return $ifvdh($dMEgP(collection));
}
module.exports = $74d923783422b512$var$baseShuffle;

});


parcelRegister("6eBRn", function(module, exports) {
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $48a16b14c2519b21$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = $48a16b14c2519b21$var$fromPairs;

});

parcelRegister("avEd9", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $21d6664bee8a1c2d$export$a55b02efe3d62583);

var $2OMIu = parcelRequire("2OMIu");

var $dMGFS = parcelRequire("dMGFS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5tDD0 = parcelRequire("5tDD0");

var $kBxPf = parcelRequire("kBxPf");

var $fqnSg = parcelRequire("fqnSg");

var $fYoko = parcelRequire("fYoko");

var $eiizX = parcelRequire("eiizX");

var $bYAAX = parcelRequire("bYAAX");

var $esLaG = parcelRequire("esLaG");

var $j1hPA = parcelRequire("j1hPA");

var $sKnbe = parcelRequire("sKnbe");

var $7DrXv = parcelRequire("7DrXv");

var $ZgFnS = parcelRequire("ZgFnS");

var $a5mGe = parcelRequire("a5mGe");
function $21d6664bee8a1c2d$var$getBillingSourceSystem(typename) {
    switch(typename){
        case 'CcpEntitlement':
            return 'CCP';
        case 'HamsEntitlement':
            return 'HAMS';
    }
}
/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $21d6664bee8a1c2d$var$EditionAwarenessImpl({ freeButton: freeButton, trialButton: trialButton, ...props }) {
    const { edition: edition, product: product, cloudId: cloudId, userRoles: userRolesFromProduct, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, siteType: siteType, isInReverseTrial: isInReverseTrial, onOpenOnboardingMenu: onOpenOnboardingMenu, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen } = props;
    const config = (0, $j1hPA.useConfig)(product, edition);
    const { isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = (0, $sKnbe.useSpotlight)();
    const trialOfferingName = (0, $bYAAX.getTrialOfferingName)(edition, config);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $dMGFS.default), {
        shouldSkip: config?.shouldSkip === true,
        trialOfferingName: trialOfferingName,
        shouldCheckForChangeOffering: edition === 'free',
        shouldCheckForTrial: edition === 'premium' || edition === 'standard',
        cloudId: cloudId,
        productKey: (0, $esLaG.getHamsKey)(product),
        shouldCheckForChargeQuantities: config.warnOnUserLimit === true || config.isStandardTrialsUserAndStorageLimitBreakersEnabled === true || // Confluence doesn't use `warnOnUserLimit` and has its own variety
        product === 'confluence' && edition === 'free',
        // The entitlement filter ensures that we apply the `inTrialOrPreDunning` only when an entitlement is
        // on a non free edition. The filter is based on the trial end timestamp inside of TCS, this means that
        // if a customer downgrades their product to free while on a trial, then they will only show up
        // if inTrialOrPreDunning is set to true as the filter assumes they are still on trial.
        entitlementFilter: edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null,
        chargeElement: (0, $fqnSg.getChargeElementKey)(product),
        shouldCheckBillingAdmin: config.shouldCheckBillingAdmin === true,
        shouldCheckForTwc: config.shouldCheckForTwc === true,
        shouldCheckForStorageUsageJira: product === 'jira' && config.isStandardTrialsUserAndStorageLimitBreakersEnabled === true,
        applicationKey: (0, $fYoko.getJiraApplicationKey)(product) ?? 'JIRA_SOFTWARE',
        shouldCheckForStorageUsageConfluence: product === 'confluence' && config.isStandardTrialsUserAndStorageLimitBreakersEnabled === true
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const isInvoiceable = entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const canAddPaymentDetails = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.isAvailableToUser === true;
    const addPaymentDetailsExperienceUrl = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.experienceUrl;
    const trialDaysLeft = (0, $eiizX.getTrialDaysLeft)(entitlement?.subscription?.trial?.timeLeft);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && !isInvoiceable;
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingExperienceUrl);
    const billingSourceSystem = $21d6664bee8a1c2d$var$getBillingSourceSystem(entitlement?.__typename);
    const isInTeamWorkCollection = (0, $5uXOq.useMemo)(()=>{
        const collectionEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION');
        return !!collectionEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const userRoles = (0, $5uXOq.useMemo)(()=>{
        const roles = [];
        if (userRolesFromProduct?.includes('SITE_ADMIN')) roles.push('SITE_ADMIN');
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            isInvoiceable: isInvoiceable,
            canAddPaymentDetails: canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            trialDaysLeft: trialDaysLeft,
            trialLengthDays: trialLengthDays,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            isInTeamWorkCollection: isInTeamWorkCollection,
            config: config,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            siteType: siteType,
            isSpotlightActive: isSpotlightActive,
            handleSetSpotlight: handleSetSpotlight,
            billingSourceSystem: billingSourceSystem,
            onOpenOnboardingMenu: onOpenOnboardingMenu,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen
        };
    }, [
        cloudId,
        product,
        edition,
        isInvoiceable,
        canAddPaymentDetails,
        addPaymentDetailsExperienceUrl,
        trialDaysLeft,
        trialLengthDays,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        isInTeamWorkCollection,
        config,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        siteType,
        isSpotlightActive,
        handleSetSpotlight,
        billingSourceSystem,
        onOpenOnboardingMenu,
        shouldAutoOpen,
        onAutoOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBxPf.EditionAwarenessContext).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ZgFnS.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "audience-and-timing",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7DrXv.AudienceAndTiming), {
                    freeButton: freeButton,
                    trialButton: trialButton,
                    entitlement: data
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a5mGe.Spotlight), {})
            ]
        })
    });
}
function $21d6664bee8a1c2d$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5tDD0.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ZgFnS.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($21d6664bee8a1c2d$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}

});
parcelRegister("dMGFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $54179a5573de5117$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fb54b74a2cdb8975438579ca74f56bb>>
 * @relayHash 1bb9f4ed5bfbcdceb4c4b7815eddf2f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c92e138c9ea9d124f98e82ddb0e907fa61396129dd431b760e8f235ec8e7c8d
const $54179a5573de5117$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckBillingAdmin"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChangeOffering"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageConfluence"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTwc"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "trialOfferingName"
    }, v14 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v15 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v16 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "trialOfferingName"
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v23 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v24 = {
        "kind": "ScalarField",
        "name": "lengthDays"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v26 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v27 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "id"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "audienceAndTiming_AtlassianEditionAwareness"
                },
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChangeOffering",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "experienceCapabilities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "args": v18 /*: any*/ ,
                                                                    "kind": "LinkedField",
                                                                    "name": "changeOfferingV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForTwc",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v13 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v11 /*: any*/ ,
                v9 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "args": v16 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChargeQuantities",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "chargeElement",
                                                                    "variableName": "chargeElement"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "latestUsageForChargeElement"
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChangeOffering",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "experienceCapabilities",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "args": v18 /*: any*/ ,
                                                                    "kind": "LinkedField",
                                                                    "name": "changeOfferingV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v29 /*: any*/ ,
                                                                                    "type": "CcpInvoiceGroup"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v29 /*: any*/ ,
                                                                    "type": "CcpSubscription"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v29 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v29 /*: any*/ ,
                                                                    "type": "CcpTransactionAccount"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForTwc",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForStorageUsageJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "applicationKey",
                                            "variableName": "applicationKey"
                                        },
                                        v30 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageUsed"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForStorageUsageConfluence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v30 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceStorage",
                            "kind": "LinkedField",
                            "name": "confluence_storage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "bytesUsed"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c92e138c9ea9d124f98e82ddb0e907fa61396129dd431b760e8f235ec8e7c8d",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$54179a5573de5117$var$node.hash = "482b3db87cad9ffcc5dac49733c4646a";
var $54179a5573de5117$export$2e2bcd8739ae039 = $54179a5573de5117$var$node;

});

parcelRegister("kBxPf", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContext", () => $c858d77a8c8a5481$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "SiteInformationContext", () => $c858d77a8c8a5481$export$75245469222eca6d);
$parcel$export(module.exports, "useEditionAwareness", () => $c858d77a8c8a5481$export$5a5baedfe8151ce);
$parcel$export(module.exports, "useSiteInformation", () => $c858d77a8c8a5481$export$85d61ed9f9a4edc6);

var $5uXOq = parcelRequire("5uXOq");
const $c858d77a8c8a5481$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c858d77a8c8a5481$export$75245469222eca6d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $c858d77a8c8a5481$export$5a5baedfe8151ce() {
    const context = (0, $5uXOq.useContext)($c858d77a8c8a5481$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}
function $c858d77a8c8a5481$export$85d61ed9f9a4edc6() {
    const context = (0, $5uXOq.useContext)($c858d77a8c8a5481$export$75245469222eca6d);
    if (!context) throw new Error('Missing context, please ensure this is used within SiteInformationContext');
    return context;
}

});

parcelRegister("fqnSg", function(module, exports) {

$parcel$export(module.exports, "getChargeElementKey", () => $2d6746688a18e51e$export$58e4e89574623b4);
const $2d6746688a18e51e$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent'
};
const $2d6746688a18e51e$export$58e4e89574623b4 = (product)=>{
    return $2d6746688a18e51e$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};

});

parcelRegister("fYoko", function(module, exports) {

$parcel$export(module.exports, "getJiraApplicationKey", () => $fe4881b6141747d3$export$2fd6994252e4887f);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $fe4881b6141747d3$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK'
};
const $fe4881b6141747d3$export$2fd6994252e4887f = (product)=>{
    return $fe4881b6141747d3$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};

});

parcelRegister("eiizX", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $9fb7818c336de4e0$export$954628993bf3188e);
const $9fb7818c336de4e0$var$MILLISECOND_IN_A_DAY = 86400000;
function $9fb7818c336de4e0$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / $9fb7818c336de4e0$var$MILLISECOND_IN_A_DAY);
}

});

parcelRegister("bYAAX", function(module, exports) {

$parcel$export(module.exports, "getTrialOfferingName", () => $dd6bdd8687199588$export$38ffae8c634274ba);
const $dd6bdd8687199588$export$38ffae8c634274ba = (edition, config)=>{
    if (edition === 'standard' && config.isPaidStandard) return 'premium';
    return 'standard';
};

});

parcelRegister("j1hPA", function(module, exports) {

$parcel$export(module.exports, "useConfig", () => $8b631e4844794b3e$export$b3611e87cd5ba6ce);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
function $8b631e4844794b3e$export$b3611e87cd5ba6ce(product, edition) {
    return (0, $5uXOq.useMemo)(()=>{
        if (product === 'jira-product-discovery') {
            if (edition === 'free') return {
                shouldSkip: (0, $fHpHg.fg)('jpd_disable_edition_awareness'),
                warnOnUserLimit: (0, $fHpHg.fg)('new_ea_jira_product_discovery_free'),
                shouldCheckBillingAdmin: false
            };
            else if (edition === 'standard' || edition === 'premium') return {
                shouldSkip: (0, $fHpHg.fg)('jpd_disable_edition_awareness')
            };
        }
        if (product === 'jira') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                warnOnUserLimit: (0, $fHpHg.fg)('new_ea_jira_free_modal_refresh'),
                shouldCheckForTwc: (0, $fHpHg.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'standard') return {
                isStandardTrialsUserAndStorageLimitBreakersEnabled: (0, $fHpHg.fg)('jira_edition_awareness_standard_trials_gate'),
                isPaidStandard: (0, $fHpHg.fg)('edition_awareness_upsell_jira_fg'),
                shouldCheckForTwc: (0, $fHpHg.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'premium') return {
                shouldCheckForTwc: (0, $fHpHg.fg)('teamwork_collection_ea_modal')
            };
        }
        if (product === 'jira-service-management') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                warnOnUserLimit: (0, $fHpHg.fg)('new_ea_jira_service_management_free')
            };
            if (edition === 'standard') return {
                isPaidStandard: (0, $fHpHg.fg)('edition_awareness_upsell_jsm_fg')
            };
        }
        if (product === 'confluence') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                shouldCheckForTwc: (0, $fHpHg.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'standard') return {
                isStandardTrialsUserAndStorageLimitBreakersEnabled: (0, $fHpHg.fg)('connie_edition_awareness_standard_trials_gate'),
                isPaidStandard: (0, $fHpHg.fg)('edition_awareness_upsell_confluence_aa_fg') || (0, $fHpHg.fg)('edition_awareness_standard_upsell_confluence_ab_fg'),
                shouldCheckForTwc: (0, $fHpHg.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'premium') return {
                shouldCheckForTwc: (0, $fHpHg.fg)('teamwork_collection_ea_modal')
            };
        }
        // Default return for other products and editions
        return {};
    }, [
        product,
        edition
    ]);
}

});

parcelRegister("sKnbe", function(module, exports) {

$parcel$export(module.exports, "useSpotlight", () => $75be8436d888ab81$export$cc7026713a353975);

var $5uXOq = parcelRequire("5uXOq");
function $75be8436d888ab81$export$cc7026713a353975() {
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const handleSetSpotlight = (0, $5uXOq.useCallback)((isActive)=>{
        setIsSpotlightActive(isActive);
    }, [
        setIsSpotlightActive
    ]);
    return {
        isSpotlightActive: isSpotlightActive,
        handleSetSpotlight: handleSetSpotlight
    };
}

});

parcelRegister("7DrXv", function(module, exports) {

$parcel$export(module.exports, "AudienceAndTiming", () => $2aa7bb0da7795442$export$d288e6ad7a0cf9f8);

var $2OMIu = parcelRequire("2OMIu");

var $bijqf = parcelRequire("bijqf");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fHpHg = parcelRequire("fHpHg");

var $jXOZU = parcelRequire("jXOZU");

var $kBxPf = parcelRequire("kBxPf");

var $c2qKY = parcelRequire("c2qKY");
/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness
 */ function $2aa7bb0da7795442$var$useTrackAudienceAndTiming(isEligible) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible
    ]);
}
/**
 * Tracks when a user should see the edition awareness experience
 */ function $2aa7bb0da7795442$var$Analytics({ children: children }) {
    $2aa7bb0da7795442$var$useTrackAudienceAndTiming(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
}
/**
 * Just sends ineligibility info through a `eligibilityCriteria checked` event.
 * This exists so we can optionally render this component
 */ function $2aa7bb0da7795442$var$IneligibleAnalytics() {
    $2aa7bb0da7795442$var$useTrackAudienceAndTiming(false);
    return null;
}
function $2aa7bb0da7795442$export$d288e6ad7a0cf9f8({ freeButton: freeButton, trialButton: trialButton, entitlement: entitlement }) {
    const data = (0, $8Uumt.useFragment)((0, $bijqf.default), entitlement);
    const context = (0, $kBxPf.useEditionAwareness)();
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, canUpgrade: canUpgrade, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails, config: config } = context;
    const isInTrialOrPredunning = isInTrial || isInPredunning;
    if (config.shouldSkip) return null;
    if (edition === 'free' && canUpgrade) return /*#__PURE__*/ (0, $2OMIu.jsx)($2aa7bb0da7795442$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2qKY.ActionsAndContent), {
            entitlement: data,
            freeButton: freeButton
        })
    });
    if (edition === 'standard' && isInTrialOrPredunning && isInvoiceable === false && canAddPaymentDetails) return /*#__PURE__*/ (0, $2OMIu.jsx)($2aa7bb0da7795442$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2qKY.ActionsAndContent), {
            entitlement: data,
            trialButton: trialButton
        })
    });
    if (edition === 'premium' && [
        'jira',
        'jira-service-management'
    ].includes(product) && isInTrialOrPredunning && isInvoiceable === false && canAddPaymentDetails) return /*#__PURE__*/ (0, $2OMIu.jsx)($2aa7bb0da7795442$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2qKY.ActionsAndContent), {
            entitlement: data,
            trialButton: trialButton
        })
    });
    if (product === 'confluence' && edition === 'premium' && isInTrialOrPredunning) // Confluence will always show the button for premium while a customer is in a trial or in predunning
    // If the customer can add payment, that is checked as part of rendering the dialog (as the dialog
    // will still show to the customer if they can not add payment details)
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2aa7bb0da7795442$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2qKY.ActionsAndContent), {
            entitlement: data,
            trialButton: trialButton
        })
    });
    if ((edition === 'free' || isInTrialOrPredunning) && (0, $fHpHg.fg)('new_ea_audience_and_timing_ineligible_analytics')) // We're only firing the ineligible analytics when we could've shown the button, not all instances
    // this is to ensure we don't send the event on every page load
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2aa7bb0da7795442$var$IneligibleAnalytics, {});
    return null;
}

});
parcelRegister("bijqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d089500e5388d9f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<737fb44f72caefa1d79edf98105e0f4b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d089500e5388d9f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "audienceAndTiming_AtlassianEditionAwareness",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionsAndContent_AtlassianEditionAwareness"
        }
    ],
    "type": "Query"
};
$7d089500e5388d9f$var$node.hash = "2794b5293bc67ae9c19c73adbc0bc9f2";
var $7d089500e5388d9f$export$2e2bcd8739ae039 = $7d089500e5388d9f$var$node;

});

parcelRegister("jXOZU", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $867fe382f46a41fa$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $867fe382f46a41fa$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $867fe382f46a41fa$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $867fe382f46a41fa$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $lniFT = parcelRequire("lniFT");

var $49NSg = parcelRequire("49NSg");
var $bngFq = parcelRequire("bngFq");

var $96Irh = parcelRequire("96Irh");

var $kBxPf = parcelRequire("kBxPf");
const $867fe382f46a41fa$export$85183a312807388d = (0, $lniFT.FabricChannel).growth;
const $867fe382f46a41fa$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $867fe382f46a41fa$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness'
};
function $867fe382f46a41fa$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $kBxPf.useEditionAwareness)();
    const experimentMeta = (0, $5uXOq.useMemo)(()=>{
        // I wanted to reference the utility function but,
        // that file imports AtlBrowserStorageLocal which makes the VR tests to fail with timeout, even if is not executed on runtime
        //if (isFreeEduOrOrgSite(editionAwarenessContext)) {
        //Only add the metadata when the site may be eligible for the experiment
        if (editionAwarenessContext.edition === 'free' && (editionAwarenessContext.siteType === 'EDU' || editionAwarenessContext.siteType === 'ORG')) return [
            {
                key: 'offer_edu_org_discount',
                cohort: (0, $96Irh.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled'),
                siteType: editionAwarenessContext.siteType
            }
        ];
        return [];
    }, [
        editionAwarenessContext
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            isInvoiceable: editionAwarenessContext.isInvoiceable,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            canUpgrade: editionAwarenessContext.canUpgrade,
            config: editionAwarenessContext.config,
            userRoles: editionAwarenessContext.userRoles,
            billingSourceSystem: editionAwarenessContext.billingSourceSystem,
            experimentMeta: experimentMeta
        };
        if (payload instanceof (0, $49NSg.default)) {
            const contextAttributes = $867fe382f46a41fa$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$867fe382f46a41fa$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes
                }
            }).fire($867fe382f46a41fa$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$867fe382f46a41fa$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes
                }
            });
            const contextAttributes = $867fe382f46a41fa$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($867fe382f46a41fa$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentMeta
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $867fe382f46a41fa$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $867fe382f46a41fa$export$e955abb82869dc84();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}

});

parcelRegister("c2qKY", function(module, exports) {

$parcel$export(module.exports, "ActionsAndContent", () => $71932e3cc20731a4$export$3bec899b1babe0fe);

var $2OMIu = parcelRequire("2OMIu");

var $1BdAr = parcelRequire("1BdAr");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $htBRZ = parcelRequire("htBRZ");

var $96Irh = parcelRequire("96Irh");

var $fHpHg = parcelRequire("fHpHg");

var $afsja = parcelRequire("afsja");

var $jXOZU = parcelRequire("jXOZU");

var $kBxPf = parcelRequire("kBxPf");

var $imWFC = parcelRequire("imWFC");

var $2CXPT = parcelRequire("2CXPT");

var $409k1 = parcelRequire("409k1");

var $lU9wU = parcelRequire("lU9wU");

var $4PRos = parcelRequire("4PRos");

var $jtMTX = parcelRequire("jtMTX");

var $dpkad = parcelRequire("dpkad");

var $3a6jk = parcelRequire("3a6jk");

var $2tMvz = parcelRequire("2tMvz");

var $c0M1m = parcelRequire("c0M1m");

var $8aSJE = parcelRequire("8aSJE");

var $4JsRx = parcelRequire("4JsRx");

var $d3JON = parcelRequire("d3JON");
const $71932e3cc20731a4$var$AddPaymentLink = ({ trialButton: trialButton })=>{
    const context = (0, $kBxPf.useEditionAwareness)();
    const { addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = context;
    if (!addPaymentDetailsExperienceUrl) // Keep it fallback until we have proper error handling
    return trialButton;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3JON.EditionAwarenessLink), {
        href: addPaymentDetailsExperienceUrl,
        target: "_blank",
        touchpointIntent: "addPaymentDetails",
        linkId: "predunning"
    });
};
/**
 * Sends an event when there is no action available for the customer to render. This is an error state
 * which means that audience and timing has passed a customer as eligible when they shouldn't have.
 *
 * Next iteration on this would be to return a safe default action for all customers
 */ function $71932e3cc20731a4$var$NoAction() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'actionsAndContent',
            action: 'missed'
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent
    ]);
    return null;
}
function $71932e3cc20731a4$var$FreeEdition({ freeButton: freeButton }) {
    const context = (0, $kBxPf.useEditionAwareness)();
    const { product: product, siteType: siteType, isInTeamWorkCollection: isInTeamWorkCollection } = context;
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInTeamWorkCollection && (0, $fHpHg.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpkad.PlanSelectionPageDialog), {
        type: "twc"
    });
    if ((0, $imWFC.isEligibleForEduDiscount)(context) && (0, $96Irh.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
        flagKey: "offer_edu_org_discount",
        cohort: "variation",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $409k1.EducationalDiscountDialog), {})
    });
    if (product === 'jira' && // We're excluding the edu experiment cohort from seeing the refresh experiment
    siteType !== 'EDU' && siteType !== 'ORG' && (0, $fHpHg.fg)('new_ea_jira_free_modal_refresh')) {
        const cohort = (0, $96Irh.default).getExperimentValue('jira_free_ea_modal_refresh', 'cohort', 'not-enrolled', {
            // We only want to fire the exposure when they view the modal.
            // The control experience is still inside of the product.
            fireExperimentExposure: false
        });
        if (cohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4PRos.FreeToStandardRefresh), {});
    }
    if (product === 'confluence' && (0, $fHpHg.fg)('growth_migrate_confluence_free_to_standard_fg')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lU9wU.FreeToStandardDialog), {});
    if (product === 'jira-product-discovery' && (0, $fHpHg.fg)('new_ea_jira_product_discovery_free')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lU9wU.FreeToStandardDialog), {});
    if (product === 'jira' && (0, $fHpHg.fg)('new_ea_jira_free')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lU9wU.FreeToStandardDialog), {});
    if (product === 'jira-service-management' && (0, $fHpHg.fg)('new_ea_jira_service_management_free')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lU9wU.FreeToStandardDialog), {});
    // Until we migrate the rest of the products to the new button content we'll use the old one from product
    return freeButton;
}
function $71932e3cc20731a4$var$StandardEdition({ trialButton: trialButton }) {
    const context = (0, $kBxPf.useEditionAwareness)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails, isInTeamWorkCollection: isInTeamWorkCollection, userRoles: userRoles } = context;
    const { licensedUsers: licensedUsers, storageUsageInGB: storageUsageInGB } = (0, $kBxPf.useSiteInformation)();
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInTrial && isInTeamWorkCollection && (0, $fHpHg.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpkad.PlanSelectionPageDialog), {
        type: "twc"
    });
    if ((isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails) {
        if (// Only eligible for Confluence and Jira
        (0, $2CXPT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
            context: context,
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB
        })) {
            const abExperimentKey = product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials';
            const abCohort = (0, $96Irh.default).getExperimentValue(abExperimentKey, 'cohort', 'not-enrolled');
            if (abCohort === 'treatment') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                flagKey: abExperimentKey,
                cohort: abCohort,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4JsRx.StandardTrialLimitBreakersDialog), {})
            });
            if (product === 'confluence' && (0, $fHpHg.fg)('new_ea_confluence_standard')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8aSJE.StandardAddPayment), {})
                ]
            });
            // Site admins get routed to JSTO
            if (product === 'jira' && isInTrial && !userRoles?.includes('SITE_ADMIN') && (0, $fHpHg.fg)('new_ea_jira_payment_details_popup')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtMTX.PaymentDetailsPopupDialog), {})
                ]
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    trialButton
                ]
            });
        }
        if (isInTrial && (product === 'jira-service-management' || product === 'jira-product-discovery') && (0, $fHpHg.fg)('new_ea_jsw_jpd_standard_in_trial')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8aSJE.StandardAddPayment), {});
        // Site admins get routed to JSTO
        if (product === 'jira' && isInTrial && !userRoles?.includes('SITE_ADMIN') && (0, $fHpHg.fg)('new_ea_jira_payment_details_popup')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtMTX.PaymentDetailsPopupDialog), {});
        if (product === 'confluence' && (0, $fHpHg.fg)('new_ea_confluence_standard')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8aSJE.StandardAddPayment), {});
        if (isInPredunning && [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ].includes(product) && (0, $fHpHg.fg)('new_ea_jsw_jsm_jpd_pre_dunning')) return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$AddPaymentLink, {
            trialButton: trialButton
        });
        // trialButton is returned for all other products + Confluence and Jira sites not eligible
        return trialButton;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$NoAction, {});
}
function $71932e3cc20731a4$var$PremiumEdition({ trialButton: trialButton }) {
    const context = (0, $kBxPf.useEditionAwareness)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial } = context;
    if (product === 'jira' && isInTrial && isInReverseTrial && (0, $fHpHg.fg)('new_ea_jira_reverse_trial_dropdown')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0M1m.ReverseTrialPopupDialog), {});
    if (product === 'jira' && isInTrial && !isInReverseTrial && (0, $fHpHg.fg)('new_ea_jira_payment_details_popup')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtMTX.PaymentDetailsPopupDialog), {});
    if (isInPredunning && [
        'jira',
        'jira-service-management'
    ].includes(product) && (0, $fHpHg.fg)('new_ea_jsw_jsm_jpd_pre_dunning')) return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$AddPaymentLink, {
        trialButton: trialButton
    });
    if (product === 'confluence' && (0, $fHpHg.fg)('new_ea_confluence_premium')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tMvz.PremiumPopup), {});
    if (isInTrial && product === 'jira-service-management' && (0, $fHpHg.fg)('new_ea_jsm_premium')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3a6jk.PremiumAddPayment), {});
    // Until we migrate the rest of the products to the new button content we'll use the old one from product
    return trialButton;
}
/**
 * Covers what button and action we show to the customer.
 *
 * Experiments here should just modify what is shown to the customer not if it is shown to the customer.
 */ function $71932e3cc20731a4$var$ActionsAndContentImpl({ freeButton: freeButton, trialButton: trialButton }) {
    const { edition: edition } = (0, $kBxPf.useEditionAwareness)();
    if (edition === 'free') return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$FreeEdition, {
        freeButton: freeButton
    });
    if (edition === 'standard') return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$StandardEdition, {
        trialButton: trialButton
    });
    if (edition === 'premium') return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$PremiumEdition, {
        trialButton: trialButton
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$NoAction, {});
}
function $71932e3cc20731a4$export$3bec899b1babe0fe({ entitlement: entitlementFragment, freeButton: freeButton, trialButton: trialButton }) {
    /**
   * When adding data to this query, you should:
   *
   * Ensure that it is behind a config that controls the `@include` to ensure that it does
   *   not query for the data if it is not required.
   *
   * That when this data is fetched it will be used the majority of the time (e.g. if this data is only)
   *   used for 5% of customers and has a high cost then we should likely load it sequentially.
   */ const data = (0, $8Uumt.useFragment)((0, $1BdAr.default), entitlementFragment);
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const bytesUsed = data?.jira?.attachmentStorageUsed || data?.confluence_storage?.bytesUsed;
    const storageUsageInGB = bytesUsed && bytesUsed / 1000000000;
    const analyticsContext = (0, $5uXOq.useMemo)(()=>({
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB
        }), [
        licensedUsers,
        storageUsageInGB
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: analyticsContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBxPf.SiteInformationContext).Provider, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($71932e3cc20731a4$var$ActionsAndContentImpl, {
                trialButton: trialButton,
                freeButton: freeButton
            })
        })
    });
}

});
parcelRegister("1BdAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0348b7076d4b562c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb3ad3166a68533e47d2d8eec710fc3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0348b7076d4b562c$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "applicationKey"
            },
            {
                "kind": "RootArgument",
                "name": "chargeElement"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "entitlementFilter"
            },
            {
                "kind": "RootArgument",
                "name": "productKey"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckForChargeQuantities"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckForStorageUsageConfluence"
            },
            {
                "kind": "RootArgument",
                "name": "shouldCheckForStorageUsageJira"
            },
            {
                "kind": "RootArgument",
                "name": "shouldSkip"
            }
        ],
        "kind": "Fragment",
        "name": "actionsAndContent_AtlassianEditionAwareness",
        "selections": [
            {
                "condition": "shouldSkip",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": [
                            {
                                "items": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudIds.0",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "kind": "ListValue",
                                "name": "cloudIds"
                            }
                        ],
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "hamsProductKey",
                                        "variableName": "productKey"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "where",
                                                "variableName": "entitlementFilter"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "entitlement",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "shouldCheckForChargeQuantities",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "chargeElement",
                                                                "variableName": "chargeElement"
                                                            }
                                                        ],
                                                        "kind": "ScalarField",
                                                        "name": "latestUsageForChargeElement"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "shouldCheckForStorageUsageJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "applicationKey",
                                        "variableName": "applicationKey"
                                    },
                                    v0 /*: any*/ 
                                ],
                                "kind": "ScalarField",
                                "name": "attachmentStorageUsed"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "shouldCheckForStorageUsageConfluence",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ 
                        ],
                        "concreteType": "ConfluenceStorage",
                        "kind": "LinkedField",
                        "name": "confluence_storage",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "bytesUsed"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$0348b7076d4b562c$var$node.hash = "44fed4ce994b2c1bda59e3db176a3353";
var $0348b7076d4b562c$export$2e2bcd8739ae039 = $0348b7076d4b562c$var$node;

});

parcelRegister("afsja", function(module, exports) {

$parcel$export(module.exports, "FeatureExposedAnalytics", () => $f2078376733c1db3$export$b12ce465f015026c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jXOZU = parcelRequire("jXOZU");
function $f2078376733c1db3$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});

parcelRegister("imWFC", function(module, exports) {

$parcel$export(module.exports, "isEligibleForEduDiscount", () => $269323820ee214b9$export$331edc99898f4a8e);
//import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

const $269323820ee214b9$export$331edc99898f4a8e = (context)=>{
    return $269323820ee214b9$export$f52e80ca0459b360(context) && $269323820ee214b9$export$eb0afc9e31269a96();
};
const $269323820ee214b9$export$f52e80ca0459b360 = (context)=>{
    const { edition: edition, siteType: siteType } = context;
    return edition === 'free' && (siteType === 'EDU' || siteType === 'ORG');
};
const $269323820ee214b9$export$eb0afc9e31269a96 = ()=>{
    // AtlBrowserStorageLocal even if is not executed, by just calling this file fails the VR test,
    //  until we have a fix, we can use the native one
    //AtlBrowserStorageLocal.getItem(PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED) !== 'true'
    try {
        return localStorage.getItem((0, $56c68beebe72015c$export$c5bc624b59af1952)) !== 'true';
    } catch (e) {
        return false;
    }
};

});
const $56c68beebe72015c$export$c5bc624b59af1952 = '__storejs_platform_educational_discount_dismissed';


parcelRegister("2CXPT", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardTrialsUserAndStorageLimitBreakers", () => $8d91045e11a91271$export$4ade6028e006f174);
function $8d91045e11a91271$export$4ade6028e006f174({ context: context, licensedUsers: licensedUsers, storageUsageInGB: storageUsageInGB }) {
    const { config: { isStandardTrialsUserAndStorageLimitBreakersEnabled: isStandardTrialsUserAndStorageLimitBreakersEnabled }, product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails, trialDaysLeft: trialDaysLeft } = context;
    const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
    const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
    const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);
    if (product === 'confluence') return !!(isStandardTrialsUserAndStorageLimitBreakersEnabled && (isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    if (product === 'jira') return !!(isStandardTrialsUserAndStorageLimitBreakersEnabled && isInTrial && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    return false;
}

});

parcelRegister("409k1", function(module, exports) {

$parcel$export(module.exports, "EducationalDiscountDialog", () => $b865b0bae9ed2b64$export$adb3efabe141b521);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $aH1Gy = parcelRequire("aH1Gy");

var $fQYcB = parcelRequire("fQYcB");
function $b865b0bae9ed2b64$export$adb3efabe141b521() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $aH1Gy.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $aH1Gy.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPoint: (0, $fQYcB.default),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps
        })
    });
}

});
parcelRegister("6nV7O", function(module, exports) {

$parcel$export(module.exports, "useOnDismissDialog", () => $dd7ec7b8c8542820$export$566c270c8354ea95);

var $5uXOq = parcelRequire("5uXOq");

var $jXOZU = parcelRequire("jXOZU");
const $dd7ec7b8c8542820$export$566c270c8354ea95 = ({ touchpointIntent: touchpointIntent, dialogType: dialogType, dialogId: dialogId, attributes: attributes })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    return (0, $5uXOq.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDialogDismissed',
            attributes: {
                touchpointIntent: touchpointIntent,
                dialogType: dialogType,
                dialogId: dialogId,
                ...attributes
            }
        });
    }, [
        sendAnalyticsEvent,
        touchpointIntent,
        dialogType,
        dialogId,
        attributes
    ]);
};

});

parcelRegister("6dCMO", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPoint", () => $cf75fc1289524ae5$export$50a5ec7edfae079b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3wIoS = parcelRequire("3wIoS");

var $grJYf = parcelRequire("grJYf");

var $hHBm5 = parcelRequire("hHBm5");

var $d3JON = parcelRequire("d3JON");
function $cf75fc1289524ae5$export$50a5ec7edfae079b(props) {
    const onError = (0, $hHBm5.useEntrypointErrorAnalytics)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3wIoS.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $grJYf.ModalTrigger), {
            ...props,
            onError: onError,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3JON.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}

});
parcelRegister("3wIoS", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $2ca36deb42c5f4ef$export$7c9538f5f3c365e9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $dImge = parcelRequire("dImge");
const $2ca36deb42c5f4ef$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $2ca36deb42c5f4ef$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dImge.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $2OMIu.jsx)($2ca36deb42c5f4ef$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}

});
parcelRegister("dImge", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $4eae74906fb593bc$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $4eae74906fb593bc$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("grJYf", function(module, exports) {

$parcel$export(module.exports, "ModalTrigger", () => $f9f344d605642341$export$fb10b32cfe19f1e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $eCE62 = parcelRequire("eCE62");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $gOkqF = parcelRequire("gOkqF");

var $ajG9J = parcelRequire("ajG9J");

var $dImge = parcelRequire("dImge");

var $2b2jE = parcelRequire("2b2jE");

var $l5ZMD = parcelRequire("l5ZMD");

var $65KjW = parcelRequire("65KjW");
const $f9f344d605642341$var$emptyEntryPointParams = {};
const $f9f344d605642341$var$emptyEntryPointProps = {};
function $f9f344d605642341$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError }) {
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $dImge.ModalContext));
    const environmentProvider = (0, $65KjW.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $ajG9J.useEntryPointConfig)();
    const metricName = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f9f344d605642341$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
                        children: title ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g1QfP.default), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7CjwE.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5ZMD.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $2OMIu.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $f9f344d605642341$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hordk.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $2b2jE.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("ajG9J", function(module, exports) {

$parcel$export(module.exports, "initEntryPointConfig", () => $c6401af6db100ff8$export$93a6801f9db838c4);
$parcel$export(module.exports, "useEntryPointConfig", () => $c6401af6db100ff8$export$dfa96f26176fa91f);

var $kkd2O = parcelRequire("kkd2O");

var $5tDD0 = parcelRequire("5tDD0");
const $c6401af6db100ff8$var$DefaultUFOSegmentComponent = (0, $5tDD0.default);
const $c6401af6db100ff8$var$entryPointConfig = {
    PlaceholderComponent: (0, $kkd2O.default),
    UFOSegmentComponent: $c6401af6db100ff8$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $c6401af6db100ff8$export$93a6801f9db838c4(overrides) {
    Object.assign($c6401af6db100ff8$var$entryPointConfig, overrides);
    return $c6401af6db100ff8$var$entryPointConfig;
}
function $c6401af6db100ff8$export$dfa96f26176fa91f() {
    return $c6401af6db100ff8$var$entryPointConfig;
}

});

parcelRegister("2b2jE", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $e839ae3b581fa173$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $e839ae3b581fa173$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $e839ae3b581fa173$var$TIME_TO_INTENT = 200;
function $e839ae3b581fa173$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $e839ae3b581fa173$var$PRELOAD_MAX_AGE);
            }, $e839ae3b581fa173$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});

parcelRegister("l5ZMD", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $e876b71a374a7568$export$5d4dc37edd8a3adb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $8Uumt = parcelRequire("8Uumt");

var $eQFPj = parcelRequire("eQFPj");

var $ajG9J = parcelRequire("ajG9J");
function $e876b71a374a7568$export$5d4dc37edd8a3adb({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent, UFOSegmentComponent: UFOSegmentComponent } = (0, $ajG9J.useEntryPointConfig)();
    const onError = (0, $5uXOq.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $eQFPj.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
    }, [
        onErrorLocal,
        id
    ]);
    const FallbackComponent = (0, $5uXOq.useCallback)(({ error: error })=>{
        return errorFallback ? errorFallback({
            error: error
        }) : null;
    }, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            FallbackComponent: FallbackComponent,
            onError: onError,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(PlaceholderComponent, {
                name: placeholderName ?? 'internal-internal-entry-point-container',
                fallback: fallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uumt.EntryPointContainer), {
                    entryPointReference: entryPointReference,
                    props: runtimeProps
                })
            })
        })
    });
}

});

parcelRegister("65KjW", function(module, exports) {

$parcel$export(module.exports, "RelayEnvironmentProvider", () => $f4fdf3f45e519c8f$export$43b1f3e917d65526);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $f4fdf3f45e519c8f$export$e237a628f59c9f4e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $ajdBN = parcelRequire("ajdBN");
const $f4fdf3f45e519c8f$var$environment = new (0, $eiowN.Environment)((0, $ajdBN.getDefaultRelayEnvironmentConfig)({}));
const $f4fdf3f45e519c8f$export$43b1f3e917d65526 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uumt.RelayEnvironmentProvider), {
        environment: $f4fdf3f45e519c8f$var$environment,
        children: children
    });
};
function $f4fdf3f45e519c8f$export$e237a628f59c9f4e() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});


parcelRegister("hHBm5", function(module, exports) {

$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $8e5a19b76856a893$export$f2e26e89f653216c);

var $5uXOq = parcelRequire("5uXOq");

var $jXOZU = parcelRequire("jXOZU");
function $8e5a19b76856a893$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const handleOnError = (0, $5uXOq.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("d3JON", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $ae9af37665f58db4$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $ae9af37665f58db4$export$1bf8122badfd728c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fv0UR = parcelRequire("fv0UR");

var $7VIfr = parcelRequire("7VIfr");

var $c5zfI = parcelRequire("c5zfI");

var $gHU1R = parcelRequire("gHU1R");
var $0yZbT = parcelRequire("0yZbT");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");

var $3926G = parcelRequire("3926G");

var $bRH8U = parcelRequire("bRH8U");

var $bsuur = parcelRequire("bsuur");

var $jXOZU = parcelRequire("jXOZU");

var $2g0fC = parcelRequire("2g0fC");

var $iMw2G = parcelRequire("iMw2G");
const $ae9af37665f58db4$var$buttonStyles = (0, $2s57o.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $ae9af37665f58db4$var$defaultStyles = (0, $2s57o.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand',
    ':hover': {
        color: 'color.text.brand'
    }
});
const $ae9af37665f58db4$var$warningStyles = (0, $2s57o.xcss)({
    borderColor: 'color.border.warning'
});
const $ae9af37665f58db4$var$dangerStyles = (0, $2s57o.xcss)({
    borderColor: 'color.border.danger'
});
const $ae9af37665f58db4$var$dismissibleStyles = (0, $2s57o.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    ':hover': {
        color: 'color.text.discovery',
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        textDecoration: 'none'
    }
});
const $ae9af37665f58db4$var$iconStyles = (0, $2s57o.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
function $ae9af37665f58db4$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E56910)";
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c5zfI))), {
            label: "",
            color: color ?? defaultColor
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7VIfr))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)",
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fv0UR))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)"
    });
}
const $ae9af37665f58db4$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $2g0fC.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3926G.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($ae9af37665f58db4$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bsuur.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gVM6m.default), {
        ...rest,
        ref: ref,
        xcss: [
            $ae9af37665f58db4$var$buttonStyles,
            appearance === 'default' && $ae9af37665f58db4$var$defaultStyles,
            appearance === 'warning' && $ae9af37665f58db4$var$warningStyles,
            appearance === 'danger' && $ae9af37665f58db4$var$dangerStyles,
            isDismissible && $ae9af37665f58db4$var$dismissibleStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $ae9af37665f58db4$var$iconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($ae9af37665f58db4$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bsuur.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});
const $ae9af37665f58db4$export$1bf8122badfd728c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $2g0fC.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $iMw2G.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3926G.LinkButton), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($ae9af37665f58db4$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bsuur.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gHU1R.default), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: [
            $ae9af37665f58db4$var$buttonStyles,
            appearance === 'default' && $ae9af37665f58db4$var$defaultStyles,
            appearance === 'warning' && $ae9af37665f58db4$var$warningStyles,
            appearance === 'danger' && $ae9af37665f58db4$var$dangerStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $ae9af37665f58db4$var$iconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($ae9af37665f58db4$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bsuur.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});

});
parcelRegister("bsuur", function(module, exports) {

$parcel$export(module.exports, "UiViewedEvent", () => $a8377d9a82d67e4e$export$d0a9edec5c713764);

var $5uXOq = parcelRequire("5uXOq");

var $jXOZU = parcelRequire("jXOZU");
function $a8377d9a82d67e4e$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});

parcelRegister("2g0fC", function(module, exports) {

$parcel$export(module.exports, "useButtonContent", () => $7ae66e153614814e$export$c810aba6284fa97d);

var $koVbs = parcelRequire("koVbs");

var $96Irh = parcelRequire("96Irh");

var $55y7Z = parcelRequire("55y7Z");

var $kBxPf = parcelRequire("kBxPf");

var $imWFC = parcelRequire("imWFC");

var $5UZ6w = parcelRequire("5UZ6w");

var $2CXPT = parcelRequire("2CXPT");

var $4weio = parcelRequire("4weio");
// TODO: `licensedUserLimit` should be fetched from the server
const $7ae66e153614814e$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $7ae66e153614814e$var$getFreeContent({ licensedUsers: licensedUsers, context: context, formatMessage: formatMessage }) {
    const { edition: edition, config: config, product: product } = context;
    const limits = $7ae66e153614814e$var$PRODUCT_LIMITS_MAP[product];
    // Education offer has a higher priority than all the other messages
    if ((0, $imWFC.isEligibleForEduDiscount)(context) && (0, $96Irh.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.education-offer',
            defaultMessage: 'Education discount',
            description: 'Informs the user that they may be are eligible for an education offer which is a discount on all products'
        }),
        appearance: 'default',
        icon: 'gem',
        isEducationDiscount: true
    };
    if (config.warnOnUserLimit && licensedUsers) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.jpd.no-creators-left',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $55y7Z.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.jpd.limited-creators-left',
                defaultMessage: 'Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their product'
            }, {
                product: (0, $55y7Z.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if (product === 'confluence' && edition === 'free' && licensedUsers && licensedUsers >= 3) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem'
    };
}
function $7ae66e153614814e$var$getTrialContent({ licensedUsers: licensedUsers, storageUsageInGB: storageUsageInGB, context: context, formatMessage: formatMessage }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays } = context;
    let appearance = 'default';
    let icon = 'gem';
    if (product === 'jira' && (0, $2CXPT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context,
        licensedUsers: licensedUsers,
        storageUsageInGB: storageUsageInGB
    }) && (0, $96Irh.default).getExperimentValue('jira_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.daysLeft',
            defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
            description: 'Informs the user how many days they have left in trial'
        }, {
            trialDaysLeft: trialDaysLeft
        }),
        appearance: trialDaysLeft && trialDaysLeft <= 3 ? 'danger' : 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && (0, $2CXPT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context,
        licensedUsers: licensedUsers,
        storageUsageInGB: storageUsageInGB
    }) && (0, $96Irh.default).getExperimentValue('connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.daysLeft',
            defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
            description: 'Informs the user how many days they have left in trial'
        }, {
            trialDaysLeft: trialDaysLeft
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product)) {
        // Trial Countdown Experiment
        const trialCountdownExperimentEnabled = (0, $4weio.isEligibleForTrialCountdown)(context) && (0, $96Irh.default).getExperimentValue('jira_edition_awareness_trial_countdown', 'isEnabled', false);
        // If trial is 3 days or less, swap the button to the warning state
        if (trialCountdownExperimentEnabled && !!trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        // If trial is still in its first half, show trial message instead of trial days left
        const isInFirstHalfOfTrial = Boolean(trialCountdownExperimentEnabled && trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.premium-trial',
                    defaultMessage: 'Premium trial',
                    description: 'Informs the user that they are on a premium trial'
                }),
                appearance: appearance,
                icon: icon
            };
            if (edition === 'standard') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.standard-trial',
                    defaultMessage: 'Standard trial',
                    description: 'Informs the user that they are on a standard trial'
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.daysLeft',
            defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
            description: 'Informs the user how many days they have left in trial'
        }, {
            trialDaysLeft: trialDaysLeft
        }),
        appearance: appearance,
        icon: icon
    };
}
function $7ae66e153614814e$var$getPredunningContent({ licensedUsers: licensedUsers, storageUsageInGB: storageUsageInGB, context: context, formatMessage: formatMessage }) {
    const { product: product } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $2CXPT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context,
        licensedUsers: licensedUsers,
        storageUsageInGB: storageUsageInGB
    }) && (0, $96Irh.default).getExperimentValue(product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') {
        appearance = 'warning';
        icon = 'warning';
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.addPaymentDetails',
            defaultMessage: 'Add payment details',
            description: 'Informs the user how many days they have left in trial'
        }),
        appearance: appearance,
        icon: icon
    };
}
function $7ae66e153614814e$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $kBxPf.useEditionAwareness)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial } = context;
    const { licensedUsers: licensedUsers, storageUsageInGB: storageUsageInGB } = (0, $kBxPf.useSiteInformation)();
    if (edition === 'free') return $7ae66e153614814e$var$getFreeContent({
        licensedUsers: licensedUsers,
        context: context,
        formatMessage: formatMessage
    });
    if (isInTrial) return $7ae66e153614814e$var$getTrialContent({
        licensedUsers: licensedUsers,
        storageUsageInGB: storageUsageInGB,
        context: context,
        formatMessage: formatMessage
    });
    if (isInPredunning) return $7ae66e153614814e$var$getPredunningContent({
        licensedUsers: licensedUsers,
        storageUsageInGB: storageUsageInGB,
        context: context,
        formatMessage: formatMessage
    });
    if ((0, $5UZ6w.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("55y7Z", function(module, exports) {

$parcel$export(module.exports, "getProductForTranslation", () => $59568490c766848a$export$fd45d905638d9909);
const $59568490c766848a$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $59568490c766848a$export$fd45d905638d9909(product) {
    return $59568490c766848a$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});

parcelRegister("5UZ6w", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $62a34244ae7770fa$export$d58c0da339bf36d9);
function $62a34244ae7770fa$export$d58c0da339bf36d9({ product: product, config: { isPaidStandard: isPaidStandard }, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    return !!([
        'confluence',
        'jira',
        'jira-service-management'
    ].includes(product) && isPaidStandard && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium');
}

});

parcelRegister("4weio", function(module, exports) {

$parcel$export(module.exports, "isEligibleForTrialCountdown", () => $eae04aa718f328a4$export$947e3549c8b868b2);
function $eae04aa718f328a4$export$947e3549c8b868b2({ isInTrial: isInTrial, isInPredunning: isInPredunning, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, billingSourceSystem: billingSourceSystem }) {
    return Boolean(isInTrial && !isInPredunning && trialDaysLeft && trialLengthDays && billingSourceSystem === 'CCP');
}

});


parcelRegister("iMw2G", function(module, exports) {

$parcel$export(module.exports, "useTracedUrl", () => $f7e10536c226b4d3$export$5eea7bde9861e87b);

var $5uXOq = parcelRequire("5uXOq");

var $2VHHh = parcelRequire("2VHHh");

var $kBxPf = parcelRequire("kBxPf");
const $f7e10536c226b4d3$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $f7e10536c226b4d3$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $kBxPf.useEditionAwareness)();
    const origin = (0, $5uXOq.useMemo)(()=>new (0, $2VHHh.default)({
            product: $f7e10536c226b4d3$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $5uXOq.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});



parcelRegister("aH1Gy", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $0fca7a2ddcbe55a1$export$3b6761b6086f6dfd);
const $0fca7a2ddcbe55a1$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'educational-discount-modal',
    dialogType: 'modal'
};

});

parcelRegister("fQYcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31b9596526b9995$export$2e2bcd8739ae039);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $8dmS5 = parcelRequire("8dmS5");

const $d31b9596526b9995$var$EducationalDiscountEntryPoint = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("faktM")), {
        moduleId: "f8e44e05",
        moduleId: 'edition-awareness-educational-discount-modal-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $8dmS5.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});
var $d31b9596526b9995$export$2e2bcd8739ae039 = $d31b9596526b9995$var$EducationalDiscountEntryPoint;

});
parcelRegister("8dmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38a4e06bdebe42c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<de281939d1647ab12360e5cb1137a0d1>>
 * @relayHash d2cd70c3b7892e3fd9793c1ba33f0af7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 092093bc1bea11a8b3077c854c7f7b25ea3881f3559f636dfc10b3c46c0ede43

var $eiowN = parcelRequire("eiowN");
const $a38a4e06bdebe42c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogEducationalDiscountEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogEducationalDiscountEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "092093bc1bea11a8b3077c854c7f7b25ea3881f3559f636dfc10b3c46c0ede43",
            "metadata": {},
            "name": "dialogEducationalDiscountEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a38a4e06bdebe42c$var$node.hash = "5b3007c742556dcc0027824b57ed5a62";
(0, $eiowN.PreloadableQueryRegistry).set($a38a4e06bdebe42c$var$node.params.id, $a38a4e06bdebe42c$var$node);
var $a38a4e06bdebe42c$export$2e2bcd8739ae039 = $a38a4e06bdebe42c$var$node;

});

parcelRegister("faktM", function(module, exports) {

let $b0a7acf603cd130e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0a7acf603cd130e$var$load("fSomj").then(()=>parcelRequire('fE70d'));

});



parcelRegister("lU9wU", function(module, exports) {

$parcel$export(module.exports, "FreeToStandardDialog", () => $e3ab478949a6c5c7$export$5077353235cd2bbf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $fqnSg = parcelRequire("fqnSg");

var $fYoko = parcelRequire("fYoko");

var $ljLzg = parcelRequire("ljLzg");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $bO92T = parcelRequire("bO92T");

var $83ebe = parcelRequire("83ebe");

var $k895m = parcelRequire("k895m");
function $e3ab478949a6c5c7$export$5077353235cd2bbf() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const jiraApplicationKey = (0, $fYoko.getJiraApplicationKey)(product);
    const projectType = (0, $ljLzg.getJiraProjectTypeKey)(product);
    const { aaCohort: aaCohort } = (0, $k895m.useNBEAExperiment)({
        fireExperimentExposure: false,
        product: product
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product),
            chargeElement: (0, $fqnSg.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence',
            shouldIncludeGUPS: product === 'confluence' && aaCohort === 'treatment'
        }), [
        aaCohort,
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $bO92T.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'x-large',
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $bO92T.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPointProps: entryPointProps,
            entryPoint: (0, $83ebe.entryPoint),
            entryPointParams: entryPointParams,
            modalProps: modalProps
        })
    });
}

});
parcelRegister("ljLzg", function(module, exports) {

$parcel$export(module.exports, "getJiraProjectTypeKey", () => $8d500aca29578b47$export$600268f282087736);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $8d500aca29578b47$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $8d500aca29578b47$export$600268f282087736 = (product)=>{
    return $8d500aca29578b47$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};

});

parcelRegister("bO92T", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $72c292e3f3d602e7$export$3b6761b6086f6dfd);
const $72c292e3f3d602e7$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard',
    dialogType: 'modal'
};

});

parcelRegister("83ebe", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $76226d5b0a3741d2$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $iPILO = parcelRequire("iPILO");

const $76226d5b0a3741d2$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("aSx98")), {
        moduleId: "f961beab",
        moduleId: 'edition-awareness-free-to-standard-jira-products-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, jiraApplicationKey: jiraApplicationKey, chargeElement: chargeElement, isJira: isJira, isConfluence: isConfluence, shouldIncludeGUPS: shouldIncludeGUPS })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $iPILO.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence,
                        shouldIncludeGUPS: shouldIncludeGUPS
                    }
                }
            }
        })
});

});
parcelRegister("iPILO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a38124b9af9bc46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e6fb4a280fa8cf74b2d4b04f2b4461a>>
 * @relayHash e60169aeb87ec589197cbf2cbcfde966
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59206be24b3f47af0c5811fd637470ae87fcb95edd5d5edcca4461c653cebf44

var $eiowN = parcelRequire("eiowN");
const $3a38124b9af9bc46$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeGUPS"
    }, v8 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v10 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Standard"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v12 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v13 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v15 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v13 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v16 = {
        "condition": "shouldIncludeGUPS",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getUnifiedProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileSiteDetails",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "GrowthUnifiedProfileProductDetails",
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "productName"
                                    },
                                    {
                                        "concreteType": "GrowthUnifiedProfileProductNBE",
                                        "kind": "LinkedField",
                                        "name": "nbeRecommendation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "edition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "recommendationDate"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v13 /*: any*/ 
    ], v18 = {
        "args": v17 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v19 = {
        "args": v17 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v20 = {
        "args": v17 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v21 = [
        v13 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v22 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "dialogFreeToStandardEditionAwarenessQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "dialogFreeToStandardEditionAwarenessQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v25 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "59206be24b3f47af0c5811fd637470ae87fcb95edd5d5edcca4461c653cebf44",
            "metadata": {},
            "name": "dialogFreeToStandardEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3a38124b9af9bc46$var$node.hash = "102da6eb251f8623305faa3a3de02b3a";
(0, $eiowN.PreloadableQueryRegistry).set($3a38124b9af9bc46$var$node.params.id, $3a38124b9af9bc46$var$node);
var $3a38124b9af9bc46$export$2e2bcd8739ae039 = $3a38124b9af9bc46$var$node;

});

parcelRegister("aSx98", function(module, exports) {

let $7eb8a8b2e4c148a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7eb8a8b2e4c148a2$var$load("d8vna").then(()=>parcelRequire('aDzNe'));

});


parcelRegister("k895m", function(module, exports) {

$parcel$export(module.exports, "useNBEAExperiment", () => $bdb2ce67065c3e5c$export$d8f75705812ce676);

var $96Irh = parcelRequire("96Irh");

var $fHpHg = parcelRequire("fHpHg");
const $bdb2ce67065c3e5c$export$d8f75705812ce676 = ({ fireExperimentExposure: fireExperimentExposure = false, product: product })=>{
    const aaExperimentKey = 'confluence_next_best_edition_recommend_aa';
    let aaCohort = 'not-enrolled';
    if (product === 'confluence' && (0, $fHpHg.fg)('edition_awareness_confluence_next_best_rec_fg')) aaCohort = (0, $96Irh.default).getExperimentValue(aaExperimentKey, 'cohort', 'not-enrolled', {
        fireExperimentExposure: fireExperimentExposure
    });
    return {
        aaExperimentKey: aaExperimentKey,
        aaCohort: aaCohort
    };
};

});


parcelRegister("4PRos", function(module, exports) {

$parcel$export(module.exports, "FreeToStandardRefresh", () => $128404683a8dacf5$export$31efb40bd42b4e9b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $fqnSg = parcelRequire("fqnSg");

var $ljLzg = parcelRequire("ljLzg");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $4NJWX = parcelRequire("4NJWX");

var $7I0n7 = parcelRequire("7I0n7");
function $128404683a8dacf5$export$31efb40bd42b4e9b() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const projectType = (0, $ljLzg.getJiraProjectTypeKey)(product);
    if (!projectType) throw new Error('Tried to render free to standard refresh dialog for unsupported product');
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product),
            chargeElement: (0, $fqnSg.getChargeElementKey)(product),
            projectType: projectType
        }), [
        cloudId,
        product,
        projectType
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $4NJWX.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            product: product
        }), [
        onClose,
        product
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 932,
            height: 500,
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $4NJWX.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPointProps: entryPointProps,
            entryPoint: (0, $7I0n7.entryPoint),
            entryPointParams: entryPointParams,
            modalProps: modalProps
        })
    });
}

});
parcelRegister("4NJWX", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $dee7a5e748bfec72$export$3b6761b6086f6dfd);
const $dee7a5e748bfec72$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-refresh',
    dialogType: 'modal'
};

});

parcelRegister("7I0n7", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $2c50084c3371987e$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $cvUDJ = parcelRequire("cvUDJ");

const $2c50084c3371987e$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("hvOFz")), {
        moduleId: "4435a54a",
        moduleId: 'edition-awareness-free-to-standard-refresh-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $cvUDJ.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType
                    }
                }
            }
        })
});

});
parcelRegister("cvUDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ad6eec4edaa8a60$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8e4865572777322e30159ca97903edb>>
 * @relayHash cc14b31c6414cb24b5268c715d9904b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d258a1181dc7872043538b051ba9afd894ad35311acd576e63abfa06ae62832

var $eiowN = parcelRequire("eiowN");
const $5ad6eec4edaa8a60$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v6 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Standard"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "freeToStandardRefreshModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "freeToStandardRefreshModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v15 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6d258a1181dc7872043538b051ba9afd894ad35311acd576e63abfa06ae62832",
            "metadata": {},
            "name": "freeToStandardRefreshModalEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5ad6eec4edaa8a60$var$node.hash = "d19b109fdc77c895f471bd0ede1236b9";
(0, $eiowN.PreloadableQueryRegistry).set($5ad6eec4edaa8a60$var$node.params.id, $5ad6eec4edaa8a60$var$node);
var $5ad6eec4edaa8a60$export$2e2bcd8739ae039 = $5ad6eec4edaa8a60$var$node;

});

parcelRegister("hvOFz", function(module, exports) {

let $cbfca2d7806e7cb4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cbfca2d7806e7cb4$var$load("kKkHt").then(()=>parcelRequire('aqRSm'));

});



parcelRegister("jtMTX", function(module, exports) {

$parcel$export(module.exports, "PaymentDetailsPopupDialog", () => $77d00c896cf121d9$export$ef0178c855cf2b43);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $jVTFJ = parcelRequire("jVTFJ");

var $ifhfY = parcelRequire("ifhfY");

var $aGZaF = parcelRequire("aGZaF");
function $77d00c896cf121d9$export$ef0178c855cf2b43() {
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $ifhfY.DIALOG_CONFIG)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $ifhfY.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jVTFJ.PopupEntryPoint), {
            entryPoint: (0, $aGZaF.entryPoint),
            placement: 'bottom-start',
            onClose: onClose
        })
    });
}

});
parcelRegister("jVTFJ", function(module, exports) {

$parcel$export(module.exports, "PopupEntryPoint", () => $9f4c74dd7c451259$export$e14c42e99b209c4d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $clxo5 = parcelRequire("clxo5");

var $lNSKD = parcelRequire("lNSKD");

var $hHBm5 = parcelRequire("hHBm5");

var $d3JON = parcelRequire("d3JON");
function $9f4c74dd7c451259$export$e14c42e99b209c4d(props) {
    const onError = (0, $hHBm5.useEntrypointErrorAnalytics)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lNSKD.PopupTrigger), {
        ...props,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3JON.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($9f4c74dd7c451259$var$PopupFallback, {}),
        onError: onError
    });
}
const $9f4c74dd7c451259$var$PopupFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
    });

});
parcelRegister("lNSKD", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $3473b3804b084cfb$export$95d4acdbab2fc6ef);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWn3s = parcelRequire("bWn3s");

var $vCqQa = parcelRequire("vCqQa");

var $clxo5 = parcelRequire("clxo5");

var $2b2jE = parcelRequire("2b2jE");

var $l5ZMD = parcelRequire("l5ZMD");

var $65KjW = parcelRequire("65KjW");

var $ikQvr = parcelRequire("ikQvr");
const $3473b3804b084cfb$var$emptyEntryPointParams = {};
const $3473b3804b084cfb$var$emptyEntryPointProps = {};
function $3473b3804b084cfb$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $65KjW.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const triggerCloseRef = (0, $ikQvr.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $3473b3804b084cfb$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5ZMD.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $3473b3804b084cfb$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        handleOpen,
        onError
    ]);
    const triggerRef = (0, $2b2jE.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const mergedRef = (0, $bWn3s.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}

});
parcelRegister("ikQvr", function(module, exports) {

$parcel$export(module.exports, "useClickToCloseRef", () => $75336bade61d787a$export$46ec6629f411921d);

var $5uXOq = parcelRequire("5uXOq");
function $75336bade61d787a$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});



parcelRegister("ifhfY", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $e178ea2b2a185e1c$export$3b6761b6086f6dfd);
const $e178ea2b2a185e1c$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("aGZaF", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $5a17e837cc34f0ec$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $5a17e837cc34f0ec$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("1WtvR")), {
        moduleId: "eba6adb0",
        moduleId: 'edition-awareness-payment-details-jira-products-popup-dialog'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("1WtvR", function(module, exports) {

let $16a219d8f6b63fea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16a219d8f6b63fea$var$load("74yog").then(()=>parcelRequire('lrY6k'));

});



parcelRegister("dpkad", function(module, exports) {

$parcel$export(module.exports, "PlanSelectionPageDialog", () => $4890dd99ac22e4d2$export$130b11c8164da129);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $7fs54 = parcelRequire("7fs54");

var $2gcTk = parcelRequire("2gcTk");
function $4890dd99ac22e4d2$export$130b11c8164da129({ type: type }) {
    const { cloudId: cloudId, product: product } = (0, $kBxPf.useEditionAwareness)();
    const getOfferingName = (OfferingType)=>{
        switch(OfferingType){
            case 'twc':
                return '';
            case 'jira-reverse-trial':
                return 'jira-software';
            default:
                return '';
        }
    };
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product),
            offeringName: getOfferingName(type)
        }), [
        cloudId,
        product,
        type
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $7fs54.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            type: type
        }), [
        onClose,
        type
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: '968px',
            height: '808px',
            autoFocus: false,
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $7fs54.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPointProps: entryPointProps,
            entryPoint: (0, $2gcTk.entryPoint),
            entryPointParams: entryPointParams,
            modalProps: modalProps
        })
    });
}

});
parcelRegister("7fs54", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $f38e649f50425537$export$3b6761b6086f6dfd);
const $f38e649f50425537$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal'
};

});

parcelRegister("2gcTk", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $f7e9386c8d4dd480$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $9ZQQY = parcelRequire("9ZQQY");

const $f7e9386c8d4dd480$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("j9VEK")), {
        moduleId: "2b81ad54",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, offeringName: offeringName })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $9ZQQY.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        offeringName: offeringName
                    }
                }
            }
        })
});

});
parcelRegister("9ZQQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb77e76e14e8873$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f80448f145a993e8d2c002bebc28895a>>
 * @relayHash fc7f6cd2462dc93658a62217a402d890
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b0a8c6bda8b5e0281e9f11da8b1b083f30b9ac52286729fa06a2b9f6f03c3737

var $eiowN = parcelRequire("eiowN");
const $4cb77e76e14e8873$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v5 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogPlanSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogPlanSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b0a8c6bda8b5e0281e9f11da8b1b083f30b9ac52286729fa06a2b9f6f03c3737",
            "metadata": {},
            "name": "dialogPlanSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4cb77e76e14e8873$var$node.hash = "c36f65e1247a7f2f9f25b9f8783840c9";
(0, $eiowN.PreloadableQueryRegistry).set($4cb77e76e14e8873$var$node.params.id, $4cb77e76e14e8873$var$node);
var $4cb77e76e14e8873$export$2e2bcd8739ae039 = $4cb77e76e14e8873$var$node;

});

parcelRegister("j9VEK", function(module, exports) {

let $df2b94eae36717d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $df2b94eae36717d1$var$load("e0XFm").then(()=>parcelRequire('WHrkt'));

});



parcelRegister("3a6jk", function(module, exports) {

$parcel$export(module.exports, "PremiumAddPayment", () => $5616a76f513c0358$export$379c828d9faf7dab);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $5H9y7 = parcelRequire("5H9y7");

var $knzHt = parcelRequire("knzHt");
function $5616a76f513c0358$export$379c828d9faf7dab() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $5H9y7.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            product: product
        }), [
        onClose,
        product
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 968,
            height: 576,
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $5H9y7.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPointProps: entryPointProps,
            entryPoint: (0, $knzHt.entryPoint),
            entryPointParams: entryPointParams,
            modalProps: modalProps
        })
    });
}

});
parcelRegister("5H9y7", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $236efc4f72009478$export$3b6761b6086f6dfd);
const $236efc4f72009478$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment',
    dialogType: 'modal'
};

});

parcelRegister("knzHt", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $d5f35c1e5677990e$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $dvzNX = parcelRequire("dvzNX");

const $d5f35c1e5677990e$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7rVhi")), {
        moduleId: "40fe10f7",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $dvzNX.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("dvzNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f89be8c9dbbd30$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0d4e8ed8172769079619ff64ce09312>>
 * @relayHash 6e1b5765145dcba7e9d63ac6f2785872
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3008de06994627e351f3fd1e57f332ed6868bc368a8d3ce0cc722078cd8c1df1

var $eiowN = parcelRequire("eiowN");
const $72f89be8c9dbbd30$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "startTimestamp"
    }, v4 = {
        "kind": "ScalarField",
        "name": "endTimestamp"
    }, v5 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "premiumAddPaymentModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "premiumAddPaymentModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v9 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3008de06994627e351f3fd1e57f332ed6868bc368a8d3ce0cc722078cd8c1df1",
            "metadata": {},
            "name": "premiumAddPaymentModalEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$72f89be8c9dbbd30$var$node.hash = "b9beea81957130507ae6f3b5f814ceb8";
(0, $eiowN.PreloadableQueryRegistry).set($72f89be8c9dbbd30$var$node.params.id, $72f89be8c9dbbd30$var$node);
var $72f89be8c9dbbd30$export$2e2bcd8739ae039 = $72f89be8c9dbbd30$var$node;

});

parcelRegister("7rVhi", function(module, exports) {

let $56c77c3e788c4289$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56c77c3e788c4289$var$load("1puIp").then(()=>parcelRequire('cUhBC'));

});



parcelRegister("2tMvz", function(module, exports) {

$parcel$export(module.exports, "PremiumPopup", () => $a9e23078a3f23150$export$831a974b36144ba6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $jVTFJ = parcelRequire("jVTFJ");

var $4zqXR = parcelRequire("4zqXR");

var $2a4DJ = parcelRequire("2a4DJ");
const $a9e23078a3f23150$export$831a974b36144ba6 = ()=>{
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $4zqXR.DIALOG_CONFIG)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $4zqXR.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jVTFJ.PopupEntryPoint), {
            entryPoint: (0, $2a4DJ.entryPoint),
            entryPointParams: entryPointParams,
            placement: 'bottom-start',
            onClose: onClose
        })
    });
};

});
parcelRegister("4zqXR", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $c6b9a7c0ae48de0f$export$3b6761b6086f6dfd);
const $c6b9a7c0ae48de0f$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("2a4DJ", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $9876e167c440663b$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $9876e167c440663b$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("a33Uc")), {
        moduleId: "2e144122",
        moduleId: 'edition-awareness-premium-popup-dialog'
    }),
    getPreloadProps: (props)=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("a33Uc", function(module, exports) {

let $750d36bbccc965a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $750d36bbccc965a5$var$load("7ivsg").then(()=>parcelRequire('3wJ4n'));

});



parcelRegister("c0M1m", function(module, exports) {

$parcel$export(module.exports, "ReverseTrialPopupDialog", () => $1c9c5dfef4abb89c$export$436172fa0e71e289);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $96Irh = parcelRequire("96Irh");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $esLaG = parcelRequire("esLaG");

var $jVTFJ = parcelRequire("jVTFJ");

var $k5NI0 = parcelRequire("k5NI0");

var $5JWI8 = parcelRequire("5JWI8");

var $7YqwQ = parcelRequire("7YqwQ");
function $1c9c5dfef4abb89c$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen } = (0, $kBxPf.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    if (shouldAutoOpen) // Clears local storage key regardless of experiment cohort
    onAutoOpen?.();
    // Auto-opens popup if on control
    const shouldAutoOpenPopup = shouldAutoOpen && (0, $96Irh.default).getExperimentValue('jsw_ea_popover_open_vs_close', 'cohort', 'control') !== 'variation';
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $5JWI8.DIALOG_CONFIG),
        attributes: {
            autoOpened: shouldAutoOpenPopup
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: {
            ...(0, $5JWI8.DIALOG_CONFIG),
            autoOpened: shouldAutoOpenPopup
        },
        children: shouldAutoOpenPopup ? // Supports the auto-open functionality for the control cohort of the ea popover experiment
        // TEMPORARY and will be removed in the future
        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5NI0.AutoOpenPopupTrigger), {
            entryPoint: (0, $7YqwQ.entryPoint),
            entryPointParams: entryPointParams,
            placement: 'bottom-end',
            onClose: onClose
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jVTFJ.PopupEntryPoint), {
            entryPoint: (0, $7YqwQ.entryPoint),
            entryPointParams: entryPointParams,
            placement: 'bottom-end',
            onClose: onClose
        })
    });
}

});
parcelRegister("k5NI0", function(module, exports) {

$parcel$export(module.exports, "AutoOpenPopupTrigger", () => $b6ef8ba453038bb9$export$6189e5bf9171fa04);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $vCqQa = parcelRequire("vCqQa");

var $0yZbT = parcelRequire("0yZbT");

var $clxo5 = parcelRequire("clxo5");

var $l5ZMD = parcelRequire("l5ZMD");

var $65KjW = parcelRequire("65KjW");

var $hHBm5 = parcelRequire("hHBm5");

var $d3JON = parcelRequire("d3JON");
const $b6ef8ba453038bb9$var$emptyEntryPointParams = {};
const $b6ef8ba453038bb9$var$emptyEntryPointProps = {};
function $b6ef8ba453038bb9$export$6189e5bf9171fa04({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $65KjW.useRelayEnvironmentProvider)();
    const onError = (0, $hHBm5.useEntrypointErrorAnalytics)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $b6ef8ba453038bb9$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5ZMD.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($b6ef8ba453038bb9$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $b6ef8ba453038bb9$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3JON.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $5uXOq.useRef)(false);
    // Auto-open on load
    (0, $5uXOq.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
const $b6ef8ba453038bb9$var$PopupFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
    });

});

parcelRegister("5JWI8", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $f61e357d15f3694a$export$3b6761b6086f6dfd);
const $f61e357d15f3694a$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("7YqwQ", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $0326c91889d7ace3$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $jaK7u = parcelRequire("jaK7u");

const $0326c91889d7ace3$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("6sAJt")), {
        moduleId: "7de08a47",
        moduleId: 'edition-awareness-reverse-trial-jira-products-popup-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $jaK7u.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("jaK7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf761363d643b25e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9baf2e7494e77513a0123eabd435667d>>
 * @relayHash 15f4661c8008097f858290fee0257849
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0370abc7092db06ddab02c7127ae03713013e0fd991d19dedf8d5e8d86b63725

var $eiowN = parcelRequire("eiowN");
const $bf761363d643b25e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogReverseTrialPopupEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogReverseTrialPopupEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0370abc7092db06ddab02c7127ae03713013e0fd991d19dedf8d5e8d86b63725",
            "metadata": {},
            "name": "dialogReverseTrialPopupEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bf761363d643b25e$var$node.hash = "9928b60f2d699770604b599a405dd81f";
(0, $eiowN.PreloadableQueryRegistry).set($bf761363d643b25e$var$node.params.id, $bf761363d643b25e$var$node);
var $bf761363d643b25e$export$2e2bcd8739ae039 = $bf761363d643b25e$var$node;

});

parcelRegister("6sAJt", function(module, exports) {

let $4b41d9e2fa062171$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b41d9e2fa062171$var$load("8K4n3").then(()=>parcelRequire('eJxNr'));

});



parcelRegister("8aSJE", function(module, exports) {

$parcel$export(module.exports, "StandardAddPayment", () => $cc108f7d0fd3c6ea$export$23c2efc70269208f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $fqnSg = parcelRequire("fqnSg");

var $fYoko = parcelRequire("fYoko");

var $ljLzg = parcelRequire("ljLzg");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $ad2vv = parcelRequire("ad2vv");

var $iXA6N = parcelRequire("iXA6N");
function $cc108f7d0fd3c6ea$export$23c2efc70269208f() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const projectType = (0, $ljLzg.getJiraProjectTypeKey)(product);
    const jiraApplicationKey = (0, $fYoko.getJiraApplicationKey)(product);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product),
            chargeElement: (0, $fqnSg.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $ad2vv.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            product: product
        }), [
        onClose,
        product
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600,
            autoFocus: false
        };
        return {
            width: 968,
            height: 576,
            autoFocus: false
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $ad2vv.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPointProps: entryPointProps,
            entryPoint: (0, $iXA6N.entryPoint),
            entryPointParams: entryPointParams,
            modalProps: modalProps
        })
    });
}

});
parcelRegister("ad2vv", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $7e938a072170babf$export$3b6761b6086f6dfd);
const $7e938a072170babf$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment',
    dialogType: 'modal'
};

});

parcelRegister("iXA6N", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $9a5ce187357606b1$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $gwoaQ = parcelRequire("gwoaQ");

const $9a5ce187357606b1$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4jlhB")), {
        moduleId: "78a8c46f",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $gwoaQ.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("gwoaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d357a06186b82de9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<93f71296dcaef19de513d598ef771fc9>>
 * @relayHash 7a2553ea3ee9d2ec59ba8e898b98a1ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID df483ca05b1065a22a8d089158d2939e8473e9d933f15caeb70f655ff39172db

var $eiowN = parcelRequire("eiowN");
const $d357a06186b82de9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "ScalarField",
        "name": "startTimestamp"
    }, v11 = {
        "kind": "ScalarField",
        "name": "endTimestamp"
    }, v12 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v16 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v14 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v15 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v14 /*: any*/ 
    ], v18 = {
        "args": v17 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v19 = {
        "args": v17 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v20 = {
        "args": v17 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v21 = [
        v14 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v22 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = [
        v26 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v16 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v25 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v27 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v27 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v16 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v25 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v26 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "df483ca05b1065a22a8d089158d2939e8473e9d933f15caeb70f655ff39172db",
            "metadata": {},
            "name": "standardAddPaymentModalEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d357a06186b82de9$var$node.hash = "46819b986467d50e44d74f10d119ec16";
(0, $eiowN.PreloadableQueryRegistry).set($d357a06186b82de9$var$node.params.id, $d357a06186b82de9$var$node);
var $d357a06186b82de9$export$2e2bcd8739ae039 = $d357a06186b82de9$var$node;

});

parcelRegister("4jlhB", function(module, exports) {

let $32397221c0708cda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32397221c0708cda$var$load("25f1J").then(()=>parcelRequire('9xaLx'));

});



parcelRegister("4JsRx", function(module, exports) {

$parcel$export(module.exports, "StandardTrialLimitBreakersDialog", () => $ccbcfb50c2266eae$export$ca1bfac58e190135);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $fqnSg = parcelRequire("fqnSg");

var $fYoko = parcelRequire("fYoko");

var $ljLzg = parcelRequire("ljLzg");

var $esLaG = parcelRequire("esLaG");

var $6dCMO = parcelRequire("6dCMO");

var $jsHdw = parcelRequire("jsHdw");

var $dJbJR = parcelRequire("dJbJR");
function $ccbcfb50c2266eae$export$ca1bfac58e190135() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const jiraApplicationKey = (0, $fYoko.getJiraApplicationKey)(product);
    const projectType = (0, $ljLzg.getJiraProjectTypeKey)(product);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product),
            chargeElement: (0, $fqnSg.getChargeElementKey)(product),
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            projectType: projectType ?? 'SOFTWARE',
            shouldIncludeIfProductIsConfluence: product === 'confluence',
            shouldIncludeIfProductIsJiraSoftware: product === 'jira'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $jsHdw.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'x-large',
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $jsHdw.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
            entryPoint: (0, $dJbJR.entryPoint),
            entryPointProps: entryPointProps,
            entryPointParams: entryPointParams,
            modalProps: modalProps
        })
    });
}

});
parcelRegister("jsHdw", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $ddade6b886b85d0f$export$3b6761b6086f6dfd);
const $ddade6b886b85d0f$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-trial-limit-breakers-modal',
    dialogType: 'modal'
};

});

parcelRegister("dJbJR", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $f0ed12472fa07373$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $lgMOH = parcelRequire("lgMOH");

const $f0ed12472fa07373$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gxmzG")), {
        moduleId: "ee84d4bb",
        moduleId: 'edition-awareness-standard-trial-limit-breakers-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, jiraApplicationKey: jiraApplicationKey, projectType: projectType, chargeElement: chargeElement, shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence, shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $lgMOH.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence,
                        shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware
                    }
                }
            }
        })
});

});
parcelRegister("lgMOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf1ae8e0d483e1e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8670c6eedd6f221a663da7d436cd323e>>
 * @relayHash 2aaf000fa8f84a915e86d620cd60a08a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b78eb58b84f4f6f855840daec0021cf0460d8b41b8ed1e914e18b658d9946b67

var $eiowN = parcelRequire("eiowN");
const $3cf1ae8e0d483e1e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeIfProductIsConfluence"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeIfProductIsJiraSoftware"
    }, v7 = {
        "kind": "Variable",
        "name": "chargeElement",
        "variableName": "chargeElement"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "Variable",
        "name": "hamsProductKey",
        "variableName": "hamsProductKey"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = [
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "experienceUrl"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "dialogStandardTrialLimitBreakersQuery",
            "selections": [
                {
                    "args": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "jiraApplicationKey",
                            "variableName": "jiraApplicationKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectType",
                            "variableName": "projectType"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsConfluence",
                            "variableName": "shouldIncludeIfProductIsConfluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsJiraSoftware",
                            "variableName": "shouldIncludeIfProductIsJiraSoftware"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "limitBreakersModal_AtlassianEditionAwareness"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "dialogStandardTrialLimitBreakersQuery",
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "inTrialOrPreDunning": true
                                            }
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": v11 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v13 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endTimestamp"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": v11 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                v7 /*: any*/ 
                                            ],
                                            "kind": "ScalarField",
                                            "name": "latestUsageForChargeElement"
                                        },
                                        v12 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":true})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldIncludeIfProductIsConfluence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceStorage",
                            "kind": "LinkedField",
                            "name": "confluence_storage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "bytesUsed"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isUnlimited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "bytesLimit"
                                }
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "cql",
                                    "value": "type=user"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 200
                                }
                            ],
                            "concreteType": "ConfluenceSearchConnection",
                            "kind": "LinkedField",
                            "name": "confluence_searchUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluencePerson",
                                            "kind": "LinkedField",
                                            "name": "confluencePerson",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "concreteType": "Icon",
                                                    "kind": "LinkedField",
                                                    "name": "profilePicture",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "path"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldIncludeIfProductIsJiraSoftware",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageUsed"
                                },
                                {
                                    "args": v15 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageAllowed"
                                },
                                {
                                    "args": v15 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageIsUnlimited"
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "fields": [
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "types.0",
                                                            "variableName": "projectType"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "types"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 20
                                                                }
                                                            ],
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:20)"
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b78eb58b84f4f6f855840daec0021cf0460d8b41b8ed1e914e18b658d9946b67",
            "metadata": {},
            "name": "dialogStandardTrialLimitBreakersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3cf1ae8e0d483e1e$var$node.hash = "20d17aeb054ad27c6f63bc76677eb767";
(0, $eiowN.PreloadableQueryRegistry).set($3cf1ae8e0d483e1e$var$node.params.id, $3cf1ae8e0d483e1e$var$node);
var $3cf1ae8e0d483e1e$export$2e2bcd8739ae039 = $3cf1ae8e0d483e1e$var$node;

});

parcelRegister("gxmzG", function(module, exports) {

let $031b5ff497556639$var$load = (parcelRequire("28QjX"))(4);
module.exports = $031b5ff497556639$var$load("i9BsC").then(()=>parcelRequire('T18il'));

});





parcelRegister("ZgFnS", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $587b2fcbaf899798$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $aatTc = parcelRequire("aatTc");

var $lAOer = parcelRequire("lAOer");

var $cjHtg = parcelRequire("cjHtg");
const $587b2fcbaf899798$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $cjHtg.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $aatTc.useInteractionContext)();
    const onError = (0, $5uXOq.useCallback)((error)=>{
        const interaction = (0, $lAOer.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $lAOer.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $lAOer.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        children: children
    });
};

});
parcelRegister("cjHtg", function(module, exports) {

$parcel$export(module.exports, "useErrorAnalytics", () => $f23313a6448e25d9$export$e2d4523bbccd2343);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $jXOZU = parcelRequire("jXOZU");
function $f23313a6448e25d9$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleOnError = (0, $5uXOq.useCallback)((error)=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                ...(0, $jXOZU.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                id: id ?? 'unknownErrorId'
            }
        });
        const contextAttributes = (0, $jXOZU.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $jXOZU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        id,
        product,
        edition
    ]);
    return handleOnError;
}

});


parcelRegister("a5mGe", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $6c805594a861fc85$export$1033c28b5e1c2deb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bkS4F = parcelRequire("bkS4F");
var $98UVV = parcelRequire("98UVV");

var $kBxPf = parcelRequire("kBxPf");

var $5UZ6w = parcelRequire("5UZ6w");
function $6c805594a861fc85$export$1033c28b5e1c2deb() {
    const context = (0, $kBxPf.useEditionAwareness)();
    const { product: product, isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = context;
    const handleDismissSpotlight = (0, $5uXOq.useCallback)(()=>{
        handleSetSpotlight?.(false);
    }, [
        handleSetSpotlight
    ]);
    if ((0, $5UZ6w.isEligibleForStandardToPremium)(context)) {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $98UVV.default), {
            children: isSpotlightActive && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bkS4F.default), {
                actions: [
                    {
                        onClick: handleDismissSpotlight,
                        text: 'Got it'
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready.",
                    description: "Message to show in the spotlight on the profile menu icon when the user dismisses the EA pill and is eligible for standard to premium upsell"
                })
            }, target)
        });
    }
    return null;
}

});


parcelRegister("85tfh", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessUpsell", () => $8870133fc397b2af$export$148b30c5d238daaa);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $96Irh = parcelRequire("96Irh");

var $5tDD0 = parcelRequire("5tDD0");

var $65KjW = parcelRequire("65KjW");

var $afsja = parcelRequire("afsja");

var $kBxPf = parcelRequire("kBxPf");

var $bYAAX = parcelRequire("bYAAX");

var $5UZ6w = parcelRequire("5UZ6w");

var $j1hPA = parcelRequire("j1hPA");

var $sKnbe = parcelRequire("sKnbe");

var $iSjRt = parcelRequire("iSjRt");

var $ZgFnS = parcelRequire("ZgFnS");

var $a5mGe = parcelRequire("a5mGe");
/**
 * Edition awareness upsell is an experimental EA implementtiona that has to be exported as its own component to avoid making ccp calls which are alerting VC90 mertics
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $8870133fc397b2af$var$EditionAwarenessUpsellImpl({ edition: edition, product: product, cloudId: cloudId, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, navVersion: navVersion }) {
    const config = (0, $j1hPA.useConfig)(product, edition);
    const { isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = (0, $sKnbe.useSpotlight)();
    const trialOfferingName = (0, $bYAAX.getTrialOfferingName)(edition, config);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            config: config,
            cloudId: cloudId,
            product: product,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            isSpotlightActive: isSpotlightActive,
            handleSetSpotlight: handleSetSpotlight,
            trialOfferingName: trialOfferingName
        };
    }, [
        config,
        cloudId,
        product,
        edition,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        isSpotlightActive,
        handleSetSpotlight,
        trialOfferingName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBxPf.EditionAwarenessContext).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $htBRZ.default), {
            data: {
                navVersion: navVersion
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($8870133fc397b2af$var$StandardEdition, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a5mGe.Spotlight), {})
            ]
        })
    });
}
function $8870133fc397b2af$export$148b30c5d238daaa(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $65KjW.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5tDD0.default), {
            name: "edition-awareness-platform",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ZgFnS.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "edition-awareness-upsell",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($8870133fc397b2af$var$EditionAwarenessUpsellImpl, {
                        ...props
                    })
                })
            })
        })
    });
}
function $8870133fc397b2af$var$StandardEdition() {
    const context = (0, $kBxPf.useEditionAwareness)();
    const { product: product, hasDismissedButton: hasDismissedButton } = context;
    if ((0, $5UZ6w.isEligibleForStandardToPremium)(context) && !hasDismissedButton) {
        const aaExperimentKey = product === 'confluence' ? 'edition_awareness_upsell_confluence_aa' : 'edition_awareness_upsell_jira_aa';
        const aaCohort = (0, $96Irh.default).getExperimentValue(aaExperimentKey, 'cohort', 'not-enrolled');
        const abExperimentKey = product === 'confluence' ? 'edition_awareness_standard_upsell_confluence_ab' : 'edition_awareness_upsell_jira_ab';
        const abCohort = (0, $96Irh.default).getExperimentValue(abExperimentKey, 'cohort', 'not-enrolled');
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                (aaCohort === 'control' || aaCohort === 'treatment') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                    flagKey: aaExperimentKey,
                    cohort: aaCohort,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {})
                }),
                abCohort === 'control' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                    flagKey: abExperimentKey,
                    cohort: abCohort,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {})
                }),
                abCohort === 'treatment' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $afsja.FeatureExposedAnalytics), {
                    flagKey: abExperimentKey,
                    cohort: abCohort,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBxPf.SiteInformationContext).Provider, {
                        value: {
                            licensedUsers: 0
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iSjRt.StandardToPremiumDialog), {})
                    })
                })
            ]
        });
    }
    return null;
}

});
parcelRegister("iSjRt", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumDialog", () => $0fd365ba931c1b10$export$67151f73e55c3a51);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6nV7O = parcelRequire("6nV7O");

var $kBxPf = parcelRequire("kBxPf");

var $esLaG = parcelRequire("esLaG");

var $bTleW = parcelRequire("bTleW");

var $9YKfo = parcelRequire("9YKfo");

var $hZvim = parcelRequire("hZvim");
function $0fd365ba931c1b10$export$67151f73e55c3a51() {
    const { product: product, cloudId: cloudId } = (0, $kBxPf.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $esLaG.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const onClose = (0, $6nV7O.useOnDismissDialog)({
        ...(0, $9YKfo.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: (0, $9YKfo.DIALOG_CONFIG),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bTleW.DismissibleModalEntryPoint), {
            entryPoint: (0, $hZvim.entryPoint),
            entryPointProps: entryPointProps,
            entryPointParams: entryPointParams
        })
    });
}

});
parcelRegister("bTleW", function(module, exports) {

$parcel$export(module.exports, "DismissibleModalEntryPoint", () => $818a81b1f6b8c416$export$3362d3660491ee6d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eWkgo = parcelRequire("eWkgo");

var $7ohXE = parcelRequire("7ohXE");

var $6dCMO = parcelRequire("6dCMO");
function $818a81b1f6b8c416$export$3362d3660491ee6d(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eWkgo.default), {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dCMO.ModalEntryPoint), {
                ...props
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ohXE.DismissMenu), {})
        ]
    });
}

});
parcelRegister("7ohXE", function(module, exports) {

$parcel$export(module.exports, "DismissMenu", () => $8107d912a9fa0476$export$6c8332cc6beadf8a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c8rIN = parcelRequire("c8rIN");

var $8zIDr = parcelRequire("8zIDr");

var $0yZbT = parcelRequire("0yZbT");
var $gVM6m = parcelRequire("gVM6m");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $7s00o = parcelRequire("7s00o");
var $35Wkh = parcelRequire("35Wkh");
var $lCQJu = parcelRequire("lCQJu");
var $d11P2 = parcelRequire("d11P2");

var $8I8C0 = parcelRequire("8I8C0");

var $kBxPf = parcelRequire("kBxPf");

var $bYAAX = parcelRequire("bYAAX");
const $8107d912a9fa0476$var$dismissMenuStyles = (0, $2s57o.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.100',
    paddingBlock: '0',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    borderColor: 'color.border.discovery',
    borderLeftWidth: '0',
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    ':hover': {
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed'
    }
});
const $8107d912a9fa0476$var$reasonsUlStyles = (0, $2s57o.xcss)({
    marginTop: '0',
    marginLeft: 'space.200',
    paddingLeft: 'space.100'
});
const $8107d912a9fa0476$var$capitalizeName = (name)=>name.charAt(0).toUpperCase() + name.slice(1);
function $8107d912a9fa0476$export$6c8332cc6beadf8a() {
    const fireDismissMenuEvent = (0, $8I8C0.useOnClickDismissMenu)();
    const { product: product, edition: edition, config: config, onDismissButton: onDismissButton, handleSetSpotlight: handleSetSpotlight } = (0, $kBxPf.useEditionAwareness)();
    const trialOfferingName = (0, $bYAAX.getTrialOfferingName)(edition, config);
    const handleOnEvents = (0, $5uXOq.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
            handleSetSpotlight?.(true);
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        handleSetSpotlight,
        fireDismissMenuEvent
    ]);
    const getAdControlsTrigger = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
            ...props,
            ref: triggerRef,
            xcss: [
                $8107d912a9fa0476$var$dismissMenuStyles
            ],
            "aria-label": "More",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #626F86)"
            })
        }), []);
    const offering = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6eFvr.default), {
        weight: "bold",
        children: [
            $8107d912a9fa0476$var$capitalizeName(product),
            " ",
            $8107d912a9fa0476$var$capitalizeName(trialOfferingName)
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35Wkh.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7s00o.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lCQJu.default), {
                            ...props,
                            children: "Dismiss"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d11P2.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this",
                                                defaultMessage: "We think {offering} will improve your team's productivity. This recommendation is only shown to billing admins and is based on:",
                                                description: "A message that informs the user why they are seeing the current plan recommendation for their current product",
                                                values: {
                                                    offering: offering
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                                            as: "ul",
                                            xcss: $8107d912a9fa0476$var$reasonsUlStyles,
                                            children: [
                                                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1",
                                                        defaultMessage: "the size of your team",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2",
                                                        defaultMessage: "your existing Atlassian products",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian",
                                                    description: "Link to Atlassian data privacy page"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}

});
parcelRegister("7s00o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0924bb4ae2f160f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $j7m8K = parcelRequire("j7m8K");
var $3jAdT = parcelRequire("3jAdT");


var $c9EVQ = parcelRequire("c9EVQ");

var $dGS7K = parcelRequire("dGS7K");
const $a0924bb4ae2f160f$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $a0924bb4ae2f160f$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $c9EVQ.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $dGS7K.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7m8K.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $ad13715e24bdee8d$export$17ff257e1f6e39f5) : (0, $ad13715e24bdee8d$export$7fc09cf740f33ed4), createInteractedUIEvent($a0924bb4ae2f160f$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $a0924bb4ae2f160f$export$2e2bcd8739ae039 = $a0924bb4ae2f160f$var$AdControlDropdownMenu;

});
// ACT Event types
// AdControlDropdownMenu
const $ad13715e24bdee8d$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $ad13715e24bdee8d$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $ad13715e24bdee8d$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $ad13715e24bdee8d$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $ad13715e24bdee8d$export$6d3088110036f124 = 'DISMISS_FAILED';
const $ad13715e24bdee8d$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $ad13715e24bdee8d$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $ad13715e24bdee8d$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $ad13715e24bdee8d$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("c9EVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3c02a61c3c7969$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $bngFq = parcelRequire("bngFq");
function $6e3c02a61c3c7969$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $4e2819b72987a07d$export$f1d537d508d2945a),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("dGS7K", function(module, exports) {

$parcel$export(module.exports, "useAdControlProvider", () => $397a1d0efcb38942$export$450072b04d50916);

var $5uXOq = parcelRequire("5uXOq");


var $3q1PP = parcelRequire("3q1PP");

var $bptIx = parcelRequire("bptIx");
function $397a1d0efcb38942$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $bptIx.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $ad13715e24bdee8d$export$5c5fc6956b7600ea:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((itemId)=>{
        return new (0, $3q1PP.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}

});
parcelRegister("3q1PP", function(module, exports) {

$parcel$export(module.exports, "default", () => $97271fb0e9d56b39$export$2e2bcd8739ae039);
class $97271fb0e9d56b39$export$2e2bcd8739ae039 {
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
}

});

parcelRegister("bptIx", function(module, exports) {

$parcel$export(module.exports, "useAdControlContext", () => $92ce327b26ed7e1a$export$4e82dc865a56141b);

var $5uXOq = parcelRequire("5uXOq");

var $iNexL = parcelRequire("iNexL");
function $92ce327b26ed7e1a$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $iNexL.AdControlContext));
}

});
parcelRegister("iNexL", function(module, exports) {

$parcel$export(module.exports, "AdControlContext", () => $3753564c0784350b$export$554b2f9bd0a293df);

var $5uXOq = parcelRequire("5uXOq");

var $4bQ1j = parcelRequire("4bQ1j");
const $3753564c0784350b$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    state: {
        ...(0, $4bQ1j.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});

});
parcelRegister("4bQ1j", function(module, exports) {

$parcel$export(module.exports, "initialAdControlProviderState", () => $e077ba8bb12594eb$export$22776e7a42f7089d);
$parcel$export(module.exports, "adControlProviderReducer", () => $e077ba8bb12594eb$export$5f3557676ca801eb);
const $e077ba8bb12594eb$export$22776e7a42f7089d = {
    flags: new Map()
};
const $e077ba8bb12594eb$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};

});





parcelRegister("35Wkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $929e5a5e0c41e60d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");

var $iNexL = parcelRequire("iNexL");

var $4bQ1j = parcelRequire("4bQ1j");

var $aYjGw = parcelRequire("aYjGw");

var $4OtDB = parcelRequire("4OtDB");

var $4lmT0 = parcelRequire("4lmT0");
const $929e5a5e0c41e60d$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useReducer((0, $4bQ1j.adControlProviderReducer), (0, $4bQ1j.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: ''
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYjGw.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iNexL.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4lmT0.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {}),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4OtDB.default), {})
                })
            ]
        })
    });
};
var $929e5a5e0c41e60d$export$2e2bcd8739ae039 = $929e5a5e0c41e60d$var$AdControlProvider;

});
parcelRegister("aYjGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6c52b9f8abb86a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dKrqP = parcelRequire("dKrqP");

var $fi091 = parcelRequire("fi091");

var $8BGHz = parcelRequire("8BGHz");
const $2f6c52b9f8abb86a$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dKrqP.default), {
        defaultMessages: (0, $8BGHz.default),
        loaderFn: (0, $fi091.fetchMessagesForLocale),
        children: children
    });
};
var $2f6c52b9f8abb86a$export$2e2bcd8739ae039 = $2f6c52b9f8abb86a$var$ActIntlProvider;

});
parcelRegister("fi091", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $275af3721df43ef4$export$2b153a2030b0feb2);

var $equL1 = parcelRequire("equL1");

var $8BGHz = parcelRequire("8BGHz");
const $275af3721df43ef4$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $275af3721df43ef4$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($275af3721df43ef4$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $equL1.locales)) {
            const messages = await (0, $equL1.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $equL1.locales)) {
            const messages = await (0, $equL1.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $8BGHz.default;
};

});
parcelRegister("equL1", function(module, exports) {

$parcel$export(module.exports, "locales", () => $befc9bdb51f4eea4$export$df1c34db1371eeed);


























const $befc9bdb51f4eea4$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("fCXVF")),
    da: ()=>(parcelRequire("bBWqX")),
    de: ()=>(parcelRequire("fQfzA")),
    en_GB: ()=>(parcelRequire("4rZDS")),
    en_ZZ: ()=>(parcelRequire("bw7ve")),
    en: ()=>Promise.resolve((parcelRequire("8BGHz"))),
    es: ()=>(parcelRequire("aIl1t")),
    fi: ()=>(parcelRequire("llc9g")),
    fr: ()=>(parcelRequire("tKDuD")),
    hu: ()=>(parcelRequire("3aNTn")),
    it: ()=>(parcelRequire("ifsJW")),
    ja: ()=>(parcelRequire("6O2ue")),
    ko: ()=>(parcelRequire("4FE18")),
    nb: ()=>(parcelRequire("706hs")),
    nl: ()=>(parcelRequire("5Z4e9")),
    pl: ()=>(parcelRequire("l79Dd")),
    pt_BR: ()=>(parcelRequire("xziGY")),
    ru: ()=>(parcelRequire("5TLqU")),
    sv: ()=>(parcelRequire("7eHER")),
    th: ()=>(parcelRequire("hoLJs")),
    tr: ()=>(parcelRequire("4B765")),
    uk: ()=>(parcelRequire("1hymO")),
    vi: ()=>(parcelRequire("dexsS")),
    zh_TW: ()=>(parcelRequire("8HQiw")),
    zh: ()=>(parcelRequire("cvA5p"))
};

});
parcelRegister("fCXVF", function(module, exports) {

let $b608e44617ed89ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b608e44617ed89ba$var$load("82cJb").then(()=>parcelRequire('kHa48'));

});

parcelRegister("bBWqX", function(module, exports) {

let $87407a2436bff40f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87407a2436bff40f$var$load("6jIXz").then(()=>parcelRequire('2LN4r'));

});

parcelRegister("fQfzA", function(module, exports) {

let $b887cacc4a5791a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b887cacc4a5791a6$var$load("cs1G1").then(()=>parcelRequire('3cT1J'));

});

parcelRegister("4rZDS", function(module, exports) {

let $33d97fe848d33627$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33d97fe848d33627$var$load("9dchs").then(()=>parcelRequire('fJleG'));

});

parcelRegister("bw7ve", function(module, exports) {

let $862880c73a10e50e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $862880c73a10e50e$var$load("3RHe5").then(()=>parcelRequire('lUYJB'));

});

parcelRegister("aIl1t", function(module, exports) {

let $7cce5225226ae04a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cce5225226ae04a$var$load("fhsUG").then(()=>parcelRequire('csVok'));

});

parcelRegister("llc9g", function(module, exports) {

let $f894fb8d94332560$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f894fb8d94332560$var$load("4OP1M").then(()=>parcelRequire('j3LyL'));

});

parcelRegister("tKDuD", function(module, exports) {

let $0596e27bba2df46c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0596e27bba2df46c$var$load("i4ARB").then(()=>parcelRequire('3dg7p'));

});

parcelRegister("3aNTn", function(module, exports) {

let $24f901cbcc3e6bd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $24f901cbcc3e6bd3$var$load("kDym8").then(()=>parcelRequire('bVpN3'));

});

parcelRegister("ifsJW", function(module, exports) {

let $d48febda4c5fbfc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d48febda4c5fbfc8$var$load("dBuiV").then(()=>parcelRequire('TVGmG'));

});

parcelRegister("6O2ue", function(module, exports) {

let $4f49575ac61bf2b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f49575ac61bf2b5$var$load("hH7CA").then(()=>parcelRequire('5xEeV'));

});

parcelRegister("4FE18", function(module, exports) {

let $366a0861683c1375$var$load = (parcelRequire("28QjX"))(4);
module.exports = $366a0861683c1375$var$load("dnjQB").then(()=>parcelRequire('idacq'));

});

parcelRegister("706hs", function(module, exports) {

let $518d67ae1269c330$var$load = (parcelRequire("28QjX"))(4);
module.exports = $518d67ae1269c330$var$load("8glNa").then(()=>parcelRequire('39ro9'));

});

parcelRegister("5Z4e9", function(module, exports) {

let $45b5edadbe8871d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45b5edadbe8871d6$var$load("c4kh8").then(()=>parcelRequire('5goIj'));

});

parcelRegister("l79Dd", function(module, exports) {

let $f5f1b90ef02e20bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5f1b90ef02e20bf$var$load("aSl0x").then(()=>parcelRequire('jKvzd'));

});

parcelRegister("xziGY", function(module, exports) {

let $064e771f785150e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $064e771f785150e4$var$load("gVhdO").then(()=>parcelRequire('7uaad'));

});

parcelRegister("5TLqU", function(module, exports) {

let $44b6e2069730c267$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44b6e2069730c267$var$load("bAGKN").then(()=>parcelRequire('kYtt5'));

});

parcelRegister("7eHER", function(module, exports) {

let $544bb4cf12e2f884$var$load = (parcelRequire("28QjX"))(4);
module.exports = $544bb4cf12e2f884$var$load("kYFZF").then(()=>parcelRequire('4s3zl'));

});

parcelRegister("hoLJs", function(module, exports) {

let $caa9b430b2899efd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $caa9b430b2899efd$var$load("kQp9u").then(()=>parcelRequire('glSwK'));

});

parcelRegister("4B765", function(module, exports) {

let $35901f7bbd80ca04$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35901f7bbd80ca04$var$load("dEtem").then(()=>parcelRequire('6OrFy'));

});

parcelRegister("1hymO", function(module, exports) {

let $0ef2098375e70201$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ef2098375e70201$var$load("c62QO").then(()=>parcelRequire('bclKA'));

});

parcelRegister("dexsS", function(module, exports) {

let $9a268a8f6bbf70a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a268a8f6bbf70a8$var$load("2ndf7").then(()=>parcelRequire('loybA'));

});

parcelRegister("8HQiw", function(module, exports) {

let $656ae81ec2ad29a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $656ae81ec2ad29a3$var$load("kFFbe").then(()=>parcelRequire('f90JK'));

});

parcelRegister("cvA5p", function(module, exports) {

let $91b45f405afc8d24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $91b45f405afc8d24$var$load("jBpAm").then(()=>parcelRequire('aDFDX'));

});




parcelRegister("4OtDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $67fa4f90c6c1262b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1D5Rp = parcelRequire("1D5Rp");
var $5Xt64 = parcelRequire("5Xt64");

var $gM4B1 = parcelRequire("gM4B1");

var $5sRpy = parcelRequire("5sRpy");



var $c9EVQ = parcelRequire("c9EVQ");

var $dGS7K = parcelRequire("dGS7K");

var $i11mp = parcelRequire("i11mp");

var $gmaMx = parcelRequire("gmaMx");
const $67fa4f90c6c1262b$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $67fa4f90c6c1262b$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $67fa4f90c6c1262b$var$DismissalFlagGroup = ()=>{
    (0, $gmaMx.overridePortalIndex)($67fa4f90c6c1262b$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $dGS7K.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $c9EVQ.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $ad13715e24bdee8d$export$5c5fc6956b7600ea), createInteractedUIEvent($67fa4f90c6c1262b$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Xt64.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                id: $67fa4f90c6c1262b$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1D5Rp.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gM4B1))), {
                        label: "Success",
                        spacing: "spacious",
                        color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$940e1f69e873f202)})`
                    }),
                    title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $i11mp.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $i11mp.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $67fa4f90c6c1262b$export$2e2bcd8739ae039 = $67fa4f90c6c1262b$var$DismissalFlagGroup;

});
parcelRegister("i11mp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $763cb03bb882a767$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $763cb03bb882a767$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    notInterested: {
        id: 'act.action.notInterested.button.text',
        defaultMessage: 'Not interested',
        description: 'The text of a button to indicate the users can dismiss the current component'
    },
    notInterestedFlag: {
        id: 'act.action.notInterestedFlag.flag.text',
        defaultMessage: 'Got it, thanks for letting us know',
        description: 'A message that informs the users the dismissal action is taken'
    },
    showReasons: {
        id: 'act.action.showReasons.common.text',
        defaultMessage: 'Why am I seeing this?',
        description: "The text of a button to indicate the users can click and see the reasons for a component's appearance"
    },
    dismissalMessage: {
        id: 'act.action.dismissalMessage.common.text',
        defaultMessage: "You won\u2019t see this here as often.",
        description: 'A message that informs the users the dismissal action is taken'
    },
    reasonsModalOkButton: {
        id: 'act.action.reasonsModalOkButton.common.text',
        defaultMessage: 'OK',
        description: 'The text of a button to indicate the users can dismiss the current modal'
    }
});

});

parcelRegister("gmaMx", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PORTAL_OVERRIDE_INDEX", () => $9dad90a581c314d2$export$335243096683aa37);
$parcel$export(module.exports, "overridePortalIndex", () => $9dad90a581c314d2$export$61df98316049b30);
const $9dad90a581c314d2$export$335243096683aa37 = 900;
function $9dad90a581c314d2$export$61df98316049b30(elementId, index = $9dad90a581c314d2$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $9dad90a581c314d2$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $9dad90a581c314d2$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $9dad90a581c314d2$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$9dad90a581c314d2$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}

});


parcelRegister("4lmT0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e89b2ff43aa9bbc3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bMFGq = parcelRequire("bMFGq");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $5sRpy = parcelRequire("5sRpy");


var $c9EVQ = parcelRequire("c9EVQ");

var $dGS7K = parcelRequire("dGS7K");

var $i11mp = parcelRequire("i11mp");

var $gmaMx = parcelRequire("gmaMx");
const $e89b2ff43aa9bbc3$var$adControlScreenName = 'adControlsReasonsModal';
const $e89b2ff43aa9bbc3$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $e89b2ff43aa9bbc3$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $gmaMx.DEFAULT_PORTAL_OVERRIDE_INDEX), ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $dGS7K.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $c9EVQ.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const eventDispatcherRef = (0, $5uXOq.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $5uXOq.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $ad13715e24bdee8d$export$ff50ad60f08a4bc0), createScreenUIEvent($e89b2ff43aa9bbc3$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $ad13715e24bdee8d$export$6bd2d8eacca15ce1), createScreenUIEvent($e89b2ff43aa9bbc3$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $gmaMx.overridePortalIndex)($e89b2ff43aa9bbc3$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hordk.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                id: $e89b2ff43aa9bbc3$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                            children: title ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $i11mp.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g1QfP.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7CjwE.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $i11mp.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $e89b2ff43aa9bbc3$export$2e2bcd8739ae039 = $e89b2ff43aa9bbc3$var$ReasonsModal;

});


parcelRegister("lCQJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8771ff1ca4d101$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1eETS = parcelRequire("1eETS");


var $c9EVQ = parcelRequire("c9EVQ");

var $dGS7K = parcelRequire("dGS7K");

var $i11mp = parcelRequire("i11mp");
const $8a8771ff1ca4d101$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $8a8771ff1ca4d101$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $dGS7K.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $c9EVQ.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $ad13715e24bdee8d$export$e33200507ac1d20a), createInteractedUIEvent($8a8771ff1ca4d101$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $ad13715e24bdee8d$export$103f41d1f3bf374e));
        } catch (e) {
            eventDispatcher.dispatchError((0, $ad13715e24bdee8d$export$6d3088110036f124), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $i11mp.messages).notInterested
        })
    });
};
var $8a8771ff1ca4d101$export$2e2bcd8739ae039 = $8a8771ff1ca4d101$var$DismissalButton;

});

parcelRegister("d11P2", function(module, exports) {

$parcel$export(module.exports, "default", () => $435225acc17e3c0c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1eETS = parcelRequire("1eETS");


var $c9EVQ = parcelRequire("c9EVQ");

var $dGS7K = parcelRequire("dGS7K");

var $i11mp = parcelRequire("i11mp");
const $435225acc17e3c0c$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $435225acc17e3c0c$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $dGS7K.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $c9EVQ.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $ad13715e24bdee8d$export$5595c6967e83d351), createInteractedUIEvent($435225acc17e3c0c$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $i11mp.messages).showReasons
        })
    });
};
var $435225acc17e3c0c$export$2e2bcd8739ae039 = $435225acc17e3c0c$var$ReasonsButton;

});

parcelRegister("8I8C0", function(module, exports) {

$parcel$export(module.exports, "useOnClickDismissMenu", () => $70a010a87f8c2a20$export$d840cf3018e72a62);

var $5uXOq = parcelRequire("5uXOq");

var $jXOZU = parcelRequire("jXOZU");
const $70a010a87f8c2a20$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jXOZU.useAnalytics)();
    return (0, $5uXOq.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});



parcelRegister("9YKfo", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $5f1fef51dbff6c49$export$3b6761b6086f6dfd);
const $5f1fef51dbff6c49$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium',
    dialogType: 'modal'
};

});

parcelRegister("hZvim", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $d2e97691db2e4714$export$6333901e831d7af0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $1jkCL = parcelRequire("1jkCL");

const $d2e97691db2e4714$export$6333901e831d7af0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("jeJGy")), {
        moduleId: "5d6f3a03",
        moduleId: 'edition-awareness-standard-to-premium-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $1jkCL.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("1jkCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ee699b73e40215$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<682e1b9258283a7f09057adf30795f9d>>
 * @relayHash 07dc38bf96b6611a01f9767f7b407b8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbf18c0421da822d19df28c840fae84cc019e38b8a514c0f675b1a9787b4a6ec

var $eiowN = parcelRequire("eiowN");
const $12ee699b73e40215$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogStandardToPremiumEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogStandardToPremiumEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dbf18c0421da822d19df28c840fae84cc019e38b8a514c0f675b1a9787b4a6ec",
            "metadata": {},
            "name": "dialogStandardToPremiumEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$12ee699b73e40215$var$node.hash = "23572a45675a29460489ba03bc2ffca8";
(0, $eiowN.PreloadableQueryRegistry).set($12ee699b73e40215$var$node.params.id, $12ee699b73e40215$var$node);
var $12ee699b73e40215$export$2e2bcd8739ae039 = $12ee699b73e40215$var$node;

});

parcelRegister("jeJGy", function(module, exports) {

let $e012c34ad30926ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e012c34ad30926ed$var$load("5tmec").then(()=>parcelRequire('et6bh'));

});




parcelRegister("lrpci", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $06ffcb35a0a21e28$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLinkButton", () => $06ffcb35a0a21e28$export$57c5e4c8900420b5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fv0UR = parcelRequire("fv0UR");

var $7VIfr = parcelRequire("7VIfr");

var $c5zfI = parcelRequire("c5zfI");

var $fHpHg = parcelRequire("fHpHg");

var $gHU1R = parcelRequire("gHU1R");
var $0yZbT = parcelRequire("0yZbT");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");

var $3926G = parcelRequire("3926G");

var $bRH8U = parcelRequire("bRH8U");

var $4STn8 = parcelRequire("4STn8");

var $9N2Ha = parcelRequire("9N2Ha");
const $06ffcb35a0a21e28$var$buttonStyles = (0, $2s57o.xcss)({
    borderWidth: 'border.width',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $06ffcb35a0a21e28$var$brandStyles = (0, $2s57o.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand',
    ':hover': {
        color: 'color.text.brand'
    }
});
const $06ffcb35a0a21e28$var$warningStyles = (0, $2s57o.xcss)({
    borderColor: 'color.border.warning'
});
const $06ffcb35a0a21e28$var$dangerStyles = (0, $2s57o.xcss)({
    borderColor: 'color.border.danger'
});
const $06ffcb35a0a21e28$var$iconStyles = (0, $2s57o.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: 'none'
});
const $06ffcb35a0a21e28$var$sparkleAnimation = null;
const $06ffcb35a0a21e28$var$sparkleStyles = null;
const $06ffcb35a0a21e28$var$ButtonIcon = (props)=>{
    const { status: status, upgradeIconType: upgradeIconType, icon: icon, isHovering: isHovering } = props;
    if (upgradeIconType === 'animated-gem') {
        if (props.color) // The animated gem icon has hardcoded colors
        // Showing the standard gem icon when a color override is provided.
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fv0UR))), {
            label: "",
            color: props.color,
            testId: ""
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4STn8.AnimatedGemIcon), {
            isHovering: isHovering
        });
    }
    const UpgradeIcon = upgradeIconType === 'gem' ? (0, (/*@__PURE__*/$parcel$interopDefault($fv0UR))) : (0, $9N2Ha.SparkleIcon);
    // Cases where the icon is specified
    if (icon === 'upgrade') return /*#__PURE__*/ (0, $2OMIu.jsx)(UpgradeIcon, {
        label: "",
        // `primaryColor` is used when `UpgradeIcon === SparkleIcon`
        primaryColor: props.color ?? "var(--ds-icon-discovery, #8270DB)",
        // `color` is used when `UpgradeIcon === EditionsIcon`
        color: props.color ?? "var(--ds-icon-discovery, #8270DB)",
        testId: `${upgradeIconType}-icon`
    });
    if (icon === 'warning') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c5zfI))), {
        label: "",
        color: props.color ?? "var(--ds-icon-warning, #E56910)",
        testId: "warning-icon"
    });
    if (icon === 'danger') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c5zfI))), {
        label: "",
        color: props.color ?? "var(--ds-icon-warning, #E56910)",
        testId: "warning-icon"
    });
    if (icon === 'missing-payment-details') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7VIfr))), {
        label: "",
        color: props.color ?? "var(--ds-icon-discovery, #8270DB)",
        LEGACY_size: "small",
        testId: "credit-card-icon"
    });
    // Cases where the icon is undefined, falls back to status determining the icon
    if (status === 'warning') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c5zfI))), {
        label: "",
        color: props.color ?? "var(--ds-icon-warning, #E56910)",
        testId: "warning-icon"
    });
    if (status === 'danger') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c5zfI))), {
        label: "",
        color: props.color ?? "var(--ds-icon-danger, #C9372C)",
        testId: "warning-icon"
    });
    // Default status
    return /*#__PURE__*/ (0, $2OMIu.jsx)(UpgradeIcon, {
        label: "",
        // `primaryColor` is used when `UpgradeIcon === SparkleIcon`
        primaryColor: props.color ?? "var(--ds-icon-discovery, #8270DB)",
        // `color` is used when `UpgradeIcon === EditionsIcon`
        color: props.color ?? "var(--ds-icon-discovery, #8270DB)",
        testId: `${upgradeIconType}-icon`
    });
};
const $06ffcb35a0a21e28$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, status: status, upgradeIconType: upgradeIconType, icon: icon, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ...rest }, ref)=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const handleOnMouseEnter = (0, $5uXOq.useCallback)((event)=>{
        setIsHovering(true);
        onMouseEnter && onMouseEnter(event);
    }, [
        onMouseEnter,
        setIsHovering
    ]);
    const handleOnMouseLeave = (0, $5uXOq.useCallback)((event)=>{
        setIsHovering(false);
        onMouseLeave && onMouseLeave(event);
    }, [
        onMouseLeave,
        setIsHovering
    ]);
    if ((0, $bRH8U.useHasCustomTheme)() && (0, $fHpHg.fg)('platform_design_system_edition_awareness_theming')) /**
     * If the top navigation is using a custom theme then we need to use a theme-aware button.
     *
     * The button will appear as a regular button without the custom, vibrant colors normally
     * applied to the edition awareness button.
     *
     * This is intentional, but could change in the future.
     */ return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1o9zidpf _kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.Button), {
            ...rest,
            ref: ref,
            onMouseEnter: (event)=>handleOnMouseEnter(event),
            onMouseLeave: (event)=>handleOnMouseLeave(event),
            iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    xcss: $06ffcb35a0a21e28$var$iconStyles,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($06ffcb35a0a21e28$var$ButtonIcon, {
                        status: status,
                        upgradeIconType: upgradeIconType,
                        icon: icon,
                        isHovering: isHovering,
                        // Icon color should match text
                        color: "currentColor"
                    })
                }),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1o9zidpf _kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gVM6m.default), {
            ...rest,
            ref: ref,
            xcss: [
                $06ffcb35a0a21e28$var$buttonStyles,
                status === 'default' && $06ffcb35a0a21e28$var$brandStyles,
                status === 'warning' && $06ffcb35a0a21e28$var$warningStyles,
                status === 'danger' && $06ffcb35a0a21e28$var$dangerStyles
            ],
            onMouseEnter: (event)=>handleOnMouseEnter(event),
            onMouseLeave: (event)=>handleOnMouseLeave(event),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    xcss: $06ffcb35a0a21e28$var$iconStyles,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($06ffcb35a0a21e28$var$ButtonIcon, {
                        status: status,
                        upgradeIconType: upgradeIconType,
                        icon: icon,
                        isHovering: isHovering
                    })
                }),
                children
            ]
        })
    });
});
const $06ffcb35a0a21e28$export$57c5e4c8900420b5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, status: status, upgradeIconType: upgradeIconType, href: href, icon: icon, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ...rest }, ref)=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const handleOnMouseEnter = (0, $5uXOq.useCallback)((event)=>{
        setIsHovering(true);
        onMouseEnter && onMouseEnter(event);
    }, [
        onMouseEnter,
        setIsHovering
    ]);
    const handleOnMouseLeave = (0, $5uXOq.useCallback)((event)=>{
        setIsHovering(false);
        onMouseLeave && onMouseLeave(event);
    }, [
        onMouseLeave,
        setIsHovering
    ]);
    if ((0, $bRH8U.useHasCustomTheme)() && (0, $fHpHg.fg)('platform_design_system_edition_awareness_theming')) /**
     * If the top navigation is using a custom theme then we need to use a theme-aware button.
     *
     * The button will appear as a regular button without the custom, vibrant colors normally
     * applied to the edition awareness button.
     *
     * This is intentional, but could change in the future.
     */ return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1o9zidpf _kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.LinkButton), {
            ...rest,
            ref: ref,
            href: href,
            onMouseEnter: (event)=>handleOnMouseEnter(event),
            onMouseLeave: (event)=>handleOnMouseLeave(event),
            iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    xcss: $06ffcb35a0a21e28$var$iconStyles,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($06ffcb35a0a21e28$var$ButtonIcon, {
                        status: status,
                        upgradeIconType: upgradeIconType,
                        icon: icon,
                        isHovering: isHovering,
                        // Icon color should match text
                        color: "currentColor"
                    })
                }),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1o9zidpf _kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gHU1R.default), {
            ...rest,
            ref: ref,
            href: href,
            xcss: [
                $06ffcb35a0a21e28$var$buttonStyles,
                status === 'default' && $06ffcb35a0a21e28$var$brandStyles,
                status === 'warning' && $06ffcb35a0a21e28$var$warningStyles,
                status === 'danger' && $06ffcb35a0a21e28$var$dangerStyles
            ],
            onMouseEnter: (event)=>handleOnMouseEnter(event),
            onMouseLeave: (event)=>handleOnMouseLeave(event),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    xcss: $06ffcb35a0a21e28$var$iconStyles,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($06ffcb35a0a21e28$var$ButtonIcon, {
                        status: status,
                        upgradeIconType: upgradeIconType,
                        icon: icon,
                        isHovering: isHovering
                    })
                }),
                children
            ]
        })
    });
});

});
parcelRegister("4STn8", function(module, exports) {

$parcel$export(module.exports, "AnimatedGemIcon", () => $7d68cc1958b85756$export$248e18d6a3a8bca0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3YUwr = parcelRequire("3YUwr");

var $eXGNC = parcelRequire("eXGNC");

var $5sRpy = parcelRequire("5sRpy");

var $6VxGE = parcelRequire("6VxGE");

var $jvx0w = parcelRequire("jvx0w");

var $2LsWe = parcelRequire("2LsWe");
const $7d68cc1958b85756$export$248e18d6a3a8bca0 = ({ isHovering: isHovering })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const isReducedMotion = (0, $eXGNC.useIsReducedMotion)();
    const lottieRef = (0, $5uXOq.useRef)(null);
    const [hasPlayedAnimation, setHasPlayedAnimation] = (0, $5uXOq.useState)(false);
    const animationInstance = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (lottieRef.current) animationInstance.current = (0, (/*@__PURE__*/$parcel$interopDefault($3YUwr))).loadAnimation({
            container: lottieRef.current,
            renderer: 'svg',
            autoplay: !isReducedMotion,
            loop: isHovering && !isReducedMotion ? true : false,
            animationData: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($jvx0w))) : (0, (/*@__PURE__*/$parcel$interopDefault($2LsWe)))
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        animationInstance.current?.addEventListener('complete', ()=>{
            setHasPlayedAnimation(true);
        });
        if (hasPlayedAnimation && !isHovering) animationInstance.current?.stop();
        return ()=>{
            if (animationInstance) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                animationInstance?.current?.removeEventListener('complete');
                animationInstance?.current?.destroy();
            }
        };
    }, [
        colorMode,
        isHovering,
        hasPlayedAnimation,
        isReducedMotion
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        ref: lottieRef
    });
};

});
parcelRegister("jvx0w", function(module, exports) {
module.exports = JSON.parse('{"v":"5.12.1","fr":60,"ip":0,"op":300,"w":16,"h":16,"nm":"Gem Icon - 16x16","ddd":0,"assets":[{"id":"comp_0","nm":"Diamond No translucent","fr":60,"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"\u25BD Diamond","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[399.875,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[271.875,234.375,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":240,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Diamind internal lines","refId":"comp_1","sr":1.75,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[400,400,0],"ix":2,"l":2},"a":{"a":0,"k":[400,400,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"w":800,"h":800,"ip":0,"op":840,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Glyph - base","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[271.875,234.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-271.875,-84.375],[-178.125,-234.375],[178.125,-234.375],[271.875,-84.375],[0,234.375]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":52,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Glyph - base","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":480,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Glyph - Horizontal","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[268,150.5,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[264.5,0],[-264.5,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":52,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Glyph - Horizontal","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":480,"st":0,"ct":1,"bm":0}]},{"id":"comp_1","nm":"Diamind internal lines","fr":60,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Side Glyph 48","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":450,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":461,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":499,"s":[100],"e":[60]},{"t":510}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":450,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":510}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":454,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":470,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":480,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":492,"s":[52],"e":[14]},{"t":505}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":450,"op":930,"st":450,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Side Glyph 47","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":420,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":431,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":469,"s":[100],"e":[60]},{"t":480}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":420,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":480}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":424,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":440,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":450,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":462,"s":[52],"e":[14]},{"t":475}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":420,"op":900,"st":420,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Side Glyph 46","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":390,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":401,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":439,"s":[100],"e":[60]},{"t":450}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":390,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":450}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":394,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":410,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":420,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":432,"s":[52],"e":[14]},{"t":445}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":390,"op":870,"st":390,"ct":1,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Side Glyph 45","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":360,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":371,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":409,"s":[100],"e":[60]},{"t":420}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":360,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":420}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":364,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":380,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":390,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":402,"s":[52],"e":[14]},{"t":415}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":360,"op":840,"st":360,"ct":1,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Side Glyph 44","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":330,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":341,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":379,"s":[100],"e":[60]},{"t":390}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":330,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":390}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":334,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":350,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":360,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":372,"s":[52],"e":[14]},{"t":385}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":330,"op":810,"st":330,"ct":1,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Side Glyph 43","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":300,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":311,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":349,"s":[100],"e":[60]},{"t":360}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":300,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":360}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":304,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":320,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":330,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":342,"s":[52],"e":[14]},{"t":355}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":300,"op":780,"st":300,"ct":1,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Side Glyph 42","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":270,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":281,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":319,"s":[100],"e":[60]},{"t":330}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":270,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":330}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":274,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":290,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":300,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":312,"s":[52],"e":[14]},{"t":325}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":270,"op":750,"st":270,"ct":1,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Side Glyph 41","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":240,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":251,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":289,"s":[100],"e":[60]},{"t":300}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":300}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":244,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":260,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":270,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":282,"s":[52],"e":[14]},{"t":295}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":240,"op":720,"st":240,"ct":1,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Side Glyph 40","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":210,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":221,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":259,"s":[100],"e":[60]},{"t":270}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":210,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":270}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":214,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":230,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":240,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":252,"s":[52],"e":[14]},{"t":265}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":210,"op":690,"st":210,"ct":1,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Side Glyph 39","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":180,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":191,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":229,"s":[100],"e":[60]},{"t":240}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":240}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":184,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":200,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":210,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":222,"s":[52],"e":[14]},{"t":235}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":180,"op":660,"st":180,"ct":1,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Side Glyph 38","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":150,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":161,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":199,"s":[100],"e":[60]},{"t":210}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":150,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":210}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":154,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":170,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":180,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":192,"s":[52],"e":[14]},{"t":205}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":150,"op":630,"st":150,"ct":1,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Side Glyph 37","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":120,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":131,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":169,"s":[100],"e":[60]},{"t":180}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":180}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":124,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":140,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":150,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":162,"s":[52],"e":[14]},{"t":175}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":120,"op":600,"st":120,"ct":1,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Side Glyph 36","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":90,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":101,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":139,"s":[100],"e":[60]},{"t":150}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":90,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":150}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":94,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":110,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":120,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":132,"s":[52],"e":[14]},{"t":145}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":90,"op":570,"st":90,"ct":1,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Side Glyph 35","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":60,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":71,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":109,"s":[100],"e":[60]},{"t":120}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":120}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":64,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":80,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":90,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":102,"s":[52],"e":[14]},{"t":115}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":60,"op":540,"st":60,"ct":1,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Side Glyph 34","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":79,"s":[100],"e":[60]},{"t":90}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":90}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":34,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":50,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":60,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":72,"s":[52],"e":[14]},{"t":85}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":30,"op":510,"st":30,"ct":1,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Side Glyph 49","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":11,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":49,"s":[100],"e":[60]},{"t":60}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":60}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":4,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":20,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[52],"e":[14]},{"t":55}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":480,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Side Glyph 18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-30,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-19,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":19,"s":[100],"e":[60]},{"t":30}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":-30,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":30}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-26,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-10,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":12,"s":[52],"e":[14]},{"t":25}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":-30,"op":450,"st":-30,"ct":1,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[8,8,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[2.7,2.7,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Diamond No translucent","parent":1,"refId":"comp_0","sr":1.14503816793893,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,0,0],"ix":2,"l":2},"a":{"a":0,"k":[400,400,0],"ix":1,"l":2},"s":{"a":0,"k":[100.5,101,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":20,"nm":"Tint","np":6,"mn":"ADBE Tint","ix":1,"en":1,"ef":[{"ty":2,"nm":"Map Black To","mn":"ADBE Tint-0001","ix":1,"v":{"a":0,"k":[0.560784339905,0.494117647409,0.905882358551,1],"ix":1}},{"ty":2,"nm":"Map White To","mn":"ADBE Tint-0002","ix":2,"v":{"a":0,"k":[0.560784339905,0.494117647409,0.905882358551,1],"ix":2}},{"ty":0,"nm":"Amount to Tint","mn":"ADBE Tint-0003","ix":3,"v":{"a":0,"k":100,"ix":3}},{"ty":6,"nm":"","mn":"ADBE Tint-0004","ix":4,"v":0}]}],"w":800,"h":800,"ip":0,"op":300,"st":-90.4580152671756,"bm":0}],"markers":[{"tm":16,"cm":"gem starts here ","dr":0},{"tm":75,"cm":"Ends here\\r","dr":0}],"props":{}}');

});

parcelRegister("2LsWe", function(module, exports) {
module.exports = JSON.parse('{"v":"5.12.1","fr":60,"ip":0,"op":300,"w":16,"h":16,"nm":"Gem Icon - 16x16","ddd":0,"assets":[{"id":"comp_0","nm":"Diamond No translucent","fr":60,"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"\u25BD Diamond","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[399.875,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[271.875,234.375,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":240,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Diamind internal lines","refId":"comp_1","sr":1.75,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[400,400,0],"ix":2,"l":2},"a":{"a":0,"k":[400,400,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"w":800,"h":800,"ip":0,"op":840,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Glyph - base","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[271.875,234.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-271.875,-84.375],[-178.125,-234.375],[178.125,-234.375],[271.875,-84.375],[0,234.375]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":52,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Glyph - base","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":480,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Glyph - Horizontal","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[268,150.5,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[264.5,0],[-264.5,0]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":52,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Glyph - Horizontal","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":480,"st":0,"ct":1,"bm":0}]},{"id":"comp_1","nm":"Diamind internal lines","fr":60,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Side Glyph 48","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":450,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":461,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":499,"s":[100],"e":[60]},{"t":510}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":450,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":510}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":454,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":470,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":480,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":492,"s":[52],"e":[14]},{"t":505}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":450,"op":930,"st":450,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Side Glyph 47","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":420,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":431,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":469,"s":[100],"e":[60]},{"t":480}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":420,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":480}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":424,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":440,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":450,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":462,"s":[52],"e":[14]},{"t":475}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":420,"op":900,"st":420,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Side Glyph 46","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":390,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":401,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":439,"s":[100],"e":[60]},{"t":450}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":390,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":450}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":394,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":410,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":420,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":432,"s":[52],"e":[14]},{"t":445}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":390,"op":870,"st":390,"ct":1,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Side Glyph 45","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":360,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":371,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":409,"s":[100],"e":[60]},{"t":420}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":360,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":420}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":364,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":380,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":390,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":402,"s":[52],"e":[14]},{"t":415}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":360,"op":840,"st":360,"ct":1,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Side Glyph 44","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":330,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":341,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":379,"s":[100],"e":[60]},{"t":390}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":330,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":390}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":334,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":350,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":360,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":372,"s":[52],"e":[14]},{"t":385}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":330,"op":810,"st":330,"ct":1,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Side Glyph 43","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":300,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":311,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":349,"s":[100],"e":[60]},{"t":360}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":300,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":360}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":304,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":320,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":330,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":342,"s":[52],"e":[14]},{"t":355}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":300,"op":780,"st":300,"ct":1,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Side Glyph 42","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":270,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":281,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":319,"s":[100],"e":[60]},{"t":330}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":270,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":330}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":274,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":290,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":300,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":312,"s":[52],"e":[14]},{"t":325}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":270,"op":750,"st":270,"ct":1,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Side Glyph 41","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":240,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":251,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":289,"s":[100],"e":[60]},{"t":300}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":300}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":244,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":260,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":270,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":282,"s":[52],"e":[14]},{"t":295}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":240,"op":720,"st":240,"ct":1,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Side Glyph 40","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":210,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":221,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":259,"s":[100],"e":[60]},{"t":270}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":210,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":270}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":214,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":230,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":240,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":252,"s":[52],"e":[14]},{"t":265}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":210,"op":690,"st":210,"ct":1,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Side Glyph 39","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":180,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":191,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":229,"s":[100],"e":[60]},{"t":240}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":240}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":184,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":200,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":210,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":222,"s":[52],"e":[14]},{"t":235}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":180,"op":660,"st":180,"ct":1,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Side Glyph 38","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":150,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":161,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":199,"s":[100],"e":[60]},{"t":210}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":150,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":210}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":154,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":170,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":180,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":192,"s":[52],"e":[14]},{"t":205}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":150,"op":630,"st":150,"ct":1,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Side Glyph 37","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":120,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":131,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":169,"s":[100],"e":[60]},{"t":180}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":180}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":124,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":140,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":150,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":162,"s":[52],"e":[14]},{"t":175}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":120,"op":600,"st":120,"ct":1,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Side Glyph 36","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":90,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":101,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":139,"s":[100],"e":[60]},{"t":150}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":90,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":150}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":94,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":110,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":120,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":132,"s":[52],"e":[14]},{"t":145}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":90,"op":570,"st":90,"ct":1,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Side Glyph 35","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":60,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":71,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":109,"s":[100],"e":[60]},{"t":120}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":120}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":64,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":80,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":90,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":102,"s":[52],"e":[14]},{"t":115}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":60,"op":540,"st":60,"ct":1,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Side Glyph 34","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":79,"s":[100],"e":[60]},{"t":90}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":90}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":34,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":50,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":60,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":72,"s":[52],"e":[14]},{"t":85}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":30,"op":510,"st":30,"ct":1,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Side Glyph 49","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":11,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":49,"s":[100],"e":[60]},{"t":60}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":60}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":4,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":20,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[52],"e":[14]},{"t":55}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":480,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Side Glyph 18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-30,"s":[60],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-19,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":19,"s":[100],"e":[60]},{"t":30}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263.938,400.375,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":-30,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.937,234.375],[-134.938,-84.375],[-42.438,-234.375]],"c":false}],"e":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[135.938,234.375],[407.062,-84.375],[313.562,-234.375]],"c":false}]},{"t":30}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-26,"s":[14],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":-10,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[52],"e":[52]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":12,"s":[52],"e":[14]},{"t":25}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Side Glyph","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":-30,"op":450,"st":-30,"ct":1,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[8,8,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[2.7,2.7,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Diamond No translucent","parent":1,"refId":"comp_0","sr":1.14503816793893,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,0,0],"ix":2,"l":2},"a":{"a":0,"k":[400,400,0],"ix":1,"l":2},"s":{"a":0,"k":[100.5,101,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":20,"nm":"Tint","np":6,"mn":"ADBE Tint","ix":1,"en":1,"ef":[{"ty":2,"nm":"Map Black To","mn":"ADBE Tint-0001","ix":1,"v":{"a":0,"k":[0.509803950787,0.439215689898,0.858823537827,1],"ix":1}},{"ty":2,"nm":"Map White To","mn":"ADBE Tint-0002","ix":2,"v":{"a":0,"k":[0.509803950787,0.439215689898,0.858823537827,1],"ix":2}},{"ty":0,"nm":"Amount to Tint","mn":"ADBE Tint-0003","ix":3,"v":{"a":0,"k":100,"ix":3}},{"ty":6,"nm":"","mn":"ADBE Tint-0004","ix":4,"v":0}]}],"w":800,"h":800,"ip":0,"op":300,"st":-90.4580152671756,"bm":0}],"markers":[{"tm":16,"cm":"gem starts here ","dr":0},{"tm":75,"cm":"Ends here\\r","dr":0}],"props":{}}');

});


parcelRegister("9N2Ha", function(module, exports) {

$parcel$export(module.exports, "SparkleIcon", () => $2ed495b1b5b18655$export$1019ff5537a7252e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $2ed495b1b5b18655$var$SparkleGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                id: "starMain",
                fillRule: "evenodd",
                d: "m5.184 1.921-1.28 3.244L.664 6.443a.52.52 0 0 0 0 .966l3.242 1.279 1.279 3.242a.52.52 0 0 0 .967 0l1.278-3.242 3.242-1.28a.52.52 0 0 0 0-.966L7.43 5.165 6.15 1.92a.517.517 0 0 0-.69-.285.519.519 0 0 0-.276.285Z",
                clipRule: "evenodd",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                id: "starBottomRight",
                fillRule: "evenodd",
                d: "m10.246 9.237-.496 1.255-1.255.496a.37.37 0 0 0-.205.494c.04.09.113.162.205.198l1.255.495.496 1.256a.373.373 0 0 0 .692 0l.496-1.256 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496-.496-1.255a.369.369 0 0 0-.494-.205.373.373 0 0 0-.198.205Z",
                clipRule: "evenodd",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                id: "starTopRight",
                fillRule: "evenodd",
                d: "m10.715.568-.495 1.257-1.256.496a.373.373 0 0 0 0 .692l1.256.495.495 1.257a.372.372 0 0 0 .692 0l.497-1.257 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496L11.407.57a.367.367 0 0 0-.209-.21.375.375 0 0 0-.483.209Z",
                clipRule: "evenodd",
                fill: "currentColor"
            })
        ]
    });
const $2ed495b1b5b18655$export$1019ff5537a7252e = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        glyph: $2ed495b1b5b18655$var$SparkleGlyph,
        ...props
    });

});


parcelRegister("eRJ8t", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $bf6fdcc0bd026839$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $bf6fdcc0bd026839$export$496e4f58036bb94d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $bf6fdcc0bd026839$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("650XM")));

const $bf6fdcc0bd026839$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("66X7a")).then((module)=>({
            default: module.ModalTransition
        })));
const $bf6fdcc0bd026839$export$be58429061ae5194 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $bf6fdcc0bd026839$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $5uXOq.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $5uXOq.useCallback)((trigger)=>{
        if (!invitePeopleState.isOpen) return;
        invitePeopleState.onClose?.(trigger);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $5uXOq.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($bf6fdcc0bd026839$export$be58429061ae5194.Provider, {
        value: context,
        children: [
            children,
            invitePeopleState.isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($bf6fdcc0bd026839$var$AKModalTransition, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($bf6fdcc0bd026839$var$AKInvitePeopleModal, {
                        onCloseHandler: closeModal,
                        experimental_onReopenHandler: reopenModal,
                        ...invitePeopleState.props
                    })
                })
            })
        ]
    });
};

});
parcelRegister("650XM", function(module, exports) {

let $0124736f6c760c2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0124736f6c760c2f$var$load("h2MrD"),
    $0124736f6c760c2f$var$load("bYT2S"),
    $0124736f6c760c2f$var$load("hPzOn"),
    $0124736f6c760c2f$var$load("7sqeF")
]).then(()=>parcelRequire('k1GKH'));

});

parcelRegister("66X7a", function(module, exports) {

let $47312884c3adec21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47312884c3adec21$var$load("8Gk0T").then(()=>parcelRequire('kULmh'));

});


parcelRegister("luvXZ", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $dad8f4fb85829961$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");
const $dad8f4fb85829961$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("26yQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f986f198b35102$export$2e2bcd8739ae039);
const $30f986f198b35102$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $30f986f198b35102$export$2e2bcd8739ae039 = $30f986f198b35102$var$convertToError;

});

parcelRegister("e35GK", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $1f5d1c831717fc17$export$81b70111112841a0);
const $1f5d1c831717fc17$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("2wNBQ", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $e21c0e48b85ac35f$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $e21c0e48b85ac35f$export$d53d07b6034c4560);
class $e21c0e48b85ac35f$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($e21c0e48b85ac35f$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($e21c0e48b85ac35f$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $e21c0e48b85ac35f$export$4ab84f6f04f6566d = new $e21c0e48b85ac35f$var$UFOLogger();
const $e21c0e48b85ac35f$export$b4958caff08a0960 = (...args)=>{
    $e21c0e48b85ac35f$export$4ab84f6f04f6566d.log(...args);
};
const $e21c0e48b85ac35f$export$d53d07b6034c4560 = (...args)=>{
    $e21c0e48b85ac35f$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("88I8J", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $7dc185119b1e6fd5$export$c00d22927c60484a);

var $1P3p8 = parcelRequire("1P3p8");
class $7dc185119b1e6fd5$export$c00d22927c60484a extends (0, $1P3p8.UFOAbstractExperience) {
}

});
parcelRegister("1P3p8", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $9824d3eed3202584$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $aLMb0 = parcelRequire("aLMb0");

var $2wNBQ = parcelRequire("2wNBQ");

var $cKyn4 = parcelRequire("cKyn4");

var $tygmh = parcelRequire("tygmh");

var $3kS24 = parcelRequire("3kS24");

var $XbbCG = parcelRequire("XbbCG");

var $e35GK = parcelRequire("e35GK");

var $imyh4 = parcelRequire("imyh4");

var $2DPlK = parcelRequire("2DPlK");
const $9824d3eed3202584$var$getPageVisibleState = ()=>{
    return !(0, $XbbCG.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $tygmh.PageVisibleState).VISIBLE : (0, $tygmh.PageVisibleState).HIDDEN;
};
const $9824d3eed3202584$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $3kS24.roundPerfNow)();
};
class $9824d3eed3202584$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $e35GK.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $tygmh.PageVisibleState).MIXED;
            (0, $cKyn4.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $9824d3eed3202584$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $2DPlK.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $2wNBQ.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $imyh4.canTransition)(this.state, newState)) {
            (0, $2wNBQ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $e35GK.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $9824d3eed3202584$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $9824d3eed3202584$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $aLMb0.getGlobalEventStream)().push((0, $aLMb0.unsubscribeEvent)((0, $tygmh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $2wNBQ.ufolog)('this.parent', this.parent);
                (0, $aLMb0.getGlobalEventStream)().push((0, $aLMb0.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $2wNBQ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $2wNBQ.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $e35GK.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $9824d3eed3202584$var$getPageVisibleState();
            (0, $cKyn4.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $2wNBQ.ufolog)('subscribed', this.id);
                (0, $aLMb0.getGlobalEventStream)().push((0, $aLMb0.subscribeEvent)((0, $tygmh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $tygmh.FMP_MARK) && name !== (0, $tygmh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $2wNBQ.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $9824d3eed3202584$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $e35GK.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $tygmh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $tygmh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $2wNBQ.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $cKyn4.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $e35GK.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $e35GK.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $e35GK.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $2wNBQ.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $7619d17858293199$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $7619d17858293199$export$2295b861f318254a = '0.1.5';

parcelRegister("aLMb0", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $c9650d6b88372c57$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $c9650d6b88372c57$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $c9650d6b88372c57$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $c9650d6b88372c57$export$7c957416596ca127);

var $2wNBQ = parcelRequire("2wNBQ");

var $tygmh = parcelRequire("tygmh");
const $c9650d6b88372c57$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $c9650d6b88372c57$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $c9650d6b88372c57$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $c9650d6b88372c57$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $2wNBQ.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $c9650d6b88372c57$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $tygmh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $c9650d6b88372c57$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $tygmh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $c9650d6b88372c57$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $tygmh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("tygmh", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $783e3ea93c098a9f$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $783e3ea93c098a9f$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $783e3ea93c098a9f$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $783e3ea93c098a9f$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $783e3ea93c098a9f$export$837e0f79a8056912);
var $783e3ea93c098a9f$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $783e3ea93c098a9f$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $783e3ea93c098a9f$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $783e3ea93c098a9f$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $783e3ea93c098a9f$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $783e3ea93c098a9f$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $783e3ea93c098a9f$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $783e3ea93c098a9f$export$9f2bf58999404c75 = 'fmp';
const $783e3ea93c098a9f$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("cKyn4", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $2d5c4cc6715bad69$export$13e680397ec8f3eb);

var $XbbCG = parcelRequire("XbbCG");
class $2d5c4cc6715bad69$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $XbbCG.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $2d5c4cc6715bad69$export$13e680397ec8f3eb = new $2d5c4cc6715bad69$var$VisibilityChangeObserver();

});
parcelRegister("XbbCG", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $e250b8eb352b8899$export$15e172712955e18f);
const $e250b8eb352b8899$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("3kS24", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $7d396d4d77bd4c64$export$5f490af6b2b115cf);
const $7d396d4d77bd4c64$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("imyh4", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6e629e7253e8adab$export$178881f329fdb81f);

var $e35GK = parcelRequire("e35GK");
const $6e629e7253e8adab$var$UFOStateAvailableTransitions = {
    [(0, $e35GK.UFOExperienceState).NOT_STARTED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ],
    [(0, $e35GK.UFOExperienceState).STARTED.id]: [
        (0, $e35GK.UFOExperienceState).IN_PROGRESS.id,
        (0, $e35GK.UFOExperienceState).BLOCKED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $e35GK.UFOExperienceState).BLOCKED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).BLOCKED.id]: [
        (0, $e35GK.UFOExperienceState).RECOVERED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).RECOVERED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).SUCCEEDED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ],
    [(0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).FAILED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ],
    [(0, $e35GK.UFOExperienceState).ABORTED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ]
};
const $6e629e7253e8adab$export$178881f329fdb81f = (state1, state2)=>{
    return $6e629e7253e8adab$var$UFOStateAvailableTransitions[state1.id] && $6e629e7253e8adab$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("2DPlK", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $7ec62a983b348252$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $7ec62a983b348252$export$cc26007c03242fff);
var $7ec62a983b348252$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $7ec62a983b348252$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});



parcelRegister("lhDyE", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $408a987fa8b0faab$export$b9ec44715ae5ad99);

var $5uXOq = parcelRequire("5uXOq");

var $eRJ8t = parcelRequire("eRJ8t");
const $408a987fa8b0faab$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $5uXOq.useContext)((0, $eRJ8t.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});

parcelRegister("6zRFe", function(module, exports) {

$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $941c8515656993cd$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $941c8515656993cd$export$26e841bcf1aeb894);
const $941c8515656993cd$export$83179404a61b001a = 'FetchError';
class $941c8515656993cd$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $941c8515656993cd$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $941c8515656993cd$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("g0t3r", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $38a440c969bd53fa$export$1d94629c94e7a17f);
const $38a440c969bd53fa$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $38a440c969bd53fa$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $38a440c969bd53fa$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("1kA5b", function(module, exports) {

$parcel$export(module.exports, "Status", () => $d904efc17732228a$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $d904efc17732228a$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $d904efc17732228a$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "hasLoaded", () => $d904efc17732228a$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $d904efc17732228a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kQmHM = parcelRequire("kQmHM");

var $3TR0I = parcelRequire("3TR0I");

var $88zyW = parcelRequire("88zyW");

var $g0t3r = parcelRequire("g0t3r");

var $fC2gv = parcelRequire("fC2gv");
const $d904efc17732228a$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $d904efc17732228a$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $d904efc17732228a$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $d904efc17732228a$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $d904efc17732228a$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $d904efc17732228a$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $d904efc17732228a$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $d904efc17732228a$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $g0t3r.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $88zyW.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$d904efc17732228a$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $88zyW.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                    actionSubject: $d904efc17732228a$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $kQmHM.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $3TR0I.default)()((0, $fC2gv.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("kQmHM", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $4a32b43cfdd33c8e$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $4a32b43cfdd33c8e$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $4a32b43cfdd33c8e$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $4a32b43cfdd33c8e$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $4a32b43cfdd33c8e$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $4a32b43cfdd33c8e$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $4a32b43cfdd33c8e$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $4a32b43cfdd33c8e$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $4a32b43cfdd33c8e$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $4a32b43cfdd33c8e$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $4a32b43cfdd33c8e$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $4a32b43cfdd33c8e$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", () => $4a32b43cfdd33c8e$export$53f2256589c0fa08);
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", () => $4a32b43cfdd33c8e$export$44c7ac3fdc1d62b8);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $4a32b43cfdd33c8e$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $4a32b43cfdd33c8e$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $4a32b43cfdd33c8e$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $4a32b43cfdd33c8e$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $4a32b43cfdd33c8e$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $4a32b43cfdd33c8e$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $4a32b43cfdd33c8e$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $4a32b43cfdd33c8e$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $4a32b43cfdd33c8e$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getJoinableSitesRenderTracker", () => $4a32b43cfdd33c8e$export$e823e937102b322b);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $4a32b43cfdd33c8e$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $4a32b43cfdd33c8e$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("3TR0I")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("cnhic")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $4e2819b72987a07d$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $4e2819b72987a07d$export$a1562d08625f5d7e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cnhic = parcelRequire("cnhic");

var $9Iej8 = parcelRequire("9Iej8");
var $3TR0I = parcelRequire("3TR0I");


var $1kA5b = parcelRequire("1kA5b");

var $8Rcp7 = parcelRequire("8Rcp7");

var $hdiM7 = parcelRequire("hdiM7");
const $4a32b43cfdd33c8e$export$515664faa1398f37 = 'navigation';
const $4a32b43cfdd33c8e$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $4a32b43cfdd33c8e$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $4a32b43cfdd33c8e$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $4a32b43cfdd33c8e$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $4a32b43cfdd33c8e$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $4a32b43cfdd33c8e$export$2b570fc112cbca = 'atlassianSwitcher';
const $4a32b43cfdd33c8e$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $4a32b43cfdd33c8e$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $4a32b43cfdd33c8e$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $4a32b43cfdd33c8e$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $4a32b43cfdd33c8e$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $4a32b43cfdd33c8e$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $4a32b43cfdd33c8e$export$44c7ac3fdc1d62b8 = 'atlassianSwitcherCurrentOrg';
const $4a32b43cfdd33c8e$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $4a32b43cfdd33c8e$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $4a32b43cfdd33c8e$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $4a32b43cfdd33c8e$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $4a32b43cfdd33c8e$var$RENDERED_ACTION = 'rendered';
const $4a32b43cfdd33c8e$var$NOT_RENDERED_ACTION = 'not_rendered';
const $4a32b43cfdd33c8e$var$VIEWED_ACTION = 'viewed';
const $4a32b43cfdd33c8e$export$884b1a4c7ac9dd14 = (0, $9Iej8.default)($4a32b43cfdd33c8e$export$515664faa1398f37);
const $4a32b43cfdd33c8e$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $4a32b43cfdd33c8e$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $4a32b43cfdd33c8e$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $4a32b43cfdd33c8e$export$e09ad93c2b74b853 = (0, $3TR0I.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
            action: $4a32b43cfdd33c8e$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$4a32b43cfdd33c8e$var$isValidDuration(duration) && {
                    bucket: (0, $hdiM7.getMetricBucket)(duration, (0, $hdiM7.RenderTrackerBuckets))
                }
            }
        }).fire($4a32b43cfdd33c8e$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $4a32b43cfdd33c8e$export$95b1f1a72cad0dcb = (0, $3TR0I.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
            action: $4a32b43cfdd33c8e$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($4a32b43cfdd33c8e$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $4a32b43cfdd33c8e$export$b3fd6624b6a6d057 = (0, $3TR0I.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
            action: $4a32b43cfdd33c8e$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($4a32b43cfdd33c8e$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $4a32b43cfdd33c8e$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $2OMIu.jsx)($4a32b43cfdd33c8e$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($4a32b43cfdd33c8e$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $4a32b43cfdd33c8e$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $2OMIu.jsx)($4a32b43cfdd33c8e$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($4a32b43cfdd33c8e$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $4a32b43cfdd33c8e$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $1kA5b.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $4a32b43cfdd33c8e$var$renderTracker({
        subject: $4a32b43cfdd33c8e$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $4a32b43cfdd33c8e$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $1kA5b.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $8Rcp7.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $4a32b43cfdd33c8e$var$renderTrackerWithReason({
        subject: $4a32b43cfdd33c8e$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $4a32b43cfdd33c8e$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$4a32b43cfdd33c8e$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("8Rcp7", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", () => $2afdf505439bfa67$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $2afdf505439bfa67$export$c460344055e97b1);
var $2afdf505439bfa67$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $2afdf505439bfa67$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("hdiM7", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerBuckets", () => $1193d84067bbd2e7$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $1193d84067bbd2e7$export$b59492d26971ae92);
const $1193d84067bbd2e7$var$INFINITY = '+Inf';
const $1193d84067bbd2e7$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $1193d84067bbd2e7$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $1193d84067bbd2e7$var$INFINITY) : null;
};

});


parcelRegister("88zyW", function(module, exports) {

$parcel$export(module.exports, "errorToReason", () => $7250616fa6fa4098$export$a3e288208721751b);
function $7250616fa6fa4098$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("fC2gv", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $18d0ad7e5ca22502$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $18d0ad7e5ca22502$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $18d0ad7e5ca22502$export$f88dde183f4d31cb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $18d0ad7e5ca22502$var$noop = ()=>{};
const $18d0ad7e5ca22502$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    start: $18d0ad7e5ca22502$var$noop,
    success: $18d0ad7e5ca22502$var$noop,
    failure: $18d0ad7e5ca22502$var$noop,
    failureAll: $18d0ad7e5ca22502$var$noop,
    abort: $18d0ad7e5ca22502$var$noop,
    abortAll: $18d0ad7e5ca22502$var$noop,
    markStart: $18d0ad7e5ca22502$var$noop,
    markEnd: $18d0ad7e5ca22502$var$noop
});
const $18d0ad7e5ca22502$export$cdefb2a8b53f879f = ()=>(0, $5uXOq.useContext)($18d0ad7e5ca22502$export$3f3eebb4b8116461);
const $18d0ad7e5ca22502$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $18d0ad7e5ca22502$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("9CftH", function(module, exports) {

$parcel$export(module.exports, "Permissions", () => $5fc108437b7acc23$export$2d41982586bbb6be);
$parcel$export(module.exports, "Product", () => $5fc108437b7acc23$export$264ad599d7cef668);
$parcel$export(module.exports, "Feature", () => $5fc108437b7acc23$export$6e91cf7616333d5);
$parcel$export(module.exports, "AnalyticsItemType", () => $5fc108437b7acc23$export$77f267162e8983fb);
$parcel$export(module.exports, "ProductKey", () => $5fc108437b7acc23$export$f3a53bd43617a593);
var $5fc108437b7acc23$export$2d41982586bbb6be = /*#__PURE__*/ function(Permissions) {
    Permissions["MANAGE"] = "manage";
    Permissions["CAN_INVITE_USERS"] = "invite-users";
    return Permissions;
}({});
var $5fc108437b7acc23$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["BITBUCKET"] = "bitbucket";
    Product["CONFLUENCE"] = "confluence";
    Product["HOME"] = "home";
    Product["JIRA"] = "jira";
    Product["SITE_ADMIN"] = "site-admin";
    Product["TRELLO"] = "trello";
    Product["START"] = "start";
    return Product;
}({});
var $5fc108437b7acc23$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["isUFOEnabled"] = "isUFOEnabled";
    return Feature;
}({});
var $5fc108437b7acc23$export$77f267162e8983fb = /*#__PURE__*/ function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    return AnalyticsItemType;
}({});
var $5fc108437b7acc23$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    return ProductKey;
}({});

});

parcelRegister("gw6fx", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $5947de93adef96c4$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $5947de93adef96c4$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $5947de93adef96c4$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $5947de93adef96c4$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $5947de93adef96c4$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $5947de93adef96c4$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $5947de93adef96c4$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $5947de93adef96c4$export$86919b84f9a64054);

var $lrUJ4 = parcelRequire("lrUJ4");

var $VZtev = parcelRequire("VZtev");
var $5947de93adef96c4$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_JOIN_SECTION"] = "render-join-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    return Experience;
}({});
const $5947de93adef96c4$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-join-section"]: {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $5947de93adef96c4$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $5947de93adef96c4$var$allNonTestExperienceMarks = Object.values($5947de93adef96c4$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $5947de93adef96c4$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $5947de93adef96c4$var$allNonTestExperienceMarks,
    ["render-join-section"]: $5947de93adef96c4$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $5947de93adef96c4$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $5947de93adef96c4$var$allNonTestExperienceMarks
};
const $5947de93adef96c4$export$805ed806e0769ee4 = (0, $VZtev.invertRecordOfArrays)($5947de93adef96c4$export$755e75afbd377bc4);
var $5947de93adef96c4$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $5947de93adef96c4$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $5947de93adef96c4$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("VZtev", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", () => $fa8673911dc7ff74$export$c371a74fe5222b3);
function $fa8673911dc7ff74$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("6hROb", function(module, exports) {

$parcel$export(module.exports, "default", () => $baaaadcd7ade24b1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $iZAGE = parcelRequire("iZAGE");

var $jj6Nk = parcelRequire("jj6Nk");

var $gw6fx = parcelRequire("gw6fx");
var $gwJdP = parcelRequire("gwJdP");

var $koVbs = parcelRequire("koVbs");

var $7BsTG = parcelRequire("7BsTG");
const $baaaadcd7ade24b1$var$iconSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    width: 32,
    height: 32,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-skeleton, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
    borderRadius: "var(--ds-border-radius-200, 8px)"
});
const $baaaadcd7ade24b1$var$lineSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    width: 98,
    height: 10,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-skeleton, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
    borderRadius: "var(--ds-border-radius, 3px)"
});
const $baaaadcd7ade24b1$var$iconSkeleton = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
    css: $baaaadcd7ade24b1$var$iconSkeletonStyles
});
const $baaaadcd7ade24b1$var$lineSkeleton = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
    css: $baaaadcd7ade24b1$var$lineSkeletonStyles
});
var $baaaadcd7ade24b1$export$2e2bcd8739ae039 = ()=>{
    (0, $gwJdP.useExperienceRenderAndMountMark)((0, $gw6fx.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iZAGE.SectionContainer), {
        sectionId: "skeleton",
        title: $baaaadcd7ade24b1$var$lineSkeleton,
        sectionRole: "alert",
        "aria-label": formatMessage((0, $7BsTG.default).skeletonLoaderAriaLabel)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jj6Nk.default), {
        tag: "li",
        icon: $baaaadcd7ade24b1$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $baaaadcd7ade24b1$var$lineSkeleton), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jj6Nk.default), {
        tag: "li",
        icon: $baaaadcd7ade24b1$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $baaaadcd7ade24b1$var$lineSkeleton), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jj6Nk.default), {
        tag: "li",
        icon: $baaaadcd7ade24b1$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $baaaadcd7ade24b1$var$lineSkeleton));
};

});
parcelRegister("iZAGE", function(module, exports) {

$parcel$export(module.exports, "SectionContainer", () => $650da9195467996e$export$be4c8679ebfd988);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable */ 
var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $6P0Kj = parcelRequire("6P0Kj");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kQmHM = parcelRequire("kQmHM");
var $cnhic = parcelRequire("cnhic");

var $c9xxi = parcelRequire("c9xxi");

var $2zJy4 = parcelRequire("2zJy4");

var $9CftH = parcelRequire("9CftH");

var $bWfiu = parcelRequire("bWfiu");

var $Hu79Z = parcelRequire("Hu79Z");
function $650da9195467996e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $650da9195467996e$var$baseSectionContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-075, 6px)"} 0`
});
const $650da9195467996e$var$visualRefreshStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    paddingTop: "var(--ds-space-100, 8px)",
    overflow: 'hidden',
    marginTop: '-1px',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $650da9195467996e$var$boxStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    marginTop: '0',
    marginBottom: 'space.100'
});
const $650da9195467996e$var$secondarySectionTitleBaseStyles = (0, $2s57o.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    marginTop: 'space.200',
    marginLeft: 'space.100',
    color: 'color.text.subtle',
    font: 'font.body.small',
    fontWeight: 'font.weight.bold',
    marginBottom: 'space.050'
});
const $650da9195467996e$var$refreshedSecondarySectionTitleBaseStyles = (0, $2s57o.xcss)({
    marginTop: 'space.075',
    marginLeft: 'space.100',
    marginBottom: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'color.text.subtlest',
    fontWeight: 'font.weight.medium'
});
const $650da9195467996e$var$sectionChildrenWrapperStyles = {
    name: "1kz5jpr",
    styles: "list-style-type:none;padding:0;margin:0"
};
const $650da9195467996e$export$7bb82566a1f2a4f5 = ({ title: title })=>{
    const isVisualRefreshEnabled = (0, $Hu79Z.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bWfiu.default), {
        as: "h3",
        size: "xxsmall"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
        xcss: isVisualRefreshEnabled ? $650da9195467996e$var$refreshedSecondarySectionTitleBaseStyles : $650da9195467996e$var$secondarySectionTitleBaseStyles
    }, title));
};
const $650da9195467996e$var$SectionContainerComponent = ({ title: title, titleLink: titleLink, children: children, actionSubject: actionSubject, sectionId: sectionId, sectionRole: sectionRole, ariaLabel: ariaLabel })=>{
    const isVisualRefreshEnabled = (0, $Hu79Z.useIsSwitcherTeam25TestCohort)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some(Boolean) ? /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        css: isVisualRefreshEnabled ? $650da9195467996e$var$visualRefreshStyles : $650da9195467996e$var$baseSectionContainerStyles,
        "data-testid": `${sectionId}__section`,
        role: sectionRole,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
        xcss: isVisualRefreshEnabled ? $650da9195467996e$var$boxStyles : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $c9xxi.FadeIn), null, title && /*#__PURE__*/ (0, $f8Sb3.jsx)($650da9195467996e$export$7bb82566a1f2a4f5, {
        title: title
    }), titleLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($650da9195467996e$var$TitleLink, {
        titleLink: titleLink,
        actionSubject: actionSubject
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
        css: $650da9195467996e$var$sectionChildrenWrapperStyles
    }, children))) : null;
};
const $650da9195467996e$var$TitleLink = ({ titleLink: titleLink, actionSubject: actionSubject })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnhic.NavigationAnalyticsContext), {
        key: titleLink.key,
        data: (0, $kQmHM.getItemAnalyticsContext)(0, titleLink.key, (0, $9CftH.AnalyticsItemType).PRODUCT, titleLink.productType)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2zJy4.default), {
        href: titleLink.href,
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        label: titleLink.label,
        testId: "section-title__link",
        actionSubject: actionSubject,
        ariaLabel: titleLink.ariaLabel
    }));
const $650da9195467996e$export$be4c8679ebfd988 = (0, $kQmHM.withAnalyticsContextData)((props)=>(0, $kQmHM.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(props.children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)).length
    }))($650da9195467996e$var$SectionContainerComponent); /* eslint-enable */ 

});
parcelRegister("c9xxi", function(module, exports) {

$parcel$export(module.exports, "FadeIn", () => $4daf0fc590e38f93$export$bd7370ffb2917ab7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

const $4daf0fc590e38f93$var$fadeIn = (0, $f8Sb3.keyframes)({
    to: {
        opacity: 1
    }
});
const $4daf0fc590e38f93$var$fadeInStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    animation: `${$4daf0fc590e38f93$var$fadeIn} 500ms ease forwards`,
    opacity: 0,
    margin: 0,
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`
});
const $4daf0fc590e38f93$export$bd7370ffb2917ab7 = ({ children: children, className: className, tag: Tag = 'div' })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        css: $4daf0fc590e38f93$var$fadeInStyles,
        className: className
    }, children);

});

parcelRegister("2zJy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $861b269a3968cb35$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $6P0Kj = parcelRequire("6P0Kj");

var $3TR0I = parcelRequire("3TR0I");


var $kQmHM = parcelRequire("kQmHM");

var $ousew = parcelRequire("ousew");
const $861b269a3968cb35$var$ItemLink = ({ label: label, href: href, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
    const buttonProps = {
        appearance: 'link',
        href: href,
        className: 'section-link',
        target: '_blank',
        rel: 'noopener noreferrer',
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        onClick: onClick ? (e, a)=>onClick(e, a) : undefined,
        testId: testId
    };
    if (ariaLabel) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...ariaLabel,
        children: (placeholder)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                ...buttonProps,
                "aria-label": String(placeholder),
                children: label
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        ...buttonProps,
        children: label
    });
};
var $861b269a3968cb35$export$2e2bcd8739ae039 = (0, $3TR0I.default)({
    onClick: (0, $kQmHM.createAndFireNavigationEvent)({
        eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: (0, $kQmHM.SWITCHER_ITEM_SUBJECT)
    })
})($861b269a3968cb35$var$ItemLink);

});

parcelRegister("Hu79Z", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperimentProvider", () => $ba4ec914157aadc1$export$cd11e4cf103a20cf);
$parcel$export(module.exports, "useSwitcherTeam25Experiment", () => $ba4ec914157aadc1$export$f0a8b7930250858a);
$parcel$export(module.exports, "useIsSwitcherTeam25TestCohort", () => $ba4ec914157aadc1$export$3b522177296bf82b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
// Temporary fix to enable the Growth team’s app recommendation section to access our experiment.
// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-350
const $ba4ec914157aadc1$var$storageKey = '@atlassian/switcher-team-25-experiment-cohort';
const $ba4ec914157aadc1$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $ba4ec914157aadc1$export$cd11e4cf103a20cf = ({ children: children })=>{
    const [switcherTeam25ExperimentCohort, setSwitcherTeam25ExperimentCohort] = (0, $5uXOq.useState)();
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort,
            setSwitcherTeam25ExperimentCohort: setSwitcherTeam25ExperimentCohort
        }), [
        switcherTeam25ExperimentCohort,
        setSwitcherTeam25ExperimentCohort
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (window?.sessionStorage && switcherTeam25ExperimentCohort) window.sessionStorage.setItem($ba4ec914157aadc1$var$storageKey, switcherTeam25ExperimentCohort);
    }, [
        switcherTeam25ExperimentCohort
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ba4ec914157aadc1$export$fcdf652c4fd8e4c7.Provider, {
        value: contextValue,
        children: children
    });
};
const $ba4ec914157aadc1$export$3135e38521020087 = ()=>(0, $5uXOq.useContext)($ba4ec914157aadc1$export$fcdf652c4fd8e4c7);
const $ba4ec914157aadc1$export$f0a8b7930250858a = ()=>{
    const experimentContext = $ba4ec914157aadc1$export$3135e38521020087();
    return {
        cohort: experimentContext?.switcherTeam25ExperimentCohort,
        setCohort: experimentContext ? experimentContext.setSwitcherTeam25ExperimentCohort : ()=>{}
    };
};
const $ba4ec914157aadc1$export$3b522177296bf82b = ()=>{
    const { cohort: cohort } = $ba4ec914157aadc1$export$f0a8b7930250858a();
    if (cohort) return cohort === 'test';
    // fallback to session storage
    return window?.sessionStorage?.getItem($ba4ec914157aadc1$var$storageKey) === 'test';
};

});


parcelRegister("jj6Nk", function(module, exports) {

$parcel$export(module.exports, "LozengeType", () => $54b585f615033641$export$b95b532653e2b7f6);
$parcel$export(module.exports, "default", () => $54b585f615033641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $5uXOq = parcelRequire("5uXOq");

var $44qT7 = parcelRequire("44qT7");

var $kQmHM = parcelRequire("kQmHM");

var $c9xxi = parcelRequire("c9xxi");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eOat1 = parcelRequire("eOat1");

var $ousew = parcelRequire("ousew");

var $7BsTG = parcelRequire("7BsTG");

var $dbU1B = parcelRequire("dbU1B");

var $Hu79Z = parcelRequire("Hu79Z");
function $54b585f615033641$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $54b585f615033641$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["Try"] = "try";
    return LozengeType;
}({});
const $54b585f615033641$var$lozengeData = {
    ["new"]: {
        label: (0, $7BsTG.default).newLozenge,
        componentProps: {
            appearance: 'new'
        }
    },
    ["try"]: {
        label: (0, $7BsTG.default).tryLozenge,
        componentProps: {
            appearance: 'new'
        }
    }
};
const $54b585f615033641$var$fadeInStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
// this marginTop -4px is to avoid the bottom of description text get cut off
const $54b585f615033641$var$itemDescriptionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    marginTop: `${"var(--ds-space-negative-050, -4px)"}`,
    display: 'block'
});
const $54b585f615033641$var$refreshedItemDescriptionStyles = {
    name: "2t38zb",
    styles: "display:block;margin-right:var(--ds-space-400, 32px);overflow:hidden;text-overflow:ellipsis"
};
const $54b585f615033641$var$refreshTitleWrapper = {
    name: "4zleql",
    styles: "display:block"
};
const $54b585f615033641$var$refreshHasDescriptionStyles = {
    name: "mmzgof",
    styles: "margin-top:var(--ds-space-negative-025, -2px)"
};
const $54b585f615033641$var$SwitcherItem = ({ icon: icon, description: description, elemAfter: elemAfter, shouldAllowMultiline: shouldAllowMultiline, onClick: onClick, children: children, lozenges: lozenges, product: product, createAnalyticsEvent: createAnalyticsEvent, tag: tag, href: href, ...rest })=>{
    const isVisualRefreshEnabled = (0, $Hu79Z.useIsSwitcherTeam25TestCohort)();
    const itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(description) || typeof description === 'string') return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: isVisualRefreshEnabled ? $54b585f615033641$var$refreshedItemDescriptionStyles : $54b585f615033641$var$itemDescriptionStyles
        }, description);
        return undefined;
    }, [
        description,
        isVisualRefreshEnabled
    ]);
    const renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!lozenges?.length) return null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dbU1B.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, lozenges.map((lozenge, index)=>{
            const { componentProps: componentProps, label: label } = $54b585f615033641$var$lozengeData[lozenge];
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                key: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    marginLeft: "var(--ds-space-100, 8px)"
                }
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), {
                ...componentProps,
                testId: "switcher-item-lozenge"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), label)));
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kQmHM.RenderTracker), {
            subject: (0, $kQmHM.SWITCHER_ITEM_LOZENGES_SUBJECT),
            data: {
                product: product,
                lozenges: lozenges,
                children: children,
                description: description
            }
        })));
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $c9xxi.FadeIn), {
        css: $54b585f615033641$var$fadeInStyles,
        tag: tag
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $44qT7.default), {
        testId: "switcher-base-item",
        description: itemDescription,
        iconBefore: icon,
        shouldTitleWrap: false,
        shouldDescriptionWrap: false,
        iconAfter: elemAfter,
        target: "_blank",
        href: href ?? '#',
        onClick: (event)=>{
            // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
            if (!href) event.preventDefault();
            if (onClick) onClick(event);
        },
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: isVisualRefreshEnabled ? [
            $54b585f615033641$var$refreshTitleWrapper,
            itemDescription && $54b585f615033641$var$refreshHasDescriptionStyles
        ] : undefined
    }, children, renderLozenges)));
};
var $54b585f615033641$export$2e2bcd8739ae039 = $54b585f615033641$var$SwitcherItem;

});
parcelRegister("7BsTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $577c060d19875e71$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $577c060d19875e71$var$messages = (0, $7VHMR.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primative'
    }
});
var $577c060d19875e71$export$2e2bcd8739ae039 = $577c060d19875e71$var$messages;

});

parcelRegister("dbU1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac1ff0c0e8818f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $bWfiu = parcelRequire("bWfiu");

var $bMFGq = parcelRequire("bMFGq");
var $liZ21 = parcelRequire("liZ21");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $f8Sb3 = parcelRequire("f8Sb3");

var $h4Z6I = parcelRequire("h4Z6I");

var $9h5aM = parcelRequire("9h5aM");

var $kQmHM = parcelRequire("kQmHM");
var $3TR0I = parcelRequire("3TR0I");

var $Oxqi1 = parcelRequire("Oxqi1");

var $88zyW = parcelRequire("88zyW");

var $8OYcu = parcelRequire("8OYcu");

var $9CftH = parcelRequire("9CftH");

var $8xH3o = parcelRequire("8xH3o");

var $6zRFe = parcelRequire("6zRFe");
function $5ac1ff0c0e8818f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5ac1ff0c0e8818f9$var$TRIGGER_SUBJECT = 'errorBoundary';
const $5ac1ff0c0e8818f9$var$ACTION_SUBJECT = 'rendered';
// This image is also used as the generic error message in Notifications
const $5ac1ff0c0e8818f9$var$robotsImgStyles = {
    name: "1nv5fft",
    styles: "height:200px"
};
const $5ac1ff0c0e8818f9$var$trelloErrorImgStyles = {
    name: "8svur3",
    styles: "width:140px;height:88px"
};
const $5ac1ff0c0e8818f9$var$unverifiedUserImageStyles = {
    name: "1vavuhq",
    styles: "height:150px"
};
const $5ac1ff0c0e8818f9$var$errorContentStyles = {
    name: "1m9g2qv",
    styles: "display:flex;align-items:center;justify-content:center;flex-direction:column"
};
const $5ac1ff0c0e8818f9$var$errorHeadingStyles = (0, $2s57o.xcss)({
    maxWidth: '240',
    marginTop: 'space.400'
});
const $5ac1ff0c0e8818f9$var$errorMessageStyles = (0, $2s57o.xcss)({
    maxWidth: '240',
    marginTop: 'space.300'
});
const $5ac1ff0c0e8818f9$var$errorBoundaryBoxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: `${"var(--ds-space-600, 48px)"} 0`
});
const $5ac1ff0c0e8818f9$var$loginButtonStyles = (0, $2s57o.xcss)({
    marginTop: 'space.300',
    justifyContent: 'center',
    alignSelf: 'stretch'
});
const $5ac1ff0c0e8818f9$var$ErrorMessage = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
        xcss: $5ac1ff0c0e8818f9$var$errorMessageStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        as: "p"
    }, props.children));
class $5ac1ff0c0e8818f9$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error) {
        const reason = error instanceof (0, $8xH3o.SwitcherLoadError) ? error.reason() : (0, $88zyW.errorToReason)(error);
        this.setState({
            hasError: true,
            reason: reason
        }, ()=>{
            this.fireOperationalEvent({
                action: $5ac1ff0c0e8818f9$var$ACTION_SUBJECT,
                attributes: {
                    ...reason,
                    ...this.props.extraAnalyticProps
                }
            });
        });
        this.props.onErrorCallback?.(error);
    }
    renderErrorBody() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $6zRFe.FETCH_ERROR_NAME)) {
            const isTrello = this.props.product === (0, $9CftH.Product).TRELLO;
            if (reason.status === 401) // Not authorised http error
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($5ac1ff0c0e8818f9$var$ErrorMessage, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorTextLoggedOut)), isTrello ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
                xcss: $5ac1ff0c0e8818f9$var$loginButtonStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $liZ21.default), {
                href: (0, $Oxqi1.getLoginUrl)((0, $9CftH.Product).TRELLO),
                onClick: this.handleLogin
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).login))) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
                xcss: $5ac1ff0c0e8818f9$var$loginButtonStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bMFGq.default), {
                onClick: this.handleLogin
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).login))));
            if (reason.status === 403) return /*#__PURE__*/ (0, $f8Sb3.jsx)($5ac1ff0c0e8818f9$var$ErrorMessage, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorTextUnverified));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)($5ac1ff0c0e8818f9$var$ErrorMessage, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorTextNetwork));
        }
        // Default error message
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($5ac1ff0c0e8818f9$var$ErrorMessage, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorText));
    }
    renderErrorHeading() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $6zRFe.FETCH_ERROR_NAME) && reason.status === 401) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorHeadingLoggedOut);
        if (reason.name === (0, $6zRFe.FETCH_ERROR_NAME) && reason.status === 403) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorHeadingUnverified);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $8OYcu.default).errorHeading);
    }
    renderErrorImage() {
        const { intl: intl, product: product } = this.props;
        const { reason: reason } = this.state;
        if (product === (0, $9CftH.Product).TRELLO) return /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
            css: $5ac1ff0c0e8818f9$var$trelloErrorImgStyles,
            src: (0, $h4Z6I.default),
            alt: intl.formatMessage((0, $8OYcu.default).errorImageAltText)
        });
        if (reason.status === 403) return /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
            css: $5ac1ff0c0e8818f9$var$unverifiedUserImageStyles,
            src: (0, $9h5aM.default),
            alt: intl.formatMessage((0, $8OYcu.default).errorImageAltText)
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($5ac1ff0c0e8818f9$var$RobotImage, {
            css: $5ac1ff0c0e8818f9$var$robotsImgStyles,
            alt: intl.formatMessage((0, $8OYcu.default).errorImageAltText)
        });
    }
    render() {
        const { hideFallbackUI: hideFallbackUI } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && hideFallbackUI) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
        if (hasError) return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $5ac1ff0c0e8818f9$var$errorBoundaryBoxStyles,
            "data-testid": "error-boundary"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $5ac1ff0c0e8818f9$var$errorContentStyles
        }, this.renderErrorImage(), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
            xcss: $5ac1ff0c0e8818f9$var$errorHeadingStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bWfiu.default), {
            size: "medium"
        }, this.renderErrorHeading())), this.renderErrorBody()));
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        }, this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                actionSubject: this.props.triggerSubject || $5ac1ff0c0e8818f9$var$TRIGGER_SUBJECT,
                ...payload
            }).fire((0, $kQmHM.NAVIGATION_CHANNEL));
        }, this.handleLogin = (_, analyticsEvent)=>{
            analyticsEvent.update({
                eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
                actionSubjectId: 'login'
            }).fire((0, $kQmHM.NAVIGATION_CHANNEL));
            if (this.props.product !== (0, $9CftH.Product).TRELLO) window.location.reload();
        };
    }
}

const $5ac1ff0c0e8818f9$var$RobotImage = (props)=>{
    const [imgSrc, setImgSrc] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        (parcelRequire("lPhw9")).then((src)=>setImgSrc(src.default));
    }, []);
    // eslint-disable-next-line jsx-a11y/alt-text
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        ...props,
        src: imgSrc
    });
};
var $5ac1ff0c0e8818f9$export$2e2bcd8739ae039 = (0, $3TR0I.default)()((0, $8RXs9.default)($5ac1ff0c0e8818f9$var$ErrorBoundary));

});
parcelRegister("h4Z6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aa2b556f70d863f$export$2e2bcd8739ae039);
var $1aa2b556f70d863f$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';

});

parcelRegister("9h5aM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ccd8748913f640$export$2e2bcd8739ae039);
var $c3ccd8748913f640$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;

});

parcelRegister("Oxqi1", function(module, exports) {

$parcel$export(module.exports, "getLoginUrl", () => $da367d993443ca76$export$8abe2e83e8d74da2);

var $9CftH = parcelRequire("9CftH");
var $da367d993443ca76$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
    return Environment;
}({});
const $da367d993443ca76$export$186d9db1ec46a9ca = (origin = window?.location?.origin)=>[
        'https://trello.com'
    ].includes(origin) ? "prod" : "stg";
const $da367d993443ca76$var$getProduct = (product)=>{
    if (product) {
        const lowerJira = (0, $9CftH.Product).JIRA.toLowerCase();
        const lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
const $da367d993443ca76$export$8abe2e83e8d74da2 = (productType, env = $da367d993443ca76$export$186d9db1ec46a9ca(), continueUrl = String(window.location), loginHint)=>{
    const baseUrl = env === "prod" ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
    const product = $da367d993443ca76$var$getProduct(productType);
    return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
};

});

parcelRegister("8OYcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a681d2656531c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c3a681d2656531c9$var$messages = (0, $7VHMR.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    atlassianHome: {
        id: 'fabric.atlassianSwitcher.home',
        defaultMessage: 'Atlassian Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    more: {
        id: 'fabric.atlassianSwitcher.more',
        defaultMessage: 'More',
        description: 'In a context in which users are able to view predefined custom links, this text is the title of the section displaying all existing custom links.'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    jiraProject: {
        id: 'fabric.atlassianSwitcher.jiraProject',
        defaultMessage: 'Jira project',
        description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Jira project'
    },
    confluenceSpace: {
        id: 'fabric.atlassianSwitcher.confluenceSpace',
        defaultMessage: 'Confluence space',
        description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Confluence space'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorTextLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorTextLoggedOut',
        defaultMessage: 'Log in again to use the Atlassian\u00A0switcher.',
        description: 'Text that is displayed when we detect user is logged out.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    login: {
        id: 'fabric.atlassianSwitcher.login',
        defaultMessage: 'Log in',
        description: 'Text in log in button.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    }
});
var $c3a681d2656531c9$export$2e2bcd8739ae039 = $c3a681d2656531c9$var$messages;

});

parcelRegister("8xH3o", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", () => $ce5ff5bf29bd3dd8$export$2c6136f6e27d3fdd);
$parcel$export(module.exports, "SwitcherLoadError", () => $ce5ff5bf29bd3dd8$export$ff0950b3c2e7f03e);

var $88zyW = parcelRequire("88zyW");
var $ce5ff5bf29bd3dd8$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    return SwitcherLoadErrorReason;
}({});
class $ce5ff5bf29bd3dd8$export$ff0950b3c2e7f03e extends Error {
    constructor(errorReason, resultError){
        super();
        this.errorReason = errorReason;
        this.resultError = resultError;
    }
    reason() {
        const potentialResultError = this.resultError;
        return {
            ...(0, $88zyW.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
            source: this.errorReason
        };
    }
}

});

parcelRegister("lPhw9", function(module, exports) {

let $fe3bf30a5b01da97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fe3bf30a5b01da97$var$load("lhghz").then(()=>parcelRequire('2f5vT'));

});



parcelRegister("gwJdP", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $2a9982f5d5bd0802$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $2a9982f5d5bd0802$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $fC2gv = parcelRequire("fC2gv");

var $5uXOq = parcelRequire("5uXOq");

var $5eTki = parcelRequire("5eTki");
function $2a9982f5d5bd0802$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $fC2gv.useExperienceTracker)();
    (0, $5eTki.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $2a9982f5d5bd0802$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $fC2gv.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $2a9982f5d5bd0802$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $fC2gv.useExperienceTracker)();
    (0, $5eTki.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("5eTki", function(module, exports) {

$parcel$export(module.exports, "useSingleton", () => $57a04d04299642e0$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $57a04d04299642e0$export$ad4f8d0eee7a0e24);

var $5uXOq = parcelRequire("5uXOq");
function $57a04d04299642e0$export$abf4268d2dd55708(builder) {
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $57a04d04299642e0$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $5uXOq.useRef)(false);
    const result = (0, $5uXOq.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});



parcelRegister("efDFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9652e716b7d89047$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $6hROb = parcelRequire("6hROb");


var $kQmHM = parcelRequire("kQmHM");

var $bngFq = parcelRequire("bngFq");






























function $9652e716b7d89047$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("hTfc6"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("4iaLi"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("i9jmP"));
        case 'en-GB':
            return (parcelRequire("jZJ4l"));
        case 'en-ZZ':
            return (parcelRequire("lO4Qz"));
        case 'en-US':
        case 'en':
            return (parcelRequire("9rWx7"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("91ct7"));
        case 'et':
            return (parcelRequire("O2xLm"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("2bFA2"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("8rARs"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("a05aG"));
        case 'is':
            return (parcelRequire("475qD"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("3Qo6G"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("ffqxP"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("lEAiF"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("6nLGj"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("bPrzE"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("iOEvM"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("cy7Zz"));
        case 'pt-PT':
            return (parcelRequire("astEm"));
        case 'ro':
            return (parcelRequire("j5F3A"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("acImq"));
        case 'sk':
            return (parcelRequire("ak56d"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("9SA5r"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("RLRO4"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("ckKDe"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("bbZi3"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("cZcIH"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("bSt2q"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("8gR6N"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $9652e716b7d89047$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $9652e716b7d89047$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch (e) {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $kQmHM.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6hROb.default), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: children
    }, locale);
};
var $9652e716b7d89047$export$2e2bcd8739ae039 = $9652e716b7d89047$var$SwitcherIntlProvider;

});
parcelRegister("hTfc6", function(module, exports) {

let $d0635bf8eb1b93f1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0635bf8eb1b93f1$var$load("7nSr8").then(()=>parcelRequire('jRlnW'));

});

parcelRegister("4iaLi", function(module, exports) {

let $320130f09ce62e6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $320130f09ce62e6c$var$load("el5u6").then(()=>parcelRequire('f30GM'));

});

parcelRegister("i9jmP", function(module, exports) {

let $d368172e948bcb1c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d368172e948bcb1c$var$load("jLdsf").then(()=>parcelRequire('7KywX'));

});

parcelRegister("jZJ4l", function(module, exports) {

let $e8e6ac9b289bfbf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8e6ac9b289bfbf2$var$load("glTnL").then(()=>parcelRequire('iwQrR'));

});

parcelRegister("lO4Qz", function(module, exports) {

let $fe020700de09cd42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fe020700de09cd42$var$load("iLpxN").then(()=>parcelRequire('1MAZI'));

});

parcelRegister("9rWx7", function(module, exports) {

let $6e140a254e313821$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e140a254e313821$var$load("iJ2cC").then(()=>parcelRequire('2NgoO'));

});

parcelRegister("91ct7", function(module, exports) {

let $690de10d4a643559$var$load = (parcelRequire("28QjX"))(4);
module.exports = $690de10d4a643559$var$load("jodyd").then(()=>parcelRequire('c5l3s'));

});

parcelRegister("O2xLm", function(module, exports) {

let $0966a4b99a7d499d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0966a4b99a7d499d$var$load("dphw1").then(()=>parcelRequire('1Fjre'));

});

parcelRegister("2bFA2", function(module, exports) {

let $197cdcce43ce316d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $197cdcce43ce316d$var$load("jyh9a").then(()=>parcelRequire('51l2t'));

});

parcelRegister("8rARs", function(module, exports) {

let $625d7038c1ea2867$var$load = (parcelRequire("28QjX"))(4);
module.exports = $625d7038c1ea2867$var$load("dT9B5").then(()=>parcelRequire('12JQK'));

});

parcelRegister("a05aG", function(module, exports) {

let $747dea607c9c9bb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $747dea607c9c9bb6$var$load("kntLI").then(()=>parcelRequire('ggEdX'));

});

parcelRegister("475qD", function(module, exports) {

let $2fec06e68645b64b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2fec06e68645b64b$var$load("jc5z3").then(()=>parcelRequire('cMP1M'));

});

parcelRegister("3Qo6G", function(module, exports) {

let $2cc8ed8d98c5ac91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2cc8ed8d98c5ac91$var$load("dhLpE").then(()=>parcelRequire('6UGK0'));

});

parcelRegister("ffqxP", function(module, exports) {

let $b19cd8eb2298d5d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b19cd8eb2298d5d7$var$load("7Ezj0").then(()=>parcelRequire('eLxo3'));

});

parcelRegister("lEAiF", function(module, exports) {

let $fc397dda422f6976$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc397dda422f6976$var$load("djtex").then(()=>parcelRequire('hkurF'));

});

parcelRegister("6nLGj", function(module, exports) {

let $4a59e09456ac6f35$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a59e09456ac6f35$var$load("fLfdP").then(()=>parcelRequire('3Tedr'));

});

parcelRegister("bPrzE", function(module, exports) {

let $89c9d8bcdf077cb7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89c9d8bcdf077cb7$var$load("aQXnG").then(()=>parcelRequire('eKAEe'));

});

parcelRegister("iOEvM", function(module, exports) {

let $db2c5246bcbdfdd1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db2c5246bcbdfdd1$var$load("ivZxg").then(()=>parcelRequire('49F5G'));

});

parcelRegister("cy7Zz", function(module, exports) {

let $922edc0e3d547133$var$load = (parcelRequire("28QjX"))(4);
module.exports = $922edc0e3d547133$var$load("cJwhv").then(()=>parcelRequire('50Lum'));

});

parcelRegister("astEm", function(module, exports) {

let $79d384c2f4797ed3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79d384c2f4797ed3$var$load("l8SFT").then(()=>parcelRequire('4hFFM'));

});

parcelRegister("j5F3A", function(module, exports) {

let $de5e54f7d7a0ca05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de5e54f7d7a0ca05$var$load("al36l").then(()=>parcelRequire('dJR6t'));

});

parcelRegister("acImq", function(module, exports) {

let $76dd6f7514e8419d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76dd6f7514e8419d$var$load("b4kWy").then(()=>parcelRequire('ej0r2'));

});

parcelRegister("ak56d", function(module, exports) {

let $783fba423e261f5f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $783fba423e261f5f$var$load("b7ymw").then(()=>parcelRequire('TymTo'));

});

parcelRegister("9SA5r", function(module, exports) {

let $7315264c2da2c5e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7315264c2da2c5e8$var$load("1yl9G").then(()=>parcelRequire('eeZaX'));

});

parcelRegister("RLRO4", function(module, exports) {

let $0a1a14b616244372$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a1a14b616244372$var$load("dMcS2").then(()=>parcelRequire('h1We4'));

});

parcelRegister("ckKDe", function(module, exports) {

let $8fab86638b9fb758$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fab86638b9fb758$var$load("eViBA").then(()=>parcelRequire('idMR8'));

});

parcelRegister("bbZi3", function(module, exports) {

let $826043bf53b8acd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $826043bf53b8acd8$var$load("4tlL6").then(()=>parcelRequire('31YLG'));

});

parcelRegister("cZcIH", function(module, exports) {

let $97450c738817c5ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $97450c738817c5ba$var$load("jPQsz").then(()=>parcelRequire('lbp9K'));

});

parcelRegister("bSt2q", function(module, exports) {

let $8a5b433c08937e91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a5b433c08937e91$var$load("9VoR5").then(()=>parcelRequire('4h7K7'));

});

parcelRegister("8gR6N", function(module, exports) {

let $6059039ab9295f46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6059039ab9295f46$var$load("3vpPM").then(()=>parcelRequire('baC4t'));

});


parcelRegister("uYpSO", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $f2c7f68d7c2bc52d$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471f81ad8bbbe4db786095f5e504cb05>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f2c7f68d7c2bc52d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.086 5.226c1.908.56 3.834.56 5.742 0 .169-.037.28.075.244.243-.543 1.958-.543 3.768 0 5.727.037.15-.075.28-.244.224a10.7 10.7 0 0 0-5.742 0c-.15.056-.28-.075-.224-.224.505-1.959.505-3.769 0-5.727-.056-.168.074-.28.224-.243m.767 6.94v.317c0 1.474-1.029 2.556-2.3 2.556a2.28 2.28 0 0 1-2.283-2.295c0-1.268 1.03-2.276 2.47-2.276h.373V6.01c-.187-.019-.374-.019-.56-.019a6.764 6.764 0 0 0-6.772 6.772c0 3.75 3.03 6.753 6.771 6.753s6.79-3.022 6.79-6.753v-.597z"/>
</svg>
`;
const $f2c7f68d7c2bc52d$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm12.828 5.226a10.03 10.03 0 0 1-5.742 0c-.15-.037-.28.075-.224.243.505 1.959.505 3.768 0 5.727-.056.15.074.28.224.224a10.7 10.7 0 0 1 5.742 0c.169.056.28-.075.244-.224-.543-1.959-.543-3.768 0-5.727.037-.168-.075-.28-.244-.243m-4.975 7.257v-.317h4.489v.597c0 3.731-3.049 6.753-6.79 6.753a6.75 6.75 0 0 1-6.77-6.753c0-3.75 3.03-6.772 6.77-6.772.187 0 .374 0 .561.019v4.458h-.374c-1.44 0-2.469 1.008-2.469 2.276a2.28 2.28 0 0 0 2.282 2.295c1.272 0 2.3-1.082 2.3-2.556" clip-rule="evenodd"/>
</svg>
`;
function $f2c7f68d7c2bc52d$export$21bfbeb62fdcce8d({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $f2c7f68d7c2bc52d$var$svg,
        customThemeSvg: $f2c7f68d7c2bc52d$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Jira Product Discovery',
        testId: testId
    });
}

});

parcelRegister("9NAcc", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $89c3d71a57721349$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1cc934d4cd647b12b27329d5fb319ddd>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $89c3d71a57721349$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.7 10.202h4.464c.67 0 .9.638.49 1.145l-6.98 8.615c-2.257-1.798-2.044-4.643-.393-6.719zm-3.449 3.433H5.788c-.67 0-.9-.637-.49-1.144l6.98-8.616c2.256 1.798 2.011 4.61.376 6.703z"/>
</svg>
`;
const $89c3d71a57721349$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm12.164 10.202h-4.463l-2.42 3.041c-1.651 2.076-1.864 4.921.392 6.72l6.981-8.616c.41-.507.18-1.145-.49-1.145M5.788 13.635h4.463l2.403-3.057c1.635-2.093 1.88-4.905-.376-6.703l-6.98 8.616c-.41.507-.18 1.144.49 1.144" clip-rule="evenodd"/>
</svg>
`;
function $89c3d71a57721349$export$3c6158790f5e01c4({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $89c3d71a57721349$var$svg,
        customThemeSvg: $89c3d71a57721349$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Jira Service Management',
        testId: testId
    });
}

});

parcelRegister("5986g", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $4da68fa3d24086d6$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59eaeab4e558289c69d9a17342ec4c57>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4da68fa3d24086d6$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M8.974 15.524H7.62c-2.04 0-3.502-1.25-3.502-3.079h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.524zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.624v7.317c-1.818 0-3.059-1.472-3.059-3.524zm3.614-3.614h-1.353c-2.04 0-3.502-1.25-3.502-3.079h7.271c.377 0 .62.268.62.625v7.317c-1.817 0-3.036-1.472-3.036-3.525z"/>
</svg>
`;
const $4da68fa3d24086d6$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm1.621 15.524h1.353v1.36c0 2.053 1.22 3.525 3.037 3.525v-7.317c0-.379-.244-.647-.62-.647H4.118c0 1.83 1.463 3.079 3.502 3.079m3.592-3.636h1.352v1.36c0 2.053 1.242 3.525 3.06 3.525V9.456c0-.38-.267-.624-.643-.624H7.71c0 1.829 1.463 3.056 3.503 3.056m3.613-3.614h1.353v1.338c0 2.053 1.219 3.525 3.037 3.525V5.82c0-.357-.244-.625-.62-.625h-7.272c0 1.83 1.463 3.079 3.502 3.079" clip-rule="evenodd"/>
</svg>
`;
function $4da68fa3d24086d6$export$c4b5b1f965d8b3eb({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $4da68fa3d24086d6$var$svg,
        customThemeSvg: $4da68fa3d24086d6$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Jira',
        testId: testId
    });
}

});

parcelRegister("f8YQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc6d1fac31a154a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6bc6d1fac31a154a$var$messages = (0, $7VHMR.defineMessages)({
    autoProvisionedSwitcherItemConfluenceDescription: {
        id: 'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription',
        defaultMessage: 'Document collaboration',
        description: 'When a user gets auto-provisioned Confluence, this is the text that will be in the description of the new Switcher Item'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    atlassianStartAriaLabel: {
        id: 'fabric.atlassianSwitcher.startAriaLabel',
        defaultMessage: 'Atlassian Start opens in a new tab',
        description: 'Aria-label for a link redirecting the user to the Start site'
    },
    switchTo: {
        id: 'fabric.atlassianSwitcher.switchTo',
        defaultMessage: 'Switch to',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    switchToTooltip: {
        id: 'fabric.atlassianSwitcher.switchToTooltip',
        defaultMessage: "Switch to\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    yourApps: {
        id: 'fabric.atlassianSwitcher.yourApps',
        defaultMessage: 'Your apps',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    yourAppsTooltip: {
        id: 'fabric.atlassianSwitcher.yourAppsTooltip',
        defaultMessage: "Your apps\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    switchSitesOrAppsTooltip: {
        id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
        defaultMessage: 'Switch sites or apps',
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    jwmInactiveSwitcherWithJSWItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription',
        defaultMessage: 'Manage business projects, free with Jira Software',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated and they have a Jira Software License'
    },
    jwmInactiveSwitcherWithDefaultItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription',
        defaultMessage: 'Manage projects for business teams',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated'
    },
    organisationsLabel: {
        id: 'fabric.atlassianSwitcher.organisationsLabel',
        defaultMessage: 'Organisations',
        description: 'The label of organisation tab list'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    resizeBarLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarLabel',
        defaultMessage: '"Expand" or "Collapse" depending on state',
        description: 'The label of the resize bar'
    },
    resizeBarTooltipCollapsed: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipCollapsed',
        defaultMessage: 'Drag to resize{separator}Press to expand',
        description: 'The label of the resize bar tooltip when in collapsed state'
    },
    resizeBarTooltipExpanded: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipExpanded',
        defaultMessage: 'Drag to resize{separator}Press to collapse',
        description: 'The label of the resize bar tooltip when in expanded state'
    },
    resizeBarValueTextLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarValueTextLabel',
        defaultMessage: 'Width',
        description: 'The value text label of the resize bar'
    },
    joinStatusText: {
        id: 'fabric.atlassianSwitcher.joinStatusText',
        defaultMessage: 'Join',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    instantAccessStatusText: {
        id: 'fabric.atlassianSwitcher.instantAccessStatusText',
        defaultMessage: 'Instant access',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    joinTeamStatusText: {
        id: 'fabric.atlassianSwitcher.joinTeamStatusText',
        defaultMessage: 'Join team',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    jpdDescriptionText: {
        id: 'fabric.atlassianSwitcher.jpdDescriptionText',
        defaultMessage: 'Prioritize and plan new ideas',
        description: 'The description displayed for Jira Product Discovery.'
    },
    confluenceDescriptionText: {
        id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
        defaultMessage: 'Document and collaborate',
        description: 'The description displayed for Confluence.'
    },
    jiraDescriptionText: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    jsmDescriptionText: {
        id: 'fabric.atlassianSwitcher.jsmDescriptionText',
        defaultMessage: 'Automate and deliver IT support',
        description: 'The description displayed for Jira Service Management.'
    },
    requestAccessStatusText: {
        id: 'fabric.atlassianSwitcher.requestAccessStatusText',
        defaultMessage: 'Request access',
        description: 'The text displayed alongside a product to indicate the user can request access for the product.'
    },
    requestSentStatusText: {
        id: 'fabric.atlassianSwitcher.requestSentStatusText',
        defaultMessage: 'Request sent',
        description: 'The text displayed alongside a product to indicate the user has requested access to the product.'
    },
    requestAccessPendingRequestFlagTitle: {
        id: 'fabric.atlassianSwitcher.successFlag.title',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to a product but the request is pending.'
    },
    requestAccessPendingRequestFlagDescription: {
        id: 'fabric.atlassianSwitcher.successFlag.description',
        defaultMessage: "You'll get an email once it's approved",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: 'fabric.atlassianSwitcher.errorFlag.title',
        defaultMessage: `We couldn't add you to {product}`,
        description: 'Title shown when user has requested access to a product but the request has failed.'
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: 'fabric.atlassianSwitcher.errorFlag.description',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description shown when user has requested access to a product but the request is pending'
    }
});
var $6bc6d1fac31a154a$export$2e2bcd8739ae039 = $6bc6d1fac31a154a$var$messages;

});

parcelRegister("980Xe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9f821dfbf0f706$export$2e2bcd8739ae039);

var $l0z7f = parcelRequire("l0z7f");

var $l2pak = parcelRequire("l2pak");
class $5b9f821dfbf0f706$export$2e2bcd8739ae039 {
    constructor(configOrCloudId, stargateUrl){
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    async start(messageId, variationId) {
        if (!(0, $l2pak.isMessagingEnabled)()) return false;
        return (0, $l0z7f.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $l2pak.isMessagingEnabled)()) return false;
        return (0, $l0z7f.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
}

});

parcelRegister("6HV40", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2305dbe349082f$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");

var $4UjQN = parcelRequire("4UjQN");

var $3O10k = parcelRequire("3O10k");

var $fynqv = parcelRequire("fynqv");

var $lKWnb = parcelRequire("lKWnb");

var $4r7nA = parcelRequire("4r7nA");

var $814TT = parcelRequire("814TT");
function $4e2305dbe349082f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e2305dbe349082f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e2305dbe349082f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e2305dbe349082f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4e2305dbe349082f$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $4e2305dbe349082f$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $eHiP8.default)(this, "fallbackArtifactMap", new Map());
        (0, $eHiP8.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $3O10k.default)($4e2305dbe349082f$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $4UjQN.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $fynqv.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $lKWnb.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $814TT.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $4e2305dbe349082f$var$_objectSpread($4e2305dbe349082f$var$_objectSpread({}, artifact), {}, {
                key: (0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $814TT.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("4UjQN", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $ceba31741f00ac93$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("jSHwt")).default);

var $26yQk = parcelRequire("26yQk");

var $l69aS = parcelRequire("l69aS");

var $jSHwt = parcelRequire("jSHwt");
const $ceba31741f00ac93$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $ceba31741f00ac93$var$NO_CALLS_ERROR = 'No calls made';
const $ceba31741f00ac93$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $l69aS.NO_RETRIES), retryOn: retryOn = [
    (0, $jSHwt.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($ceba31741f00ac93$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $ceba31741f00ac93$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $ceba31741f00ac93$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $26yQk.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("l69aS", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $ddeffea3d7a5796f$export$a0a1c8f90becc136);
const $ddeffea3d7a5796f$export$a0a1c8f90becc136 = [];
const $ddeffea3d7a5796f$export$972171517b12aa4 = [
    0,
    0
];
const $ddeffea3d7a5796f$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $ddeffea3d7a5796f$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("jSHwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec9a958cf96d084$export$2e2bcd8739ae039);
class $6ec9a958cf96d084$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("3O10k", function(module, exports) {

$parcel$export(module.exports, "default", () => $8690df2b53013035$export$2e2bcd8739ae039);

var $bfliS = parcelRequire("bfliS");
const $8690df2b53013035$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $8690df2b53013035$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
					 * Commented out removing this item, as it is a slightly different state
					 * to the item not existing that we may want to preserve.
					 *  this.client.removeItem(this.itemKey(key));
					 */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $8690df2b53013035$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $bfliS.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("bfliS", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $5e6bdd5b3875de2d$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $5e6bdd5b3875de2d$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $5e6bdd5b3875de2d$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$5e6bdd5b3875de2d$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("fynqv", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $b52c33ff29e619cd$export$6026918e023c9101);

var $2AtjH = parcelRequire("2AtjH");

var $6l8hg = parcelRequire("6l8hg");

var $3TdLx = parcelRequire("3TdLx");

var $3Oidj = parcelRequire("3Oidj");

var $d5LIN = parcelRequire("d5LIN");

var $95uqQ = parcelRequire("95uqQ");

var $kJG1r = parcelRequire("kJG1r");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $b52c33ff29e619cd$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $b52c33ff29e619cd$var$defaultPerimeter = "commercial";
async function $b52c33ff29e619cd$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b52c33ff29e619cd$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b52c33ff29e619cd$var$defaultPerimeter;
    const environment = $b52c33ff29e619cd$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $2AtjH.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $b52c33ff29e619cd$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $b52c33ff29e619cd$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $b52c33ff29e619cd$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b52c33ff29e619cd$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b52c33ff29e619cd$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $b52c33ff29e619cd$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $95uqQ.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $95uqQ.getVersionMetadataFetchExperience)();
    return new (0, $d5LIN.ConfigClient)(new (0, $3TdLx.BifrostDataSource)(new (0, $3Oidj.BifrostHttpClientImpl)(env, perimeter), (0, $6l8hg.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $b52c33ff29e619cd$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("2AtjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ecf3235a5f8986e$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $2ecf3235a5f8986e$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $2ecf3235a5f8986e$export$2e2bcd8739ae039 = $2ecf3235a5f8986e$export$852ff24d0930c62f;

});

parcelRegister("6l8hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $auuB0 = parcelRequire("auuB0");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $auuB0.Either;
    }
});

var $2v7c1 = parcelRequire("2v7c1");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $2v7c1.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $2v7c1.tryGetArtifactData;
    }
});

var $8Xjp5 = parcelRequire("8Xjp5");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $8Xjp5.parseArtifactManifest;
    }
});

var $1NPzc = parcelRequire("1NPzc");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $1NPzc.parseVersionMetadata;
    }
});

var $5LTws = parcelRequire("5LTws");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $5LTws.checkManifest;
    }
});

var $6FHvZ = parcelRequire("6FHvZ");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $6FHvZ.ConfigRegistryDataSource;
    }
});

var $3ijEk = parcelRequire("3ijEk");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3ijEk.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3ijEk.Versions;
    }
});

});
parcelRegister("auuB0", function(module, exports) {
"use strict";
var $7a34706d0f0f02a3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $7a34706d0f0f02a3$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $7a34706d0f0f02a3$var$Right(value);
    };
    Either.left = function(error) {
        return new $7a34706d0f0f02a3$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $7a34706d0f0f02a3$var$Either;
var $7a34706d0f0f02a3$var$Right = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $7a34706d0f0f02a3$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.right(this.right);
    };
    return Right;
}($7a34706d0f0f02a3$var$Either);
var $7a34706d0f0f02a3$var$Left = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    return Left;
}($7a34706d0f0f02a3$var$Either);

});

parcelRegister("2v7c1", function(module, exports) {
"use strict";
var $1d240e683f64836f$var$__assign = module.exports && module.exports.__assign || function() {
    $1d240e683f64836f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d240e683f64836f$var$__assign.apply(this, arguments);
};
var $1d240e683f64836f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1d240e683f64836f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $6l8hg = parcelRequire("6l8hg");

var $9te7V = parcelRequire("9te7V");

var $9P145 = parcelRequire("9P145");

var $3evgk = parcelRequire("3evgk");
function $1d240e683f64836f$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $6l8hg.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $9te7V.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9P145.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $1d240e683f64836f$var$getArtifactFromSource;
function $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $hdDPm.interpolateTagScheme)(manifest.tagScheme, $1d240e683f64836f$var$__assign($1d240e683f64836f$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $1d240e683f64836f$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9P145.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $1d240e683f64836f$var$tryGetArtifactData;

});
parcelRegister("hdDPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
const $c8928b7419a5cc69$var$TAG_SCHEME_VERSION = 2;
function $c8928b7419a5cc69$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $c8928b7419a5cc69$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $c8928b7419a5cc69$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $c8928b7419a5cc69$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $c8928b7419a5cc69$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
module.exports.generateTagScheme = $c8928b7419a5cc69$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
module.exports.getDimensionsFromTagScheme = $c8928b7419a5cc69$var$getDimensionsFromTagScheme;
function $c8928b7419a5cc69$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
module.exports.getDataTagForManifest = $c8928b7419a5cc69$var$getDataTagForManifest;
function $c8928b7419a5cc69$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
module.exports.getVersionMetadataTag = $c8928b7419a5cc69$var$getVersionMetadataTag;
function $c8928b7419a5cc69$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("9te7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $6e51c7c28a67d567$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $6e51c7c28a67d567$var$getDimensionContext;

});

parcelRegister("9P145", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $7269b3f523ad10e5$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $7269b3f523ad10e5$var$assertUnreachable;

});

parcelRegister("3evgk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $25aaedf68a816fe7$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $25aaedf68a816fe7$var$toJson;
function $25aaedf68a816fe7$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $25aaedf68a816fe7$var$toPrettyJson;

});


parcelRegister("8Xjp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $6852e290d659d0bd$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $4DuZk.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $4DuZk.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $6852e290d659d0bd$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $4DuZk.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $6852e290d659d0bd$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $6852e290d659d0bd$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $4DuZk.parseUnknownObject)(dimensions);
    var supported = (0, $4DuZk.parseArray)(unparsedDimensions.supported).map($4DuZk.parseString);
    var fallback = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $6852e290d659d0bd$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $4DuZk.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $6852e290d659d0bd$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $6852e290d659d0bd$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $4DuZk.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $4DuZk.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $4DuZk.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $6852e290d659d0bd$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $6852e290d659d0bd$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $6852e290d659d0bd$var$parseArtifactManifest;

});
parcelRegister("4DuZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $3602d78656005db6$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $3602d78656005db6$var$parseString;
function $3602d78656005db6$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $3602d78656005db6$var$parseArray;
function $3602d78656005db6$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $3602d78656005db6$var$parseBoolean;
function $3602d78656005db6$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $3602d78656005db6$var$parseUnknownObject;
function $3602d78656005db6$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $3602d78656005db6$var$parseUndefinedOr;

});


parcelRegister("1NPzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $15025e265438bcca$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $4DuZk.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $4DuZk.parseString)(unknownObject.version);
    var publishTime = new Date((0, $4DuZk.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $4DuZk.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $15025e265438bcca$var$parseVersionMetadata;

});

parcelRegister("5LTws", function(module, exports) {
"use strict";
var $433c69239a917447$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $433c69239a917447$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $433c69239a917447$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $433c69239a917447$var$checkManifest;

});

parcelRegister("6FHvZ", function(module, exports) {
"use strict";
var $4db8538ddb439aee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4db8538ddb439aee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $auuB0 = parcelRequire("auuB0");

var $8Xjp5 = parcelRequire("8Xjp5");

var $1NPzc = parcelRequire("1NPzc");
var $4db8538ddb439aee$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($8Xjp5.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $auuB0.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $hdDPm.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $1NPzc.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $4db8538ddb439aee$var$ConfigRegistryDataSource;

});

parcelRegister("3ijEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $26624b831163931e$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $26624b831163931e$var$BaseUrls;
var $26624b831163931e$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $26624b831163931e$var$Versions;

});


parcelRegister("3TdLx", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $2d512fbe779401ec$export$2cb8d79200775058);

var $6l8hg = parcelRequire("6l8hg");

var $hdDPm = parcelRequire("hdDPm");
class $2d512fbe779401ec$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $hdDPm.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $6l8hg.parseVersionMetadata)(response);
                return (0, $6l8hg.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $6l8hg.parseArtifactManifest)(response);
                return (0, $6l8hg.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3Oidj", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $2c642b791ff52615$export$45c6d12ca9c14f83);

var $6l8hg = parcelRequire("6l8hg");
function $2c642b791ff52615$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $2c642b791ff52615$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $2c642b791ff52615$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $6l8hg.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $6l8hg.Either).right(json)));
            }).catch((error)=>resolve((0, $6l8hg.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("d5LIN", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $9880c2778e17f5cd$export$8489e2f039bfcc4c);

var $eHiP8 = parcelRequire("eHiP8");

var $6l8hg = parcelRequire("6l8hg");

var $4gZ5I = parcelRequire("4gZ5I");
function $9880c2778e17f5cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9880c2778e17f5cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9880c2778e17f5cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9880c2778e17f5cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9880c2778e17f5cd$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $4gZ5I.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $9880c2778e17f5cd$var$_objectSpread($9880c2778e17f5cd$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $6l8hg.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $6l8hg.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("4gZ5I", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $31c80b8146ec82d5$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $31c80b8146ec82d5$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("95uqQ", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $69dc2fdcb553c857$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $69dc2fdcb553c857$export$c3ac7702bfd47c1b);
const $69dc2fdcb553c857$var$SAMPLING_RATE = 10;
class $69dc2fdcb553c857$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $69dc2fdcb553c857$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $69dc2fdcb553c857$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $69dc2fdcb553c857$var$SAMPLING_RATE) return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("2bJTu"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $69dc2fdcb553c857$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
    }
}
const $69dc2fdcb553c857$export$a3006f8f221c0a3b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $69dc2fdcb553c857$export$c3ac7702bfd47c1b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("2bJTu", function(module, exports) {

let $198035774b116f9c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $198035774b116f9c$var$load("cfDeu").then(()=>parcelRequire('8GXI8'));

});


parcelRegister("kJG1r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $fiwxX = parcelRequire("fiwxX");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $fiwxX.parseConfigWithTargeting;
    }
});

var $hTlW1 = parcelRequire("hTlW1");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $hTlW1.TargetedConfig;
    }
});

});
parcelRegister("fiwxX", function(module, exports) {
"use strict";
var $b231c88986716fb9$var$__assign = module.exports && module.exports.__assign || function() {
    $b231c88986716fb9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b231c88986716fb9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $hTlW1 = parcelRequire("hTlW1");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $b231c88986716fb9$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $b231c88986716fb9$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $hTlW1.TargetedConfig({
                defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $b231c88986716fb9$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $hTlW1.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $b231c88986716fb9$var$__assign($b231c88986716fb9$var$__assign({}, accObject), (_a = {}, _a[key] = $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $b231c88986716fb9$var$parseConfigWithTargeting;
function $b231c88986716fb9$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $b231c88986716fb9$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $b231c88986716fb9$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $b231c88986716fb9$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $b231c88986716fb9$var$parseIdentifierList(target.orgIds),
            siteIds: $b231c88986716fb9$var$parseIdentifierList(target.siteIds),
            userIds: $b231c88986716fb9$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $b231c88986716fb9$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("hTlW1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $d068968b22fc3b5a$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $d068968b22fc3b5a$var$TargetedConfig;
function $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("lKWnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039);
class $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $fd6b2c7e02ec3fe7$export$1d76d155060824c9 = (e)=>e instanceof $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039;

});

parcelRegister("4r7nA", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $33af6871e9658618$export$e3553dc63541d477);
const $33af6871e9658618$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("814TT", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $5d6237e1ec8a6bfc$export$f33622abb5224195);

var $eHiP8 = parcelRequire("eHiP8");

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
function $5d6237e1ec8a6bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d6237e1ec8a6bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d6237e1ec8a6bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d6237e1ec8a6bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5d6237e1ec8a6bfc$export$6061a1a9a61f2e21 = ()=>new (0, $kkzI0.UFOExperience)("fetch", {
        type: (0, $lrUJ4.ExperienceTypes).Operation,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5 = ()=>new (0, $kkzI0.UFOExperience)("retrieve-artifact", {
        type: (0, $lrUJ4.ExperienceTypes).Operation,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $5d6237e1ec8a6bfc$var$_objectSpread($5d6237e1ec8a6bfc$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("kuGny", function(module, exports) {

$parcel$export(module.exports, "SwitchToTooltipText", () => $18f20eb0e76c4b99$export$c5ef4d14b7e18cbd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $efDFd = parcelRequire("efDFd");

var $f8YQQ = parcelRequire("f8YQQ");
const $18f20eb0e76c4b99$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efDFd.default), {
    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $f8YQQ.default).switchSitesOrAppsTooltip
    })
});

});

parcelRegister("brgOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afbaf69bf524c19$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $7afbaf69bf524c19$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            fallback: null
        };
    }
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});

parcelRegister("6puUq", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $a7163fb23f0dc28f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $98UVV = parcelRequire("98UVV");

var $5V4nm = parcelRequire("5V4nm");

var $80pg0 = parcelRequire("80pg0");

var $iro8J = parcelRequire("iro8J");

var $gP6wp = parcelRequire("gP6wp");
const $a7163fb23f0dc28f$var$SpotlightWithVariables = (0, $5V4nm.default)((0, $gP6wp.default));
const $a7163fb23f0dc28f$export$f57123e11f24bec9 = (0, $80pg0.default)($a7163fb23f0dc28f$var$SpotlightWithVariables);
const $a7163fb23f0dc28f$var$SpotlightWithMessage = (0, $iro8J.default)($a7163fb23f0dc28f$export$f57123e11f24bec9, 'spotlight');
function $a7163fb23f0dc28f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $98UVV.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($a7163fb23f0dc28f$var$SpotlightWithMessage, {
            ...props
        })
    });
}

});
parcelRegister("5V4nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4e565b503fcafe$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kgLW7 = parcelRequire("kgLW7");
function $2b4e565b503fcafe$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $5uXOq.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $2b4e565b503fcafe$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(TargetComponent, {
                ...props
            });
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $2b4e565b503fcafe$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $kgLW7.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $kgLW7.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $kgLW7.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("kgLW7", function(module, exports) {

$parcel$export(module.exports, "rebuildButtonAction", () => $cfad97fd4aa01ac6$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $cfad97fd4aa01ac6$export$d808999430a3f186);

var $2bhPQ = parcelRequire("2bhPQ");
function $cfad97fd4aa01ac6$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $cfad97fd4aa01ac6$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $2bhPQ.runTemplateForUrl)(input, variables) : (0, $2bhPQ.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $4e1a8042384ba19b$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $4e1a8042384ba19b$export$e26f00bd90899835 = 'success';
const $4e1a8042384ba19b$export$edb46161045fece7 = 'error';

parcelRegister("2bhPQ", function(module, exports) {

$parcel$export(module.exports, "runTemplateForUrl", () => $f11548ac1f3ecfce$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $f11548ac1f3ecfce$export$5681b97796b74884);

var $yLFxy = parcelRequire("yLFxy");

var $8oNs0 = parcelRequire("8oNs0");


var $gvUBn = parcelRequire("gvUBn");
function $f11548ac1f3ecfce$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $yLFxy.default)(template);
    return (0, $gvUBn.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $f11548ac1f3ecfce$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $yLFxy.default)(template);
    return (0, $8oNs0.replaceForUrl)(epTemplate, variables);
}
function $f11548ac1f3ecfce$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $yLFxy.default)(template);
    return (0, $8oNs0.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("yLFxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4010c2387600aeab$export$2e2bcd8739ae039);

var $erKY8 = parcelRequire("erKY8");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $4010c2387600aeab$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $4010c2387600aeab$var$UNESCAPED_MATCH = 1;
const $4010c2387600aeab$var$UNESCAPED_GROUP_CONTENTS = 2;
const $4010c2387600aeab$var$ESCAPED_GROUP_CONTENTS = 5;
function $4010c2387600aeab$export$2e2bcd8739ae039(template) {
    const parts = (0, $erKY8.regexpParts)(template, $4010c2387600aeab$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$4010c2387600aeab$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$4010c2387600aeab$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$4010c2387600aeab$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("erKY8", function(module, exports) {

$parcel$export(module.exports, "regexpParts", () => $c85458000c13225a$export$b16d411b3b6d6dff);
function $c85458000c13225a$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $c85458000c13225a$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $c85458000c13225a$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $c85458000c13225a$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $c85458000c13225a$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("8oNs0", function(module, exports) {

$parcel$export(module.exports, "replaceForUrl", () => $7173ea7515069331$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $7173ea7515069331$export$ca536300dbd6350);

var $gvUBn = parcelRequire("gvUBn");

var $jZ9oS = parcelRequire("jZ9oS");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $7173ea7515069331$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $gvUBn.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $7173ea7515069331$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $7173ea7515069331$var$rawReplaceVariablesForUrl(template, variables) {
    return $7173ea7515069331$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $7173ea7515069331$var$rawReplaceVariablesForHtml(template, variables) {
    return $7173ea7515069331$var$rawReplaceVariables(template, variables, (0, $jZ9oS.default));
}
function $7173ea7515069331$export$d10ae881b12b8ef2(template, variables) {
    return $7173ea7515069331$var$withVariableValidation(template, variables, $7173ea7515069331$var$rawReplaceVariablesForUrl);
}
function $7173ea7515069331$export$ca536300dbd6350(template, variables) {
    return $7173ea7515069331$var$withVariableValidation(template, variables, $7173ea7515069331$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("gvUBn", function(module, exports) {

$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $4d502853833214f5$export$4a33186abb06007b);

var $2ZVgf = parcelRequire("2ZVgf");
function $4d502853833214f5$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $4d502853833214f5$export$4a33186abb06007b(template) {
    const variableParts = $4d502853833214f5$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $2ZVgf.uniqStrings)(variableNames);
}

});
parcelRegister("2ZVgf", function(module, exports) {

$parcel$export(module.exports, "uniqStrings", () => $b999d0c2823ebb9c$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $b999d0c2823ebb9c$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("jZ9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $07bd6165ed19aa1b$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $07bd6165ed19aa1b$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("gP6wp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1fc4ac7cb3f3314$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $bkS4F = parcelRequire("bkS4F");

var $emcPf = parcelRequire("emcPf");

var $e2jLj = parcelRequire("e2jLj");
class $a1fc4ac7cb3f3314$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $emcPf.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bkS4F.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2jLj.default), {
                html: body
            })
        });
    }
}

});


parcelRegister("7uvRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $84722fc66c705872$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $aJagc = parcelRequire("aJagc");

var $cBx5H = parcelRequire("cBx5H");

var $2gv4N = parcelRequire("2gv4N");

var $bZvct = parcelRequire("bZvct");
const $84722fc66c705872$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $cBx5H.default)(endpoint);
        const requester = new (0, $bZvct.default)(new (0, $2gv4N.RecommendationsRequestBroker)());
        const context = (0, $aJagc.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $4b30e584736b3c4d$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $84722fc66c705872$export$2e2bcd8739ae039 = $84722fc66c705872$var$useRecommendations;

});
// Events
const $4b30e584736b3c4d$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $4b30e584736b3c4d$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $4b30e584736b3c4d$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $4b30e584736b3c4d$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $4b30e584736b3c4d$export$14b7e2c312f27acd = 'atlassian-growth-recos';

parcelRegister("aJagc", function(module, exports) {

$parcel$export(module.exports, "isNotEmpty", () => $b5af87570d0b6686$export$a079a83b07f794bf);
$parcel$export(module.exports, "getContext", () => $b5af87570d0b6686$export$31553aaa555c1514);
function $b5af87570d0b6686$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $b5af87570d0b6686$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("cBx5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d271622913dd96d$export$2e2bcd8739ae039);

var $fr56G = parcelRequire("fr56G");
class $1d271622913dd96d$export$2e2bcd8739ae039 extends (0, $fr56G.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $1d271622913dd96d$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $1d271622913dd96d$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});
parcelRegister("fr56G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdde66a833846ada$export$2e2bcd8739ae039);

var $aJagc = parcelRequire("aJagc");
class $fdde66a833846ada$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $aJagc.getContext)(contextResolver);
    }
}

});


parcelRegister("2gv4N", function(module, exports) {

$parcel$export(module.exports, "RecommendationsRequestBroker", () => $d36022f4ff637f21$export$7f19312509e0d2c0);

var $2TX01 = parcelRequire("2TX01");
class $d36022f4ff637f21$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $2TX01.RecommendationSuccessResultCreator)(response, result);
    }
}

});
parcelRegister("2TX01", function(module, exports) {

$parcel$export(module.exports, "RecommendationSuccessResultCreator", () => $df88c41553a16275$export$c02f0b31b3b527a3);

var $8qa63 = parcelRequire("8qa63");
class $df88c41553a16275$export$c02f0b31b3b527a3 extends (0, $8qa63.QuerySuccessResultCreator) {
    constructor(response, data){
        super(response, data), this.response = response;
    }
    makeQueryResult() {
        return new (0, $8qa63.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
}

});
parcelRegister("8qa63", function(module, exports) {

$parcel$export(module.exports, "GraphQlQueryResult", () => $2e11b4f3d18dafe4$export$d0a1abfd57dc5018);
$parcel$export(module.exports, "NonOkQueryResultCreator", () => $2e11b4f3d18dafe4$export$ad7cb7f4450dd7c4);
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", () => $2e11b4f3d18dafe4$export$553722ecbbe27276);
$parcel$export(module.exports, "MissingQueryDataResultCreator", () => $2e11b4f3d18dafe4$export$ff264bfdc9a404eb);
$parcel$export(module.exports, "QuerySuccessResultCreator", () => $2e11b4f3d18dafe4$export$6b16771e962990ff);
class $2e11b4f3d18dafe4$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $2e11b4f3d18dafe4$var$QueryResultCreator {
}
class $2e11b4f3d18dafe4$export$ad7cb7f4450dd7c4 extends $2e11b4f3d18dafe4$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $2e11b4f3d18dafe4$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
}
class $2e11b4f3d18dafe4$export$553722ecbbe27276 extends $2e11b4f3d18dafe4$var$QueryResultCreator {
    constructor(errors){
        super(), this.errors = errors;
    }
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $2e11b4f3d18dafe4$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
}
class $2e11b4f3d18dafe4$export$ff264bfdc9a404eb extends $2e11b4f3d18dafe4$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $2e11b4f3d18dafe4$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
}
class $2e11b4f3d18dafe4$export$6b16771e962990ff extends $2e11b4f3d18dafe4$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}

});



parcelRegister("bZvct", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a427f4e6aef6ef4$export$2e2bcd8739ae039);

var $8qa63 = parcelRequire("8qa63");

var $dorTd = parcelRequire("dorTd");
class $6a427f4e6aef6ef4$export$2e2bcd8739ae039 {
    constructor(broker){
        this.broker = broker;
    }
    /**
	 * Fetches the response by the given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The query result
	 */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $8qa63.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $8qa63.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $8qa63.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
	 * Fetches the response by tha given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The response from the request
	 */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $dorTd.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
}

});
parcelRegister("dorTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d464920952faa220$export$2e2bcd8739ae039);

var $iGNkL = parcelRequire("iGNkL");

var $chNot = parcelRequire("chNot");
class $d464920952faa220$export$2e2bcd8739ae039 {
    /**
	 * Returns the cache provider based on the given cache configuration
	 *
	 * @param cacheConfig The cache configuration to use
	 * @returns The cache provider
	 */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $chNot.default)(cacheConfig);
        return new (0, $iGNkL.default)();
    }
}

});
parcelRegister("iGNkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1591cbfbf443bad1$export$2e2bcd8739ae039);
class $1591cbfbf443bad1$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}

});

parcelRegister("chNot", function(module, exports) {

$parcel$export(module.exports, "default", () => $575921182bdb34d8$export$2e2bcd8739ae039);

var $kR8iv = parcelRequire("kR8iv");

var $bQNwe = parcelRequire("bQNwe");
class $575921182bdb34d8$export$2e2bcd8739ae039 {
    /**
	 * Initialise the WebCacheStorage
	 * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
	 * @param onError a callback when any error occurs
	 */ constructor(cacheProviderConfig){
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $kR8iv.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $bQNwe.default)(this.cacheConfig);
    }
    /**
	 * Get cached response
	 */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Put response in cache
	 */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Delete cached response
	 */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
	 * Check if the cached response is expired
	 */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
	 * Compose the URL and the use case as the search params to cache the response
	 */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
	 * Get the key to store the response
	 * Interally, it hashes the request body to get a unique key
	 */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
}

});
parcelRegister("kR8iv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1a33bd37379f56$export$2e2bcd8739ae039);
const $7d1a33bd37379f56$var$DEFAULT_TTL = 60;
class $7d1a33bd37379f56$export$2e2bcd8739ae039 {
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $7d1a33bd37379f56$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
}

});

parcelRegister("bQNwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d33100b530c2ac4$export$2e2bcd8739ae039);
class $0d33100b530c2ac4$export$2e2bcd8739ae039 {
    /**
	 * Initialise the ExpiryStorage
	 */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
    /**
	 * Set the expiry date of the cached response
	 */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Get the expiry date of the cached response
	 */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Initialise the IndexedDB
	 */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
	 * Get the object store from the IndexedDB
	 */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
}

});





parcelRegister("hC4ud", function(module, exports) {

$parcel$export(module.exports, "ARTICLE_TYPE", () => $4c0f64298947e898$export$a72bfd9b1e5592c8);
var $4c0f64298947e898$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("7FUon", function(module, exports) {

$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("fEj24")).default);

var $fEj24 = parcelRequire("fEj24");

});
parcelRegister("fEj24", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7fb7f2829d196dc$export$2e2bcd8739ae039);

var $ddgvn = parcelRequire("ddgvn");
const $a7fb7f2829d196dc$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
class $a7fb7f2829d196dc$export$2e2bcd8739ae039 {
    constructor(baseUrl, cloudId, source = $a7fb7f2829d196dc$export$b055de0e665cb20c){
        this.serviceConfig = {
            url: baseUrl
        };
        this.cloudId = cloudId;
        this.source = source;
    }
    async countUnseenNotifications(options = {}) {
        const mergedOptions = {
            path: '/api/3/notifications/count/unseen',
            ...options,
            queryParams: {
                ...this.cloudId && {
                    cloudId: this.cloudId
                },
                source: this.source,
                ...options.queryParams || {}
            },
            requestInit: {
                mode: 'cors',
                headers: {
                    'x-app-version': `${"0.0.0-use.local"}-${$a7fb7f2829d196dc$export$b055de0e665cb20c}`
                },
                ...options.requestInit || {}
            }
        };
        return (0, $ddgvn.utils).requestService(this.serviceConfig, mergedOptions);
    }
}

});
parcelRegister("ddgvn", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("jBMVr")).AbstractResource);

$parcel$export(module.exports, "utils", () => $c1297672c9276419$export$eab97d15b1788b8d);
$parcel$export(module.exports, "multipartUtils", () => $c1297672c9276419$export$3b4c04cf7dad0e50);
parcelRequire("1fc6F");
parcelRequire("jBMVr");

var $h29JV = parcelRequire("h29JV");

var $gOgp6 = parcelRequire("gOgp6");
const $c1297672c9276419$export$eab97d15b1788b8d = $h29JV;
const $c1297672c9276419$export$3b4c04cf7dad0e50 = $gOgp6;

});
parcelRegister("1fc6F", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $13f1b8b4f9044d1a$export$2ac26f1ab7eda637);
const $13f1b8b4f9044d1a$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("jBMVr", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $c1a8324c94887b62$export$4529f10aed0950d4);
class $c1a8324c94887b62$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("h29JV", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $ffe076fecee74d1f$export$97bfde5a702aaeca);

var $7xBz2 = parcelRequire("7xBz2");

var $fHpHg = parcelRequire("fHpHg");

var $7Ws94 = parcelRequire("7Ws94");

var $1fc6F = parcelRequire("1fc6F");

var $irjUu = parcelRequire("irjUu");
const $ffe076fecee74d1f$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $irjUu.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $irjUu.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $irjUu.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $1fc6F.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $fHpHg.fg)('platform_collab_provider_tracingheaders');
    (0, $7Ws94.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $7xBz2.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $ffe076fecee74d1f$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("irjUu", function(module, exports) {

$parcel$export(module.exports, "defaultRequestServiceOptions", () => $6e156108e0537d0f$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $6e156108e0537d0f$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $6e156108e0537d0f$export$7d6ed858a91629c3);
const $6e156108e0537d0f$export$160dbda113bfad3b = {};
const $6e156108e0537d0f$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $6e156108e0537d0f$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $6e156108e0537d0f$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $6e156108e0537d0f$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $6e156108e0537d0f$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("gOgp6", function(module, exports) {

$parcel$export(module.exports, "requestServiceMultipart", () => $630105f29b787a94$export$8b13532c81e8ac89);

var $lGkPt = parcelRequire("lGkPt");

var $1fc6F = parcelRequire("1fc6F");

var $irjUu = parcelRequire("irjUu");

var $fHpHg = parcelRequire("fHpHg");

var $7Ws94 = parcelRequire("7Ws94");

var $7xBz2 = parcelRequire("7xBz2");
const $630105f29b787a94$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $irjUu.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $irjUu.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $irjUu.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $1fc6F.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $fHpHg.fg)('platform_collab_provider_tracingheaders');
    (0, $7Ws94.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $7xBz2.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $lGkPt.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $630105f29b787a94$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("lGkPt", function(module, exports) {

$parcel$export(module.exports, "meros", () => $fc8dad7b24d7fa67$export$74e0a034be2368c7);
var $fc8dad7b24d7fa67$var$e = new TextDecoder;
async function $fc8dad7b24d7fa67$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $fc8dad7b24d7fa67$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});





parcelRegister("jf6er", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $212bdc2919de7494$export$17d3acb0b4379d02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a3857ab2c9c2e4ce097a46f69b45351>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bFnHI = parcelRequire("bFnHI");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $212bdc2919de7494$var$svg = `<svg width="56" viewBox="0 0 56 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M8.974 15.524H7.62c-2.04 0-3.502-1.25-3.502-3.079h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.524zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.271c.377 0 .643.245.643.624v7.317c-1.818 0-3.059-1.472-3.059-3.524zm3.614-3.614h-1.353c-2.04 0-3.503-1.25-3.503-3.079h7.272c.377 0 .62.268.62.625v7.317c-1.817 0-3.036-1.472-3.036-3.525z"/>
    <path fill="var(--ds-text, #292a2e)" d="M50.89 17.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $212bdc2919de7494$var$customThemeSvg = `<svg width="56" viewBox="0 0 56 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M5 0a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zm2.734 15.434H9.05v1.326c0 2 1.188 3.434 2.96 3.434v-7.13c0-.37-.238-.63-.605-.63H4.32c0 1.782 1.425 3 3.413 3m3.499-3.543h1.318v1.326c0 2 1.21 3.434 2.98 3.434V9.52c0-.37-.259-.608-.626-.608H7.82c0 1.782 1.426 2.978 3.413 2.978m3.52-3.522h1.319v1.305c0 2 1.188 3.434 2.959 3.434v-7.13c0-.347-.238-.608-.605-.608H11.34c0 1.782 1.426 3 3.413 3" clip-rule="evenodd"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M50.89 17.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $212bdc2919de7494$export$17d3acb0b4379d02({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bFnHI.LogoWrapper), {
        svg: $212bdc2919de7494$var$svg,
        customThemeSvg: $212bdc2919de7494$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira',
        testId: testId
    });
}

});
parcelRegister("bFnHI", function(module, exports) {

$parcel$export(module.exports, "LogoWrapper", () => $db7fab50988fd5b2$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6VxGE = parcelRequire("6VxGE");

const $db7fab50988fd5b2$var$styles = {
    root: "_1e0c1o8l _vwz4idpf"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $db7fab50988fd5b2$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
function $db7fab50988fd5b2$export$f827d3c5a9c3f644({ svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: iconColor, textColor: textColor }) {
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (iconColor || textColor);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $c680f909cd2c0a82$export$582e20fccfce3089)]: iconColor === 'inherit' ? textColor : iconColor || 'initial',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $c680f909cd2c0a82$export$8344f093f1e14646)]: textColor || 'initial'
        },
        "data-testid": testId,
        "aria-label": label,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $bwpsq.default)([
            $db7fab50988fd5b2$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $db7fab50988fd5b2$var$logoTextColorMap[colorMode ?? 'light']
        ])
    });
}

});


parcelRegister("iP5mc", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $32aeb3459485fc5b$export$dabef2be6cd28c20);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00f577fb495b25659d88995abc61f42a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bFnHI = parcelRequire("bFnHI");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $32aeb3459485fc5b$var$svg = `<svg width="206" viewBox="0 0 206 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.7 10.202h4.464c.67 0 .9.638.49 1.145l-6.98 8.616c-2.257-1.799-2.044-4.644-.393-6.72zm-3.449 3.434H5.788c-.67 0-.9-.638-.49-1.145l6.98-8.616c2.256 1.798 2.011 4.61.376 6.703z"/>
    <path fill="var(--ds-text, #292a2e)" d="M205.27 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M171.93 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34a1.4 1.4 0 0 0-.68.17 1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 165 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26T166 11q-.39.26-.59.7t-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.33-.52l1.75.34q-.18.62-.63 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.91 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.3 2.3 0 0 1-.62-.94l1.64-.51q.11.21.31.42.21.21.55.35.35.14.87.14.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15a2.3 2.3 0 0 1-.4.58q-.25.29-.68.48-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3a1.86 1.86 0 0 0-.58.83 3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.36 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.9 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84t.21-1.25q0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M115.65 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a93 93 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h2.99V17h-1.96v-4.96q0-.33.01-.81l.03-1.04.03-1.13q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14a44 44 0 0 1-.55 1.76L122.01 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1a129 129 0 0 1-.64-2.29h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.31-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.96-.49q.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17M91.92 17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM85.77 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L87.95 17zm-8.01 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7q-.21.44-.21.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.87-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.32.88t.74.53q.46.17 1.03.17t1.01-.17q.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17q-.39.16-.6.44a1.06 1.06 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23a6.5 6.5 0 0 1 1.15.38q.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38m-13.18-.03a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $32aeb3459485fc5b$var$customThemeSvg = `<svg width="206" viewBox="0 0 206 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm12.322 10.156h-4.578l-2.481 3.119c-1.694 2.13-1.912 5.047.402 6.892l7.16-8.837c.42-.52.185-1.174-.503-1.174M5.63 13.677h4.577l2.465-3.135c1.677-2.147 1.929-5.03-.385-6.875l-7.16 8.837c-.42.52-.185 1.173.503 1.173" clip-rule="evenodd"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M205.27 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M171.93 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34a1.4 1.4 0 0 0-.68.17 1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 165 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26T166 11q-.39.26-.59.7t-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.33-.52l1.75.34q-.18.62-.63 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.91 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.3 2.3 0 0 1-.62-.94l1.64-.51q.11.21.31.42.21.21.55.35.35.14.87.14.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15a2.3 2.3 0 0 1-.4.58q-.25.29-.68.48-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3a1.86 1.86 0 0 0-.58.83 3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.36 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.9 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84t.21-1.25q0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M115.65 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a93 93 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h2.99V17h-1.96v-4.96q0-.33.01-.81l.03-1.04.03-1.13q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14a44 44 0 0 1-.55 1.76L122.01 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1a129 129 0 0 1-.64-2.29h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.31-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.96-.49q.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17M91.92 17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM85.77 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L87.95 17zm-8.01 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7q-.21.44-.21.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.87-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.32.88t.74.53q.46.17 1.03.17t1.01-.17q.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17q-.39.16-.6.44a1.06 1.06 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23a6.5 6.5 0 0 1 1.15.38q.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38m-13.18-.03a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $32aeb3459485fc5b$export$dabef2be6cd28c20({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bFnHI.LogoWrapper), {
        svg: $32aeb3459485fc5b$var$svg,
        customThemeSvg: $32aeb3459485fc5b$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira Service Management',
        testId: testId
    });
}

});

parcelRegister("e6boy", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $5eeb7a1d914d36d2$export$c49a2b642fe9eef4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e057ee1c5922ac9ae00ba55c0fe365f1>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bFnHI = parcelRequire("bFnHI");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5eeb7a1d914d36d2$var$svg = `<svg width="186" viewBox="0 0 186 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.086 5.226c1.908.56 3.834.56 5.742 0 .169-.037.28.075.244.243-.543 1.958-.543 3.768 0 5.727.037.15-.075.28-.244.224a10.7 10.7 0 0 0-5.742 0c-.15.056-.28-.075-.224-.224.505-1.959.505-3.769 0-5.727-.056-.168.074-.28.224-.243m.767 6.94v.317c0 1.474-1.029 2.556-2.3 2.556a2.28 2.28 0 0 1-2.283-2.295c0-1.268 1.03-2.276 2.47-2.276h.373V6.01c-.187-.019-.374-.019-.56-.019a6.764 6.764 0 0 0-6.772 6.772c0 3.75 3.03 6.753 6.771 6.753s6.79-3.022 6.79-6.753v-.597z"/>
    <path fill="var(--ds-text, #292a2e)" d="m177.61 19.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.21-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06a2.3 2.3 0 0 1-.88.68q-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-5.8-2.72V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-9.33-.16-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.18-.79.36-1.54.17-.75.41-1.49l1.33-4.05h2.02L159.79 17zm-7.09.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.97-.49t1.96.49q.84.49 1.29 1.39.45.89.45 2.07t-.45 2.07a3.3 3.3 0 0 1-1.28 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23q-.19-.55-.58-.86-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-8.22 1.52q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.31 0 .57-.09t.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.2-.02q-.9 0-1.6-.25a2.85 2.85 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25a2.6 2.6 0 0 1 1.05.7q.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-6.73-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM120.9 17h-2.6v-1.69h2.52q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.03-1.12q-.68-.37-1.69-.37h-2.6v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.59 1.14.59 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.11.61-2.66.61m-1.55-10.19V17h-1.96V6.81zm-6.81 2.53v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03a5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.64.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.11.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-9.43-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16.38.42 1.05.42.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.83L97 15.1h.12q-.31.98-.93 1.49t-1.56.51m-8.61.03a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84a3.5 3.5 0 0 0 .21-1.25q0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31m-8.55 1.58q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07T80 16.67t-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31M69.35 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-8.98 0V6.81h3.9q1.16 0 1.97.45.81.44 1.22 1.21.42.77.42 1.76t-.42 1.76a3 3 0 0 1-1.24 1.2q-.81.43-1.99.43H61.7v-1.6h2.25q.66 0 1.09-.22.43-.23.64-.64a2.05 2.05 0 0 0 .21-.93q0-.53-.2-.93a1.44 1.44 0 0 0-.64-.63q-.43-.23-1.09-.23h-1.6V17zm-9.48.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $5eeb7a1d914d36d2$var$customThemeSvg = `<svg width="186" viewBox="0 0 186 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm12.889 4.882a9.47 9.47 0 0 1-5.422 0c-.142-.035-.265.07-.212.229.476 1.85.476 3.558 0 5.408-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.559 0-5.408.035-.159-.071-.264-.23-.23m-4.698 6.852v-.3h4.238v.564c0 3.523-2.878 6.377-6.41 6.377a6.37 6.37 0 0 1-6.394-6.377 6.387 6.387 0 0 1 6.393-6.394c.177 0 .354 0 .53.018v4.21h-.353c-1.36 0-2.331.95-2.331 2.149 0 1.197.953 2.166 2.154 2.166s2.173-1.021 2.173-2.413" clip-rule="evenodd"/>
    <path fill="var(--themed-text-color, currentcolor)" d="m177.61 19.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.21-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06a2.3 2.3 0 0 1-.88.68q-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-5.8-2.72V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-9.33-.16-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.18-.79.36-1.54.17-.75.41-1.49l1.33-4.05h2.02L159.79 17zm-7.09.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.97-.49t1.96.49q.84.49 1.29 1.39.45.89.45 2.07t-.45 2.07a3.3 3.3 0 0 1-1.28 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23q-.19-.55-.58-.86-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-8.22 1.52q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.31 0 .57-.09t.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.2-.02q-.9 0-1.6-.25a2.85 2.85 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25a2.6 2.6 0 0 1 1.05.7q.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-6.73-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM120.9 17h-2.6v-1.69h2.52q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.03-1.12q-.68-.37-1.69-.37h-2.6v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.59 1.14.59 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.11.61-2.66.61m-1.55-10.19V17h-1.96V6.81zm-6.81 2.53v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03a5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.64.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.11.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-9.43-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16.38.42 1.05.42.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.83L97 15.1h.12q-.31.98-.93 1.49t-1.56.51m-8.61.03a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84a3.5 3.5 0 0 0 .21-1.25q0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31m-8.55 1.58q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07T80 16.67t-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31M69.35 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-8.98 0V6.81h3.9q1.16 0 1.97.45.81.44 1.22 1.21.42.77.42 1.76t-.42 1.76a3 3 0 0 1-1.24 1.2q-.81.43-1.99.43H61.7v-1.6h2.25q.66 0 1.09-.22.43-.23.64-.64a2.05 2.05 0 0 0 .21-.93q0-.53-.2-.93a1.44 1.44 0 0 0-.64-.63q-.43-.23-1.09-.23h-1.6V17zm-9.48.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $5eeb7a1d914d36d2$export$c49a2b642fe9eef4({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bFnHI.LogoWrapper), {
        svg: $5eeb7a1d914d36d2$var$svg,
        customThemeSvg: $5eeb7a1d914d36d2$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira Product Discovery',
        testId: testId
    });
}

});

parcelRegister("biEXp", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $d3e5d3f1d9e35791$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cad139fec80d8164de31f1709da5dcb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d3e5d3f1d9e35791$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#ffc716" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $d3e5d3f1d9e35791$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm10.43 6.58-2.668 2.669A3.25 3.25 0 0 0 12 8.733c-.649 0-1.253.19-1.761.515L7.57 6.58A6.97 6.97 0 0 1 12 5a6.97 6.97 0 0 1 4.43 1.58M19 12a6.97 6.97 0 0 1-1.58 4.43l-2.668-2.668A3.25 3.25 0 0 0 15.267 12c0-.649-.19-1.253-.515-1.761l2.668-2.67A6.97 6.97 0 0 1 19 12m-7 7a6.97 6.97 0 0 0 4.43-1.58l-2.668-2.669a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.761-.515L6.4 18.533V19zm-7-7c0-1.68.593-3.223 1.58-4.43l2.669 2.668A3.25 3.25 0 0 0 8.733 12c0 .649.19 1.253.516 1.762L6.58 16.43A6.97 6.97 0 0 1 5 12" clip-rule="evenodd"/>
</svg>
`;
function $d3e5d3f1d9e35791$export$6da5aa77c402ba0f({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $d3e5d3f1d9e35791$var$svg,
        customThemeSvg: $d3e5d3f1d9e35791$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Customer Service Management',
        testId: testId
    });
}

});

parcelRegister("2WMBe", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogo", () => $a2b6c9a5d27cc48d$export$abc95e6180bb1d88);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8c0cda94d72bc2e3334f1e618534dc1>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bFnHI = parcelRequire("bFnHI");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a2b6c9a5d27cc48d$var$svg = `<svg width="249" viewBox="0 0 249 24">
    <path fill="#ffc716" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
    <path fill="var(--ds-text, #292a2e)" d="M246.92 17.03q-1.33 0-1.92-.48t-.59-1.57v-4.07h-1.16V9.5h1.16V7.68h1.89V9.5h1.57v1.42h-1.56v3.63q0 .53.23.78.23.24.75.24.19 0 .31-.01t.27-.03v1.42a12 12 0 0 1-.43.06 5 5 0 0 1-.52.03M235.19 17V9.5h1.87v1.15h.12q.26-.61.8-.96.55-.35 1.35-.35 1.26 0 1.91.73.66.73.66 2.07V17h-1.87v-4.42q0-.83-.35-1.25-.34-.42-1.08-.42-.48 0-.83.22a1.4 1.4 0 0 0-.54.6q-.18.39-.18.92V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31q.42.85.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.56 1.56 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24 1.63 1.63 0 0 0-.89.25q-.39.25-.61.72t-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25a2 2 0 0 0 .77-.13q.32-.13.51-.31.2-.18.27-.33l.02-.05h1.75l-.01.07a2.6 2.6 0 0 1-.33.74 2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21M213.92 17V9.5h1.87v1.17h.12q.24-.64.78-.98.55-.35 1.29-.35.51 0 .92.16.42.16.71.47t.45.74h.12q.18-.42.51-.72a2.4 2.4 0 0 1 .79-.48q.45-.17.97-.17.75 0 1.29.31.55.3.84.86.29.55.29 1.33V17H223v-4.69q0-.47-.14-.78a.95.95 0 0 0-.42-.47q-.29-.16-.72-.16-.42 0-.73.19t-.48.52a1.6 1.6 0 0 0-.17.74V17h-1.87v-4.8q0-.4-.16-.7a1 1 0 0 0-.44-.44 1.4 1.4 0 0 0-.69-.16q-.4 0-.72.21a1.37 1.37 0 0 0-.48.55 1.7 1.7 0 0 0-.18.79V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24 1.63 1.63 0 0 0-.89.25q-.39.25-.61.72t-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31q.2-.18.27-.33l.02-.05h1.75l-.01.07a2.6 2.6 0 0 1-.33.74 2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21m-8.95 2.46q-1.02 0-1.75-.27t-1.15-.75a2.1 2.1 0 0 1-.51-1.11l.01-.04h1.85l.01.03q.09.34.49.55.4.22 1.09.22.83 0 1.29-.38.47-.37.47-1.04v-1.41h-.12q-.21.4-.54.68a2.4 2.4 0 0 1-.77.42 3.1 3.1 0 0 1-.95.14q-.94 0-1.63-.45a3 3 0 0 1-1.06-1.26q-.37-.81-.37-1.88v-.01q0-1.09.37-1.92a3 3 0 0 1 1.07-1.29q.7-.46 1.66-.46.52 0 .95.16.44.16.77.46.34.3.54.73h.09V9.5h1.87v7.29q0 .88-.44 1.51-.44.65-1.26.99-.82.35-1.93.35m.01-4.43q.56 0 .96-.27t.62-.75.22-1.12v-.01q0-.64-.22-1.12a1.73 1.73 0 0 0-.62-.76q-.4-.27-.96-.27t-.96.27q-.39.27-.6.76-.2.48-.2 1.11v.01q0 .64.21 1.12.21.49.6.76.4.27.96.27m-9.48 1.91q-.71 0-1.27-.27a2.13 2.13 0 0 1-.87-.79q-.31-.5-.31-1.19v-.01q0-.68.34-1.15.34-.48.98-.76.64-.27 1.57-.33l2.79-.17v1.18l-2.51.16q-.67.04-1 .29a.8.8 0 0 0-.32.68v.01q0 .45.34.71t.88.25q.49 0 .86-.19.38-.2.6-.53.23-.33.23-.75v-2.38q0-.52-.34-.81-.34-.28-.98-.28-.56 0-.92.19a.97.97 0 0 0-.47.55l-.01.02h-1.74l.01-.06q.08-.65.5-1.13t1.12-.75 1.61-.27q.98 0 1.67.3t1.05.87.36 1.37V17h-1.84v-1.01h-.12q-.19.36-.52.61-.32.25-.74.39a2.9 2.9 0 0 1-.91.14M179.76 17V9.5h1.87v1.15h.12q.26-.61.8-.96.55-.35 1.35-.35 1.26 0 1.92.73t.66 2.07V17h-1.87v-4.42q0-.83-.35-1.25-.34-.42-1.08-.42-.48 0-.83.22a1.4 1.4 0 0 0-.54.6q-.18.39-.18.92V17zm-6.14.12q-.71 0-1.27-.27a2.13 2.13 0 0 1-.87-.79q-.31-.5-.31-1.19v-.01q0-.68.34-1.15.34-.48.98-.76.64-.27 1.57-.33l2.79-.17v1.18l-2.52.16q-.67.04-1 .29a.8.8 0 0 0-.32.68v.01q0 .45.34.71t.88.25q.48 0 .86-.19.38-.2.6-.53.23-.33.23-.75v-2.38q0-.52-.34-.81-.33-.28-.98-.28-.56 0-.92.19a.97.97 0 0 0-.47.55l-.01.02h-1.74l.01-.06q.08-.65.5-1.13t1.11-.75q.7-.27 1.61-.27.98 0 1.67.3t1.05.87.36 1.37V17h-1.85v-1.01h-.12a1.9 1.9 0 0 1-.52.61 2.4 2.4 0 0 1-.74.39 2.9 2.9 0 0 1-.91.14M159.15 17V7.14h2.22l2.83 7.38h.12l2.83-7.38h2.21V17h-1.74v-6.84h-.95l1.88-2.75-3.67 9.59h-1.26l-3.66-9.59 1.87 2.75h-.95V17zm-8.95.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24 1.63 1.63 0 0 0-.89.25q-.39.25-.61.72t-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31q.2-.18.27-.33l.02-.05h1.75l-.01.07a2.6 2.6 0 0 1-.33.74 2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21m-8.16-.02q-1.16 0-1.97-.46a3.06 3.06 0 0 1-1.24-1.34q-.43-.87-.43-2.11v-.01q0-1.23.42-2.09a3 3 0 0 1 1.24-1.33q.81-.46 1.97-.46.98 0 1.69.34a2.7 2.7 0 0 1 1.12.94q.42.6.51 1.42v.02h-1.75l-.01-.01a1.48 1.48 0 0 0-.5-.88q-.39-.34-1.05-.34-.55 0-.94.28t-.59.81-.2 1.31v.01q0 .77.21 1.32.21.54.59.83.39.29.94.29.64 0 1.02-.29.39-.29.53-.87l.01-.02 1.74-.01v.05a3.2 3.2 0 0 1-.53 1.39 2.74 2.74 0 0 1-1.11.92q-.7.33-1.66.33m-7.2-.2V9.5h1.87V17zm.94-8.7a1.06 1.06 0 0 1-.76-.31 1.03 1.03 0 0 1-.31-.75q0-.44.31-.75.32-.31.76-.31t.76.31.32.75-.32.75q-.31.31-.76.31m-7.04 8.7-2.63-7.5h2l1.63 5.72h.12l1.61-5.72h1.97l-2.62 7.5zm-8.08 0V9.5h1.87v1.16h.12q.19-.61.68-.94.5-.33 1.23-.33.2 0 .39.03.19.02.33.06v1.65a3.6 3.6 0 0 0-.88-.11q-.57 0-.99.21a1.56 1.56 0 0 0-.65.6q-.23.38-.23.92V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31q.42.85.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24q-.5 0-.89.25t-.62.72q-.22.47-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31q.2-.18.27-.33l.02-.05h1.75l-.01.07q-.09.36-.33.74a2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21m-8.96.07q-1.17 0-2.03-.35-.85-.36-1.35-1a2.8 2.8 0 0 1-.55-1.5l-.01-.1h1.87l.01.07q.05.38.32.68.27.29.73.46.47.16 1.07.16.57 0 1-.17.44-.17.68-.48.25-.31.25-.7v-.02a.99.99 0 0 0-.4-.82q-.4-.31-1.33-.51l-1.05-.22q-1.52-.31-2.22-1.02-.7-.72-.7-1.83v-.01q.01-.9.48-1.58.48-.68 1.31-1.05.84-.38 1.93-.38 1.12 0 1.94.38.81.37 1.27 1.01.47.64.53 1.45l.01.08h-1.83l-.01-.08a1.25 1.25 0 0 0-.31-.64 1.6 1.6 0 0 0-.65-.44 2.4 2.4 0 0 0-.94-.16q-.53 0-.92.16-.4.15-.62.44-.22.28-.22.68v.01q0 .49.39.81.4.32 1.29.5l1.05.23q1.05.21 1.7.57.66.36.96.91.32.54.32 1.3v.01q0 .97-.48 1.68-.48.7-1.36 1.09-.87.39-2.08.39M93.32 17V9.5h1.87v1.16h.12q.18-.61.68-.94t1.23-.33q.2 0 .39.03.19.02.33.06v1.65a3.6 3.6 0 0 0-.88-.11q-.57 0-.99.21a1.56 1.56 0 0 0-.65.6q-.22.38-.22.92V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31q.42.85.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24q-.5 0-.89.25t-.61.72-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31a1.3 1.3 0 0 0 .27-.33l.02-.05h1.75l-.01.07q-.09.36-.33.74a2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21M72.05 17V9.5h1.87v1.17h.12q.24-.64.78-.98.55-.35 1.29-.35.51 0 .92.16.42.16.71.47t.45.74h.12q.18-.42.51-.72.34-.31.79-.48t.97-.17q.75 0 1.29.31.55.3.84.86.29.55.29 1.33V17h-1.87v-4.69q0-.47-.14-.78a.95.95 0 0 0-.42-.47q-.29-.16-.72-.16-.42 0-.73.19t-.48.52a1.6 1.6 0 0 0-.17.74V17h-1.89v-4.8q0-.4-.16-.7a1 1 0 0 0-.44-.44 1.4 1.4 0 0 0-.69-.16q-.4 0-.72.21a1.37 1.37 0 0 0-.48.55 1.7 1.7 0 0 0-.18.79V17zm-5.33.16q-1.14 0-1.96-.46a3.17 3.17 0 0 1-1.26-1.35q-.44-.87-.44-2.09v-.01q0-1.21.44-2.08a3.17 3.17 0 0 1 1.26-1.35q.83-.47 1.96-.47t1.96.47q.82.47 1.26 1.34.45.88.45 2.09v.01q0 1.22-.44 2.09a3.13 3.13 0 0 1-1.26 1.35q-.82.47-1.96.47m0-1.48q.56 0 .94-.29.39-.29.6-.83t.21-1.3v-.01q0-.76-.21-1.29-.2-.54-.59-.83t-.94-.29q-.56 0-.94.29-.39.29-.6.83-.2.53-.2 1.29v.01q0 .77.21 1.31t.59.83q.4.29.95.29m-5.89 1.33q-1.33 0-1.92-.48t-.59-1.57v-4.07h-1.16V9.5h1.16V7.68h1.89V9.5h1.57v1.42h-1.57v3.63q0 .53.23.78.23.24.75.24.18 0 .31-.01.12-.01.27-.03v1.42q-.18.03-.43.06a5 5 0 0 1-.52.03m-7.91.12q-.98 0-1.7-.28-.7-.28-1.11-.77a2.1 2.1 0 0 1-.47-1.13l-.01-.02h1.85l.01.02q.13.36.49.6.36.23.97.23.41 0 .71-.11.3-.12.47-.31a.68.68 0 0 0 .17-.46v-.01a.64.64 0 0 0-.25-.52q-.25-.21-.85-.34l-1.24-.27q-.71-.16-1.18-.44a1.9 1.9 0 0 1-.7-.7 1.96 1.96 0 0 1-.23-.97v-.01q0-.7.38-1.22.39-.53 1.08-.81.7-.29 1.61-.29.96 0 1.63.29.68.29 1.05.78.38.48.42 1.09v.02h-1.75v-.03q-.09-.33-.43-.57-.34-.25-.92-.25a1.8 1.8 0 0 0-.64.11 1.1 1.1 0 0 0-.44.3.7.7 0 0 0-.16.46v.01q0 .21.1.36.11.15.35.27t.64.21l1.23.27q1.11.25 1.65.74.53.49.53 1.31v.01q0 .73-.42 1.28t-1.15.85-1.68.3m-9.13 0q-.84 0-1.41-.33a2.06 2.06 0 0 1-.85-.96q-.28-.63-.28-1.52V9.5h1.87v4.42q0 .83.33 1.25.33.43 1.07.43.38 0 .68-.12.3-.13.51-.36a1.4 1.4 0 0 0 .3-.55q.1-.32.1-.72V9.5h1.87V17h-1.89v-1.15H46a2.1 2.1 0 0 1-.48.7 2.1 2.1 0 0 1-.74.45 2.8 2.8 0 0 1-.96.16m-8.46.09q-1.42 0-2.45-.63t-1.58-1.79-.55-2.75v-.01q0-1.61.55-2.76.55-1.16 1.58-1.79 1.02-.63 2.45-.63 1.15 0 2.07.46a3.96 3.96 0 0 1 1.5 1.24q.57.79.68 1.81v.08h-1.9l-.01-.04a2.4 2.4 0 0 0-.44-.99 2.2 2.2 0 0 0-.81-.66 2.4 2.4 0 0 0-1.09-.24q-.8 0-1.39.43-.58.43-.9 1.22-.31.79-.31 1.87v.01q0 1.09.31 1.88.32.79.9 1.22.59.43 1.39.43.61 0 1.09-.22.49-.22.81-.61.32-.4.43-.93l.01-.05h1.89l-.01.07a3.6 3.6 0 0 1-.68 1.78 3.8 3.8 0 0 1-1.47 1.19q-.91.43-2.08.43"/>
</svg>
`;
const $a2b6c9a5d27cc48d$var$customThemeSvg = `<svg width="249" viewBox="0 0 249 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm10.43 6.58-2.668 2.669A3.25 3.25 0 0 0 12 8.733c-.649 0-1.253.19-1.761.515L7.569 6.58A6.97 6.97 0 0 1 12 5a6.97 6.97 0 0 1 4.43 1.58M19 12a6.97 6.97 0 0 1-1.58 4.43l-2.669-2.668A3.25 3.25 0 0 0 15.268 12c0-.649-.19-1.253-.515-1.761l2.668-2.67A6.97 6.97 0 0 1 19 12m-7 7c1.68 0 3.223-.593 4.43-1.58l-2.668-2.669a3.25 3.25 0 0 1-1.762.516c-.649 0-1.253-.19-1.761-.515L6.4 18.533V19zm-7-7a6.97 6.97 0 0 1 1.58-4.43l2.669 2.668A3.25 3.25 0 0 0 8.733 12c0 .649.19 1.253.516 1.762L6.58 16.43A6.97 6.97 0 0 1 5 12" clip-rule="evenodd"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M246.92 17.03q-1.33 0-1.92-.48t-.59-1.57v-4.07h-1.16V9.5h1.16V7.68h1.89V9.5h1.57v1.42h-1.56v3.63q0 .53.23.78.23.24.75.24.19 0 .31-.01t.27-.03v1.42a12 12 0 0 1-.43.06 5 5 0 0 1-.52.03M235.19 17V9.5h1.87v1.15h.12q.26-.61.8-.96.55-.35 1.35-.35 1.26 0 1.91.73.66.73.66 2.07V17h-1.87v-4.42q0-.83-.35-1.25-.34-.42-1.08-.42-.48 0-.83.22a1.4 1.4 0 0 0-.54.6q-.18.39-.18.92V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31q.42.85.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.56 1.56 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24 1.63 1.63 0 0 0-.89.25q-.39.25-.61.72t-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25a2 2 0 0 0 .77-.13q.32-.13.51-.31.2-.18.27-.33l.02-.05h1.75l-.01.07a2.6 2.6 0 0 1-.33.74 2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21M213.92 17V9.5h1.87v1.17h.12q.24-.64.78-.98.55-.35 1.29-.35.51 0 .92.16.42.16.71.47t.45.74h.12q.18-.42.51-.72a2.4 2.4 0 0 1 .79-.48q.45-.17.97-.17.75 0 1.29.31.55.3.84.86.29.55.29 1.33V17H223v-4.69q0-.47-.14-.78a.95.95 0 0 0-.42-.47q-.29-.16-.72-.16-.42 0-.73.19t-.48.52a1.6 1.6 0 0 0-.17.74V17h-1.87v-4.8q0-.4-.16-.7a1 1 0 0 0-.44-.44 1.4 1.4 0 0 0-.69-.16q-.4 0-.72.21a1.37 1.37 0 0 0-.48.55 1.7 1.7 0 0 0-.18.79V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24 1.63 1.63 0 0 0-.89.25q-.39.25-.61.72t-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31q.2-.18.27-.33l.02-.05h1.75l-.01.07a2.6 2.6 0 0 1-.33.74 2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21m-8.95 2.46q-1.02 0-1.75-.27t-1.15-.75a2.1 2.1 0 0 1-.51-1.11l.01-.04h1.85l.01.03q.09.34.49.55.4.22 1.09.22.83 0 1.29-.38.47-.37.47-1.04v-1.41h-.12q-.21.4-.54.68a2.4 2.4 0 0 1-.77.42 3.1 3.1 0 0 1-.95.14q-.94 0-1.63-.45a3 3 0 0 1-1.06-1.26q-.37-.81-.37-1.88v-.01q0-1.09.37-1.92a3 3 0 0 1 1.07-1.29q.7-.46 1.66-.46.52 0 .95.16.44.16.77.46.34.3.54.73h.09V9.5h1.87v7.29q0 .88-.44 1.51-.44.65-1.26.99-.82.35-1.93.35m.01-4.43q.56 0 .96-.27t.62-.75.22-1.12v-.01q0-.64-.22-1.12a1.73 1.73 0 0 0-.62-.76q-.4-.27-.96-.27t-.96.27q-.39.27-.6.76-.2.48-.2 1.11v.01q0 .64.21 1.12.21.49.6.76.4.27.96.27m-9.48 1.91q-.71 0-1.27-.27a2.13 2.13 0 0 1-.87-.79q-.31-.5-.31-1.19v-.01q0-.68.34-1.15.34-.48.98-.76.64-.27 1.57-.33l2.79-.17v1.18l-2.51.16q-.67.04-1 .29a.8.8 0 0 0-.32.68v.01q0 .45.34.71t.88.25q.49 0 .86-.19.38-.2.6-.53.23-.33.23-.75v-2.38q0-.52-.34-.81-.34-.28-.98-.28-.56 0-.92.19a.97.97 0 0 0-.47.55l-.01.02h-1.74l.01-.06q.08-.65.5-1.13t1.12-.75 1.61-.27q.98 0 1.67.3t1.05.87.36 1.37V17h-1.84v-1.01h-.12q-.19.36-.52.61-.32.25-.74.39a2.9 2.9 0 0 1-.91.14M179.76 17V9.5h1.87v1.15h.12q.26-.61.8-.96.55-.35 1.35-.35 1.26 0 1.92.73t.66 2.07V17h-1.87v-4.42q0-.83-.35-1.25-.34-.42-1.08-.42-.48 0-.83.22a1.4 1.4 0 0 0-.54.6q-.18.39-.18.92V17zm-6.14.12q-.71 0-1.27-.27a2.13 2.13 0 0 1-.87-.79q-.31-.5-.31-1.19v-.01q0-.68.34-1.15.34-.48.98-.76.64-.27 1.57-.33l2.79-.17v1.18l-2.52.16q-.67.04-1 .29a.8.8 0 0 0-.32.68v.01q0 .45.34.71t.88.25q.48 0 .86-.19.38-.2.6-.53.23-.33.23-.75v-2.38q0-.52-.34-.81-.33-.28-.98-.28-.56 0-.92.19a.97.97 0 0 0-.47.55l-.01.02h-1.74l.01-.06q.08-.65.5-1.13t1.11-.75q.7-.27 1.61-.27.98 0 1.67.3t1.05.87.36 1.37V17h-1.85v-1.01h-.12a1.9 1.9 0 0 1-.52.61 2.4 2.4 0 0 1-.74.39 2.9 2.9 0 0 1-.91.14M159.15 17V7.14h2.22l2.83 7.38h.12l2.83-7.38h2.21V17h-1.74v-6.84h-.95l1.88-2.75-3.67 9.59h-1.26l-3.66-9.59 1.87 2.75h-.95V17zm-8.95.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24 1.63 1.63 0 0 0-.89.25q-.39.25-.61.72t-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31q.2-.18.27-.33l.02-.05h1.75l-.01.07a2.6 2.6 0 0 1-.33.74 2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21m-8.16-.02q-1.16 0-1.97-.46a3.06 3.06 0 0 1-1.24-1.34q-.43-.87-.43-2.11v-.01q0-1.23.42-2.09a3 3 0 0 1 1.24-1.33q.81-.46 1.97-.46.98 0 1.69.34a2.7 2.7 0 0 1 1.12.94q.42.6.51 1.42v.02h-1.75l-.01-.01a1.48 1.48 0 0 0-.5-.88q-.39-.34-1.05-.34-.55 0-.94.28t-.59.81-.2 1.31v.01q0 .77.21 1.32.21.54.59.83.39.29.94.29.64 0 1.02-.29.39-.29.53-.87l.01-.02 1.74-.01v.05a3.2 3.2 0 0 1-.53 1.39 2.74 2.74 0 0 1-1.11.92q-.7.33-1.66.33m-7.2-.2V9.5h1.87V17zm.94-8.7a1.06 1.06 0 0 1-.76-.31 1.03 1.03 0 0 1-.31-.75q0-.44.31-.75.32-.31.76-.31t.76.31.32.75-.32.75q-.31.31-.76.31m-7.04 8.7-2.63-7.5h2l1.63 5.72h.12l1.61-5.72h1.97l-2.62 7.5zm-8.08 0V9.5h1.87v1.16h.12q.19-.61.68-.94.5-.33 1.23-.33.2 0 .39.03.19.02.33.06v1.65a3.6 3.6 0 0 0-.88-.11q-.57 0-.99.21a1.56 1.56 0 0 0-.65.6q-.23.38-.23.92V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31q.42.85.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24q-.5 0-.89.25t-.62.72q-.22.47-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31q.2-.18.27-.33l.02-.05h1.75l-.01.07q-.09.36-.33.74a2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21m-8.96.07q-1.17 0-2.03-.35-.85-.36-1.35-1a2.8 2.8 0 0 1-.55-1.5l-.01-.1h1.87l.01.07q.05.38.32.68.27.29.73.46.47.16 1.07.16.57 0 1-.17.44-.17.68-.48.25-.31.25-.7v-.02a.99.99 0 0 0-.4-.82q-.4-.31-1.33-.51l-1.05-.22q-1.52-.31-2.22-1.02-.7-.72-.7-1.83v-.01q.01-.9.48-1.58.48-.68 1.31-1.05.84-.38 1.93-.38 1.12 0 1.94.38.81.37 1.27 1.01.47.64.53 1.45l.01.08h-1.83l-.01-.08a1.25 1.25 0 0 0-.31-.64 1.6 1.6 0 0 0-.65-.44 2.4 2.4 0 0 0-.94-.16q-.53 0-.92.16-.4.15-.62.44-.22.28-.22.68v.01q0 .49.39.81.4.32 1.29.5l1.05.23q1.05.21 1.7.57.66.36.96.91.32.54.32 1.3v.01q0 .97-.48 1.68-.48.7-1.36 1.09-.87.39-2.08.39M93.32 17V9.5h1.87v1.16h.12q.18-.61.68-.94t1.23-.33q.2 0 .39.03.19.02.33.06v1.65a3.6 3.6 0 0 0-.88-.11q-.57 0-.99.21a1.56 1.56 0 0 0-.65.6q-.22.38-.22.92V17zm-5.09.16q-1.13 0-1.95-.47a3.2 3.2 0 0 1-1.25-1.35q-.44-.88-.44-2.07v-.01q0-1.2.44-2.07a3.2 3.2 0 0 1 1.24-1.36q.8-.49 1.88-.49t1.87.47 1.22 1.31q.42.85.42 1.98v.6h-6.12v-1.2h5.22l-.89 1.13v-.74q0-.7-.21-1.17a1.57 1.57 0 0 0-.59-.71 1.63 1.63 0 0 0-.88-.24q-.5 0-.89.25t-.61.72-.22 1.16v.75q0 .66.22 1.13t.62.71q.41.25.97.25.45 0 .77-.13t.51-.31a1.3 1.3 0 0 0 .27-.33l.02-.05h1.75l-.01.07q-.09.36-.33.74a2.8 2.8 0 0 1-.64.71q-.4.32-1 .53-.59.21-1.38.21M72.05 17V9.5h1.87v1.17h.12q.24-.64.78-.98.55-.35 1.29-.35.51 0 .92.16.42.16.71.47t.45.74h.12q.18-.42.51-.72.34-.31.79-.48t.97-.17q.75 0 1.29.31.55.3.84.86.29.55.29 1.33V17h-1.87v-4.69q0-.47-.14-.78a.95.95 0 0 0-.42-.47q-.29-.16-.72-.16-.42 0-.73.19t-.48.52a1.6 1.6 0 0 0-.17.74V17h-1.89v-4.8q0-.4-.16-.7a1 1 0 0 0-.44-.44 1.4 1.4 0 0 0-.69-.16q-.4 0-.72.21a1.37 1.37 0 0 0-.48.55 1.7 1.7 0 0 0-.18.79V17zm-5.33.16q-1.14 0-1.96-.46a3.17 3.17 0 0 1-1.26-1.35q-.44-.87-.44-2.09v-.01q0-1.21.44-2.08a3.17 3.17 0 0 1 1.26-1.35q.83-.47 1.96-.47t1.96.47q.82.47 1.26 1.34.45.88.45 2.09v.01q0 1.22-.44 2.09a3.13 3.13 0 0 1-1.26 1.35q-.82.47-1.96.47m0-1.48q.56 0 .94-.29.39-.29.6-.83t.21-1.3v-.01q0-.76-.21-1.29-.2-.54-.59-.83t-.94-.29q-.56 0-.94.29-.39.29-.6.83-.2.53-.2 1.29v.01q0 .77.21 1.31t.59.83q.4.29.95.29m-5.89 1.33q-1.33 0-1.92-.48t-.59-1.57v-4.07h-1.16V9.5h1.16V7.68h1.89V9.5h1.57v1.42h-1.57v3.63q0 .53.23.78.23.24.75.24.18 0 .31-.01.12-.01.27-.03v1.42q-.18.03-.43.06a5 5 0 0 1-.52.03m-7.91.12q-.98 0-1.7-.28-.7-.28-1.11-.77a2.1 2.1 0 0 1-.47-1.13l-.01-.02h1.85l.01.02q.13.36.49.6.36.23.97.23.41 0 .71-.11.3-.12.47-.31a.68.68 0 0 0 .17-.46v-.01a.64.64 0 0 0-.25-.52q-.25-.21-.85-.34l-1.24-.27q-.71-.16-1.18-.44a1.9 1.9 0 0 1-.7-.7 1.96 1.96 0 0 1-.23-.97v-.01q0-.7.38-1.22.39-.53 1.08-.81.7-.29 1.61-.29.96 0 1.63.29.68.29 1.05.78.38.48.42 1.09v.02h-1.75v-.03q-.09-.33-.43-.57-.34-.25-.92-.25a1.8 1.8 0 0 0-.64.11 1.1 1.1 0 0 0-.44.3.7.7 0 0 0-.16.46v.01q0 .21.1.36.11.15.35.27t.64.21l1.23.27q1.11.25 1.65.74.53.49.53 1.31v.01q0 .73-.42 1.28t-1.15.85-1.68.3m-9.13 0q-.84 0-1.41-.33a2.06 2.06 0 0 1-.85-.96q-.28-.63-.28-1.52V9.5h1.87v4.42q0 .83.33 1.25.33.43 1.07.43.38 0 .68-.12.3-.13.51-.36a1.4 1.4 0 0 0 .3-.55q.1-.32.1-.72V9.5h1.87V17h-1.89v-1.15H46a2.1 2.1 0 0 1-.48.7 2.1 2.1 0 0 1-.74.45 2.8 2.8 0 0 1-.96.16m-8.46.09q-1.42 0-2.45-.63t-1.58-1.79-.55-2.75v-.01q0-1.61.55-2.76.55-1.16 1.58-1.79 1.02-.63 2.45-.63 1.15 0 2.07.46a3.96 3.96 0 0 1 1.5 1.24q.57.79.68 1.81v.08h-1.9l-.01-.04a2.4 2.4 0 0 0-.44-.99 2.2 2.2 0 0 0-.81-.66 2.4 2.4 0 0 0-1.09-.24q-.8 0-1.39.43-.58.43-.9 1.22-.31.79-.31 1.87v.01q0 1.09.31 1.88.32.79.9 1.22.59.43 1.39.43.61 0 1.09-.22.49-.22.81-.61.32-.4.43-.93l.01-.05h1.89l-.01.07a3.6 3.6 0 0 1-.68 1.78 3.8 3.8 0 0 1-1.47 1.19q-.91.43-2.08.43"/>
</svg>
`;
function $a2b6c9a5d27cc48d$export$abc95e6180bb1d88({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bFnHI.LogoWrapper), {
        svg: $a2b6c9a5d27cc48d$var$svg,
        customThemeSvg: $a2b6c9a5d27cc48d$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Customer Service Management',
        testId: testId
    });
}

});

parcelRegister("1Y49U", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $16ee9eeb56acb423$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira-servicedesk/queue/manifest.ts
var $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $16ee9eeb56acb423$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("1WQct", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $16b3b3167d49c971$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira-software/board/manifest.ts
var $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $16b3b3167d49c971$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("k0goX", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $e90087bcd5853238$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/dashboard/manifest.ts
var $e90087bcd5853238$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $e90087bcd5853238$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $e90087bcd5853238$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $e90087bcd5853238$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("89DrR", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $5efdc39c8e0dee87$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/plan/manifest.ts
var $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $5efdc39c8e0dee87$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});


parcelRegister("j5YhT", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $de6d3fcbf97a80dc$export$75a0a0a7cb0a58ae);

var $FYyiD = parcelRequire("FYyiD");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/project/manifest.ts
var $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $FYyiD.JiraProjectAriResourceOwner),
    resourceType: (0, $FYyiD.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $de6d3fcbf97a80dc$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("FYyiD", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $07e2ccdc15c7364e$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $07e2ccdc15c7364e$export$736763838d3aa22e);
// src/jira/project/types.ts
var $07e2ccdc15c7364e$export$99d538a3b04916b1 = "jira", $07e2ccdc15c7364e$export$736763838d3aa22e = "project";

});


parcelRegister("dp4Da", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", () => $cf448f007bea333b$export$6620595b7f837f8f);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $4Q5Iw = parcelRequire("4Q5Iw");

var $1g5Ni = parcelRequire("1g5Ni");
const $cf448f007bea333b$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $btDaU.useFlightDeckContext)();
    return (0, $5uXOq.useMemo)(()=>(0, $1g5Ni.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $4Q5Iw.FD_CLIENT_FETCH_PROPS).name, (0, $4Q5Iw.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("btDaU", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $85b0ca77dee62619$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $85b0ca77dee62619$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $85b0ca77dee62619$export$3b241cde208d2c5e);

var $5uXOq = parcelRequire("5uXOq");

var $6HV40 = parcelRequire("6HV40");
const $85b0ca77dee62619$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    getArtifact: null
});
function $85b0ca77dee62619$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return new (0, $6HV40.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85b0ca77dee62619$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $85b0ca77dee62619$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($85b0ca77dee62619$export$ca1b33377afa620);
function $85b0ca77dee62619$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const { getArtifact: getArtifact } = $85b0ca77dee62619$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("4Q5Iw", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $58edd14ac927523b$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $58edd14ac927523b$export$2e2bcd8739ae039);

var $6HV40 = parcelRequire("6HV40");

var $gbQTN = parcelRequire("gbQTN");
const $58edd14ac927523b$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $58edd14ac927523b$var$FD_ENVIRONMENT = 'prod';
const $58edd14ac927523b$export$c270c412a04ff3e6 = {
    name: $58edd14ac927523b$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $58edd14ac927523b$var$FD_ENVIRONMENT
    }
};
class $58edd14ac927523b$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        this.flightDeck = new (0, $6HV40.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $58edd14ac927523b$var$FD_ENVIRONMENT
                },
                value: (0, $gbQTN.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return this.artifactFetch();
        return this.flightDeck.fetchConfigFromFlightDeck($58edd14ac927523b$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
        {
            intervalsMS: [
                100,
                500
            ]
        });
    }
}

});
parcelRegister("gbQTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $77f352a7e3f03bf6$export$2e2bcd8739ae039);
var $77f352a7e3f03bf6$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("1g5Ni", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", () => $f039c513460e3e5b$export$224367b01f71f2aa);

var $867B3 = parcelRequire("867B3");

var $bInHp = parcelRequire("bInHp");
let $f039c513460e3e5b$var$previousClientVersion;
const $f039c513460e3e5b$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($f039c513460e3e5b$var$previousClientVersion && $f039c513460e3e5b$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $f039c513460e3e5b$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $867B3.ActivityClientV2)(product, baseUrl);
    return new (0, $bInHp.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("867B3", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", () => $852c388bb55bb115$export$330ab0047f2fb745);

var $5ecei = parcelRequire("5ecei");

var $5kL8I = parcelRequire("5kL8I");

var $gtPf6 = parcelRequire("gtPf6");
class $852c388bb55bb115$export$330ab0047f2fb745 extends (0, $5kL8I.ActivityClient) {
    constructor(product, baseUrl){
        super('v2', product, undefined, baseUrl), this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $5ecei.fetchActivitiesWithExperience)((experience)=>(0, $gtPf6.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        }, this.setProduct = (product)=>{
            this.product = product;
        };
    }
}

});
parcelRegister("5ecei", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $2c81ad2bfd653a39$export$4a906f16800734f3);

var $10QS8 = parcelRequire("10QS8");

var $hO3Uw = parcelRequire("hO3Uw");

var $lwaI9 = parcelRequire("lwaI9");
async function $2c81ad2bfd653a39$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $lwaI9.recentWorkClientExperienceV2)() : (0, $lwaI9.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $hO3Uw.packageName,
            packageVersion: $hO3Uw.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $2c81ad2bfd653a39$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $2c81ad2bfd653a39$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $10QS8.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("10QS8", function(module, exports) {

$parcel$export(module.exports, "default", () => $247169901b65cdaf$export$2e2bcd8739ae039);
class $247169901b65cdaf$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $247169901b65cdaf$export$97b788730ba59845 = (e)=>e instanceof $247169901b65cdaf$export$2e2bcd8739ae039;

});

parcelRegister("hO3Uw", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $3a0a827f46c943de$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $3a0a827f46c943de$export$91546b032799aa40);
const $3a0a827f46c943de$export$9345d7360ffe0722 = "platform-pkg";
const $3a0a827f46c943de$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("lwaI9", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $3e1331ba30573df5$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $3e1331ba30573df5$export$9e32a4ed888f4717);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
const $3e1331ba30573df5$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $3e1331ba30573df5$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($3e1331ba30573df5$var$keyToTiming);
const $3e1331ba30573df5$export$d7769758f5eaa63b = ()=>{
    return new (0, $kkzI0.UFOExperience)('client', {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $3e1331ba30573df5$var$timings
    });
};
const $3e1331ba30573df5$export$9e32a4ed888f4717 = ()=>new (0, $kkzI0.UFOExperience)('client-v3', {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $3e1331ba30573df5$var$timings
    });

});


parcelRegister("5kL8I", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", () => $3305886d2a43fafb$export$157740f5433f3dbe);

var $bCIX4 = parcelRequire("bCIX4");
class $3305886d2a43fafb$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.product = 'unknown';
        this.baseUrl = (0, $bCIX4.GRAPHQL_GATEWAY_PATH);
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("bCIX4", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $5e4091de5759ac02$export$851c5df667ca24c8);
$parcel$export(module.exports, "WORKED_EVENT", () => $5e4091de5759ac02$export$eb4e9f525aef1cc3);
const $5e4091de5759ac02$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $5e4091de5759ac02$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $5e4091de5759ac02$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $5e4091de5759ac02$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("gtPf6", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", () => $28631f8ed7734bf8$export$750ec7816fdd2f9e);

var $204os = parcelRequire("204os");

var $hLjUS = parcelRequire("hLjUS");

var $4zVHn = parcelRequire("4zVHn");

var $cXMGD = parcelRequire("cXMGD");
const $28631f8ed7734bf8$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $28631f8ed7734bf8$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $28631f8ed7734bf8$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $28631f8ed7734bf8$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $28631f8ed7734bf8$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $4zVHn.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $28631f8ed7734bf8$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $hLjUS.postResource)(baseUrl, {
            operationName: (0, $204os.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($28631f8ed7734bf8$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $cXMGD.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $cXMGD.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $cXMGD.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $cXMGD.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $cXMGD.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("204os", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $66efde9f72b18f60$export$41bca9dc6871dd4e);

var $e4eHl = parcelRequire("e4eHl");
const $66efde9f72b18f60$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(product);
};
const $66efde9f72b18f60$export$41bca9dc6871dd4e = (product)=>{
    return `${$66efde9f72b18f60$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("hLjUS", function(module, exports) {

$parcel$export(module.exports, "postResource", () => $61f89de03f864750$export$2ff3e1f219ccfad6);
parcelRequire("4UjQN");
var $jSHwt = parcelRequire("jSHwt");
var $4UjQN = parcelRequire("4UjQN");

var $cBB13 = parcelRequire("cBB13");

var $10QS8 = parcelRequire("10QS8");
const $61f89de03f864750$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $cBB13.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $jSHwt.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $61f89de03f864750$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $10QS8.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $61f89de03f864750$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $61f89de03f864750$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    return text ? JSON.parse(text) : {};
};
const $61f89de03f864750$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $4UjQN.retryOnException)(()=>$61f89de03f864750$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $61f89de03f864750$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("cBB13", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", () => $e4d1ac0ee993fd6a$export$2414511207262909);
const $e4d1ac0ee993fd6a$var$urlRegex = new RegExp(/^https?:\/\//);
function $e4d1ac0ee993fd6a$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($e4d1ac0ee993fd6a$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("4zVHn", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $a727134ce6012026$export$855cd08371c65b8c);

var $204os = parcelRequire("204os");

var $bCX5W = parcelRequire("bCX5W");
const $a727134ce6012026$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $a727134ce6012026$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$a727134ce6012026$var$ACTIVITIES}
   }
`;
const $a727134ce6012026$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$a727134ce6012026$var$ACTIVITIES}
   }
`;
const $a727134ce6012026$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$a727134ce6012026$var$ACTIVITIES}
    }
`;
const $a727134ce6012026$var$activityQueryMap = new Map([
    [
        'workedOn',
        $a727134ce6012026$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $a727134ce6012026$var$VIEWED__QUERY
    ],
    [
        'all',
        $a727134ce6012026$var$ALL__QUERY
    ]
]);
const $a727134ce6012026$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $a727134ce6012026$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $204os.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $a727134ce6012026$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $a727134ce6012026$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$a727134ce6012026$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $bCX5W.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $a727134ce6012026$var$getActivitiesQuery(product, $a727134ce6012026$var$getMyActivitiesQuery(activityQueries.map((query)=>$a727134ce6012026$var$activityQueryMap.get(query)))),
        queryFilters: (0, $bCX5W.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("bCX5W", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $b73d19ab20b0da02$export$5201d39848130041);

var $cLqhS = parcelRequire("cLqhS");

var $kHY7L = parcelRequire("kHY7L");
const $b73d19ab20b0da02$export$5201d39848130041 = {
    v2: (0, $cLqhS.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $kHY7L.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("cLqhS", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $7292bf5ee3f0da4e$export$1dca7bc1ec360897);

var $4kKHW = parcelRequire("4kKHW");

var $dPdma = parcelRequire("dPdma");
const $7292bf5ee3f0da4e$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $dPdma.default)
    ],
    [
        'activities',
        (0, $4kKHW.default)
    ]
]);

});
parcelRegister("4kKHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4313ee0e331cdf68$export$2e2bcd8739ae039);

var $4gafv = parcelRequire("4gafv");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $4313ee0e331cdf68$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $4gafv.generateActivityFiltersV2)(restFilters);
};
var $4313ee0e331cdf68$export$2e2bcd8739ae039 = $4313ee0e331cdf68$var$generateV2ActivitiesFilters;

});
parcelRegister("4gafv", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", () => $7d8a18de68b98a34$export$ebef9c1f1e15c057);

var $gHCq5 = parcelRequire("gHCq5");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $7d8a18de68b98a34$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $7d8a18de68b98a34$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $7d8a18de68b98a34$export$ebef9c1f1e15c057 = (filters = {})=>(0, $gHCq5.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $7d8a18de68b98a34$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $7d8a18de68b98a34$var$KEYS_TO_TRANSFROM.has(originalkey) ? $7d8a18de68b98a34$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("gHCq5", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", () => $e25765e5a00d364d$export$23c75313f46dd54e);
const $e25765e5a00d364d$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("dPdma", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb11d43ec405720$export$2e2bcd8739ae039);

var $4gafv = parcelRequire("4gafv");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $acb11d43ec405720$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $4gafv.generateActivityFiltersV2)(restFilters);
};
var $acb11d43ec405720$export$2e2bcd8739ae039 = $acb11d43ec405720$var$generateV2MyActivityFilters;

});


parcelRegister("kHY7L", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $15c39e74edb4a9b7$export$9a1782843b6e99d2);

var $l8CbP = parcelRequire("l8CbP");

var $ifqam = parcelRequire("ifqam");
const $15c39e74edb4a9b7$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $ifqam.default)
    ],
    [
        'activities',
        (0, $l8CbP.default)
    ]
]);

});
parcelRegister("l8CbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bafa55bb86952a$export$2e2bcd8739ae039);

var $4rkuH = parcelRequire("4rkuH");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $65bafa55bb86952a$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $4rkuH.generateActivityFiltersV3)(restFilters);
};
var $65bafa55bb86952a$export$2e2bcd8739ae039 = $65bafa55bb86952a$var$generateV3ActivityFilters;

});
parcelRegister("4rkuH", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", () => $1a4fd41021ae32f9$export$e73fe7ded3fe2664);

var $gHCq5 = parcelRequire("gHCq5");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $1a4fd41021ae32f9$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $1a4fd41021ae32f9$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $1a4fd41021ae32f9$export$e73fe7ded3fe2664 = (filters = {})=>(0, $gHCq5.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $1a4fd41021ae32f9$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $1a4fd41021ae32f9$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("ifqam", function(module, exports) {

$parcel$export(module.exports, "default", () => $da84278e3f779c56$export$2e2bcd8739ae039);

var $4rkuH = parcelRequire("4rkuH");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $da84278e3f779c56$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $4rkuH.generateActivityFiltersV3)(restFilters);
};
var $da84278e3f779c56$export$2e2bcd8739ae039 = $da84278e3f779c56$var$generateV3MyActivityFilters;

});




parcelRegister("cXMGD", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", () => $f190f97102b4fbd6$export$306a8b649360ca6f);
const $f190f97102b4fbd6$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $f190f97102b4fbd6$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$f190f97102b4fbd6$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("bInHp", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", () => $e51f83d7bf8650d2$export$3c3c237c92ca1fb9);

var $4UjQN = parcelRequire("4UjQN");

var $fHpHg = parcelRequire("fHpHg");

var $bCIX4 = parcelRequire("bCIX4");

var $hO3Uw = parcelRequire("hO3Uw");

var $5ecei = parcelRequire("5ecei");

var $hLjUS = parcelRequire("hLjUS");

var $h1HUm = parcelRequire("h1HUm");

var $7wTmO = parcelRequire("7wTmO");

var $h1aGS = parcelRequire("h1aGS");

var $6oN0H = parcelRequire("6oN0H");

var $4cXkM = parcelRequire("4cXkM");

var $4Q5Iw = parcelRequire("4Q5Iw");

var $5kL8I = parcelRequire("5kL8I");

var $42ZX5 = parcelRequire("42ZX5");

var $bKrvh = parcelRequire("bKrvh");

var $fMxVh = parcelRequire("fMxVh");
const $e51f83d7bf8650d2$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $e51f83d7bf8650d2$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $e51f83d7bf8650d2$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $e51f83d7bf8650d2$var$DEFAULT_TAGS = {
    source: (0, $hO3Uw.packageName),
    sourcePackageVersion: (0, $hO3Uw.packageVersion)
};
class $e51f83d7bf8650d2$export$3c3c237c92ca1fb9 extends (0, $5kL8I.ActivityClient) {
    constructor(product, baseUrl, logger, configFetch){
        super('v3', product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl), this.setProduct = (product)=>{
            this.product = product;
        }, this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$e51f83d7bf8650d2$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$e51f83d7bf8650d2$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig(), this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $7wTmO.GraphQLJSError)(err));
                    const invalidFragment = (0, $42ZX5.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        }, this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $4UjQN.retryOnException)(async ()=>{
                    const request = (0, $bKrvh.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $fMxVh.filtersToMetadata)(filters)
                    });
                    const res = await (0, $hLjUS.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $fMxVh.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $h1HUm.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $h1HUm.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$e51f83d7bf8650d2$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$e51f83d7bf8650d2$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $fMxVh.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $h1aGS.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $e51f83d7bf8650d2$var$transformActivityItem('workedOn', (0, $fMxVh.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $e51f83d7bf8650d2$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $e51f83d7bf8650d2$var$transformActivityItem('all', (0, $fMxVh.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $fMxVh.rollupActivitiesData)(activities) : activities;
        }, this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $5ecei.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $4Q5Iw.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, product, configFetch);
    }
}
const $e51f83d7bf8650d2$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $4cXkM.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc && (0, $fHpHg.fg)('platform_support_live_doc_icons_in_link_picker')) return (0, $4cXkM.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    return $e51f83d7bf8650d2$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $4cXkM.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $4cXkM.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
function $e51f83d7bf8650d2$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $6oN0H.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $4cXkM.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $4cXkM.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $bCIX4.WORKED_EVENT).CREATED ? (0, $bCIX4.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $fMxVh.parseRootContainerARI)(object.rootContainerId),
                        icon: $e51f83d7bf8650d2$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $4cXkM.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $4cXkM.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $4cXkM.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: object.data.subtype,
                        url: (0, $4cXkM.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $4cXkM.hydratedValueToString)(hydratedData.objectTypeName)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("h1HUm", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", () => $003c766efdd4ba2e$export$2d1b192199788179);
class $003c766efdd4ba2e$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("7wTmO", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", () => $f477a4714a9f5ed3$export$8d4af49ee2a0fbe2);
class $f477a4714a9f5ed3$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("h1aGS", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", () => $2c724f4dd1a78735$export$3f19ff30d409b70);
class $2c724f4dd1a78735$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("6oN0H", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", () => $d4afd007924d0afd$export$d658049bf1a63492);

var $9XE6b = parcelRequire("9XE6b");

var $kZx7n = parcelRequire("kZx7n");
const $d4afd007924d0afd$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $d4afd007924d0afd$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $kZx7n.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $kZx7n.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $kZx7n.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $d4afd007924d0afd$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $d4afd007924d0afd$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(object, path);
}
function $d4afd007924d0afd$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $d4afd007924d0afd$var$getOrSearch(current, split);
    return current;
}
function $d4afd007924d0afd$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(edge, fieldId) === searchValue);
}
function $d4afd007924d0afd$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$d4afd007924d0afd$var$resolvePath(object, path));
}
const $d4afd007924d0afd$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $d4afd007924d0afd$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("kZx7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d3da73099f5dbc$export$2e2bcd8739ae039);
class $84d3da73099f5dbc$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("4cXkM", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", () => $f5a01adfefdca4ef$export$c5cea44a1f75b431);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $f5a01adfefdca4ef$export$86b9f44277b105a6);
$parcel$export(module.exports, "hydrateIcon", () => $f5a01adfefdca4ef$export$a328b2bb0d21d984);
const $f5a01adfefdca4ef$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $f5a01adfefdca4ef$var$isURL(icon) {
    return typeof icon === 'string';
}
function $f5a01adfefdca4ef$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $f5a01adfefdca4ef$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $f5a01adfefdca4ef$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $f5a01adfefdca4ef$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $f5a01adfefdca4ef$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $f5a01adfefdca4ef$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $f5a01adfefdca4ef$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $f5a01adfefdca4ef$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($f5a01adfefdca4ef$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($f5a01adfefdca4ef$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $f5a01adfefdca4ef$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("42ZX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9fcbdc5981c21dd$export$2e2bcd8739ae039);

var $5YBlc = parcelRequire("5YBlc");
const $a9fcbdc5981c21dd$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $5YBlc.default)
    ]
]);
const $a9fcbdc5981c21dd$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $a9fcbdc5981c21dd$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $a9fcbdc5981c21dd$export$2e2bcd8739ae039 = $a9fcbdc5981c21dd$var$graphQLErrorHandler;

});
parcelRegister("5YBlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed320bd633bfeb3$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $7ed320bd633bfeb3$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $7ed320bd633bfeb3$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $7ed320bd633bfeb3$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $7ed320bd633bfeb3$export$2e2bcd8739ae039 = $7ed320bd633bfeb3$var$validationErrorHandler;

});


parcelRegister("bKrvh", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", () => $0a7ee3593b315716$export$7489a6ef09862e48);

var $204os = parcelRequire("204os");

var $bCX5W = parcelRequire("bCX5W");
const $0a7ee3593b315716$var$ACTIVITIES_LIMIT = 50;
const $0a7ee3593b315716$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $0a7ee3593b315716$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $0a7ee3593b315716$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $0a7ee3593b315716$var$activityQueryMap = new Map([
    [
        'workedOn',
        $0a7ee3593b315716$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $0a7ee3593b315716$var$VIEWED__QUERY
    ],
    [
        'all',
        $0a7ee3593b315716$var$ALL__QUERY
    ]
]);
const $0a7ee3593b315716$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $0a7ee3593b315716$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $204os.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $0a7ee3593b315716$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $0a7ee3593b315716$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$0a7ee3593b315716$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $bCX5W.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $0a7ee3593b315716$var$getActivitiesQuery(product, $0a7ee3593b315716$var$getMyActivitiesQuery(activityQueries.map((query)=>$0a7ee3593b315716$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $bCX5W.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $0a7ee3593b315716$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $0a7ee3593b315716$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $0a7ee3593b315716$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $204os.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("fMxVh", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", () => $cc5bcd2bacd4de9a$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $cc5bcd2bacd4de9a$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $cc5bcd2bacd4de9a$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $cc5bcd2bacd4de9a$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $cc5bcd2bacd4de9a$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $cc5bcd2bacd4de9a$export$c939d6148e47244a);
function $cc5bcd2bacd4de9a$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $cc5bcd2bacd4de9a$var$rollUpActivityItems(all),
        viewed: $cc5bcd2bacd4de9a$var$rollUpActivityItems(viewed),
        workedOn: $cc5bcd2bacd4de9a$var$rollUpActivityItems(workedOn)
    };
}
function $cc5bcd2bacd4de9a$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $cc5bcd2bacd4de9a$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$cc5bcd2bacd4de9a$var$fragmentName(key)} on ${$cc5bcd2bacd4de9a$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $cc5bcd2bacd4de9a$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $cc5bcd2bacd4de9a$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $cc5bcd2bacd4de9a$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $cc5bcd2bacd4de9a$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $cc5bcd2bacd4de9a$var$containerMapTypes = new Map([
    [
        $cc5bcd2bacd4de9a$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $cc5bcd2bacd4de9a$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $cc5bcd2bacd4de9a$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $cc5bcd2bacd4de9a$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $cc5bcd2bacd4de9a$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $cc5bcd2bacd4de9a$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$cc5bcd2bacd4de9a$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($cc5bcd2bacd4de9a$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $cc5bcd2bacd4de9a$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $cc5bcd2bacd4de9a$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$cc5bcd2bacd4de9a$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $cc5bcd2bacd4de9a$export$884573c560ed3600(response.data);
}
function $cc5bcd2bacd4de9a$export$884573c560ed3600(queryData) {
    return !queryData.activity || $cc5bcd2bacd4de9a$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $cc5bcd2bacd4de9a$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}

});




parcelRegister("goAXv", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $f8c1c9ca602f0747$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $f8c1c9ca602f0747$export$130340d16a670190);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $gV0yq = parcelRequire("gV0yq");

var $k2GTg = parcelRequire("k2GTg");

var $8CpHp = parcelRequire("8CpHp");
const $f8c1c9ca602f0747$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k2GTg.DEFAULT_CONTEXT));
const $f8c1c9ca602f0747$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $8CpHp.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $gV0yq.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f8c1c9ca602f0747$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $k2GTg.DEFAULT_CONTEXT),
        children: children
    });
};
const $f8c1c9ca602f0747$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btDaU.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f8c1c9ca602f0747$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $f8c1c9ca602f0747$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($f8c1c9ca602f0747$export$8a37839ac1e08b25);

});
parcelRegister("gV0yq", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $2cf7e2b192377604$export$233293b7afb7b362);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $aTgU0 = parcelRequire("aTgU0");
const $2cf7e2b192377604$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $2cf7e2b192377604$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $5uXOq.useMemo)(()=>({
            ...(0, $aTgU0.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $btDaU.useFlightDeckArtifact)((0, $aTgU0.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $5uXOq.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $2cf7e2b192377604$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("aTgU0", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $7d37a6f0dea405c2$export$c270c412a04ff3e6);

var $b4PzF = parcelRequire("b4PzF");
const $7d37a6f0dea405c2$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $7d37a6f0dea405c2$export$71f196808ce40e60 = 'prod';
const $7d37a6f0dea405c2$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $7d37a6f0dea405c2$export$e836203c1e95eac3 = 'commercial';
const $7d37a6f0dea405c2$export$c270c412a04ff3e6 = {
    name: $7d37a6f0dea405c2$export$953923d576277fd6,
    dimensions: {
        environmentType: $7d37a6f0dea405c2$export$71f196808ce40e60,
        perimeter: (0, $b4PzF.isFedRamp)() ? $7d37a6f0dea405c2$export$6392ca3738ed1e9 : $7d37a6f0dea405c2$export$e836203c1e95eac3
    }
};

});


parcelRegister("k2GTg", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $fd0084aabf019b77$export$9c542858adf7dcd0);
const $fd0084aabf019b77$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("8CpHp", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $8b5f279a57655e36$export$66d7d96ce076bcd6);

var $98eWh = parcelRequire("98eWh");

var $8OsWE = parcelRequire("8OsWE");
const $8b5f279a57655e36$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $98eWh.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $8OsWE.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $8OsWE.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("98eWh", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $c422f3bbfff133b5$export$b24dcbe1ec677a8);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $2IhN6 = parcelRequire("2IhN6");

var $7aG62 = parcelRequire("7aG62");
const $c422f3bbfff133b5$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $7aG62.useTeamsPermissionsStore)();
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>(0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                })
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("2IhN6", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $5dd9c8d45c216e7a$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $5dd9c8d45c216e7a$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $5dd9c8d45c216e7a$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $5dd9c8d45c216e7a$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $5dd9c8d45c216e7a$export$91c413c8a5c77e19);
const $5dd9c8d45c216e7a$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $5dd9c8d45c216e7a$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $5dd9c8d45c216e7a$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $5dd9c8d45c216e7a$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($5dd9c8d45c216e7a$var$ANALYTICS_CHANNEL);
        });
    };
const $5dd9c8d45c216e7a$export$a1fb57756f0de62b = $5dd9c8d45c216e7a$var$fireEvent('operational');
const $5dd9c8d45c216e7a$export$59608e0169622110 = $5dd9c8d45c216e7a$var$fireEvent('screen');
const $5dd9c8d45c216e7a$export$574d2f19a52d67ca = $5dd9c8d45c216e7a$var$fireEvent('track');
const $5dd9c8d45c216e7a$export$7eca133280843f9e = $5dd9c8d45c216e7a$var$fireEvent('ui');
const $5dd9c8d45c216e7a$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("7aG62", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsStore", () => $d628cf87a017ca8b$export$4e7a1c55cba5a168);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aQ1r6 = parcelRequire("aQ1r6");
var $2Ixyh = parcelRequire("2Ixyh");

var $lLdzw = parcelRequire("lLdzw");
const $d628cf87a017ca8b$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $2Ixyh.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $2Ixyh.teamsClient).getPermissions();
                dispatch($d628cf87a017ca8b$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($d628cf87a017ca8b$var$actions.setError(error instanceof (0, $aQ1r6.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $lLdzw.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $d628cf87a017ca8b$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $d628cf87a017ca8b$var$actions,
    name: 'teams-permissions'
});
const $d628cf87a017ca8b$export$4e7a1c55cba5a168 = (0, $3sQ5x.createHook)($d628cf87a017ca8b$var$Store);

});
parcelRegister("aQ1r6", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $551760e785e1235d$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $551760e785e1235d$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $551760e785e1235d$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $551760e785e1235d$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $551760e785e1235d$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $551760e785e1235d$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $551760e785e1235d$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $551760e785e1235d$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $551760e785e1235d$export$476aa014e2fd89d5);
var $551760e785e1235d$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $551760e785e1235d$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $551760e785e1235d$export$cde1786a482f9a1c(error) {
    return $551760e785e1235d$export$9677d7c364ada66c(401, error) || $551760e785e1235d$export$9677d7c364ada66c(403, error);
}
function $551760e785e1235d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $551760e785e1235d$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $551760e785e1235d$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $551760e785e1235d$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $551760e785e1235d$export$c73ca302efeda3b4 extends $551760e785e1235d$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $551760e785e1235d$export$c73ca302efeda3b4.prototype);
    }
}
class $551760e785e1235d$export$d87f401f8106d7a2 extends $551760e785e1235d$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $551760e785e1235d$export$d87f401f8106d7a2.prototype);
    }
}
class $551760e785e1235d$export$65bd6083489bd8bb extends $551760e785e1235d$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $551760e785e1235d$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $551760e785e1235d$export$826a3d65b8435adf extends $551760e785e1235d$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $551760e785e1235d$export$826a3d65b8435adf.prototype);
    }
}
class $551760e785e1235d$export$92d6ed0888e7cb7f extends $551760e785e1235d$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $551760e785e1235d$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $551760e785e1235d$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $551760e785e1235d$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("2Ixyh", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $ab9aaf1ad4d000ff$export$5ed932c3646b89c6);

var $hwEjR = parcelRequire("hwEjR");

var $hh91N = parcelRequire("hh91N");

var $iP2rx = parcelRequire("iP2rx");

var $b588f = parcelRequire("b588f");

var $7J53V = parcelRequire("7J53V");

var $anvms = parcelRequire("anvms");

var $6TUmh = parcelRequire("6TUmh");

var $35qDI = parcelRequire("35qDI");

var $9hFON = parcelRequire("9hFON");

var $61gA0 = parcelRequire("61gA0");

var $cSkc1 = parcelRequire("cSkc1");

var $8GxHN = parcelRequire("8GxHN");

var $ee0JC = parcelRequire("ee0JC");
class $ab9aaf1ad4d000ff$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $hh91N.aggClient);
        this._directoryClient = (0, $b588f.directoryClient);
        this._legionClient = (0, $6TUmh.defaultLegionClient);
        this._mutabilityClient = (0, $35qDI.default);
        this._permsClient = (0, $61gA0.default);
        this._publicApiClient = (0, $cSkc1.default);
        this._invitationsClient = (0, $anvms.default);
        this._userPreferencesClient = (0, $ee0JC.default);
        this._objectResolverClient = (0, $9hFON.default);
        this._teamsInSlackClient = (0, $8GxHN.default);
        this._collaborationGraphClient = (0, $iP2rx.default);
        this._identityClient = (0, $7J53V.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $hwEjR.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) this.setContext({
            cloudId: cloudId
        });
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
}
const $ab9aaf1ad4d000ff$export$5ed932c3646b89c6 = new $ab9aaf1ad4d000ff$export$db59823f35bf78ce();

});
parcelRegister("hwEjR", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $abbaf475a35076c2$export$879344107b04120c);

var $2DPlK = parcelRequire("2DPlK");

var $6tKtB = parcelRequire("6tKtB");
const $abbaf475a35076c2$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack'
];
const $abbaf475a35076c2$export$879344107b04120c = new Map([
    ...$abbaf475a35076c2$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $6tKtB.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $2DPlK.ExperienceTypes).Operation,
                performanceType: (0, $2DPlK.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("6tKtB", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $12fa0c98ffbda9ea$export$9a18529d1e90e81a);

var $88I8J = parcelRequire("88I8J");

var $aQ1r6 = parcelRequire("aQ1r6");

var $bc7vO = parcelRequire("bc7vO");
class $12fa0c98ffbda9ea$export$9a18529d1e90e81a extends (0, $88I8J.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $bc7vO.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $aQ1r6.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $aQ1r6.isErrorStatusCode)((0, $aQ1r6.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $bc7vO.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $aQ1r6.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $bc7vO.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("bc7vO", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $4749946037e36f80$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $4749946037e36f80$export$a8da197a8bcc7e95);

var $aQ1r6 = parcelRequire("aQ1r6");
const $4749946037e36f80$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $aQ1r6.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $aQ1r6.HttpError) ? error.status : undefined
        }
    });
const $4749946037e36f80$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $4749946037e36f80$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $4749946037e36f80$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("hh91N", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $a9bc48e9e7ef30bf$export$464c991dbf0b2393);

var $64Ivq = parcelRequire("64Ivq");

var $baA0M = parcelRequire("baA0M");

var $9redt = parcelRequire("9redt");

var $jP0Fy = parcelRequire("jP0Fy");

var $89hNI = parcelRequire("89hNI");

var $faC2N = parcelRequire("faC2N");

var $hgkgf = parcelRequire("hgkgf");
class $a9bc48e9e7ef30bf$export$b44e5dafe13af7b3 extends (0, $9redt.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $89hNI.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $64Ivq.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $64Ivq.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $hgkgf.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $faC2N.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
}
const $a9bc48e9e7ef30bf$export$464c991dbf0b2393 = new $a9bc48e9e7ef30bf$export$b44e5dafe13af7b3((0, $baA0M.DEFAULT_CONFIG).stargateRoot, {
    logException: $jP0Fy.logException
});

});
parcelRegister("64Ivq", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $0dc9a2d1b1790ce3$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toTeamARI", () => $0dc9a2d1b1790ce3$export$2bcc6e4924859c6f);

const $0dc9a2d1b1790ce3$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $a02f5f6d1e9873aa$export$470b0d72e4fdc43a));
const $0dc9a2d1b1790ce3$export$1d0eef1d33b05366 = (ari)=>{
    if ($0dc9a2d1b1790ce3$export$caac29844ad91f64(ari)) return ari.replace((0, $a02f5f6d1e9873aa$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $0dc9a2d1b1790ce3$export$fca6a88adb58674a = (userId)=>{
    return $0dc9a2d1b1790ce3$export$caac29844ad91f64(userId) ? userId : `${0, $a02f5f6d1e9873aa$export$470b0d72e4fdc43a}${userId}`;
};
const $0dc9a2d1b1790ce3$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $a02f5f6d1e9873aa$export$cfedc369802e0c68));
const $0dc9a2d1b1790ce3$export$e78216c959b9f3af = (ari)=>{
    if ($0dc9a2d1b1790ce3$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $a02f5f6d1e9873aa$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $0dc9a2d1b1790ce3$export$2bcc6e4924859c6f = (teamId)=>{
    return $0dc9a2d1b1790ce3$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $a02f5f6d1e9873aa$export$cfedc369802e0c68}${teamId}`;
};

});
const $a02f5f6d1e9873aa$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $a02f5f6d1e9873aa$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("baA0M", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $a561a1744704bd62$export$c2f8e0cc249a8d8f);
const $a561a1744704bd62$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("9redt", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $4605e9f1dbc653a4$export$42f6d6baced34b2d);

var $aQ1r6 = parcelRequire("aQ1r6");

var $fNgdz = parcelRequire("fNgdz");

var $hB3Gq = parcelRequire("hB3Gq");
class $4605e9f1dbc653a4$export$42f6d6baced34b2d extends (0, $fNgdz.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $hB3Gq.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $aQ1r6.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $aQ1r6.DefaultError)({});
        }
    }
}

});
parcelRegister("fNgdz", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $c74c5ef9f0584636$export$4f22f74eddb7716a);

var $jP0Fy = parcelRequire("jP0Fy");
class $c74c5ef9f0584636$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $jP0Fy.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("jP0Fy", function(module, exports) {

$parcel$export(module.exports, "logException", () => $96b1e2fb578cfd91$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $96b1e2fb578cfd91$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $96b1e2fb578cfd91$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $96b1e2fb578cfd91$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $96b1e2fb578cfd91$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $96b1e2fb578cfd91$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $96b1e2fb578cfd91$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $96b1e2fb578cfd91$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $chKb5 = parcelRequire("chKb5");
function $96b1e2fb578cfd91$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $96b1e2fb578cfd91$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $chKb5.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $96b1e2fb578cfd91$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $96b1e2fb578cfd91$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $chKb5.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $96b1e2fb578cfd91$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $96b1e2fb578cfd91$export$ece28f5cfa04608(message, context = {}) {
    $96b1e2fb578cfd91$var$logMessage('error', message, context).catch(()=>{});
}
function $96b1e2fb578cfd91$export$386587bcf05ee8ea(message, context = {}) {
    $96b1e2fb578cfd91$var$logMessage('info', message, context).catch(()=>{});
}
const $96b1e2fb578cfd91$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $96b1e2fb578cfd91$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $96b1e2fb578cfd91$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $96b1e2fb578cfd91$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $96b1e2fb578cfd91$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $96b1e2fb578cfd91$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $96b1e2fb578cfd91$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $96b1e2fb578cfd91$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $96b1e2fb578cfd91$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$96b1e2fb578cfd91$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $96b1e2fb578cfd91$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $chKb5.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("chKb5", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $45d9c4622f953154$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $45d9c4622f953154$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $45d9c4622f953154$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $45d9c4622f953154$export$d8bd0edf6c978788);

var $1RZxF = parcelRequire("1RZxF");

var $6BnaC = parcelRequire("6BnaC");
let $45d9c4622f953154$export$ac71c212168fcd2b;
const $45d9c4622f953154$export$7d446c6f4e54de82 = (client)=>{
    $45d9c4622f953154$export$ac71c212168fcd2b = client;
};
const $45d9c4622f953154$export$f553e8b08ef59d31 = async ()=>{
    if (!$45d9c4622f953154$export$ac71c212168fcd2b) await $45d9c4622f953154$export$d8bd0edf6c978788({});
    return $45d9c4622f953154$export$ac71c212168fcd2b;
};
async function $45d9c4622f953154$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $45d9c4622f953154$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $6BnaC.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $45d9c4622f953154$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $1RZxF.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $45d9c4622f953154$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("2Skbu"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $45d9c4622f953154$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("1RZxF", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $060728f43b7dcc88$export$6faa4a850bc4d0ce);

var $b4PzF = parcelRequire("b4PzF");
const $060728f43b7dcc88$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $060728f43b7dcc88$export$68c35ed3898e185a = '5988845';
const $060728f43b7dcc88$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $060728f43b7dcc88$export$97db6664a1e55fa6 = '47';
const $060728f43b7dcc88$var$SENTRY_COMMERCIAL_DSN = `https://${$060728f43b7dcc88$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$060728f43b7dcc88$export$68c35ed3898e185a}`;
const $060728f43b7dcc88$var$SENTRY_FEDRAMP_DSN = `https://${$060728f43b7dcc88$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$060728f43b7dcc88$export$97db6664a1e55fa6}`;
const $060728f43b7dcc88$export$6faa4a850bc4d0ce = (0, $b4PzF.isFedRamp)() ? $060728f43b7dcc88$var$SENTRY_FEDRAMP_DSN : $060728f43b7dcc88$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("6BnaC", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $eafee94b36a68431$export$357606956af25316);

var $eqG4a = parcelRequire("eqG4a");

var $chKb5 = parcelRequire("chKb5");
const $eafee94b36a68431$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $eafee94b36a68431$export$357606956af25316(client, options) {
    if (0, $chKb5.sentryClient) return;
    if (!client) return;
    (0, $chKb5.setSentryClient)(client);
    const sentryConfig = (0, $eqG4a.getSentryConfig)(options);
    (0, $chKb5.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $eafee94b36a68431$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("eqG4a", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $ad3540171fbf5dde$export$5580e6304e95c792);

var $1RZxF = parcelRequire("1RZxF");
const $ad3540171fbf5dde$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $1RZxF.SENTRY_DSN),
    attachStacktrace: true
};
function $ad3540171fbf5dde$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$ad3540171fbf5dde$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("2Skbu", function(module, exports) {

let $218048172b0d3488$var$load = (parcelRequire("28QjX"))(4);
module.exports = $218048172b0d3488$var$load("hy6uh").then(()=>parcelRequire('bbj0o'));

});




parcelRegister("hB3Gq", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $9ae83c72f27fe801$export$7feffc86760ee7ce);

var $aQ1r6 = parcelRequire("aQ1r6");

var $j3BP9 = parcelRequire("j3BP9");

var $azoDc = parcelRequire("azoDc");
async function $9ae83c72f27fe801$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $aQ1r6.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $aQ1r6.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $9ae83c72f27fe801$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $j3BP9.withExponentialBackoff)($9ae83c72f27fe801$export$93d33e3b46bf00e7, {
        initial: (0, $j3BP9.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $j3BP9.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $j3BP9.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $j3BP9.isFetchResponse)(data) && (0, $j3BP9.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $azoDc.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $aQ1r6.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("j3BP9", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $b610b6a4ef88ae07$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $b610b6a4ef88ae07$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $b610b6a4ef88ae07$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $b610b6a4ef88ae07$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $b610b6a4ef88ae07$export$b4c0bf5325504bf3);
const $b610b6a4ef88ae07$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $b610b6a4ef88ae07$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $b610b6a4ef88ae07$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $b610b6a4ef88ae07$var$defaultRetryIfCallback = (a)=>!a;
const $b610b6a4ef88ae07$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $b610b6a4ef88ae07$var$defaultRetryIfCallback
};
function $b610b6a4ef88ae07$export$20eaa22f2295996f(toTry, hofOptions = $b610b6a4ef88ae07$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $b610b6a4ef88ae07$export$b4c0bf5325504bf3 = $b610b6a4ef88ae07$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $b610b6a4ef88ae07$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $b610b6a4ef88ae07$export$8f4286bf21155381.JITTER,
    max: $b610b6a4ef88ae07$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$b610b6a4ef88ae07$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("azoDc", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $a42e851a738eb262$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $a42e851a738eb262$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $a42e851a738eb262$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $a42e851a738eb262$export$8c005e458e12d501.handlers = handlers;
    }
};
function $a42e851a738eb262$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $a42e851a738eb262$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("89hNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c3c0fa30ff64e1$export$2e2bcd8739ae039);
const $06c3c0fa30ff64e1$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $06c3c0fa30ff64e1$export$2e2bcd8739ae039 = $06c3c0fa30ff64e1$var$TeamMembershipQuery;

});

parcelRegister("faC2N", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $313483e55cd4159b$export$9963ed3cbf7b791c);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $313483e55cd4159b$export$9963ed3cbf7b791c = (0, $1c8Um.print)((0, $5cllN.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("hgkgf", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $61f7b56f01268d5f$export$6b53fef091c7e27d);
function $61f7b56f01268d5f$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("iP2rx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9227276d931e9911$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
var $9227276d931e9911$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($9227276d931e9911$var$CONTAINER_TYPE || {});
var $9227276d931e9911$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($9227276d931e9911$var$ENTITY_TYPE || {});
class $9227276d931e9911$export$cd5b4a06db0ea4e2 extends (0, $jKOLC.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $9227276d931e9911$export$2e2bcd8739ae039 = new $9227276d931e9911$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $baA0M.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("jKOLC", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $629d4cff8dcaedb0$export$ea8b5b3aea9558ce);

var $bxYf9 = parcelRequire("bxYf9");

var $aQ1r6 = parcelRequire("aQ1r6");

var $j3BP9 = parcelRequire("j3BP9");

var $azoDc = parcelRequire("azoDc");

var $fNgdz = parcelRequire("fNgdz");

var $8GfwS = parcelRequire("8GfwS");

var $5k2Qs = parcelRequire("5k2Qs");

var $1a2Op = parcelRequire("1a2Op");

var $f6KYz = parcelRequire("f6KYz");
const $629d4cff8dcaedb0$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $629d4cff8dcaedb0$var$incrementRedirectCount;
let $629d4cff8dcaedb0$var$clearRedirectCount;
$629d4cff8dcaedb0$export$7a0fc52d8c359feb();
function $629d4cff8dcaedb0$export$7a0fc52d8c359feb() {
    $629d4cff8dcaedb0$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $8GfwS.setCookie)((0, $8GfwS.REDIRECT_COUNT), (0, $8GfwS.getCookieAsInteger)((0, $8GfwS.REDIRECT_COUNT)) + 1));
    $629d4cff8dcaedb0$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $8GfwS.clearCookie)((0, $8GfwS.REDIRECT_COUNT)));
}
class $629d4cff8dcaedb0$export$ea8b5b3aea9558ce extends (0, $fNgdz.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $629d4cff8dcaedb0$var$incrementRedirectCount();
            } else $629d4cff8dcaedb0$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$629d4cff8dcaedb0$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $j3BP9.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $azoDc.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $aQ1r6.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $5k2Qs.parseErrorMessage)(response);
                const httpError = new (0, $aQ1r6.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $f6KYz.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $1a2Op.parseResponse)(response);
    }
}

});
parcelRegister("8GfwS", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $8ab8184007f2458c$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $8ab8184007f2458c$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $8ab8184007f2458c$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $8ab8184007f2458c$export$ad3506281d5a5e5d);
const $8ab8184007f2458c$export$f6101897f0230549 = 'redirectCount';
const $8ab8184007f2458c$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $8ab8184007f2458c$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $8ab8184007f2458c$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $8ab8184007f2458c$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("5k2Qs", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $ac8015bf09e207cd$export$91c32f1b22d29b2d);
async function $ac8015bf09e207cd$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("1a2Op", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $4ebfd5a32a6c41d6$export$ba14d9a5a581e827);
function $4ebfd5a32a6c41d6$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("f6KYz", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $2d44e113a02fcfb8$export$6bd073e2c6dda996);
const $2d44e113a02fcfb8$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $2d44e113a02fcfb8$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($2d44e113a02fcfb8$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("b588f", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $38786afdafa4bba7$export$ead519165de472de);

var $baA0M = parcelRequire("baA0M");

var $9redt = parcelRequire("9redt");

var $jP0Fy = parcelRequire("jP0Fy");
const $38786afdafa4bba7$export$28456d095a642fd = 'internal.browse-users-allowed';
const $38786afdafa4bba7$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $38786afdafa4bba7$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $38786afdafa4bba7$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $38786afdafa4bba7$export$c8a50bf6c196fc10 extends (0, $9redt.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $38786afdafa4bba7$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $38786afdafa4bba7$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $38786afdafa4bba7$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $38786afdafa4bba7$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $38786afdafa4bba7$export$ead519165de472de = new $38786afdafa4bba7$export$c8a50bf6c196fc10((0, $baA0M.DEFAULT_CONFIG).stargateRoot, {
    logException: $jP0Fy.logException
});

});

parcelRegister("7J53V", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e9e89d3e27fc84$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");

var $8voKJ = parcelRequire("8voKJ");
const $51e9e89d3e27fc84$var$defaultConfig = {
    serviceUrl: `${(0, $baA0M.DEFAULT_CONFIG).stargateRoot}/users`
};
class $51e9e89d3e27fc84$export$f9c003efee04f318 extends (0, $jKOLC.RestClient) {
    constructor(config = {}){
        super({
            ...$51e9e89d3e27fc84$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $8voKJ.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $8voKJ.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $8voKJ.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $51e9e89d3e27fc84$export$2e2bcd8739ae039 = new $51e9e89d3e27fc84$export$f9c003efee04f318();

});
parcelRegister("8voKJ", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $c3067dc85ba2cff0$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $c3067dc85ba2cff0$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $c3067dc85ba2cff0$export$80d19edb7b1ae293);
parcelRequire("cyhaj");
var $hFVwU = parcelRequire("hFVwU");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $c3067dc85ba2cff0$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $c3067dc85ba2cff0$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $c3067dc85ba2cff0$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $hFVwU.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($c3067dc85ba2cff0$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($c3067dc85ba2cff0$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$c3067dc85ba2cff0$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($c3067dc85ba2cff0$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($c3067dc85ba2cff0$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$c3067dc85ba2cff0$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $c3067dc85ba2cff0$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $c3067dc85ba2cff0$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $c3067dc85ba2cff0$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $c3067dc85ba2cff0$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $c3067dc85ba2cff0$export$2ff7b92b9e1bb4d2[field]) return data[$c3067dc85ba2cff0$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $c3067dc85ba2cff0$export$78158d2c2c6998d9 ? $c3067dc85ba2cff0$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $c3067dc85ba2cff0$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($c3067dc85ba2cff0$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $c3067dc85ba2cff0$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $c3067dc85ba2cff0$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $c3067dc85ba2cff0$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $c3067dc85ba2cff0$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($c3067dc85ba2cff0$export$78158d2c2c6998d9).map((field)=>$c3067dc85ba2cff0$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $c3067dc85ba2cff0$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($c3067dc85ba2cff0$var$PROFILE_PROPS_MAP.has(key)) output[$c3067dc85ba2cff0$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($c3067dc85ba2cff0$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$c3067dc85ba2cff0$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $c3067dc85ba2cff0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("cyhaj", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("hFVwU")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $hFVwU = parcelRequire("hFVwU");





});
parcelRegister("hFVwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde2e43576534c84$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $jMWHS = parcelRequire("jMWHS");

var $h72dw = parcelRequire("h72dw");
function $cde2e43576534c84$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $jMWHS.default)((0, $h72dw.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("jMWHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68009eed86f9c79$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $3ZyiR = parcelRequire("3ZyiR");

var $7knci = parcelRequire("7knci");
var $e68009eed86f9c79$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $e68009eed86f9c79$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($e68009eed86f9c79$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $7knci.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $3ZyiR.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("3ZyiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e81ad7d1ff4d95f$export$2e2bcd8739ae039);

var $7bfIT = parcelRequire("7bfIT");

var $ckX8H = parcelRequire("ckX8H");
var $2e81ad7d1ff4d95f$var$MILLISECONDS_IN_MINUTE = 60000;
var $2e81ad7d1ff4d95f$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $2e81ad7d1ff4d95f$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2e81ad7d1ff4d95f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $2e81ad7d1ff4d95f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2e81ad7d1ff4d95f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $2e81ad7d1ff4d95f$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2e81ad7d1ff4d95f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $2e81ad7d1ff4d95f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2e81ad7d1ff4d95f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $2e81ad7d1ff4d95f$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2e81ad7d1ff4d95f$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2e81ad7d1ff4d95f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $7bfIT.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $7bfIT.default)('long', date, options);
        }
    }
};
function $2e81ad7d1ff4d95f$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $ckX8H.default)(timeZone, originalDate, true) / $2e81ad7d1ff4d95f$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $2e81ad7d1ff4d95f$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $2e81ad7d1ff4d95f$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $2e81ad7d1ff4d95f$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $2e81ad7d1ff4d95f$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $2e81ad7d1ff4d95f$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $2e81ad7d1ff4d95f$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $2e81ad7d1ff4d95f$var$formatTimezone(offset, dirtyDelimeter);
}
function $2e81ad7d1ff4d95f$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $2e81ad7d1ff4d95f$var$addLeadingZeros(minutes, 2);
}
var $2e81ad7d1ff4d95f$export$2e2bcd8739ae039 = $2e81ad7d1ff4d95f$var$formatters;

});
parcelRegister("7bfIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a5c1c278a347f4$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $53a5c1c278a347f4$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $53a5c1c278a347f4$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $53a5c1c278a347f4$var$partsTimeZone(dtf, date) : $53a5c1c278a347f4$var$hackyTimeZone(dtf, date);
}
function $53a5c1c278a347f4$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $53a5c1c278a347f4$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $53a5c1c278a347f4$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("ckX8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb53a24a9e4b8ec$export$2e2bcd8739ae039);

var $57VM6 = parcelRequire("57VM6");

var $doLCU = parcelRequire("doLCU");
var $8fb53a24a9e4b8ec$var$MILLISECONDS_IN_HOUR = 3600000;
var $8fb53a24a9e4b8ec$var$MILLISECONDS_IN_MINUTE = 60000;
var $8fb53a24a9e4b8ec$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $8fb53a24a9e4b8ec$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $8fb53a24a9e4b8ec$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $8fb53a24a9e4b8ec$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$8fb53a24a9e4b8ec$var$validateTimezone(hours)) return NaN;
        return -(hours * $8fb53a24a9e4b8ec$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $8fb53a24a9e4b8ec$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$8fb53a24a9e4b8ec$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $8fb53a24a9e4b8ec$var$MILLISECONDS_IN_HOUR + minutes * $8fb53a24a9e4b8ec$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($8fb53a24a9e4b8ec$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $8fb53a24a9e4b8ec$var$toUtcDate(date);
        var offset = $8fb53a24a9e4b8ec$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $8fb53a24a9e4b8ec$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $8fb53a24a9e4b8ec$var$toUtcDate(date) {
    return (0, $doLCU.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $8fb53a24a9e4b8ec$var$calcOffset(date, timezoneString) {
    var tokens = (0, $57VM6.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $doLCU.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $8fb53a24a9e4b8ec$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $8fb53a24a9e4b8ec$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $8fb53a24a9e4b8ec$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $8fb53a24a9e4b8ec$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $8fb53a24a9e4b8ec$var$validIANATimezoneCache = {};
function $8fb53a24a9e4b8ec$var$isValidTimezoneIANAString(timeZoneString) {
    if ($8fb53a24a9e4b8ec$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $8fb53a24a9e4b8ec$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("57VM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bba6c17ea1a68a8$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $3bba6c17ea1a68a8$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $3bba6c17ea1a68a8$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $3bba6c17ea1a68a8$var$partsOffset(dtf, date) : $3bba6c17ea1a68a8$var$hackyOffset(dtf, date);
}
var $3bba6c17ea1a68a8$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $3bba6c17ea1a68a8$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $3bba6c17ea1a68a8$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $3bba6c17ea1a68a8$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $3bba6c17ea1a68a8$var$dtfCache = {};
function $3bba6c17ea1a68a8$var$getDateTimeFormat(timeZone) {
    if (!$3bba6c17ea1a68a8$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $3bba6c17ea1a68a8$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $3bba6c17ea1a68a8$var$dtfCache[timeZone];
}

});

parcelRegister("doLCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c1275e5dfced318$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $9c1275e5dfced318$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("7knci", function(module, exports) {

$parcel$export(module.exports, "default", () => $555c6529b392a29e$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $ckX8H = parcelRequire("ckX8H");

var $cbXrB = parcelRequire("cbXrB");
var $555c6529b392a29e$var$MILLISECONDS_IN_HOUR = 3600000;
var $555c6529b392a29e$var$MILLISECONDS_IN_MINUTE = 60000;
var $555c6529b392a29e$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $555c6529b392a29e$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cbXrB.default)
};
function $555c6529b392a29e$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $555c6529b392a29e$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $555c6529b392a29e$var$splitDateString(argument);
    var parseYearResult = $555c6529b392a29e$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $555c6529b392a29e$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $555c6529b392a29e$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $ckX8H.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $555c6529b392a29e$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $555c6529b392a29e$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $555c6529b392a29e$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $555c6529b392a29e$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $555c6529b392a29e$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $555c6529b392a29e$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $555c6529b392a29e$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $555c6529b392a29e$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $555c6529b392a29e$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $555c6529b392a29e$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $555c6529b392a29e$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$555c6529b392a29e$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $555c6529b392a29e$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$555c6529b392a29e$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $555c6529b392a29e$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$555c6529b392a29e$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $555c6529b392a29e$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$555c6529b392a29e$var$validateWeekDate(year, week)) return new Date(NaN);
        return $555c6529b392a29e$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $555c6529b392a29e$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$555c6529b392a29e$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $555c6529b392a29e$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $555c6529b392a29e$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $555c6529b392a29e$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$555c6529b392a29e$var$validateTime(hours)) return NaN;
        return hours % 24 * $555c6529b392a29e$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $555c6529b392a29e$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$555c6529b392a29e$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $555c6529b392a29e$var$MILLISECONDS_IN_HOUR + minutes * $555c6529b392a29e$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $555c6529b392a29e$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$555c6529b392a29e$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $555c6529b392a29e$var$MILLISECONDS_IN_HOUR + minutes * $555c6529b392a29e$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $555c6529b392a29e$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $555c6529b392a29e$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $555c6529b392a29e$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $555c6529b392a29e$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $555c6529b392a29e$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $555c6529b392a29e$var$isLeapYearIndex(year);
        if (isLeapYear && date > $555c6529b392a29e$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $555c6529b392a29e$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $555c6529b392a29e$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $555c6529b392a29e$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $555c6529b392a29e$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $555c6529b392a29e$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cbXrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e049f7a23bc9cb0$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $8e049f7a23bc9cb0$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $8e049f7a23bc9cb0$export$2e2bcd8739ae039 = $8e049f7a23bc9cb0$var$tzPattern;

});



parcelRegister("h72dw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c754cf63d091ee50$export$2e2bcd8739ae039);

var $ckX8H = parcelRequire("ckX8H");

var $7knci = parcelRequire("7knci");
function $c754cf63d091ee50$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $7knci.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $ckX8H.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("anvms", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67d7e85dc944e67$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");

var $jP0Fy = parcelRequire("jP0Fy");

var $czeGv = parcelRequire("czeGv");
const $b67d7e85dc944e67$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $b67d7e85dc944e67$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $b67d7e85dc944e67$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $b67d7e85dc944e67$export$3209eb31343f39d extends (0, $jKOLC.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $b67d7e85dc944e67$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $b67d7e85dc944e67$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$b67d7e85dc944e67$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $b67d7e85dc944e67$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $czeGv.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($b67d7e85dc944e67$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$b67d7e85dc944e67$export$2e2bcd8739ae039 = new $b67d7e85dc944e67$export$3209eb31343f39d((0, $baA0M.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $jP0Fy.logException
});

});
parcelRegister("czeGv", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $d6fcccb298ddf06d$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $d6fcccb298ddf06d$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $d6fcccb298ddf06d$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $d6fcccb298ddf06d$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($d6fcccb298ddf06d$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($d6fcccb298ddf06d$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($d6fcccb298ddf06d$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($d6fcccb298ddf06d$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $d6fcccb298ddf06d$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $d6fcccb298ddf06d$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $d6fcccb298ddf06d$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($d6fcccb298ddf06d$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($d6fcccb298ddf06d$var$toRecommendation)
        }
    };
};

});


parcelRegister("6TUmh", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $d8593f840b59b32a$export$95c697fe95d86a77);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
const $d8593f840b59b32a$var$v3UrlPath = `/v3/teams`;
const $d8593f840b59b32a$var$v4UrlPath = `/v4/teams`;
class $d8593f840b59b32a$export$68a6a391e3cf23be extends (0, $jKOLC.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$d8593f840b59b32a$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$d8593f840b59b32a$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$d8593f840b59b32a$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$d8593f840b59b32a$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$d8593f840b59b32a$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$d8593f840b59b32a$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$d8593f840b59b32a$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$d8593f840b59b32a$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$d8593f840b59b32a$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$d8593f840b59b32a$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$d8593f840b59b32a$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$d8593f840b59b32a$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$d8593f840b59b32a$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $d8593f840b59b32a$export$95c697fe95d86a77 = new $d8593f840b59b32a$export$68a6a391e3cf23be((0, $baA0M.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("35qDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d6444ce38f12b7$export$2e2bcd8739ae039);

var $aQ1r6 = parcelRequire("aQ1r6");

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
const $b7d6444ce38f12b7$var$defaultConfig = {
    serviceUrl: `${(0, $baA0M.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $b7d6444ce38f12b7$var$NOT_EDITABLE = 'not_editable';
const $b7d6444ce38f12b7$var$NOT_EDITABLE_FIELD = 'field';
const $b7d6444ce38f12b7$var$NOT_EDITABLE_REASON = 'reason';
class $b7d6444ce38f12b7$export$1f387592ab3ca6d0 extends (0, $jKOLC.RestClient) {
    constructor(config = {}){
        super({
            ...$b7d6444ce38f12b7$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $b7d6444ce38f12b7$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $b7d6444ce38f12b7$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$b7d6444ce38f12b7$var$NOT_EDITABLE] != null) for (const value of json[$b7d6444ce38f12b7$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$b7d6444ce38f12b7$var$NOT_EDITABLE_FIELD],
        reason: $b7d6444ce38f12b7$var$determineReason(value[$b7d6444ce38f12b7$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $b7d6444ce38f12b7$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $aQ1r6.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$b7d6444ce38f12b7$export$2e2bcd8739ae039 = new $b7d6444ce38f12b7$export$1f387592ab3ca6d0();

});

parcelRegister("9hFON", function(module, exports) {

$parcel$export(module.exports, "default", () => $95366a1134c82c09$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");

var $deCiP = parcelRequire("deCiP");
const $95366a1134c82c09$var$defaultConfig = {
    serviceUrl: `${(0, $baA0M.DEFAULT_CONFIG).stargateRoot}`
};
class $95366a1134c82c09$export$a78b00aedb6cb3e9 extends (0, $jKOLC.RestClient) {
    constructor(config = {}){
        super({
            ...$95366a1134c82c09$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $deCiP.transformIconData));
    }
}
var $95366a1134c82c09$export$2e2bcd8739ae039 = new $95366a1134c82c09$export$a78b00aedb6cb3e9();

});
parcelRegister("deCiP", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $51b8b4f4b38ba14e$export$39f4468adf4cb57c);

var $7RSWK = parcelRequire("7RSWK");
const $51b8b4f4b38ba14e$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $7RSWK.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $51b8b4f4b38ba14e$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $7RSWK.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $51b8b4f4b38ba14e$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $51b8b4f4b38ba14e$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $51b8b4f4b38ba14e$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($51b8b4f4b38ba14e$var$isIconItemSuccess).map((resp)=>resp.body.data).map($51b8b4f4b38ba14e$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $51b8b4f4b38ba14e$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $51b8b4f4b38ba14e$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("7RSWK", function(module, exports) {

$parcel$export(module.exports, "ProviderNames", () => $0cd175c86beee789$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $0cd175c86beee789$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("61gA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $866921238fe0312e$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
class $866921238fe0312e$export$23820d8d740dd467 extends (0, $jKOLC.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$866921238fe0312e$export$2e2bcd8739ae039 = new $866921238fe0312e$export$23820d8d740dd467({
    serviceUrl: (0, $baA0M.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("cSkc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $48173d0ad07e1fdf$export$2e2bcd8739ae039);

var $aQ1r6 = parcelRequire("aQ1r6");

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
const $48173d0ad07e1fdf$var$V1_URL = '/teams/v1';
const $48173d0ad07e1fdf$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $48173d0ad07e1fdf$export$38575d07403d67c extends (0, $jKOLC.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$48173d0ad07e1fdf$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $aQ1r6.HttpError) && $48173d0ad07e1fdf$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $aQ1r6.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$48173d0ad07e1fdf$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$48173d0ad07e1fdf$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$48173d0ad07e1fdf$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$48173d0ad07e1fdf$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$48173d0ad07e1fdf$export$2e2bcd8739ae039 = new $48173d0ad07e1fdf$export$38575d07403d67c((0, $baA0M.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("8GxHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7668a96b8c6dcbf2$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
const $7668a96b8c6dcbf2$var$defaultConfig = {
    serviceUrl: `${(0, $baA0M.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $7668a96b8c6dcbf2$export$9509cbc6b0605446 extends (0, $jKOLC.RestClient) {
    constructor(config = {}){
        super({
            ...$7668a96b8c6dcbf2$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $7668a96b8c6dcbf2$export$2e2bcd8739ae039 = new $7668a96b8c6dcbf2$export$9509cbc6b0605446();

});

parcelRegister("ee0JC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fcb50ebadbaa92c$export$2e2bcd8739ae039);

var $baA0M = parcelRequire("baA0M");

var $jKOLC = parcelRequire("jKOLC");
const $9fcb50ebadbaa92c$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $9fcb50ebadbaa92c$export$3c27e20d1b94924 extends (0, $jKOLC.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($9fcb50ebadbaa92c$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $9fcb50ebadbaa92c$export$2e2bcd8739ae039 = new $9fcb50ebadbaa92c$export$3c27e20d1b94924({
    serviceUrl: (0, $baA0M.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("lLdzw", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $4d2b0d44e951f245$export$7fe0bfa353103198);
const $4d2b0d44e951f245$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("8OsWE", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $6d7c77375402e3a6$export$c6e6fe52d34907dc);
var $6d7c77375402e3a6$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("2Xf08", function(module, exports) {

$parcel$export(module.exports, "useNudgeController", () => $ef501231c9f22c28$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $ef501231c9f22c28$export$eb8a96124d659f2d);

var $5uXOq = parcelRequire("5uXOq");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $ef501231c9f22c28$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $ef501231c9f22c28$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
const $ef501231c9f22c28$export$9a533735412babca = ()=>$ef501231c9f22c28$var$NudgeController.instance;
const $ef501231c9f22c28$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $ef501231c9f22c28$export$9a533735412babca();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("2C9Mo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e623eab643fff0d2$export$2e2bcd8739ae039);
// export main component

var $a3wrb = parcelRequire("a3wrb");
var $e623eab643fff0d2$export$2e2bcd8739ae039 = (0, $a3wrb.default);

});
parcelRegister("a3wrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $62fcf2d9fba0c4d9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");

var $2uT3N = parcelRequire("2uT3N");

var $vCqQa = parcelRequire("vCqQa");

var $iNxf2 = parcelRequire("iNxf2");

var $jP9gu = parcelRequire("jP9gu");

var $cc0xQ = parcelRequire("cc0xQ");

var $ejWgu = parcelRequire("ejWgu");

var $lttJX = parcelRequire("lttJX");

var $fTi46 = parcelRequire("fTi46");

var $g32Gp = parcelRequire("g32Gp");

var $eMBQd = parcelRequire("eMBQd");

var $3Xscx = parcelRequire("3Xscx");

var $gQNaE = parcelRequire("gQNaE");
// if `@atlaskit/popup` is upgraded from 0.6.x to 1.x,
// we may need to change this to an array of numbers like [0, 12];.
const $62fcf2d9fba0c4d9$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
const $62fcf2d9fba0c4d9$var$eventuallyClearHoverMeasure = ()=>{
    setTimeout(()=>{
        (0, $ejWgu.clearMeasure)('hoverAndClick');
    }, 5 * $62fcf2d9fba0c4d9$var$SECOND);
};
const $62fcf2d9fba0c4d9$var$SECOND = 1000;
function $62fcf2d9fba0c4d9$export$b26ac1e1a63fbe24(props) {
    const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, $cc0xQ.VOID_FUNC) } = props;
    const [canPrefetch, setCanPrefetch] = (0, $5uXOq.useState)(false);
    const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, $cc0xQ.VOID_FUNC), renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent = false } = (0, $5uXOq.useContext)((0, $iNxf2.PeopleMenuContext));
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const closeMenu = (0, $5uXOq.useCallback)(()=>togglePeopleMenu(false), [
        togglePeopleMenu
    ]);
    const handleClickOnTriggerButton = (0, $5uXOq.useCallback)(()=>{
        onClick(!isPeopleMenuOpen);
        togglePeopleMenu(!isPeopleMenuOpen);
        // measure duration of click and show menu
        (0, $ejWgu.startMeasure)('clickAndShow');
        (0, $ejWgu.stopMeasure)('hoverAndClick', (duration, startTime)=>{
            (0, $lttJX.triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isPeopleMenuOpen,
        onClick,
        togglePeopleMenu
    ]);
    const handleMouseEnterTriggerButton = (0, $5uXOq.useCallback)(()=>{
        (0, $fTi46.MenuContent).preload();
        if (!canPrefetch) {
            setCanPrefetch(true);
            // measure duration time between hovering and clicking
            (0, $ejWgu.startMeasure)('hoverAndClick');
            // clear all unwanted hovering after 5 seconds
            $62fcf2d9fba0c4d9$var$eventuallyClearHoverMeasure();
        }
    }, [
        canPrefetch,
        setCanPrefetch
    ]);
    const buttonProps = {
        isSelected: isPeopleMenuOpen,
        onClick: handleClickOnTriggerButton,
        onMouseEnter: handleMouseEnterTriggerButton,
        testId: `${testId}-people-primary-button`,
        peopleText: peopleText
    };
    const PopupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $g32Gp.PeopleMenuContentInternal), {}), []);
    if (isSSR) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Xscx.PeopleMenuTriggerSSR), {
        testId: testId,
        peopleText: peopleText
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
                // @ts-ignore
                offset: isVisible ? undefined : $62fcf2d9fba0c4d9$var$OFFSET_FOR_MORE_BUTTON_VIEW,
                content: PopupContent,
                isOpen: isPeopleMenuOpen,
                placement: isVisible ? 'bottom-start' : 'right-start',
                onClose: closeMenu,
                shouldRenderToParent: shouldRenderToParent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Xscx.default), {
                        isVisible: isVisible,
                        isHighlighted: isHighlighted,
                        customChevronIcon: customChevronIcon,
                        triggerProps: triggerProps,
                        ...buttonProps
                    })
            }),
            enablePreFetchingByHovering && canPrefetch && (0, $jP9gu.isCachedDataClear)() && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gQNaE.UsersTeamsPreFetch), {
                cloudId: cloudId,
                orgId: orgId,
                userId: userId,
                product: product,
                tenantUrl: tenantUrl,
                renotifyExperiment: renotifyExperimentProps
            })
        ]
    });
}
const $62fcf2d9fba0c4d9$var$PeopleMenuInternalWithAnalytics = (0, $3TR0I.default)()($62fcf2d9fba0c4d9$export$b26ac1e1a63fbe24);
function $62fcf2d9fba0c4d9$export$2e2bcd8739ae039(props) {
    const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMBQd.default), {
        ...providerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($62fcf2d9fba0c4d9$var$PeopleMenuInternalWithAnalytics, {
            customChevronIcon: customChevronIcon,
            isHighlighted: isHighlighted,
            onClick: onClick,
            enablePreFetchingByHovering: enablePreFetchingByHovering,
            peopleText: peopleText
        })
    });
}

});
parcelRegister("iNxf2", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContext", () => $9bea95b1cc38c059$export$c92ff8b73313c89);
$parcel$export(module.exports, "PeopleMenuContextProvider", () => $9bea95b1cc38c059$export$4e812997de4564ae);
$parcel$export(module.exports, "usePeopleMenuContext", () => $9bea95b1cc38c059$export$c8d82c28669da5dc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $ihijj = parcelRequire("ihijj");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
parcelRequire("lttJX");
var $albme = parcelRequire("albme");

var $awaXD = parcelRequire("awaXD");

var $74T2L = parcelRequire("74T2L");

const $9bea95b1cc38c059$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("66X7a")).then((module)=>({
            default: module.ModalTransition
        })));

const $9bea95b1cc38c059$var$TeamCreateDialog = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("b6KyP")).then((module)=>({
            default: module.TeamCreateDialog
        })));
// this wrapper is for preventing changing layout of around elements
const $9bea95b1cc38c059$var$DialogWrapper = (0, $2s57o.xcss)({
    width: 'space.0',
    height: 'space.0',
    margin: '0',
    padding: '0',
    '::before': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    },
    '::after': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    }
});
const $9bea95b1cc38c059$var$analyticsAttrsTeamCreateDialog = {
    ref: (0, $albme.AnalyticsSource).PEOPLE_MENU
};
const $9bea95b1cc38c059$export$c92ff8b73313c89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    orgId: '',
    cloudId: '',
    userId: '',
    product: 'confluence',
    testId: '',
    isPeopleMenuOpen: false,
    isSSR: false,
    onClickedItem: ()=>undefined,
    pushRoute: ()=>undefined,
    togglePeopleMenu: ()=>undefined,
    toggleTeamCreateDialog: ()=>undefined,
    _hasError: undefined,
    teamCreateDialogProps: {},
    renotifyExperimentProps: {
        isLoading: false,
        isEnrolled: false
    },
    showRenotifyMessage: false,
    shouldRenderToParent: false,
    isSectionList: false
});
function $9bea95b1cc38c059$export$4e812997de4564ae(props) {
    const { isSSR: isSSR = false, cloudId: cloudId, renotifyExperimentProps: renotifyExperimentProps } = props;
    const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $5uXOq.useState)(false);
    const [renotifyDismissed, setRenotifyDismissed] = (0, $5uXOq.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(undefined);
    const [showRenotifyModal, setShowRenotifyModal] = (0, $5uXOq.useState)(false);
    const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
    const pendingUsersResponse = (0, $74T2L.usePendingUsers)({
        cloudId: cloudId,
        startFetching: isOpen,
        renotifyExperiment: renotifyExperimentProps,
        product: props?.product
    });
    const renotifyEligible = pendingUsersResponse.status === (0, $74T2L.RenotifyStatus).ELIGIBLE;
    const pendingUsers = renotifyEligible ? pendingUsersResponse.pendingUsers : undefined;
    const showRenotifyMessage = renotifyEligible && !renotifyDismissed;
    const togglePeopleMenu = (0, $5uXOq.useCallback)((newState)=>{
        if (newState === isOpen) return;
        if (newState) onOpen();
        else onClose();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const toggleTeamCreateDialog = (0, $5uXOq.useCallback)((isOpen)=>{
        toggleOpenTeamCreateDialog(isOpen);
    }, [
        toggleOpenTeamCreateDialog
    ]);
    const toggleRenotifyModal = (0, $5uXOq.useCallback)(()=>{
        setShowRenotifyModal((prevState)=>{
            return !prevState;
        });
    }, []);
    const values = (0, $5uXOq.useMemo)(()=>({
            teamCreateDialogProps: {},
            ...otherProps,
            // extra props
            isPeopleMenuOpen: isOpen,
            togglePeopleMenu: togglePeopleMenu,
            toggleTeamCreateDialog: toggleTeamCreateDialog,
            toggleRenotifyModal: toggleRenotifyModal,
            pendingUsers: pendingUsers,
            renotifyEligible: renotifyEligible,
            showRenotifyMessage: showRenotifyMessage,
            setRenotifyDismissed: setRenotifyDismissed,
            isSpotlightActive: isSpotlightActive,
            setIsSpotlightActive: setIsSpotlightActive
        }), [
        otherProps,
        isOpen,
        togglePeopleMenu,
        toggleTeamCreateDialog,
        toggleRenotifyModal,
        pendingUsers,
        renotifyEligible,
        showRenotifyMessage,
        setRenotifyDismissed,
        isSpotlightActive,
        setIsSpotlightActive
    ]);
    const closeTeamCreateDialog = (0, $5uXOq.useCallback)(()=>{
        toggleOpenTeamCreateDialog(false);
        if (typeof values.teamCreateDialogProps?.onClose === 'function') values.teamCreateDialogProps.onClose();
    }, [
        toggleOpenTeamCreateDialog,
        values.teamCreateDialogProps
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($9bea95b1cc38c059$export$c92ff8b73313c89.Provider, {
        value: values,
        children: [
            children,
            !isSSR && isOpenTeamCreateDialog && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $9bea95b1cc38c059$var$DialogWrapper,
                testId: `${otherProps.testId}-team-create-dialog-wrapper`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($9bea95b1cc38c059$var$AKModalTransition, {
                        children: isOpenTeamCreateDialog && /*#__PURE__*/ (0, $2OMIu.jsx)($9bea95b1cc38c059$var$TeamCreateDialog, {
                            cloudId: values.cloudId,
                            orgId: values.orgId,
                            product: values.product,
                            principalId: values.userId,
                            addFlag: values.addFlag,
                            pushRoute: values.pushRoute,
                            extraAnalyticsAttrs: $9bea95b1cc38c059$var$analyticsAttrsTeamCreateDialog,
                            ...values.teamCreateDialogProps,
                            onClose: closeTeamCreateDialog
                        })
                    })
                })
            }),
            !isSSR && showRenotifyModal && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $9bea95b1cc38c059$var$DialogWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihijj.LazySuspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($9bea95b1cc38c059$var$AKModalTransition, {
                        children: showRenotifyModal && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $awaXD.RenotifyModal), {})
                    })
                })
            })
        ]
    });
}
const $9bea95b1cc38c059$export$c8d82c28669da5dc = ()=>(0, $5uXOq.useContext)($9bea95b1cc38c059$export$c92ff8b73313c89);

});
parcelRegister("lttJX", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", () => $57cd6b9ab6587137$export$c22050996e7c2c8a);
$parcel$export(module.exports, "triggerAnalyticsForMenuLink", () => $57cd6b9ab6587137$export$e2de484c93cb7dd8);
$parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", () => $57cd6b9ab6587137$export$e3be20a27c367b1d);
$parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", () => $57cd6b9ab6587137$export$bb6086ba6d61c34e);
$parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", () => $57cd6b9ab6587137$export$8c5588f22f5cd9d8);
$parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", () => $57cd6b9ab6587137$export$580e4977bd9f636d);
$parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", () => $57cd6b9ab6587137$export$b7b4061d9dd52eb9);
$parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", () => $57cd6b9ab6587137$export$3e9b11df8135b7cb);
$parcel$export(module.exports, "triggerAnalyticsForPreFetchData", () => $57cd6b9ab6587137$export$750c07c02477d2f7);
$parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", () => $57cd6b9ab6587137$export$d88a623841ba7b50);
$parcel$export(module.exports, "triggerAnalyticsForFetchingData", () => $57cd6b9ab6587137$export$bda81aea2199d550);
$parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", () => $57cd6b9ab6587137$export$f2cf5fec906275c6);
$parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", () => $57cd6b9ab6587137$export$589011fd49e3f6d6);
$parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", () => $57cd6b9ab6587137$export$1eb2f70fed6b75f7);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalViewed", () => $57cd6b9ab6587137$export$fdfb31060bc22a02);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCopyLink", () => $57cd6b9ab6587137$export$5deab56d147776ca);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCancelButton", () => $57cd6b9ab6587137$export$a4a63a010743799d);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalSendReminderButton", () => $57cd6b9ab6587137$export$faf6c5030f38bba5);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded", () => $57cd6b9ab6587137$export$736bb3246fa74c1f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersFailed", () => $57cd6b9ab6587137$export$794d511945a81231);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesSucceeded", () => $57cd6b9ab6587137$export$866a7379b396a7e3);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesFailed", () => $57cd6b9ab6587137$export$498c81c82596e8ea);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyNotEligible", () => $57cd6b9ab6587137$export$644347da17a1bc39);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightViewed", () => $57cd6b9ab6587137$export$68b8d9efc6f7f58f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightCancelButton", () => $57cd6b9ab6587137$export$f900d0881e38df06);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightConfirmButton", () => $57cd6b9ab6587137$export$acbad06cf5c53b17);
$parcel$export(module.exports, "AnalyticsActionSubject", () => (parcelRequire("albme")).AnalyticsActionSubject);
$parcel$export(module.exports, "AnalyticsAction", () => (parcelRequire("albme")).AnalyticsAction);
$parcel$export(module.exports, "AnalyticsSource", () => (parcelRequire("albme")).AnalyticsSource);

var $2IhN6 = parcelRequire("2IhN6");

var $albme = parcelRequire("albme");

var $dcfc7 = parcelRequire("dcfc7");
const $57cd6b9ab6587137$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
        action: (0, $albme.AnalyticsAction).CLICKED
    });
};
const $57cd6b9ab6587137$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
        actionSubjectId: additionalLinkId,
        action: action,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $57cd6b9ab6587137$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
        action: (0, $albme.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $57cd6b9ab6587137$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
        actionSubjectId: 'addPeopleNavigationMenuItem',
        action: (0, $albme.AnalyticsAction).CLICKED,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $57cd6b9ab6587137$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: (0, $albme.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $57cd6b9ab6587137$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: (0, $albme.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $57cd6b9ab6587137$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
    (0, $2IhN6.fireScreenEvent)(createAnalyticsEvent, {
        name: 'peopleMenu',
        attributes: {
            isCacheEmpty: isCacheEmpty
        }
    });
};
const $57cd6b9ab6587137$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: 'addPeopleNavigationItem',
        action: (0, $albme.AnalyticsAction).RENDERED
    });
};
const $57cd6b9ab6587137$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).PRE_FETCH_DATA,
        action: (0, $albme.AnalyticsAction).TRIGGERED
    });
};
const $57cd6b9ab6587137$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).PEOPLE_MENU,
        actionSubjectId: 'loadingIndicator',
        action: (0, $albme.AnalyticsAction).VIEWED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $57cd6b9ab6587137$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $2IhN6.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
        action: (0, $albme.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $57cd6b9ab6587137$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $2IhN6.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
        action: (0, $albme.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $57cd6b9ab6587137$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
    (0, $2IhN6.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $albme.AnalyticsAction).SUCCEEDED,
        attributes: {
            usersCount: usersCount,
            teamsCount: teamsCount,
            duration: duration,
            startTime: startTime
        }
    });
};
const $57cd6b9ab6587137$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $albme.AnalyticsAction).VIEWED,
        actionSubjectId: 'noBrowsePermission'
    });
};
const $57cd6b9ab6587137$export$a5bdd25287196af4 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $57cd6b9ab6587137$export$881b6b12fd147cc = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'remindTeamMembersButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $57cd6b9ab6587137$export$451dcd11e28959 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $albme.AnalyticsAction).VIEWED,
        name: (0, $albme.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $57cd6b9ab6587137$export$fdfb31060bc22a02 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $albme.AnalyticsAction).VIEWED,
        name: (0, $albme.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $57cd6b9ab6587137$export$5deab56d147776ca = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'copyInviteLinkButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $57cd6b9ab6587137$export$a4a63a010743799d = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $57cd6b9ab6587137$export$faf6c5030f38bba5 = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'sendReminderButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $57cd6b9ab6587137$export$736bb3246fa74c1f = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $albme.AnalyticsAction).SUCCEEDED,
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $57cd6b9ab6587137$export$794d511945a81231 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $albme.AnalyticsAction).FAILED,
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $57cd6b9ab6587137$export$866a7379b396a7e3 = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $albme.AnalyticsAction).SUCCEEDED,
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $57cd6b9ab6587137$export$498c81c82596e8ea = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $albme.AnalyticsAction).FAILED,
        source: (0, $albme.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $57cd6b9ab6587137$export$644347da17a1bc39 = (createAnalyticsEvent, attributes)=>{
    (0, $2IhN6.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).RENOTIFY_EXPERIMENT,
        action: (0, $albme.AnalyticsAction).INELIGIBLE,
        source: (0, $albme.AnalyticsSource).RENOTIFY_MESSAGE,
        attributes: attributes
    });
};
const $57cd6b9ab6587137$export$68b8d9efc6f7f58f = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $albme.AnalyticsAction).VIEWED,
        name: (0, $albme.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $57cd6b9ab6587137$export$f900d0881e38df06 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightDismissButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $57cd6b9ab6587137$export$acbad06cf5c53b17 = (createAnalyticsEvent)=>{
    (0, $2IhN6.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).BUTTON,
        action: (0, $albme.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightConfirmButton',
        source: (0, $albme.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};

});
parcelRegister("albme", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionSubject", () => $5d06c0f7e6d40934$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsAction", () => $5d06c0f7e6d40934$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $5d06c0f7e6d40934$export$6890652a1aff7d1c);
var $5d06c0f7e6d40934$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
    AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
    AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
    AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
    AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
    AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
    AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
    AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
    AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
    AnalyticsActionSubject["BUTTON"] = "button";
    AnalyticsActionSubject["FETCH_INACTIVE_USERS_DATA"] = "fetchInactiveUsersData";
    AnalyticsActionSubject["SEND_REINVITES"] = "sendReinvites";
    AnalyticsActionSubject["RENOTIFY_EXPERIMENT"] = "renotifyExperiment";
    return AnalyticsActionSubject;
}({});
var $5d06c0f7e6d40934$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["TRIGGERED"] = "triggered";
    AnalyticsAction["MEASURED"] = "measured";
    AnalyticsAction["INELIGIBLE"] = "ineligible";
    return AnalyticsAction;
}({});
var $5d06c0f7e6d40934$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsSource["RENOTIFY_MESSAGE"] = "renotifyMessage";
    AnalyticsSource["RENOTIFY_MODAL"] = "renotifyModal";
    AnalyticsSource["RENOTIFY_SPOTLIGHT"] = "renotifySpotlight";
    return AnalyticsSource;
}({});

});

parcelRegister("dcfc7", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", () => $0b9434b98a9f7005$export$62ecc9342d32a444);
$parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", () => $0b9434b98a9f7005$export$e648838c8bbef986);

var $2IhN6 = parcelRequire("2IhN6");
parcelRequire("lttJX");
var $albme = parcelRequire("albme");
const $0b9434b98a9f7005$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
    (0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: action === 'succeeded' ? (0, $albme.AnalyticsAction).SUCCEEDED : (0, $albme.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};
const $0b9434b98a9f7005$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
    (0, $2IhN6.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $albme.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: action === 'succeeded' ? (0, $albme.AnalyticsAction).SUCCEEDED : (0, $albme.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};

});


parcelRegister("awaXD", function(module, exports) {

$parcel$export(module.exports, "RenotifyModal", () => $c398cca11fff5928$export$c68d29a05874a11b);
parcelRequire("kc9vJ");
var $8DfXF = parcelRequire("8DfXF");

const $c398cca11fff5928$export$c68d29a05874a11b = (0, $8DfXF.lazy)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("5vuD4")));

});
parcelRegister("5vuD4", function(module, exports) {

let $40279b5587c53aff$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $40279b5587c53aff$var$load("hPzOn"),
    $40279b5587c53aff$var$load("k9zhN")
]).then(()=>parcelRequire('aMSMh'));

});


parcelRegister("74T2L", function(module, exports) {

$parcel$export(module.exports, "RenotifyStatus", () => $970556a8706e355c$export$e1b7db4c83021afe);
$parcel$export(module.exports, "usePendingUsers", () => $970556a8706e355c$export$8d720c7cdd23491d);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $lttJX = parcelRequire("lttJX");

var $3zSnI = parcelRequire("3zSnI");
const $970556a8706e355c$export$50fd3325777ce4bc = new Map();
const $970556a8706e355c$export$7149af0c7f6b6e85 = 'pendingUsers';
const $970556a8706e355c$export$c9c3fbf7cb17786e = 'renotifyEligibility';
var $970556a8706e355c$export$e1b7db4c83021afe = /*#__PURE__*/ function(RenotifyStatus) {
    RenotifyStatus["IS_LOADING"] = "isLoading";
    RenotifyStatus["ELIGIBLE"] = "eligible";
    RenotifyStatus["INELIGIBLE"] = "ineligible";
    RenotifyStatus["ERROR"] = "error";
    return RenotifyStatus;
}({});
const $970556a8706e355c$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS = 600000; // 10 minutes
function $970556a8706e355c$export$8d720c7cdd23491d({ cloudId: cloudId, startFetching: startFetching, renotifyExperiment: renotifyExperiment, product: product, requestCacheTimeout: requestCacheTimeout }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [pendingUsers, setPendingUsers] = (0, $5uXOq.useState)($970556a8706e355c$export$50fd3325777ce4bc.get($970556a8706e355c$export$7149af0c7f6b6e85));
    const [renotifyEligible, setRenotifyEligibility] = (0, $5uXOq.useState)($970556a8706e355c$export$50fd3325777ce4bc.get($970556a8706e355c$export$c9c3fbf7cb17786e));
    const { loading: pendingUsersLoading, error: pendingUsersError, data: pendingUsersData, fetchData: fetchPendingUsers } = (0, $3zSnI.usePendingUsersService)(cloudId, requestCacheTimeout === undefined ? $970556a8706e355c$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS : requestCacheTimeout, product);
    (0, $5uXOq.useEffect)(()=>{
        if (renotifyEligible !== undefined || renotifyExperiment?.isLoading || !startFetching) return;
        if (renotifyExperiment?.isEnrolled) fetchPendingUsers();
        else {
            $970556a8706e355c$export$50fd3325777ce4bc.set($970556a8706e355c$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        renotifyEligible,
        fetchPendingUsers,
        renotifyExperiment?.isLoading,
        renotifyExperiment?.isEnrolled,
        startFetching
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (pendingUsersError) {
            (0, $lttJX.triggerAnalyticsForRenotifyFetchInactiveUsersFailed)(createAnalyticsEvent);
            $970556a8706e355c$export$50fd3325777ce4bc.set($970556a8706e355c$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
            return;
        }
        if (pendingUsersData === undefined || pendingUsersLoading) return;
        $970556a8706e355c$export$50fd3325777ce4bc.set($970556a8706e355c$export$7149af0c7f6b6e85, pendingUsersData);
        setPendingUsers(pendingUsersData);
        if (pendingUsersData?.length) {
            (0, $lttJX.triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded)(createAnalyticsEvent, {
                numberOfInviteeEmails: pendingUsersData?.length
            });
            $970556a8706e355c$export$50fd3325777ce4bc.set($970556a8706e355c$export$c9c3fbf7cb17786e, true);
            if (renotifyExperiment?.isEnrolled) setRenotifyEligibility(true);
        } else {
            (0, $lttJX.triggerAnalyticsForRenotifyNotEligible)(createAnalyticsEvent, {
                reason: 'No pending users'
            });
            $970556a8706e355c$export$50fd3325777ce4bc.set($970556a8706e355c$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        createAnalyticsEvent,
        pendingUsersData,
        pendingUsersError,
        pendingUsersLoading,
        renotifyExperiment
    ]);
    if (pendingUsersLoading || renotifyExperiment?.isLoading) return {
        status: "isLoading",
        isLoading: true
    };
    if (pendingUsersError) return {
        status: "error",
        pendingUsersError: pendingUsersError ?? new Error('Invalid pending user response'),
        isLoading: false
    };
    if (renotifyEligible === false || !pendingUsers) return {
        status: "ineligible",
        isLoading: false
    };
    return {
        status: "eligible",
        isLoading: false,
        pendingUsers: pendingUsers
    };
}

});
parcelRegister("3zSnI", function(module, exports) {

$parcel$export(module.exports, "usePendingUsersService", () => $64df6fe024f8f441$export$4e16c66a0a5052e1);

var $5uXOq = parcelRequire("5uXOq");

var $aqkD4 = parcelRequire("aqkD4");

var $e5rfO = parcelRequire("e5rfO");

var $5FZgT = parcelRequire("5FZgT");

var $iNxf2 = parcelRequire("iNxf2");
const $64df6fe024f8f441$var$mapFetchInactiveUserFnByTimeout = new Map();
function $64df6fe024f8f441$var$getFetchInactiveUsersCachedFn(timeout = (0, $aqkD4.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $64df6fe024f8f441$var$mapFetchInactiveUserFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $aqkD4.withCached)((0, $5FZgT.fetchInactiveUsers), timeout);
    $64df6fe024f8f441$var$mapFetchInactiveUserFnByTimeout.set(timeout, fn);
    return fn;
}
function $64df6fe024f8f441$export$4e16c66a0a5052e1(cloudId, cacheTimeout, product) {
    const { product: contextProduct } = (0, $iNxf2.usePeopleMenuContext)();
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $64df6fe024f8f441$var$getFetchInactiveUsersCachedFn(cacheTimeout);
            return fn(cloudId, product ?? contextProduct);
        }
        return (0, $5FZgT.fetchInactiveUsers)(cloudId, product ?? contextProduct);
    }, [
        cacheTimeout,
        cloudId,
        product,
        contextProduct
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $e5rfO.useService)(request);
    return {
        loading: loading,
        error: error,
        data: data?.users,
        fetchData: fetchData
    };
}

});
parcelRegister("aqkD4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", () => $47c48e045dd6ba2f$export$d8b1aa62ff4847fc);
$parcel$export(module.exports, "withCached", () => $47c48e045dd6ba2f$export$7f51828d6b6af163);
const $47c48e045dd6ba2f$var$ONE_SECOND = 1000;
const $47c48e045dd6ba2f$export$d8b1aa62ff4847fc = 5 * $47c48e045dd6ba2f$var$ONE_SECOND;
const $47c48e045dd6ba2f$var$isPromise = (p)=>{
    return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
};
const $47c48e045dd6ba2f$export$7f51828d6b6af163 = (fn, timeout = $47c48e045dd6ba2f$export$d8b1aa62ff4847fc)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        // we don't handle non-promise data so skip it
        if ($47c48e045dd6ba2f$var$isPromise(maybePromise)) {
            promiseCache.set(cacheKey, maybePromise);
            maybePromise.then((result)=>{
                resultCache.set(cacheKey, result);
                setTimeout(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                }, timeout);
            }).catch(()=>{
                promiseCache.delete(cacheKey);
                resultCache.delete(cacheKey);
            });
        }
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("e5rfO", function(module, exports) {

$parcel$export(module.exports, "useService", () => $3e9112325e7e39d5$export$6de4685a6c88b4e9);

var $5uXOq = parcelRequire("5uXOq");
const $3e9112325e7e39d5$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $5uXOq.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $5uXOq.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});

parcelRegister("5FZgT", function(module, exports) {

$parcel$export(module.exports, "fetchInactiveUsers", () => $63e179437f8d57cf$export$b6000772b84436c7);
$parcel$export(module.exports, "sendReinvites", () => $63e179437f8d57cf$export$df764bf7318de5);

var $jrvAy = parcelRequire("jrvAy");
const $63e179437f8d57cf$var$EXPERIMENT_API_BASE = '/gateway/api/growth/';
const $63e179437f8d57cf$var$getExperimentAPICommonPath = (product)=>`${$63e179437f8d57cf$var$EXPERIMENT_API_BASE}${product === 'confluence' ? 'notify-if-invitee-never-logged-in-confluence' : 'notify-if-invitee-never-logged-in'}`;
const $63e179437f8d57cf$var$getInactiveUsersUrl = (cloudId, product)=>`${$63e179437f8d57cf$var$getExperimentAPICommonPath(product)}/get-inactive-users?cloudId=${cloudId}`;
const $63e179437f8d57cf$export$b6000772b84436c7 = (cloudId, product)=>(0, $jrvAy.fetchJson)($63e179437f8d57cf$var$getInactiveUsersUrl(cloudId, product));
const $63e179437f8d57cf$var$getReinviteUrl = (product)=>`${$63e179437f8d57cf$var$getExperimentAPICommonPath(product)}/reinvite`;
const $63e179437f8d57cf$export$df764bf7318de5 = (cloudId, reInvites, product)=>{
    return (0, $jrvAy.postJson)($63e179437f8d57cf$var$getReinviteUrl(product), {
        owner: `ari:cloud:platform::site/${cloudId}`,
        reInvites: reInvites.map(({ userId: userId, continueUrl: continueUrl })=>({
                inviteeId: `ari:cloud:identity::user/${userId}`,
                continueUrl: continueUrl
            }))
    });
};

});
parcelRegister("jrvAy", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $295bb01a1f203dc5$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $295bb01a1f203dc5$export$c776284ef4b1209a);
const $295bb01a1f203dc5$export$83179404a61b001a = 'FetchError';
function $295bb01a1f203dc5$export$847691ec04985fa0(error, status) {
    return {
        name: $295bb01a1f203dc5$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status
    };
}
const $295bb01a1f203dc5$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw $295bb01a1f203dc5$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status);
    });
const $295bb01a1f203dc5$export$c776284ef4b1209a = (url, data)=>$295bb01a1f203dc5$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

});




parcelRegister("b6KyP", function(module, exports) {

let $81645f42886654ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $81645f42886654ed$var$load("h2MrD"),
    $81645f42886654ed$var$load("bYT2S"),
    $81645f42886654ed$var$load("hPzOn"),
    $81645f42886654ed$var$load("2tDjo")
]).then(()=>parcelRequire('fGUTg'));

});


parcelRegister("jP9gu", function(module, exports) {

$parcel$export(module.exports, "isCachedDataClear", () => $370434c5743e6548$export$cee8b843259f0f74);
$parcel$export(module.exports, "default", () => $370434c5743e6548$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ekW4v = parcelRequire("ekW4v");
var $8ghlB = parcelRequire("8ghlB");
const $370434c5743e6548$export$50fd3325777ce4bc = new Map();
const $370434c5743e6548$export$cd84c175965a58da = 'collaborators';
const $370434c5743e6548$export$b5c382592ac689a7 = 'teams';
const $370434c5743e6548$var$ONE_SEC = 1000;
const $370434c5743e6548$var$ONE_MINUTE = $370434c5743e6548$var$ONE_SEC * 60;
const $370434c5743e6548$var$REQUEST_CACHE_TIMEOUT_TEAMS = $370434c5743e6548$var$ONE_MINUTE;
const $370434c5743e6548$var$REQUEST_CACHE_TIMEOUT_USERS = $370434c5743e6548$var$ONE_MINUTE * 5;
function $370434c5743e6548$export$cee8b843259f0f74() {
    return $370434c5743e6548$export$50fd3325777ce4bc.size === 0;
}
function $370434c5743e6548$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
    const [dataUsers, setDataUsers] = (0, $5uXOq.useState)(undefined);
    const [dataTeams, setDataTeams] = (0, $5uXOq.useState)(undefined);
    const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, $ekW4v.useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $370434c5743e6548$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
    const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, $8ghlB.useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $370434c5743e6548$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
    // after the service return the latest data,
    // we store users data in cache store.
    (0, $5uXOq.useEffect)(()=>{
        if (!users || isLoadingUsers || errorUsers) return;
        $370434c5743e6548$export$50fd3325777ce4bc.set($370434c5743e6548$export$cd84c175965a58da, users);
        setDataUsers(users);
    }, [
        users,
        isLoadingUsers,
        errorUsers
    ]);
    // after the service return the latest data,
    // store teams data in cache store.
    (0, $5uXOq.useEffect)(()=>{
        if (!teams || isLoadingTeams || errorTeams) return;
        $370434c5743e6548$export$50fd3325777ce4bc.set($370434c5743e6548$export$b5c382592ac689a7, teams);
        setDataTeams(teams);
    }, [
        teams,
        isLoadingTeams,
        errorTeams
    ]);
    return {
        users: dataUsers && dataUsers.length ? dataUsers : $370434c5743e6548$export$50fd3325777ce4bc.get($370434c5743e6548$export$cd84c175965a58da),
        teams: dataTeams && dataTeams.length ? dataTeams : $370434c5743e6548$export$50fd3325777ce4bc.get($370434c5743e6548$export$b5c382592ac689a7),
        errorTeams: errorTeams,
        errorUsers: errorUsers,
        isLoading: isLoadingUsers || isLoadingTeams
    };
}

});
parcelRegister("ekW4v", function(module, exports) {

$parcel$export(module.exports, "useCollaboratorsService", () => $c92afea68f9db410$export$979a4f9449b8be53);

var $5uXOq = parcelRequire("5uXOq");

var $bPXBh = parcelRequire("bPXBh");

var $knf2m = parcelRequire("knf2m");

var $aqkD4 = parcelRequire("aqkD4");

var $e5rfO = parcelRequire("e5rfO");
const $c92afea68f9db410$var$mapFetchCollaboratorsFnByTimeout = new Map();
function $c92afea68f9db410$var$getFetchCollaboratorsCachedFn(timeout = (0, $aqkD4.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $c92afea68f9db410$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $aqkD4.withCached)((0, $bPXBh.fetchCollaborators), timeout);
    $c92afea68f9db410$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
    return fn;
}
function $c92afea68f9db410$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $c92afea68f9db410$var$getFetchCollaboratorsCachedFn(cacheTimeout);
            return fn(cloudId, userId, tenantUrl);
        }
        return (0, $bPXBh.fetchCollaborators)(cloudId, userId, tenantUrl);
    }, [
        cacheTimeout,
        cloudId,
        userId,
        tenantUrl
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $e5rfO.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $5uXOq.useMemo)(()=>(0, $knf2m.transformCollabsDataToUsers)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("bPXBh", function(module, exports) {

$parcel$export(module.exports, "fetchCollaborators", () => $ce1e0aa6729eb3c7$export$cadad85c3acf2ad8);

var $khG5U = parcelRequire("khG5U");
const $ce1e0aa6729eb3c7$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
const $ce1e0aa6729eb3c7$var$LIMIT_RESULTS = 5;
const $ce1e0aa6729eb3c7$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, $khG5U.postJson)(`${tenantUrl}${$ce1e0aa6729eb3c7$export$42623aff9edf525f}`, {
        context: {
            contextType: 'atlassianPeoplePackage',
            principalId: userId,
            siteId: cloudId
        },
        maxNumberOfResults: $ce1e0aa6729eb3c7$var$LIMIT_RESULTS,
        userId: userId,
        expanded: true
    });

});
parcelRegister("khG5U", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $972f1225ed14457d$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $972f1225ed14457d$export$c776284ef4b1209a);
const $972f1225ed14457d$export$83179404a61b001a = 'FetchError';
function $972f1225ed14457d$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $972f1225ed14457d$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $972f1225ed14457d$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        const traceId = response?.headers?.get('atl-traceid') || undefined;
        throw $972f1225ed14457d$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $972f1225ed14457d$export$c776284ef4b1209a = (url, data, headers)=>$972f1225ed14457d$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });

});


parcelRegister("knf2m", function(module, exports) {

$parcel$export(module.exports, "transformCollabsDataToUsers", () => $e5ef0250418a972c$export$1eb7590d078520b8);

var $jV4JA = parcelRequire("jV4JA");
const $e5ef0250418a972c$var$userMapper = (user)=>{
    const { userProfile: userProfile, entityType: entityType } = user;
    if (!userProfile || entityType !== (0, $jV4JA.ENTITY_TYPE).USER) return null;
    return {
        id: user.id,
        fullName: userProfile.name,
        nickname: userProfile.nickname,
        email: userProfile.email,
        avatarUrl: userProfile.picture,
        collaborationGraphScore: user.score,
        status: userProfile.account_status
    };
};
const $e5ef0250418a972c$export$1eb7590d078520b8 = (data)=>{
    if (!data) return [];
    const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
    return collaborationGraphEntities.map($e5ef0250418a972c$var$userMapper).filter((item)=>item) || [];
};

});
parcelRegister("jV4JA", function(module, exports) {

$parcel$export(module.exports, "ENTITY_TYPE", () => $c1a6050759d1aa8e$export$49be827a0aef75dd);
var $c1a6050759d1aa8e$export$49be827a0aef75dd = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}({});
var $c1a6050759d1aa8e$export$fba7c3adda5094d9 = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}({});

});



parcelRegister("8ghlB", function(module, exports) {

$parcel$export(module.exports, "useTeamsOfService", () => $fd754e23d7fcc2c3$export$668750a034956301);

var $5uXOq = parcelRequire("5uXOq");

var $c1GIt = parcelRequire("c1GIt");

var $4RZBh = parcelRequire("4RZBh");

var $aqkD4 = parcelRequire("aqkD4");

var $e5rfO = parcelRequire("e5rfO");
const $fd754e23d7fcc2c3$var$mapFetchMyTeamsFnByTimeout = new Map();
function $fd754e23d7fcc2c3$var$getFetchMyTeamsCachedFn(timeout = (0, $aqkD4.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $fd754e23d7fcc2c3$var$mapFetchMyTeamsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $aqkD4.withCached)((0, $c1GIt.searchTeamsOfUser), timeout);
    $fd754e23d7fcc2c3$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
    return fn;
}
function $fd754e23d7fcc2c3$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $fd754e23d7fcc2c3$var$getFetchMyTeamsCachedFn(cacheTimeout);
            return fn(userId, cloudId, product, tenantUrl, orgId);
        }
        return (0, $c1GIt.searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
    }, [
        cacheTimeout,
        userId,
        cloudId,
        product,
        tenantUrl,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $e5rfO.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $5uXOq.useMemo)(()=>(0, $4RZBh.transformTeams)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("c1GIt", function(module, exports) {

$parcel$export(module.exports, "searchTeamsOfUser", () => $16b7cbd17c4f57fe$export$c52386bca71fd065);
$parcel$export(module.exports, "postCreateTeam", () => $16b7cbd17c4f57fe$export$db3c0c162386baf4);

var $2Ixyh = parcelRequire("2Ixyh");

var $96l9U = parcelRequire("96l9U");

var $czUG0 = parcelRequire("czUG0");

var $dQAmO = parcelRequire("dQAmO");

var $khG5U = parcelRequire("khG5U");
const $16b7cbd17c4f57fe$var$LIMIT_RESULTS = 5;
const $16b7cbd17c4f57fe$export$51eb1e4b266d279a = '/gateway/api';
const $16b7cbd17c4f57fe$export$a6635dd972d6facf = `${$16b7cbd17c4f57fe$export$51eb1e4b266d279a}/v3/teams`;
const $16b7cbd17c4f57fe$export$8ebb304bc6fdbba2 = `${$16b7cbd17c4f57fe$export$51eb1e4b266d279a}/v4/teams`;
const $16b7cbd17c4f57fe$export$d6cee1ef1aa86c6d = `${$16b7cbd17c4f57fe$export$a6635dd972d6facf}/of-user`;
const $16b7cbd17c4f57fe$export$5c5040d455d75334 = `${$16b7cbd17c4f57fe$export$8ebb304bc6fdbba2}/search`;
const $16b7cbd17c4f57fe$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$16b7cbd17c4f57fe$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId ?? ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$16b7cbd17c4f57fe$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $16b7cbd17c4f57fe$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$16b7cbd17c4f57fe$export$5c5040d455d75334}${(0, $96l9U.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $16b7cbd17c4f57fe$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $khG5U.fetchJson)($16b7cbd17c4f57fe$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
const $16b7cbd17c4f57fe$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $dQAmO.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $16b7cbd17c4f57fe$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $16b7cbd17c4f57fe$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $khG5U.postJson)(url, postData);
};
const $16b7cbd17c4f57fe$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    (0, $2Ixyh.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $2Ixyh.teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$16b7cbd17c4f57fe$export$51eb1e4b266d279a}`);
    const result = await (0, $2Ixyh.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings === (0, $czUG0.TeamMembershipSettings).OPEN ? 'OPEN' : 'MEMBER_INVITE');
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $czUG0.TeamState).ACTIVE : (0, $czUG0.TeamState).PURGED,
        membershipSettings: result.membershipSettings === 'OPEN' ? (0, $czUG0.TeamMembershipSettings).OPEN : (0, $czUG0.TeamMembershipSettings).INVITE_ONLY,
        memberCount: result.memberIds?.length ?? 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $czUG0.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $czUG0.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        memberIds: result.memberIds,
        permission: result.permission === 'FULL_WRITE' ? (0, $czUG0.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $czUG0.TeamPermission).FULL_READ : (0, $czUG0.TeamPermission).NONE
    };
};
const $16b7cbd17c4f57fe$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$16b7cbd17c4f57fe$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $96l9U.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $16b7cbd17c4f57fe$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $16b7cbd17c4f57fe$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $khG5U.postJson)(url, postData);
};

});
parcelRegister("96l9U", function(module, exports) {

$parcel$export(module.exports, "constructProductOriginParams", () => $93fdfd31993765aa$export$d479c7e8f449d360);
$parcel$export(module.exports, "getPeopleDirectoryHomePageWithOrgId", () => $93fdfd31993765aa$export$873f5b458fb2c7bd);
$parcel$export(module.exports, "getPeopleProfilePage", () => $93fdfd31993765aa$export$8d1c08ae3a193cc5);
$parcel$export(module.exports, "getTeamProfilePageLinkWithOrgId", () => $93fdfd31993765aa$export$143be302a1686103);
$parcel$export(module.exports, "trimLastForwardSlash", () => $93fdfd31993765aa$export$41ba1f3da3359c4);
function $93fdfd31993765aa$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $93fdfd31993765aa$export$d479c7e8f449d360(originQuery) {
    return $93fdfd31993765aa$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': originQuery.product?.toUpperCase() || ''
    });
}
function $93fdfd31993765aa$export$575daf737e125483(remoteConfigResources) {
    return remoteConfigResources?.baseUrl || '';
}
function $93fdfd31993765aa$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$93fdfd31993765aa$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$93fdfd31993765aa$var$toStrParams(params)}`;
}
function $93fdfd31993765aa$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$93fdfd31993765aa$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$93fdfd31993765aa$var$toStrParams(params)}`;
}
function $93fdfd31993765aa$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$93fdfd31993765aa$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$93fdfd31993765aa$var$toStrParams(params)}`;
}
function $93fdfd31993765aa$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$93fdfd31993765aa$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$93fdfd31993765aa$var$toStrParams(params)}`;
}
function $93fdfd31993765aa$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$93fdfd31993765aa$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$93fdfd31993765aa$var$toStrParams(params)}`;
}
function $93fdfd31993765aa$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}

});

parcelRegister("czUG0", function(module, exports) {

$parcel$export(module.exports, "TeamState", () => $23dcc4b55281e45d$export$c5c56131401e0716);
$parcel$export(module.exports, "TeamMembershipSettings", () => $23dcc4b55281e45d$export$93b1c6cf9d16dce6);
$parcel$export(module.exports, "TeamDiscoverability", () => $23dcc4b55281e45d$export$c698762b98da6685);
$parcel$export(module.exports, "TeamRestriction", () => $23dcc4b55281e45d$export$e94592bde85a4d74);
$parcel$export(module.exports, "TeamPermission", () => $23dcc4b55281e45d$export$4db108522156032a);
// raw data is returned from Legion API
var $23dcc4b55281e45d$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
    return TeamState;
}({});
var $23dcc4b55281e45d$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
    return TeamMembershipSettings;
}({});
var $23dcc4b55281e45d$export$c698762b98da6685 = /*#__PURE__*/ function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    return TeamDiscoverability;
}({});
var $23dcc4b55281e45d$export$e94592bde85a4d74 = /*#__PURE__*/ function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    return TeamRestriction;
}({});
var $23dcc4b55281e45d$export$4db108522156032a = /*#__PURE__*/ function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
    return TeamPermission;
}({});

});

parcelRegister("dQAmO", function(module, exports) {

$parcel$export(module.exports, "ErrorWithContext", () => $3c96b68f69761d56$export$6e749dfbce027249);
class $3c96b68f69761d56$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = context;
    }
}

});


parcelRegister("4RZBh", function(module, exports) {

$parcel$export(module.exports, "trimTeamAriInObject", () => $06ce747bf12d40c0$export$c75c12ecb0b3724e);
$parcel$export(module.exports, "transformTeams", () => $06ce747bf12d40c0$export$fd398a52d6f57b46);
function $06ce747bf12d40c0$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $06ce747bf12d40c0$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($06ce747bf12d40c0$export$c75c12ecb0b3724e);
};

});



parcelRegister("cc0xQ", function(module, exports) {

$parcel$export(module.exports, "VOID_FUNC", () => $58e01ac491dab7d4$export$7e6ba5d480e9bd2f);
const $58e01ac491dab7d4$export$53bb833296af4a30 = 5;
const $58e01ac491dab7d4$export$88d6945644578407 = 3;
const $58e01ac491dab7d4$export$7e6ba5d480e9bd2f = ()=>undefined;

});

parcelRegister("ejWgu", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $6621354047ae2dce$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $6621354047ae2dce$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $6621354047ae2dce$export$6f766653554dac02);
const $6621354047ae2dce$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $6621354047ae2dce$var$hasPerformanceAPIAvailable = $6621354047ae2dce$var$isPerformanceAPIAvailable();
const $6621354047ae2dce$var$measureMap = new Map();
function $6621354047ae2dce$export$b62aa2130c86b59b(measureName) {
    if (!$6621354047ae2dce$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $6621354047ae2dce$var$measureMap.set(measureName, performance.now());
}
function $6621354047ae2dce$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$6621354047ae2dce$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$6621354047ae2dce$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $6621354047ae2dce$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $6621354047ae2dce$export$6f766653554dac02(measureName);
    }
}
function $6621354047ae2dce$export$6f766653554dac02(measureName) {
    if (!$6621354047ae2dce$var$hasPerformanceAPIAvailable) return;
    $6621354047ae2dce$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("fTi46", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $38e272ebf5cfeff7$export$479f0f2f71193efe);
$parcel$export(module.exports, "MenuContentFallback", () => $38e272ebf5cfeff7$export$48b47052ec2aea7f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $8DfXF = parcelRequire("8DfXF");

var $aOrxC = parcelRequire("aOrxC");

var $iNxf2 = parcelRequire("iNxf2");

var $jP9gu = parcelRequire("jP9gu");

var $gRGSb = parcelRequire("gRGSb");

var $kUFRp = parcelRequire("kUFRp");

const $38e272ebf5cfeff7$export$479f0f2f71193efe = (0, $8DfXF.lazyForPaint)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("4z5Kg")));
const $38e272ebf5cfeff7$export$b0396be60c0e9152 = 480;
const $38e272ebf5cfeff7$export$3f133812f81dfa49 = 320;
const $38e272ebf5cfeff7$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $38e272ebf5cfeff7$export$48b47052ec2aea7f() {
    const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $5uXOq.useContext)((0, $iNxf2.PeopleMenuContext));
    // kick off some requests sooner
    (0, $jP9gu.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aOrxC.default), {
        testId: `${testId}-group-loading`,
        maxWidth: $38e272ebf5cfeff7$export$b0396be60c0e9152,
        maxHeight: $38e272ebf5cfeff7$export$94aaf6acd960c412,
        minWidth: $38e272ebf5cfeff7$export$3f133812f81dfa49,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gRGSb.MenuGroupPeople), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kUFRp.MenuGroupTeams), {
                isLoading: true
            })
        ]
    });
}

});
parcelRegister("gRGSb", function(module, exports) {

$parcel$export(module.exports, "MenuGroupPeople", () => $3ff881ee25a25a3c$export$c521b8e86241ef89);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3TR0I = parcelRequire("3TR0I");

var $44qT7 = parcelRequire("44qT7");

var $lw9uA = parcelRequire("lw9uA");

var $96l9U = parcelRequire("96l9U");

var $iNxf2 = parcelRequire("iNxf2");

var $cc0xQ = parcelRequire("cc0xQ");

var $3q5sC = parcelRequire("3q5sC");
parcelRequire("lttJX");
var $albme = parcelRequire("albme");
var $lttJX = parcelRequire("lttJX");

var $kRpDN = parcelRequire("kRpDN");

var $2wG5H = parcelRequire("2wG5H");

var $1sbWU = parcelRequire("1sbWU");
const $3ff881ee25a25a3c$export$2e63129145f0c868 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $cc0xQ.VOID_FUNC), pushRoute: pushRoute = (0, $cc0xQ.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $cc0xQ.VOID_FUNC) } = (0, $5uXOq.useContext)((0, $iNxf2.PeopleMenuContext));
    const handleClickOnPeople = (0, $5uXOq.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $3q5sC.isModifiedEvent)(event);
            (0, $lttJX.triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'people', event);
            if (isLeftClick) {
                const peopleProfilePage = (0, $96l9U.getPeopleProfilePage)(remoteConfig.resources, id, product, (0, $albme.AnalyticsActionSubject).PEOPLE_MENU);
                pushRoute(peopleProfilePage);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.collaborators.enabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2wG5H.MenuGroupSection), {
        title: remoteConfig.sections.collaborators.label ?? intl.formatMessage((0, $kRpDN.messages).yourCollab),
        testId: `${testId}-people-section`,
        isLoading: isLoading,
        isEmpty: users.length === 0,
        sectionType: 'user',
        maxItems: remoteConfig.sections.collaborators.maxItems,
        children: users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1sbWU.ImgIcon), {
                    src: user.avatarUrl,
                    alt: ""
                }),
                testId: `${testId}-people-item`,
                href: (0, $96l9U.getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, $albme.AnalyticsActionSubject).PEOPLE_MENU),
                onClick: handleClickOnPeople(user.id),
                children: user.fullName
            }, user.id))
    });
};
const $3ff881ee25a25a3c$export$c521b8e86241ef89 = (0, $3TR0I.default)()((0, $lw9uA.withMandatoryPeopleMenuConfiguration)($3ff881ee25a25a3c$export$2e63129145f0c868));

});
parcelRegister("lw9uA", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", () => $d4301921e9f0b182$export$c616dd7f2557d148);
$parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", () => $d4301921e9f0b182$export$aecb6ab9d1724228);

var $goAXv = parcelRequire("goAXv");
var $1YBZi = parcelRequire("1YBZi");
const $d4301921e9f0b182$var$KEY = 'people-menu';
const $d4301921e9f0b182$export$c616dd7f2557d148 = ()=>{
    const configuration = (0, $goAXv.usePeopleAndTeamsConfigurationContext)();
    return configuration[$d4301921e9f0b182$var$KEY];
};
const $d4301921e9f0b182$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, $1YBZi.withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $d4301921e9f0b182$var$KEY);

});
parcelRegister("1YBZi", function(module, exports) {

$parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", () => $59b786e146c133d4$export$aead0eac38c797a5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $goAXv = parcelRequire("goAXv");
function $59b786e146c133d4$var$isMandatoryPeopleAndTeamsConfiguration(context) {
    return Boolean(context);
}
const $59b786e146c133d4$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
        const remoteConfig = (0, $goAXv.usePeopleAndTeamsConfigurationContext)();
        if (!remoteConfig) return null;
        const keyedConfig = remoteConfig[key];
        if (!$59b786e146c133d4$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            remoteConfig: keyedConfig,
            ...props
        });
    };

});


parcelRegister("3q5sC", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $c4d4b6804e80e8ae$export$642c6f14f6d4bbd5);
const $c4d4b6804e80e8ae$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("kRpDN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3295b590a706b562$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3295b590a706b562$var$PREFIX = 'ptc.pm';
const $3295b590a706b562$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    yourCollab: {
        id: `${$3295b590a706b562$var$PREFIX}.collaborators.title`,
        defaultMessage: 'Your Collaborators',
        description: 'A title of Your-Collaborators section in People Menu dropdown'
    },
    yourTeams: {
        id: `${$3295b590a706b562$var$PREFIX}.your-teams.title`,
        defaultMessage: 'Your Teams',
        description: 'A title of a Your-Teams section in People Menu dropdown'
    },
    viewYourProfile: {
        id: `${$3295b590a706b562$var$PREFIX}.view-your-profile`,
        defaultMessage: 'View your profile',
        description: 'A link in People Menu. Clicking on it will navigate the user to their personal profile'
    },
    errorHeading: {
        id: `${$3295b590a706b562$var$PREFIX}.error-heading`,
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the People Menu. Usually due to failed network requests.'
    },
    errorText: {
        id: `${$3295b590a706b562$var$PREFIX}.error-text`,
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the People Menu.'
    },
    errorImageAltText: {
        id: `${$3295b590a706b562$var$PREFIX}.error-image-alt-text`,
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the People Menu'
    },
    people: {
        id: `${$3295b590a706b562$var$PREFIX}.people`,
        defaultMessage: 'People',
        description: 'A default title of primary People menu'
    },
    teams: {
        id: `${$3295b590a706b562$var$PREFIX}.teams`,
        defaultMessage: 'Teams',
        description: 'A new default title of primary People menu'
    },
    numMembers: {
        id: `${$3295b590a706b562$var$PREFIX}.num-members`,
        defaultMessage: `{memberCount, plural,
    one {# member}
    other {# members}
}`,
        description: 'Subtext of the number of members belonging to a team'
    }
});

});

parcelRegister("2wG5H", function(module, exports) {

$parcel$export(module.exports, "MenuGroupSection", () => $477401709299164a$export$33b4adfb29dd0d95);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");
var $Wkf8o = parcelRequire("Wkf8o");

var $iNxf2 = parcelRequire("iNxf2");

var $85Y0f = parcelRequire("85Y0f");
const $477401709299164a$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
    const { isSectionList: isSectionList = false } = (0, $5uXOq.useContext)((0, $iNxf2.PeopleMenuContext));
    if (!isLoading && isEmpty) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70rf1.default), {
        // title is undefined if we are loading as we show the heading skeleton below
        title: isLoading ? undefined : title,
        testId: testId,
        isList: isSectionList,
        children: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Wkf8o.default), {
                    testId: `${sectionType}-skeleton-heading`
                }),
                Array(maxItems).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $85Y0f.default), {}, `${sectionType}-${index}`))
            ]
        }) : children
    });
};

});
parcelRegister("85Y0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5190b60d8ab9969$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");


var $1sbWU = parcelRequire("1sbWU");
const $a5190b60d8ab9969$var$cssFn = ()=>{
    return {
        '&::before': {
            backgroundColor: `var(--ds-skeleton, ${0, $a7f8c6b391092279$export$8d43898f60b96a82})`,
            borderRadius: '100%',
            flexShrink: 0,
            content: '""',
            marginLeft: 0,
            marginRight: "var(--ds-space-150, 12px)",
            width: (0, $1sbWU.ICON_SIZE),
            height: (0, $1sbWU.ICON_SIZE)
        }
    };
};
function $a5190b60d8ab9969$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
        hasAvatar: true,
        cssFn: $a5190b60d8ab9969$var$cssFn,
        testId: "people-menu-skeleton-item"
    }));
}

});
parcelRegister("1sbWU", function(module, exports) {

$parcel$export(module.exports, "ICON_SIZE", () => $7ae8fe1078bb91c7$export$91a15f1424900d33);
$parcel$export(module.exports, "MAX_POPUP_WIDTH", () => $7ae8fe1078bb91c7$export$b0396be60c0e9152);
$parcel$export(module.exports, "MIN_POPUP_WIDTH", () => $7ae8fe1078bb91c7$export$3f133812f81dfa49);
$parcel$export(module.exports, "MAX_POPUP_HEIGHT", () => $7ae8fe1078bb91c7$export$94aaf6acd960c412);
$parcel$export(module.exports, "ImgIcon", () => $7ae8fe1078bb91c7$export$804b6389edcac2c2);
$parcel$export(module.exports, "Buggy", () => $7ae8fe1078bb91c7$export$6b52db8960fbef38);
$parcel$export(module.exports, "fireRenderPeopleNavMenuFail", () => $7ae8fe1078bb91c7$export$5884f4bd467a603a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $cFwjb = parcelRequire("cFwjb");

var $dQAmO = parcelRequire("dQAmO");

var $2WrI4 = parcelRequire("2WrI4");
const $7ae8fe1078bb91c7$export$91a15f1424900d33 = 32;
const $7ae8fe1078bb91c7$export$b0396be60c0e9152 = 480;
const $7ae8fe1078bb91c7$export$3f133812f81dfa49 = 320;
const $7ae8fe1078bb91c7$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $7ae8fe1078bb91c7$export$804b6389edcac2c2({ src: src, alt: alt }) {
    if ((0, $fHpHg.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFwjb.default), {
        size: "medium",
        src: src
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src || '',
        alt: alt,
        height: $7ae8fe1078bb91c7$export$91a15f1424900d33,
        width: $7ae8fe1078bb91c7$export$91a15f1424900d33,
        style: {
            borderRadius: $7ae8fe1078bb91c7$export$91a15f1424900d33 / 2
        }
    });
}
function $7ae8fe1078bb91c7$export$6b52db8960fbef38() {
    (0, $5uXOq.useEffect)(()=>{
        throw new Error('Something wrong inside People menu.');
    });
    return null;
}
const $7ae8fe1078bb91c7$export$5884f4bd467a603a = (error)=>{
    (0, $2WrI4.renderPeopleNavMenuExp).failure({
        metadata: {
            ...error && 'status' in error ? {
                status: error.status
            } : {},
            ...error instanceof (0, $dQAmO.ErrorWithContext) ? {
                context: error.context
            } : {},
            error: error?.message
        }
    });
};

});
parcelRegister("2WrI4", function(module, exports) {

$parcel$export(module.exports, "renderPeopleNavMenuExp", () => $00946cfff55e3eb3$export$a0db9187c809008d);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $kvWiC = parcelRequire("kvWiC");
class $00946cfff55e3eb3$var$UFOExperienceWithPackageContext extends (0, $kkzI0.UFOExperience) {
    async success() {
        return super.success({
            metadata: {
                ...(0, $kvWiC.packageContext)
            }
        });
    }
    async failure(config) {
        return super.failure({
            force: config?.force,
            metadata: {
                ...config?.metadata ?? {},
                ...(0, $kvWiC.packageContext)
            }
        });
    }
    async abort() {
        return super.abort({
            metadata: {
                ...(0, $kvWiC.packageContext)
            }
        });
    }
}
const $00946cfff55e3eb3$export$a0db9187c809008d = new $00946cfff55e3eb3$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("kvWiC", function(module, exports) {

$parcel$export(module.exports, "packageContext", () => $5a77557928925683$export$beac86d91b8e8b21);
const $5a77557928925683$export$beac86d91b8e8b21 = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});






parcelRegister("kUFRp", function(module, exports) {

$parcel$export(module.exports, "MenuGroupTeams", () => $061f49d56cabfd62$export$c3915c5ac3f99d49);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3TR0I = parcelRequire("3TR0I");

var $44qT7 = parcelRequire("44qT7");

var $lw9uA = parcelRequire("lw9uA");

var $96l9U = parcelRequire("96l9U");

var $iNxf2 = parcelRequire("iNxf2");

var $cc0xQ = parcelRequire("cc0xQ");

var $3q5sC = parcelRequire("3q5sC");
parcelRequire("lttJX");
var $albme = parcelRequire("albme");
var $lttJX = parcelRequire("lttJX");

var $kRpDN = parcelRequire("kRpDN");

var $2wG5H = parcelRequire("2wG5H");

var $1sbWU = parcelRequire("1sbWU");
const $061f49d56cabfd62$export$86c994b04df922e = (props)=>{
    const intl = (0, $koVbs.default)();
    const { orgId: orgId } = (0, $iNxf2.usePeopleMenuContext)();
    const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $cc0xQ.VOID_FUNC), pushRoute: pushRoute = (0, $cc0xQ.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $cc0xQ.VOID_FUNC) } = (0, $5uXOq.useContext)((0, $iNxf2.PeopleMenuContext));
    const handleClickOnTeam = (0, $5uXOq.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $3q5sC.isModifiedEvent)(event);
            (0, $lttJX.triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'team', event);
            if (isLeftClick) {
                const teamUrl = (0, $96l9U.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: id,
                    orgId: orgId,
                    ref: product,
                    src: (0, $albme.AnalyticsActionSubject).PEOPLE_MENU
                });
                pushRoute(teamUrl);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        orgId,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.teams.enabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2wG5H.MenuGroupSection), {
        title: remoteConfig.sections.teams.label ?? intl.formatMessage((0, $kRpDN.messages).yourTeams),
        testId: `${testId}-teams-section`,
        isLoading: isLoading,
        isEmpty: teams.length === 0,
        sectionType: 'team',
        maxItems: remoteConfig.sections.teams.maxItems,
        children: teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
                href: (0, $96l9U.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: team.id,
                    orgId: orgId
                }),
                onClick: handleClickOnTeam(team.id),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1sbWU.ImgIcon), {
                    src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                    alt: team.displayName
                }),
                description: intl.formatMessage((0, $kRpDN.messages).numMembers, {
                    memberCount: team.memberCount ?? 1
                }),
                testId: `${testId}-team-item`,
                children: team.displayName
            }, team.id))
    });
};
const $061f49d56cabfd62$export$c3915c5ac3f99d49 = (0, $3TR0I.default)()((0, $lw9uA.withMandatoryPeopleMenuConfiguration)($061f49d56cabfd62$export$86c994b04df922e));

});

parcelRegister("4z5Kg", function(module, exports) {

let $352ee332bbaa623d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $352ee332bbaa623d$var$load("3EV1h").then(()=>parcelRequire('7Ia8o'));

});


parcelRegister("g32Gp", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContentInternal", () => $1738e5069f20ec27$export$78306a734b6419e6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $ihijj = parcelRequire("ihijj");

var $iNxf2 = parcelRequire("iNxf2");

var $fGjLs = parcelRequire("fGjLs");

var $cc0xQ = parcelRequire("cc0xQ");

var $fTi46 = parcelRequire("fTi46");

var $eMBQd = parcelRequire("eMBQd");
const $1738e5069f20ec27$var$stopPropagation = (e)=>e.stopPropagation();
const $1738e5069f20ec27$export$78306a734b6419e6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $5uXOq.useContext)((0, $iNxf2.PeopleMenuContext));
    const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, $fGjLs.default)(isBrowseUsersEnabled);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: $1738e5069f20ec27$var$stopPropagation,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihijj.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fTi46.MenuContentFallback), {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fTi46.MenuContent), {
                isLoadingPermission: isLoadingPermission,
                hasPermission: hasPermission
            })
        })
    }));
});
const $1738e5069f20ec27$var$PeopleMenuContent = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMBQd.default), {
        isOpen: true,
        onOpen: (0, $cc0xQ.VOID_FUNC),
        onClose: (0, $cc0xQ.VOID_FUNC),
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($1738e5069f20ec27$export$78306a734b6419e6, {})
    });
};
var $1738e5069f20ec27$export$2e2bcd8739ae039 = $1738e5069f20ec27$var$PeopleMenuContent;

});
parcelRegister("fGjLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f965a374e741e4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $80f965a374e741e4$export$2e2bcd8739ae039(permissionPromise) {
    const noQuery = !permissionPromise;
    const [hasPermission, setPermission] = (0, $5uXOq.useState)(noQuery);
    const [loading, setLoading] = (0, $5uXOq.useState)(!noQuery);
    (0, $5uXOq.useEffect)(()=>{
        if (permissionPromise) permissionPromise().then((permissionResult)=>{
            setPermission(permissionResult);
            setLoading(false);
        }).catch(()=>{
            setPermission(false);
            setLoading(false);
        });
    }, [
        permissionPromise,
        setLoading,
        setPermission
    ]);
    return {
        loading: loading,
        hasPermission: hasPermission
    };
}

});

parcelRegister("eMBQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c903d59a55eb2bc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $dSfB8 = parcelRequire("dSfB8");

var $96l9U = parcelRequire("96l9U");

var $iNxf2 = parcelRequire("iNxf2");

var $kvWiC = parcelRequire("kvWiC");
parcelRequire("lttJX");
var $albme = parcelRequire("albme");

var $hS8LQ = parcelRequire("hS8LQ");
const $5c903d59a55eb2bc$var$defaultProps = {
    onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
    testId: 'menu',
    isSSR: false
};
/**
 * There are some essential higher components wrapping an actual PeopleMenu component:
 * - PeopleMenuContext: is used to avoid passing common props like cloudId
 * - IntlProvider: to make i18n working
 * - AnalyticsContext: is used to avoid passing many props for triggering analytics events
 * - ErrorBoundary: to capture any errors inside actual PeopleMenu component
 */ const $5c903d59a55eb2bc$var$PeopleMenuProviders = (props)=>{
    const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
        ...$5c903d59a55eb2bc$var$defaultProps,
        ...props
    };
    const analyticsContextData = {
        product: product,
        source: (0, $albme.AnalyticsSource).PEOPLE_MENU,
        componentName: (0, $albme.AnalyticsSource).PEOPLE_MENU,
        ...(0, $kvWiC.packageContext)
    };
    const commonPropsInContext = {
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: userId,
        isBrowseUsersEnabled: isBrowseUsersEnabled,
        isSSR: isSSR,
        testId: testId,
        tenantUrl: (0, $96l9U.trimLastForwardSlash)(tenantUrl),
        onClickedItem: onClickedItem,
        onClickedMenuLink: onClickedMenuLink,
        invitePeopleHandlers: invitePeopleHandlers,
        onOpen: onOpen,
        onClose: onClose,
        pushRoute: pushRoute,
        _hasError: _hasError,
        addFlag: addFlag,
        isPeopleMenuOpen: false,
        isOpen: isOpen,
        teamCreateDialogProps: teamCreateDialogProps,
        renotifyExperimentProps: renotifyExperimentProps,
        shouldRenderToParent: shouldRenderToParent,
        isSectionList: isSectionList
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iNxf2.PeopleMenuContextProvider), {
        ...commonPropsInContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dSfB8.LazyIntlProvider), {
            fetchLanguageFile: (0, $hS8LQ.fetchLanguageFile),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
                data: analyticsContextData,
                children: children
            })
        })
    });
};
var $5c903d59a55eb2bc$export$2e2bcd8739ae039 = $5c903d59a55eb2bc$var$PeopleMenuProviders;

});
parcelRegister("dSfB8", function(module, exports) {

$parcel$export(module.exports, "LazyIntlProvider", () => $fe72bcc7adefe026$export$b4f1ecc6daf5eb10);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");
const $fe72bcc7adefe026$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $fe72bcc7adefe026$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $fe72bcc7adefe026$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $fe72bcc7adefe026$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $fe72bcc7adefe026$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale, messages: allMessages = {} } = (0, $koVbs.default)();
    const { messages: messages } = $fe72bcc7adefe026$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    // Product might have already provided messages.
    // In the server-side environment, useFetchMessagesByLocale is noop we are relying on product to provide messages.
    for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
    return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $i5FdW.default), {
        ...rest,
        messages: allMessages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }, children);
};

});

parcelRegister("hS8LQ", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $c2afe7840c1c5457$export$c08b58fa4727b0d2);

var $lbEF2 = parcelRequire("lbEF2");
function $c2afe7840c1c5457$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $lbEF2.cs();
        case 'da-DK':
        case 'da':
            return $lbEF2.da();
        case 'de-DE':
        case 'de':
            return $lbEF2.de();
        case 'en-GB':
            return $lbEF2.engb();
        case 'en-US':
        case 'en':
            return $lbEF2.en();
        case 'en-ZZ':
            return $lbEF2.enzz();
        case 'es-ES':
        case 'es':
            return $lbEF2.es();
        case 'et-EE':
        case 'et':
            return $lbEF2.et();
        case 'fi-FI':
        case 'fi':
            return $lbEF2.fi();
        case 'fr-FR':
        case 'fr':
            return $lbEF2.fr();
        case 'hu-HU':
        case 'hu':
            return $lbEF2.hu();
        case 'is-IS':
        case 'is':
            return $lbEF2.is();
        case 'it-IT':
        case 'it':
            return $lbEF2.it();
        case 'ja-JP':
        case 'ja':
            return $lbEF2.ja();
        case 'ko-KR':
        case 'ko':
            return $lbEF2.ko();
        case 'nb-NB':
        case 'nb':
            return $lbEF2.nb();
        case 'nl-NL':
        case 'nl':
            return $lbEF2.nl();
        case 'pl-PL':
        case 'pl':
            return $lbEF2.pl();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $lbEF2.pt();
        case 'pt-BR':
        case 'pt_BR':
            return $lbEF2.ptbr();
        case 'ro-RO':
        case 'ro':
            return $lbEF2.ro();
        case 'ru-RU':
        case 'ru':
            return $lbEF2.ru();
        case 'sk-SK':
        case 'sk':
            return $lbEF2.sk();
        case 'sv-SE':
        case 'sv':
            return $lbEF2.sv();
        case 'tr-TR':
        case 'tr':
            return $lbEF2.tr();
        case 'th-TH':
        case 'th':
            return $lbEF2.th();
        case 'uk-UK':
        case 'uk':
            return $lbEF2.uk();
        case 'vi-VI':
        case 'vi':
            return $lbEF2.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $lbEF2.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $lbEF2.zh();
    }
    return $lbEF2.fallback();
}

});
parcelRegister("lbEF2", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $2797b2bac379b68f$export$bcd1dd1f397bba12);
$parcel$export(module.exports, "cs", () => $2797b2bac379b68f$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "da", () => $2797b2bac379b68f$export$8c8450b83b664ba4);
$parcel$export(module.exports, "de", () => $2797b2bac379b68f$export$2fa162a495d26869);
$parcel$export(module.exports, "en", () => $2797b2bac379b68f$export$84584c2a98eb6753);
$parcel$export(module.exports, "engb", () => $2797b2bac379b68f$export$141cd05f569bae45);
$parcel$export(module.exports, "enzz", () => $2797b2bac379b68f$export$a3f288d6c3177b8a);
$parcel$export(module.exports, "es", () => $2797b2bac379b68f$export$ca5e4045a55e76d2);
$parcel$export(module.exports, "et", () => $2797b2bac379b68f$export$457177dcde8472be);
$parcel$export(module.exports, "fi", () => $2797b2bac379b68f$export$ed5179c818622fb);
$parcel$export(module.exports, "fr", () => $2797b2bac379b68f$export$acb2a88f7d552ebf);
$parcel$export(module.exports, "hu", () => $2797b2bac379b68f$export$9901d21957972d53);
$parcel$export(module.exports, "is", () => $2797b2bac379b68f$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "it", () => $2797b2bac379b68f$export$3486a10f30cf1ee4);
$parcel$export(module.exports, "ja", () => $2797b2bac379b68f$export$8c6f505e9474ce90);
$parcel$export(module.exports, "ko", () => $2797b2bac379b68f$export$798cf677954c9533);
$parcel$export(module.exports, "nb", () => $2797b2bac379b68f$export$38ef0e3f791a121e);
$parcel$export(module.exports, "nl", () => $2797b2bac379b68f$export$9c64ee4d84d79ce1);
$parcel$export(module.exports, "pl", () => $2797b2bac379b68f$export$6ea5311eda92944f);
$parcel$export(module.exports, "pt", () => $2797b2bac379b68f$export$84175d5f1cb4e39d);
$parcel$export(module.exports, "ptbr", () => $2797b2bac379b68f$export$82924b14976e7373);
$parcel$export(module.exports, "ro", () => $2797b2bac379b68f$export$ea30ec7f37fb148d);
$parcel$export(module.exports, "ru", () => $2797b2bac379b68f$export$cf48009033a0126b);
$parcel$export(module.exports, "sk", () => $2797b2bac379b68f$export$d608fa5b5bfd2021);
$parcel$export(module.exports, "sv", () => $2797b2bac379b68f$export$65540e5f7f6e7dce);
$parcel$export(module.exports, "tr", () => $2797b2bac379b68f$export$72451b88a72ad9c2);
$parcel$export(module.exports, "th", () => $2797b2bac379b68f$export$d657bc098992a431);
$parcel$export(module.exports, "uk", () => $2797b2bac379b68f$export$312745a8a3013c00);
$parcel$export(module.exports, "vi", () => $2797b2bac379b68f$export$e3786bf10a8abdf2);
$parcel$export(module.exports, "zh", () => $2797b2bac379b68f$export$b65a7f08f2280505);
$parcel$export(module.exports, "zhtw", () => $2797b2bac379b68f$export$41779e6acd26e15f);
/* istanbul ignore file */ const $2797b2bac379b68f$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $2797b2bac379b68f$export$bde1ed0f60b38f2f = ()=>(parcelRequire("1deLX"));

const $2797b2bac379b68f$export$8c8450b83b664ba4 = ()=>(parcelRequire("e6fnD"));

const $2797b2bac379b68f$export$2fa162a495d26869 = ()=>(parcelRequire("5GfzZ"));

const $2797b2bac379b68f$export$84584c2a98eb6753 = ()=>(parcelRequire("iE0q9"));

const $2797b2bac379b68f$export$141cd05f569bae45 = ()=>(parcelRequire("kaiHF"));

const $2797b2bac379b68f$export$a3f288d6c3177b8a = ()=>(parcelRequire("1jue8"));

const $2797b2bac379b68f$export$ca5e4045a55e76d2 = ()=>(parcelRequire("70mYF"));

const $2797b2bac379b68f$export$457177dcde8472be = ()=>(parcelRequire("9r3Lm"));

const $2797b2bac379b68f$export$ed5179c818622fb = ()=>(parcelRequire("lP8J8"));

const $2797b2bac379b68f$export$acb2a88f7d552ebf = ()=>(parcelRequire("glDt5"));

const $2797b2bac379b68f$export$9901d21957972d53 = ()=>(parcelRequire("7pR6B"));

const $2797b2bac379b68f$export$226b3eccf92c9ed9 = ()=>(parcelRequire("9wpYr"));

const $2797b2bac379b68f$export$3486a10f30cf1ee4 = ()=>(parcelRequire("gEyc1"));

const $2797b2bac379b68f$export$8c6f505e9474ce90 = ()=>(parcelRequire("fHLBc"));

const $2797b2bac379b68f$export$798cf677954c9533 = ()=>(parcelRequire("49zjF"));

const $2797b2bac379b68f$export$38ef0e3f791a121e = ()=>(parcelRequire("1A5Qk"));

const $2797b2bac379b68f$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("ikEW9"));

const $2797b2bac379b68f$export$6ea5311eda92944f = ()=>(parcelRequire("3fr8I"));

const $2797b2bac379b68f$export$84175d5f1cb4e39d = ()=>(parcelRequire("108Y1"));

const $2797b2bac379b68f$export$82924b14976e7373 = ()=>(parcelRequire("79DuY"));

const $2797b2bac379b68f$export$ea30ec7f37fb148d = ()=>(parcelRequire("4CDsZ"));

const $2797b2bac379b68f$export$cf48009033a0126b = ()=>(parcelRequire("5jYVt"));

const $2797b2bac379b68f$export$d608fa5b5bfd2021 = ()=>(parcelRequire("iAhA1"));

const $2797b2bac379b68f$export$65540e5f7f6e7dce = ()=>(parcelRequire("fyGB0"));

const $2797b2bac379b68f$export$72451b88a72ad9c2 = ()=>(parcelRequire("f51Fb"));

const $2797b2bac379b68f$export$d657bc098992a431 = ()=>(parcelRequire("efW7q"));

const $2797b2bac379b68f$export$312745a8a3013c00 = ()=>(parcelRequire("fFqLI"));

const $2797b2bac379b68f$export$e3786bf10a8abdf2 = ()=>(parcelRequire("ktmV7"));

const $2797b2bac379b68f$export$b65a7f08f2280505 = ()=>(parcelRequire("958CB"));

const $2797b2bac379b68f$export$41779e6acd26e15f = ()=>(parcelRequire("aG4oE"));

});
parcelRegister("1deLX", function(module, exports) {

let $0e2276dc4b0e2820$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e2276dc4b0e2820$var$load("gkh6m").then(()=>parcelRequire('r2SOn'));

});

parcelRegister("e6fnD", function(module, exports) {

let $a43d8e6e7ffbf135$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a43d8e6e7ffbf135$var$load("eG1Xn").then(()=>parcelRequire('jGDFM'));

});

parcelRegister("5GfzZ", function(module, exports) {

let $01113dc5461b1e79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01113dc5461b1e79$var$load("kPnD9").then(()=>parcelRequire('14lP6'));

});

parcelRegister("iE0q9", function(module, exports) {

let $d92c49fcc7e38261$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d92c49fcc7e38261$var$load("l382X").then(()=>parcelRequire('9bC9u'));

});

parcelRegister("kaiHF", function(module, exports) {

let $eae33fe48e514679$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eae33fe48e514679$var$load("jUQ6g").then(()=>parcelRequire('iBxSM'));

});

parcelRegister("1jue8", function(module, exports) {

let $0f4f033c420c1d11$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f4f033c420c1d11$var$load("gEIYt").then(()=>parcelRequire('lhqX4'));

});

parcelRegister("70mYF", function(module, exports) {

let $519a5b54ba97f993$var$load = (parcelRequire("28QjX"))(4);
module.exports = $519a5b54ba97f993$var$load("joQMp").then(()=>parcelRequire('74aXU'));

});

parcelRegister("9r3Lm", function(module, exports) {

let $6de98de340e42860$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6de98de340e42860$var$load("5EbaC").then(()=>parcelRequire('7fJUH'));

});

parcelRegister("lP8J8", function(module, exports) {

let $fe3521621fd9507a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fe3521621fd9507a$var$load("6DtEX").then(()=>parcelRequire('2DoyO'));

});

parcelRegister("glDt5", function(module, exports) {

let $be6d390c8aac6dea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be6d390c8aac6dea$var$load("gTvfg").then(()=>parcelRequire('9ipKH'));

});

parcelRegister("7pR6B", function(module, exports) {

let $56640fd505df7d80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56640fd505df7d80$var$load("865P1").then(()=>parcelRequire('8CbBt'));

});

parcelRegister("9wpYr", function(module, exports) {

let $6eeb40101c493c0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6eeb40101c493c0e$var$load("kiizO").then(()=>parcelRequire('6CRYa'));

});

parcelRegister("gEyc1", function(module, exports) {

let $c1fae7c38da3eea9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1fae7c38da3eea9$var$load("aXkEN").then(()=>parcelRequire('lmUCo'));

});

parcelRegister("fHLBc", function(module, exports) {

let $b6efcb57088894f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6efcb57088894f4$var$load("7rcGV").then(()=>parcelRequire('8m1Bh'));

});

parcelRegister("49zjF", function(module, exports) {

let $306365bf67e4a431$var$load = (parcelRequire("28QjX"))(4);
module.exports = $306365bf67e4a431$var$load("i9cIJ").then(()=>parcelRequire('9ZGxr'));

});

parcelRegister("1A5Qk", function(module, exports) {

let $126daf8e3e8591fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $126daf8e3e8591fb$var$load("BMgcY").then(()=>parcelRequire('6g4Qr'));

});

parcelRegister("ikEW9", function(module, exports) {

let $d589d97e0c7589a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d589d97e0c7589a7$var$load("luXp7").then(()=>parcelRequire('jxfzD'));

});

parcelRegister("3fr8I", function(module, exports) {

let $25d7d32d850f86e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25d7d32d850f86e0$var$load("dgRmO").then(()=>parcelRequire('czrdJ'));

});

parcelRegister("108Y1", function(module, exports) {

let $0bacbf38c4f67d56$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0bacbf38c4f67d56$var$load("6rLYG").then(()=>parcelRequire('a0Gw9'));

});

parcelRegister("79DuY", function(module, exports) {

let $5358034444b831eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5358034444b831eb$var$load("45q0r").then(()=>parcelRequire('cWJwp'));

});

parcelRegister("4CDsZ", function(module, exports) {

let $35d95342d6593efd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35d95342d6593efd$var$load("4bUqM").then(()=>parcelRequire('gbydu'));

});

parcelRegister("5jYVt", function(module, exports) {

let $3dfdfcb6fb2cba8d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3dfdfcb6fb2cba8d$var$load("dMW5n").then(()=>parcelRequire('iBrfY'));

});

parcelRegister("iAhA1", function(module, exports) {

let $d87939cddbb737dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d87939cddbb737dc$var$load("2i0cR").then(()=>parcelRequire('9WvK0'));

});

parcelRegister("fyGB0", function(module, exports) {

let $b53b12a3f37dcc90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b53b12a3f37dcc90$var$load("bNaT5").then(()=>parcelRequire('jDiYr'));

});

parcelRegister("f51Fb", function(module, exports) {

let $afa89cef984f6e79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $afa89cef984f6e79$var$load("5ibOe").then(()=>parcelRequire('2eGaK'));

});

parcelRegister("efW7q", function(module, exports) {

let $a60f8c9a67b57877$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a60f8c9a67b57877$var$load("YI4h0").then(()=>parcelRequire('KXWjy'));

});

parcelRegister("fFqLI", function(module, exports) {

let $b67f73098b27823c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b67f73098b27823c$var$load("fhcZ6").then(()=>parcelRequire('l5cZL'));

});

parcelRegister("ktmV7", function(module, exports) {

let $ee784b8beaf34fc6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee784b8beaf34fc6$var$load("bZIBF").then(()=>parcelRequire('jLRNT'));

});

parcelRegister("958CB", function(module, exports) {

let $69cb44c183fe9f66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69cb44c183fe9f66$var$load("bFTpM").then(()=>parcelRequire('f6twy'));

});

parcelRegister("aG4oE", function(module, exports) {

let $0201917ea870b33d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0201917ea870b33d$var$load("9cLQA").then(()=>parcelRequire('lfsMF'));

});





parcelRegister("3Xscx", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuTriggerSSR", () => $6b84f9dc98ed4f2e$export$7e1e2ab520ce5d59);
$parcel$export(module.exports, "default", () => $6b84f9dc98ed4f2e$export$2e2bcd8739ae039);
// eslint-disable @atlaskit/design-system/no-legacy-icons

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jRAgj = parcelRequire("jRAgj");

var $GYj5l = parcelRequire("GYj5l");

var $LD2gx = parcelRequire("LD2gx");

var $7H980 = parcelRequire("7H980");

var $lw9uA = parcelRequire("lw9uA");

var $iNxf2 = parcelRequire("iNxf2");

var $kRpDN = parcelRequire("kRpDN");

var $exIYQ = parcelRequire("exIYQ");

var $eisxT = parcelRequire("eisxT");
function $6b84f9dc98ed4f2e$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
    const remoteConfig = (0, $lw9uA.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRAgj.PrimaryDropdownButton), {
        testId: `${testId}-people-primary-button-ssr`,
        children: navLabel ? navLabel : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $kRpDN.messages).teams
        })
    });
}
function $6b84f9dc98ed4f2e$var$PeopleMenuTrigger(props) {
    const { isSpotlightActive: isSpotlightActive, renotifyExperimentProps: renotifyExperimentProps } = (0, $iNxf2.usePeopleMenuContext)();
    const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
    const buttonProps = (0, $5uXOq.useMemo)(()=>({
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId
        }), [
        isSelected,
        onClick,
        onMouseEnter,
        testId
    ]);
    const remoteConfig = (0, $lw9uA.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    const chevron = customChevronIcon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LD2gx))), {
        label: "dropdown-chevron",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($GYj5l)))
    });
    const renderPrimaryDropDownButton = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRAgj.PrimaryDropdownButton), {
            isHighlighted: isHighlighted,
            ...buttonProps,
            ...triggerProps,
            children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $kRpDN.messages).teams
            })
        });
    }, [
        buttonProps,
        isHighlighted,
        navLabel,
        triggerProps
    ]);
    if (isVisible) {
        if (renotifyExperimentProps?.isEnrolled && isSpotlightActive !== false) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: renderPrimaryDropDownButton(),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $exIYQ.RenotifySpotlight), {
                "data-testid": "renotify-spotlight-trigger",
                setIsOpen: onClick,
                renderFallback: renderPrimaryDropDownButton,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eisxT.default), {
                    testId: "renotify-menu-trigger-button",
                    triggerProps: triggerProps,
                    children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $kRpDN.messages).teams
                    })
                })
            })
        });
        return renderPrimaryDropDownButton();
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
        iconAfter: chevron,
        ...triggerProps,
        ...buttonProps,
        children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $kRpDN.messages).teams
        })
    });
}
var $6b84f9dc98ed4f2e$export$2e2bcd8739ae039 = $6b84f9dc98ed4f2e$var$PeopleMenuTrigger;

});
parcelRegister("exIYQ", function(module, exports) {

$parcel$export(module.exports, "RenotifySpotlight", () => $a4ae90955420fdaf$export$c598a42b0405f75);

var $5uXOq = parcelRequire("5uXOq");

const $a4ae90955420fdaf$export$c598a42b0405f75 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("8KYpa")));

});
parcelRegister("8KYpa", function(module, exports) {

let $660179c529367bca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $660179c529367bca$var$load("kgq9d").then(()=>parcelRequire('lhR6s'));

});


parcelRegister("eisxT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9592ccf2bf6287$export$2e2bcd8739ae039);
/* RenotifyMenuButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eXSfx = parcelRequire("eXSfx");

var $cUaD8 = parcelRequire("cUaD8");

var $jVpd1 = parcelRequire("jVpd1");

var $gU15o = parcelRequire("gU15o");
function $0a9592ccf2bf6287$var$RenotifyMenuButton(props) {
    const { testId: testId, triggerProps: triggerProps, children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eXSfx.PrimaryButton), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "renotify-menu-button",
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU15o.RenotifySpotlightTriggerChevron), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))), {
                label: "dropdown-chevron",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cUaD8)))
            })
        }),
        ...triggerProps,
        children: children
    });
}
var $0a9592ccf2bf6287$export$2e2bcd8739ae039 = $0a9592ccf2bf6287$var$RenotifyMenuButton;

});
parcelRegister("gU15o", function(module, exports) {

$parcel$export(module.exports, "RenotifyModalWidthFull", () => $2c2c901681854635$export$1b5dc0ba5fe67cdb);
$parcel$export(module.exports, "RenotifyModalUsersContainer", () => $2c2c901681854635$export$ecd3b6bfab51e27c);
$parcel$export(module.exports, "RenotifySpotlightTriggerChevron", () => $2c2c901681854635$export$bdd40b9dcae00142);
$parcel$export(module.exports, "RenotifySpotlightContent", () => $2c2c901681854635$export$75293539a002acf6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $70rf1 = parcelRequire("70rf1");


var $bWGt6 = parcelRequire("bWGt6");
function $2c2c901681854635$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c2c901681854635$export$82eb61f2818fcdcb = /*#__PURE__*/ (0, $bWGt6.default)((0, $70rf1.default), {
    target: "e11sj30a4"
})({
    maxWidth: '300px',
    padding: "var(--ds-space-200, 16px)",
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${(0, $a7f8c6b391092279$export$1cc05bbbf340e559)})`,
    '&::before': {
        height: "var(--ds-space-0, 0px)"
    },
    '&::after': {
        height: "var(--ds-space-0, 0px)"
    }
});
const $2c2c901681854635$export$1b5dc0ba5fe67cdb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e11sj30a3"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $2c2c901681854635$export$ecd3b6bfab51e27c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e11sj30a2"
})({
    name: "cjcfh5",
    styles: "height:fit-content;max-height:174px;overflow-y:auto;margin-top:var(--ds-space-200, 16px);padding-top:var(--ds-space-100, 8px)"
});
const $2c2c901681854635$export$bdd40b9dcae00142 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e11sj30a1"
})({
    name: "x63kpl",
    styles: "margin-left:var(--ds-space-negative-100, -8px);margin-right:var(--ds-space-negative-100, -8px);opacity:0.5"
});
const $2c2c901681854635$export$75293539a002acf6 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e11sj30a0"
})({
    name: "kzyyo8",
    styles: "margin-top:var(--ds-space-050, 4px);margin-bottom:var(--ds-space-100, 8px)"
});

});



parcelRegister("gQNaE", function(module, exports) {

$parcel$export(module.exports, "UsersTeamsPreFetch", () => $b024368e4ba1aad0$export$ffb64487c0de3976);

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");

var $74T2L = parcelRequire("74T2L");

var $jP9gu = parcelRequire("jP9gu");

var $ejWgu = parcelRequire("ejWgu");

var $lttJX = parcelRequire("lttJX");
function $b024368e4ba1aad0$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent, renotifyExperiment: renotifyExperiment }) {
    (0, $5uXOq.useEffect)(()=>{
        (0, $lttJX.triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
        // measure duration time of fetching users and teams data
        (0, $ejWgu.startMeasure)('fetchingData');
    }, [
        createAnalyticsEvent
    ]);
    const { isLoading: isLoading } = (0, $jP9gu.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    /*
	 * This hook checks the renotify experiments eligibility passed from Jira
	 * and will only take action if enrolled. It makes a single call to
	 * Experiment-API which proxies a call to Hydra and Identity Gatekeeper
	 * to return users who have been invited to Jira but not accepted.
	 */ (0, $74T2L.usePendingUsers)({
        cloudId: cloudId,
        startFetching: true,
        renotifyExperiment: renotifyExperiment
    });
    // stop to measure fetching data time when isLoading is finished.
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) (0, $ejWgu.stopMeasure)('fetchingData', (duration, startTime)=>{
            (0, $lttJX.triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isLoading
    ]);
    return null;
}
const $b024368e4ba1aad0$export$ffb64487c0de3976 = (0, $3TR0I.default)()($b024368e4ba1aad0$export$50ca75733630fce1);

});



parcelRegister("gAdxH", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $277517654b5bade7$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $7jOIT = parcelRequire("7jOIT");
var $7eaNr = parcelRequire("7eaNr");
parcelRequire("5uXOq");
const $277517654b5bade7$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7eaNr.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jOIT.default), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7jOIT.default), {
        ...rest
    });
};

});
parcelRegister("7jOIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a27a5aea4a5b8cf$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7eaNr = parcelRequire("7eaNr");

var $3bXN5 = parcelRequire("3bXN5");

var $99SnD = parcelRequire("99SnD");

var $8SFlq = parcelRequire("8SFlq");

var $1Seuh = parcelRequire("1Seuh");

var $5NTkF = parcelRequire("5NTkF");

var $jdJH0 = parcelRequire("jdJH0");
const $0a27a5aea4a5b8cf$var$MAX_INPUT_LENGTH = 500;
const $0a27a5aea4a5b8cf$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $7eaNr.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $5NTkF.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdJH0.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $99SnD.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3bXN5.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SFlq.SearchIcon), {
                                theme: theme,
                                isExpanded: false,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SFlq.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $0a27a5aea4a5b8cf$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $0a27a5aea4a5b8cf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($0a27a5aea4a5b8cf$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("7eaNr", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $b3c9805a0e5cad96$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $b3c9805a0e5cad96$export$93d4e7f90805808f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $b3c9805a0e5cad96$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
            borderColor: `var(--ds-border-input, ${(0, $a7f8c6b391092279$export$d6447c357493214f)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $a7f8c6b391092279$export$d6447c357493214f)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $b3c9805a0e5cad96$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $b3c9805a0e5cad96$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, $b3c9805a0e5cad96$export$e6c62eb05a8288ed.default, searchCSS);
};
const $b3c9805a0e5cad96$var$ctx = /*#__PURE__*/ (0, $5uXOq.createContext)($b3c9805a0e5cad96$export$e6c62eb05a8288ed.default);
const $b3c9805a0e5cad96$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $b3c9805a0e5cad96$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b3c9805a0e5cad96$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $b3c9805a0e5cad96$export$93d4e7f90805808f = ()=>{
    return (0, $5uXOq.useContext)($b3c9805a0e5cad96$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $b3c9805a0e5cad96$export$f9bb738f552c610d = $b3c9805a0e5cad96$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $b3c9805a0e5cad96$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("3bXN5", function(module, exports) {

$parcel$export(module.exports, "MobileSearchIconWrapper", () => $d232cabe082093d7$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $d232cabe082093d7$export$9673cb6b61244e6e);
$parcel$export(module.exports, "InputBoxOverlayRight", () => $d232cabe082093d7$export$1da38d078e896a10);
$parcel$export(module.exports, "ClearIconWrapper", () => $d232cabe082093d7$export$ff9b1a25d343474d);
$parcel$export(module.exports, "ArrowIconWrapper", () => $d232cabe082093d7$export$54c466678ae7c638);
$parcel$export(module.exports, "SearchInputContainer", () => $d232cabe082093d7$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $d232cabe082093d7$export$b6261a2c5ea449d);
$parcel$export(module.exports, "HiddenTooltip", () => $d232cabe082093d7$export$ca6fe3402791d08e);
$parcel$export(module.exports, "SSRsearchInputField", () => $d232cabe082093d7$export$6d53dccb772ed720);
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $d232cabe082093d7$export$c47d4a3e1f1297f1);
$parcel$export(module.exports, "SSRformContainer", () => $d232cabe082093d7$export$58ae19ee1fc7be8a);
$parcel$export(module.exports, "SSRsearchInputContainer", () => $d232cabe082093d7$export$b40f2abde293e8e4);
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $d232cabe082093d7$export$eb4e9f55bbe045df);
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $d232cabe082093d7$export$3f33ed4b273b43d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1Jlkv = parcelRequire("1Jlkv");

var $3GEkU = parcelRequire("3GEkU");


var $kU1q1 = parcelRequire("kU1q1");

var $fHpHg = parcelRequire("fHpHg");

var $8vDSm = parcelRequire("8vDSm");

var $bWGt6 = parcelRequire("bWGt6");
function $d232cabe082093d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d232cabe082093d7$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $d232cabe082093d7$export$63e083aca343a6ae = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eq4kchp14"
})("display:none;@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $d232cabe082093d7$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp13"
})("width:", (0, $3GEkU.grid).multiple(2).px, ";height:", (0, $3GEkU.grid).multiple(2).px, ";position:absolute;top:", (0, $3GEkU.grid).px, ";left:", (0, $3GEkU.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $a7f8c6b391092279$export$fbda843f0a27fe96})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:none;}");
const $d232cabe082093d7$export$1da38d078e896a10 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp12"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){right:24px;}");
const $d232cabe082093d7$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp11"
})("width:", (0, $3GEkU.grid).multiple(2).px, ";height:", (0, $3GEkU.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`, ";}&>span>svg{vertical-align:unset;}");
const $d232cabe082093d7$export$54c466678ae7c638 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp10"
})("display:none;margin:0 ", (0, $3GEkU.grid).px, ";height:", (0, $3GEkU.grid).multiple(4).px, ";padding-bottom:", (0, $3GEkU.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $d232cabe082093d7$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $d232cabe082093d7$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp9"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $f8Sb3.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $3GEkU.dialogWidth) : (0, $3GEkU.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $d232cabe082093d7$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)(styles, " @media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $3GEkU.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d232cabe082093d7$var$SearchInputFieldOld = /*#__PURE__*/ (0, $bWGt6.default)("input", {
    target: "eq4kchp8"
})("height:", (0, $3GEkU.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $d232cabe082093d7$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $3GEkU.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $3GEkU.grid).multiple(1.5).px} ${(0, $3GEkU.grid).multiple(0.25).px};
            margin: 0 ${(0, $3GEkU.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, ";");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d232cabe082093d7$var$SearchInputFieldWithMobileFix = /*#__PURE__*/ (0, $bWGt6.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $3GEkU.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $d232cabe082093d7$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $3GEkU.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $3GEkU.grid).multiple(1.5).px} ${(0, $3GEkU.grid).multiple(0.25).px};
            margin: 0 ${(0, $3GEkU.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $kU1q1.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");
const $d232cabe082093d7$export$b6261a2c5ea449d = (0, $8vDSm.componentWithCondition)(()=>(0, $fHpHg.fg)('jira_mobile_search_responsiveness'), $d232cabe082093d7$var$SearchInputFieldWithMobileFix, $d232cabe082093d7$var$SearchInputFieldOld);
const $d232cabe082093d7$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $bWGt6.default)((0, $1Jlkv.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $d232cabe082093d7$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $bWGt6.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $3GEkU.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $a7f8c6b391092279$export$d6447c357493214f})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $a7f8c6b391092279$export$fbda843f0a27fe96)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $a7f8c6b391092279$export$d6447c357493214f})`}`, ";}@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:none;}");
const $d232cabe082093d7$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp4"
})("position:relative;height:32px;@media screen and (min-width: 781px){min-width:", (props)=>props.shouldFillContainer ? '100%' : '200px', ";}", (props)=>props.shouldFillContainer ? 'width: 100%;' : '', ";");
const $d232cabe082093d7$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $d232cabe082093d7$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $3GEkU.collapsedSearchInputWidth;
}, ";");
const $d232cabe082093d7$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $3GEkU.grid).multiple(2).px, ";height:", (0, $3GEkU.grid).multiple(2).px, ";position:absolute;top:", (0, $3GEkU.grid).px, ";left:", (0, $3GEkU.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:none;}");
const $d232cabe082093d7$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $3GEkU.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){display:flex;}");

});
parcelRegister("3GEkU", function(module, exports) {

$parcel$export(module.exports, "zIndex", () => $4edf45a6a323767c$export$56446adcecbeec34);
$parcel$export(module.exports, "grid", () => $4edf45a6a323767c$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $4edf45a6a323767c$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $4edf45a6a323767c$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $4edf45a6a323767c$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $4edf45a6a323767c$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $4edf45a6a323767c$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $4edf45a6a323767c$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $4edf45a6a323767c$export$30310ee354b45eb0);
$parcel$export(module.exports, "primaryTextColour", () => $4edf45a6a323767c$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $4edf45a6a323767c$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $4edf45a6a323767c$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $4edf45a6a323767c$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $4edf45a6a323767c$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $b4a3S = parcelRequire("b4a3S");

function $4edf45a6a323767c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4edf45a6a323767c$var$GRID_UNIT = (0, $b4a3S.gridSize)();
const $4edf45a6a323767c$var$AkGrid = (num = 1)=>({
        px: `${num * $4edf45a6a323767c$var$GRID_UNIT}px`,
        unitless: num * $4edf45a6a323767c$var$GRID_UNIT,
        multiple: (multiplier)=>$4edf45a6a323767c$var$AkGrid(multiplier * num),
        half: ()=>$4edf45a6a323767c$var$AkGrid(0.5 * num),
        twice: ()=>$4edf45a6a323767c$var$AkGrid(2 * num)
    });
const $4edf45a6a323767c$export$56446adcecbeec34 = {
    searchDialog: (0, $b4a3S.layers).dialog()
};
const $4edf45a6a323767c$export$85fc379452d91af0 = $4edf45a6a323767c$var$AkGrid(1);
const $4edf45a6a323767c$export$b9930dabfa4a3a3 = '56px';
const $4edf45a6a323767c$export$f6af7620e8789c39 = '200px';
const $4edf45a6a323767c$export$64d8573e83b64ff8 = '150px';
const $4edf45a6a323767c$export$a3da89b899389ed8 = '780px';
const $4edf45a6a323767c$export$ce4512df260a325a = 780;
const $4edf45a6a323767c$export$a406031ed42c8e02 = '1130px';
const $4edf45a6a323767c$export$e00021bea368c518 = $4edf45a6a323767c$export$85fc379452d91af0.multiple(4);
const $4edf45a6a323767c$export$30310ee354b45eb0 = $4edf45a6a323767c$export$85fc379452d91af0.multiple(6);
const $4edf45a6a323767c$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $a7f8c6b391092279$export$fbda843f0a27fe96)})`;
const $4edf45a6a323767c$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`;
const $4edf45a6a323767c$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`;
const $4edf45a6a323767c$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $a7f8c6b391092279$export$b48405b95304b5a1)})`;
const $4edf45a6a323767c$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});

parcelRegister("8vDSm", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $4b4964ec75f7ce7e$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $4b4964ec75f7ce7e$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("99SnD", function(module, exports) {

$parcel$export(module.exports, "AbsoluteContainer", () => $d0171bc59df793ba$export$36aa0f4a98890c96);
$parcel$export(module.exports, "SearchDialogAnchor", () => $d0171bc59df793ba$export$f565ce1043dae7c9);
$parcel$export(module.exports, "SearchAnchorWrapper", () => $d0171bc59df793ba$export$dfece74a62f1398d);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $d0171bc59df793ba$export$5566658d36f6ca7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $3GEkU = parcelRequire("3GEkU");

var $bWGt6 = parcelRequire("bWGt6");
const $d0171bc59df793ba$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "exl9bxq3"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $3GEkU.zIndex).searchDialog
    });
    return {};
});
const $d0171bc59df793ba$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "exl9bxq2"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)("@media screen and (max-width: ", (0, $3GEkU.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $3GEkU.zIndex).searchDialog, ";left:calc((100% - ", (0, $3GEkU.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $3GEkU.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $d0171bc59df793ba$export$dfece74a62f1398d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "exl9bxq1"
})("position:relative;@media screen and (min-width: ", (0, $3GEkU.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $3GEkU.inputFieldHeight).px, ";height:", (0, $3GEkU.inputFieldHeight).px, ";");
const $d0171bc59df793ba$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $bWGt6.default)($d0171bc59df793ba$export$dfece74a62f1398d, {
    target: "exl9bxq0"
})("height:", (props)=>props.isExpanded ? (0, $3GEkU.enlargedInputFieldHeight).px : (0, $3GEkU.inputFieldHeight).px, ";");

});

parcelRegister("8SFlq", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $33565bf405f811dd$export$82eafebb825fc23f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4QlcP = parcelRequire("4QlcP");

const $33565bf405f811dd$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $a7f8c6b391092279$export$7d61b15e0da132af})`, label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4QlcP))), {
        label: label,
        LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
        LEGACY_size: size,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });

});

parcelRegister("5NTkF", function(module, exports) {

$parcel$export(module.exports, "getInputSkeletonQuery", () => $51785b11f029bb97$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $51785b11f029bb97$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $51785b11f029bb97$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $51785b11f029bb97$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $51785b11f029bb97$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $51785b11f029bb97$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $51785b11f029bb97$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $51785b11f029bb97$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $51785b11f029bb97$export$c830bcf42e072a93);
const $51785b11f029bb97$export$b8b6c2e7a0664212 = ()=>{
    return window?.inputSkeletonState?.query || '';
};
const $51785b11f029bb97$export$baa1c819dd4691f3 = (newQuery)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.query = newQuery;
};
const $51785b11f029bb97$export$38fcbc98be180790 = ()=>{
    return window?.inputSkeletonState?.isFocused || false;
};
const $51785b11f029bb97$export$d3c6894b4e9af000 = (newIsFocused)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.isFocused = newIsFocused;
};
const $51785b11f029bb97$export$a0c71b3bd9ec143c = ()=>{
    const selectionStart = window?.inputSkeletonState?.selectionStart || 0;
    const selectionEnd = window?.inputSkeletonState?.selectionEnd || 0;
    const selectionDirection = window?.inputSkeletonState?.selectionDirection || 'none';
    return {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        selectionDirection: selectionDirection
    };
};
const $51785b11f029bb97$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    if (window?.inputSkeletonState) {
        window.inputSkeletonState.selectionStart = newSelectionStart;
        window.inputSkeletonState.selectionEnd = newSelectionEnd;
        window.inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $51785b11f029bb97$export$c89dd2d5d4024c5e = ()=>{
    window.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $51785b11f029bb97$export$166ce39761ad7743 = ()=>{
    if (window.inputSkeletonState) {
        window.inputSkeletonState.listeners.forEach((ssrEventListener)=>{
            const [target, event, handler] = ssrEventListener;
            target.removeEventListener(event, handler);
        });
        window.inputSkeletonState.listeners = [];
    }
};
const $51785b11f029bb97$export$c830bcf42e072a93 = ()=>{
    if (window['inputSkeletonState']) {
        $51785b11f029bb97$export$166ce39761ad7743();
        delete window['inputSkeletonState'];
    }
};

});

parcelRegister("jdJH0", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bXN5 = parcelRequire("3bXN5");


var $8SFlq = parcelRequire("8SFlq");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3bXN5.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SFlq.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SFlq.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bXN5.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $b3902bbc58576585$export$bc237d627614fc48)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});
/* eslint-disable */ // @ts-ignore
const $b3902bbc58576585$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;




parcelRegister("gKzaO", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $579f55e1549c51eb$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $579f55e1549c51eb$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID'
};

});

parcelRegister("edoq1", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $3dde691e9036e90d$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $49NSg = parcelRequire("49NSg");
var $bngFq = parcelRequire("bngFq");

var $2Fuel = parcelRequire("2Fuel");

var $gKzaO = parcelRequire("gKzaO");

var $gGnIB = parcelRequire("gGnIB");

var $lWJUO = parcelRequire("lWJUO");
const $3dde691e9036e90d$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $3dde691e9036e90d$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $3dde691e9036e90d$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef } = (0, $2Fuel.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $5uXOq.useCallback)((inputPayload)=>{
        const payload = inputPayload instanceof (0, $49NSg.default) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $3dde691e9036e90d$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const getDefaultAttributes = (0, $5uXOq.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader } = propertiesRef.current;
        return {
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $gKzaO.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $5uXOq.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$3dde691e9036e90d$var$DEFAULT_TAGS
        ];
        if ($3dde691e9036e90d$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, invokedPlugins: invokedPlugins } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        // Core AI MAU payload
        let eventPayload = {
            eventType: 'track',
            tags: tags,
            source: source,
            actionSubjectId: subjectId,
            attributes: attributes
        };
        // Handle specific AI MAU events
        switch(payload.type){
            case 'initiated':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'initiated'
                };
                break;
            case 'viewed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'viewed'
                };
                break;
            case 'error':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'error'
                };
                break;
            case 'dismissed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'dismissed'
                };
                break;
            case 'actioned':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'actioned',
                    attributes: {
                        ...eventPayload.attributes,
                        aiResultAction: payload.actionResult
                    }
                };
                break;
            case 'feedback':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiFeedback',
                    action: 'submitted',
                    attributes: {
                        ...eventPayload.attributes,
                        aiFeedbackResult: payload.feedbackResult
                    }
                };
                break;
        }
        // Build event and apply context attributes
        const event = createAnalyticsEvent(eventPayload);
        const aiMateContextAttributes = (0, $lWJUO.getAttributesFromContexts)(event.context);
        // Fire
        event.update({
            attributes: {
                ...event.payload.attributes,
                ...aiMateContextAttributes
            }
        }).fire((0, $gGnIB.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        getDefaultAttributes
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $3dde691e9036e90d$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if (payload instanceof (0, $49NSg.default)) {
            const aiMateContextAttributes = (0, $lWJUO.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $gGnIB.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $lWJUO.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $gGnIB.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent
    };
};

});
parcelRegister("2Fuel", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $26fb75e6ea5d3842$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $26fb75e6ea5d3842$export$ab8aa3dfd687f012);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");
const $26fb75e6ea5d3842$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: ''
};
const $26fb75e6ea5d3842$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    propertiesRef: {
        current: {
            ...$26fb75e6ea5d3842$var$initialState
        }
    },
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $26fb75e6ea5d3842$export$1aefd27d2ed3c1c9 = ({ children: children })=>{
    const propertiesRef = (0, $5uXOq.useRef)({
        ...$26fb75e6ea5d3842$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $5uXOq.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            propertiesRef: propertiesRef,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($26fb75e6ea5d3842$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $26fb75e6ea5d3842$export$a00cd3c213413389 = ({ source: source, children: children })=>{
    const data = (0, $5uXOq.useMemo)(()=>({
            source: source
        }), [
        source
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($26fb75e6ea5d3842$export$1aefd27d2ed3c1c9, {
            children: children
        })
    });
};
const $26fb75e6ea5d3842$export$ab8aa3dfd687f012 = ()=>{
    return (0, $5uXOq.useContext)($26fb75e6ea5d3842$var$AnalyticsPropertiesContext);
};

});

parcelRegister("gGnIB", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $dc667349c777c15f$export$85183a312807388d);

var $lniFT = parcelRequire("lniFT");
const $dc667349c777c15f$export$85183a312807388d = (0, $lniFT.FabricChannel).aiMate;

});

parcelRegister("lWJUO", function(module, exports) {

$parcel$export(module.exports, "getAttributesFromContexts", () => $b12b87b56315e5a7$export$d97c97ed77ff09e8);

var $cnhic = parcelRequire("cnhic");
const $b12b87b56315e5a7$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return true;
};
const $b12b87b56315e5a7$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let aiMateOnly = context.filter((x)=>$b12b87b56315e5a7$var$isSourceAndAttributes(x) && x.source === 'AIMate' || x[0, $cnhic.AI_MATE_CONTEXT]);
    return aiMateOnly.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $cnhic.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};

});


parcelRegister("6Dd8Z", function(module, exports) {

$parcel$export(module.exports, "ChatOpenerSubscriber", () => $1674ffdf804c8c40$export$6fa95a645837361b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aUv7N = parcelRequire("aUv7N");
var $hh1dC = parcelRequire("hh1dC");
var $9KIkq = parcelRequire("9KIkq");

var $edoq1 = parcelRequire("edoq1");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $1674ffdf804c8c40$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);
const $1674ffdf804c8c40$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $1674ffdf804c8c40$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $edoq1.useAnalytics)();
    const [triggerOpen, setTriggerOpen] = (0, $5uXOq.useState)(!!(0, $aUv7N.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $5uXOq.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $9KIkq.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $1674ffdf804c8c40$var$ignoredEvents.has(type);
        if (!$1674ffdf804c8c40$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        onTriggerOpeningChat();
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hh1dC.RovoPostMessagePubsubListener), {})
    });
};

});
parcelRegister("aUv7N", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $6a92696282e830c6$export$6405071f390601f7);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $6a92696282e830c6$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $6a92696282e830c6$export$eddc20a009406015);

var $6cyEW = parcelRequire("6cyEW");
const $6a92696282e830c6$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $6a92696282e830c6$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $6a92696282e830c6$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $6a92696282e830c6$export$9748efee331ec573 = (param)=>`${0, $6cyEW.ROVO_PARAM_PREFIX}${$6a92696282e830c6$export$fda91e425d265029(param)}`;
const $6a92696282e830c6$export$f2888183a34644d4 = (param)=>{
    return $6a92696282e830c6$export$858653b7ee3cbb17(param.replace((0, $6cyEW.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $6a92696282e830c6$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $6a92696282e830c6$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $6cyEW.ROVO_PARAM_PREFIX))) return;
        const paramKey = $6a92696282e830c6$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $6a92696282e830c6$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $6a92696282e830c6$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $6a92696282e830c6$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $6a92696282e830c6$export$ef04687636c850fe(window.location.pathname, params));
};
const $6a92696282e830c6$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $6a92696282e830c6$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $6a92696282e830c6$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $6a92696282e830c6$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$6a92696282e830c6$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$6a92696282e830c6$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $6a92696282e830c6$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $6a92696282e830c6$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $6cyEW.ROVO_VALID_PARAMS).map((param)=>`${$6a92696282e830c6$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("6cyEW", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $2afb36ad2d160c5d$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $2afb36ad2d160c5d$export$3cd6b610e7ede579);
const $2afb36ad2d160c5d$export$5a550907ffbc9119 = 'rovoChat';
const $2afb36ad2d160c5d$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen'
];

});



parcelRegister("jVuEq", function(module, exports) {

$parcel$export(module.exports, "useRovoEntitlement", () => $ea14c038f9fb1f0d$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $ea14c038f9fb1f0d$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $ea14c038f9fb1f0d$export$d03a05ad8547472c);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $ea14c038f9fb1f0d$var$rovoEntitlementStore = (0, $iXqE5.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $ea14c038f9fb1f0d$var$useStateHook = (0, $3sQ5x.createStateHook)($ea14c038f9fb1f0d$var$rovoEntitlementStore);
const $ea14c038f9fb1f0d$export$66d5dd4be64dea43 = ()=>{
    const result = $ea14c038f9fb1f0d$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $ea14c038f9fb1f0d$export$8004893135276275 = (0, $3sQ5x.createActionsHook)($ea14c038f9fb1f0d$var$rovoEntitlementStore);
const $ea14c038f9fb1f0d$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $ea14c038f9fb1f0d$export$8004893135276275();
    (0, $5uXOq.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};

});

parcelRegister("dETjw", function(module, exports) {

$parcel$export(module.exports, "ChatContextSubscriber", () => $6cc64c8ed6af36f1$export$29ff0802eb3bb217);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9KIkq = parcelRequire("9KIkq");

var $im1Ur = parcelRequire("im1Ur");
const $6cc64c8ed6af36f1$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext } = (0, $im1Ur.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KIkq.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    default:
                }
            } catch (error) {}
        }
    });
};

});
parcelRegister("im1Ur", function(module, exports) {

$parcel$export(module.exports, "useChatContextStoreActions", () => $808dd493a609f7fe$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $808dd493a609f7fe$export$9465f65715425f1b);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $808dd493a609f7fe$var$store = (0, $iXqE5.createStore)({
    initialState: {
        editorContext: undefined,
        browserContext: undefined
    },
    actions: {
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            }
    }
});
const $808dd493a609f7fe$export$53bf948a400e8426 = (0, $3sQ5x.createActionsHook)($808dd493a609f7fe$var$store);
const $808dd493a609f7fe$export$9465f65715425f1b = (0, $3sQ5x.createHook)($808dd493a609f7fe$var$store, {
    selector: (state)=>state.editorContext
});

});


parcelRegister("jAO3g", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantButton", () => $ee1da043bdc4004a$export$7c328c0993982813);
$parcel$export(module.exports, "ConversationAssistantButtonNav4", () => $ee1da043bdc4004a$export$25e85d244cbf7845);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");
var $k9Z8W = parcelRequire("k9Z8W");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $eXSfx = parcelRequire("eXSfx");

var $96Irh = parcelRequire("96Irh");

var $inni2 = parcelRequire("inni2");
var $cOGPo = parcelRequire("cOGPo");
var $Pxnvj = parcelRequire("Pxnvj");

var $5KCCi = parcelRequire("5KCCi");

var $edoq1 = parcelRequire("edoq1");

var $jHCos = parcelRequire("jHCos");
var $drIvu = parcelRequire("drIvu");
var $2TdGK = parcelRequire("2TdGK");

var $3926G = parcelRequire("3926G");

var $grH2u = parcelRequire("grH2u");

var $eGWlG = parcelRequire("eGWlG");
const $ee1da043bdc4004a$var$defaultButtonStyles = {
    paddingInline: '8px'
};
const $ee1da043bdc4004a$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #091E420F)"
};
const $ee1da043bdc4004a$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #091E4208)",
    color: "var(--ds-text-disabled, #091E424F)"
};
const $ee1da043bdc4004a$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
const $ee1da043bdc4004a$var$getConversationAssistantButton = (Button = (0, $eXSfx.PrimaryButton))=>({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, tooltipContent: tooltipContent, siteId: siteId, productKey: productKey })=>{
        (0, $gKZoD.di)((0, $k9Z8W.useCoordination), (0, $2TdGK.useCoordinationClient), (0, $96Irh.default));
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const { start: start } = (0, $drIvu.useConversationAssistantSpotlightActions)();
        const [shouldShowMessage, setShouldShowMessage] = (0, $5uXOq.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $edoq1.useAnalytics)();
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $5uXOq.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const getChildren = ()=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                onMouseEnter: ()=>{
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: formatMessage((0, $eGWlG.messages).buttonLabel)
                }),
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$ee1da043bdc4004a$var$defaultButtonStyles,
                    ...!isActive && $ee1da043bdc4004a$var$inactiveButtonStyles,
                    ...isDisabled && $ee1da043bdc4004a$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $grH2u.ChatIcon), {
                    isSelected: isActive,
                    isDisabled: isDisabled
                }),
                children: formatMessage((0, $eGWlG.messages).buttonLabel)
            });
        };
        return shouldUseCoordination ? /*#__PURE__*/ (0, $2OMIu.jsx)($ee1da043bdc4004a$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: openRovoChat
        }) : getChildren();
    };
const $ee1da043bdc4004a$export$7c328c0993982813 = $ee1da043bdc4004a$var$getConversationAssistantButton((0, $eXSfx.PrimaryButton));
const $ee1da043bdc4004a$export$25e85d244cbf7845 = $ee1da043bdc4004a$var$getConversationAssistantButton(function Nav4Button({ tooltip: tooltip, ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltip,
        // This button's visible text matches the tooltip
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.Button), {
                ref: ref,
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $ee1da043bdc4004a$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
    const { activeSpotlight: activeSpotlight } = (0, $drIvu.useConversationAssistantSpotlightState)();
    const coordinationClient = (0, $2TdGK.useCoordinationClient)(siteId);
    const [onboardingStarted, stopOnboarding] = (0, $k9Z8W.useCoordination)(coordinationClient, messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $edoq1.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ee1da043bdc4004a$export$39aecc95f0365819, {
        condition: shouldShowMessage,
        wrapper: (children)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inni2.default), {
                blanketIsTinted: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Pxnvj.default), {
                    name: (0, $da20f1755d1b93ce$export$12496216771c6bdd),
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cOGPo.Pulse), {
                        radius: 3,
                        pulse: activeSpotlight === null,
                        children: [
                            children,
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHCos.ConversationAssistantOnboardingSpotlight), {
                                onDismiss: onDismissMessage,
                                openRovoChat: openRovoChat
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6puUq.EngagementSpotlight), {
                                engagementId: (0, $da20f1755d1b93ce$export$12496216771c6bdd)
                            })
                        ]
                    })
                })
            }),
        children: children
    });
};

});
parcelRegister("k9Z8W", function(module, exports) {

$parcel$export(module.exports, "useCoordination", () => $b31a81fb5c64c5e0$export$3c29cca421979b0e);

var $5uXOq = parcelRequire("5uXOq");
const $b31a81fb5c64c5e0$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $5uXOq.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};

});

parcelRegister("jHCos", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $f385bece8579e202$export$e4abc8af2fc5e2ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $bkS4F = parcelRequire("bkS4F");

var $edoq1 = parcelRequire("edoq1");

var $drIvu = parcelRequire("drIvu");


var $gdXAL = parcelRequire("gdXAL");
const $f385bece8579e202$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, openAgentSelectorMenu: openAgentSelectorMenu, onDismiss: onDismiss })=>{
    (0, $gKZoD.di)((0, $drIvu.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { end: end } = (0, $drIvu.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $drIvu.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $edoq1.useAnalytics)();
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bkS4F.default), {
                actions: [
                    {
                        onClick: (event, analyticsEvent)=>{
                            if (openRovoChat) openRovoChat(event, analyticsEvent);
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                // this is more of 'chatButtonClicked'
                                action: 'dismissed',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $gdXAL.default).tryChat)
                    },
                    {
                        onClick: ()=>{
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'dismissButtonClicked',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $gdXAL.default).dismissOnboarding),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $gdXAL.default).onboardingHeading),
                target: (0, $da20f1755d1b93ce$export$12496216771c6bdd),
                targetRadius: 3,
                children: formatMessage((0, $gdXAL.default).onboardingDescription)
            }, (0, $da20f1755d1b93ce$export$12496216771c6bdd))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: renderActiveSpotlight()
    });
};

});
parcelRegister("drIvu", function(module, exports) {

$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $7e9e103bf5e46dd2$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $7e9e103bf5e46dd2$export$258c2a6b93cdef4a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $7e9e103bf5e46dd2$var$initialState = {
    activeSpotlight: null
};
const $7e9e103bf5e46dd2$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $7e9e103bf5e46dd2$var$ConversationAssistantSpotlightStore = (0, $iXqE5.createStore)({
    initialState: $7e9e103bf5e46dd2$var$initialState,
    actions: $7e9e103bf5e46dd2$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $7e9e103bf5e46dd2$export$283f4929c8863814 = (0, $3sQ5x.createActionsHook)($7e9e103bf5e46dd2$var$ConversationAssistantSpotlightStore);
const $7e9e103bf5e46dd2$export$258c2a6b93cdef4a = (0, $3sQ5x.createStateHook)($7e9e103bf5e46dd2$var$ConversationAssistantSpotlightStore);

});

const $da20f1755d1b93ce$export$12496216771c6bdd = 'rovo-chat-button';

parcelRegister("gdXAL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f062d63985d9afee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f062d63985d9afee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Chat now',
        description: 'Action button for rovo onboarding spotlight'
    },
    dismissOnboarding: {
        id: 'rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for rovo onboarding spotlight'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Chat with AI',
        description: 'Onboarding step heading'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'With Rovo Chat, use AI to explore company knowledge, create new things, and collaborate on your work.',
        description: 'Onboarding step description'
    }
});

});


parcelRegister("2TdGK", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $978e2204fde41951$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $980Xe = parcelRequire("980Xe");
const $978e2204fde41951$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
    return (0, $5uXOq.useMemo)(()=>new (0, $980Xe.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            workspaceId: workspaceId,
            orgId: orgId
        }), [
        cloudId,
        workspaceId,
        orgId
    ]);
};

});

parcelRegister("grH2u", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", () => $6c31d8c4d0e6ff2f$export$52cd484a7ef4f2b9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $6c31d8c4d0e6ff2f$export$52cd484a7ef4f2b9 = ({ isSelected: isSelected = false, isDisabled: isDisabled = false })=>{
    const color = isDisabled ? "var(--ds-icon-disabled, #091E424F)" : isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)";
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M10.4489 3.4504L7.75593 4.49767C7.75381 4.4985 7.75381 4.5015 7.75593 4.50233L10.4489 5.5496C10.4496 5.54986 10.4501 5.55037 10.4503 5.55103L11.4976 8.24401C11.4984 8.24613 11.5014 8.24613 11.5023 8.24401L12.5495 5.55103C12.5498 5.55037 12.5503 5.54986 12.551 5.5496L15.2439 4.50233C15.2461 4.5015 15.2461 4.4985 15.2439 4.49767L12.551 3.4504C12.5503 3.45014 12.5498 3.44963 12.5495 3.44897L11.5023 0.755991C11.5014 0.753866 11.4984 0.753866 11.4976 0.755991L10.4503 3.44897C10.4501 3.44963 10.4496 3.45014 10.4489 3.4504Z",
                    stroke: color,
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 3.125C0 1.67525 1.17525 0.5 2.625 0.5H7.5V2H2.625C2.00368 2 1.5 2.50368 1.5 3.125V13.9576L4.05083 12.5H13.375C13.9963 12.5 14.5 11.9963 14.5 11.375V9H16V11.375C16 12.8247 14.8247 14 13.375 14H4.44917L1.12584 15.899C0.624381 16.1856 0 15.8237 0 15.2457V3.125Z",
                    fill: color
                })
            ]
        })
    });
};

});

parcelRegister("eGWlG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ad96ec7831a087f1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ad96ec7831a087f1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        id: 'conversation-assistant-button.label',
        defaultMessage: 'Chat',
        description: 'Label for the button that opens the conversation assistant'
    },
    rovoChatButtonLabel: {
        id: 'conversation-assistant-button.rovo-chat-label',
        defaultMessage: 'Rovo Chat',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("j2niS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc047cf9e7996a6$export$2e2bcd8739ae039);
function $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a) {
    a = a || [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a.concat(args));
    };
}

});

parcelRegister("59y5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c083ca41bc0ca78$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $jovBr = parcelRequire("jovBr");

var $j2niS = parcelRequire("j2niS");
var $3c083ca41bc0ca78$var$isValid = (0, $j2niS.default)((0, $jovBr.default), 1);
var $3c083ca41bc0ca78$export$2e2bcd8739ae039 = $3c083ca41bc0ca78$var$isValid;

});

parcelRegister("dQChl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14dd31138eb438e$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $lb7qa = parcelRequire("lb7qa");

var $j2niS = parcelRequire("j2niS");
var $a14dd31138eb438e$var$isWithinInterval = (0, $j2niS.default)((0, $lb7qa.default), 2);
var $a14dd31138eb438e$export$2e2bcd8739ae039 = $a14dd31138eb438e$var$isWithinInterval;

});

parcelRegister("2xkYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8ef08fb2404f13$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $gn1v9 = parcelRequire("gn1v9");

var $j2niS = parcelRequire("j2niS");
var $1d8ef08fb2404f13$var$sub = (0, $j2niS.default)((0, $gn1v9.default), 2);
var $1d8ef08fb2404f13$export$2e2bcd8739ae039 = $1d8ef08fb2404f13$var$sub;

});

const $efe1b14e3364046c$export$42f4885608027d0c = 'non_boolean';

const $d253eab4f2dd6d94$export$f636b5b56f1d624a = 'Screen';
const $d253eab4f2dd6d94$export$9d2de6eebf7462b5 = 'Drawer';
const $d253eab4f2dd6d94$export$1171103ea9083ffa = 'Modal';
const $d253eab4f2dd6d94$export$cae2783c9279926 = 'InlineDialog';
const $d253eab4f2dd6d94$export$d1123261ca8831d2 = 'Dropdown';
const $d253eab4f2dd6d94$export$a1562d08625f5d7e = 'UI';
const $d253eab4f2dd6d94$export$947dac6c72b26f81 = 'TRACK';
const $d253eab4f2dd6d94$export$f1d537d508d2945a = 'SCREEN';
const $d253eab4f2dd6d94$export$12346a674644c156 = 'OPERATIONAL';
const $d253eab4f2dd6d94$export$2ceccf177fae277c = 'analyticsBridge';

const $0b39752fc2bc7c2a$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $0b39752fc2bc7c2a$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $0b39752fc2bc7c2a$export$13f57c02915787b3 = 'atlaskit-portal';

const $6389428f3f803f5f$export$ed5835cc67e87f72 = 'akPortalMount';
const $6389428f3f803f5f$export$80816bd900e5bd00 = 'akPortalUnmount';

/**
 * Character key codes which can be used in keyboard events.
 */ const $f13eec7fa1d5338f$export$390330c10ff2b9a1 = 'ArrowUp';
const $f13eec7fa1d5338f$export$a80636c6f41931fe = 'ArrowDown';
const $f13eec7fa1d5338f$export$4af703091671bc = 'Home';
const $f13eec7fa1d5338f$export$e2bc30913faa5db7 = 'End';
const $f13eec7fa1d5338f$export$10f6869ed0a7d75b = 'Tab';
const $f13eec7fa1d5338f$export$8152f929a25a0ff4 = 'Enter';
const $f13eec7fa1d5338f$export$e51a3576c045c8d5 = 'Space';
const $f13eec7fa1d5338f$export$2bb790b9008907b4 = 'Escape';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $86eff7942395d7f1$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $362d94c114865ca0$export$b98e411ae80c806f = '/';

const $70f2b964398aee35$export$cf090d5281b5ae06 = 10000;
const $70f2b964398aee35$export$8575e30be0feb909 = 30000;

const $99bc8d2d71e909fb$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $99bc8d2d71e909fb$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $99bc8d2d71e909fb$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $99bc8d2d71e909fb$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

const $4bcf9932c1d0df17$export$d6830277b06edd6 = 'normal';

const $40a49d4606bee4e1$export$30fa7cc5f2690a43 = 56;
const $40a49d4606bee4e1$export$4033a111ca79977d = 1280;
const $40a49d4606bee4e1$export$24ec62cee78b7042 = 1130;
const $40a49d4606bee4e1$export$d8bde68ac946124f = '--ds--ans--fbc';
const $40a49d4606bee4e1$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $40a49d4606bee4e1$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $40a49d4606bee4e1$export$d81606c1fc5119bc = '--ds--ans--c';
const $40a49d4606bee4e1$export$65f656ad520ea71 = '--ds--ans--bc';

// dimension vars
const $62b79b702763d93f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $62b79b702763d93f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $62b79b702763d93f$export$c103b605cd368aed = 'rightSidebarWidth';
const $62b79b702763d93f$export$fa34f417972d6341 = 'rightPanelWidth';
const $62b79b702763d93f$export$3a6a779d9181047c = 'topNavigationHeight';
const $62b79b702763d93f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $62b79b702763d93f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $62b79b702763d93f$export$344062f7cfc9528e = 'left-panel';
const $62b79b702763d93f$export$c7139cc2d6110b5f = 'right-panel';
const $62b79b702763d93f$export$238d30785c4bca84 = 'banner';
const $62b79b702763d93f$export$bec6dca2e63de4ae = 'top-navigation';
const $62b79b702763d93f$export$d1213e82613ff4df = 'content';
const $62b79b702763d93f$export$be83e7118304b28e = 56;
const $62b79b702763d93f$export$4a98ee0bd1ae362 = 56;
const $62b79b702763d93f$export$539e68c09584883a = 240;
const $62b79b702763d93f$export$b92df8810d2fcd01 = 280;
const $62b79b702763d93f$export$c3e41153b9288bcf = 368;
const $62b79b702763d93f$export$c4d6152f86ea28f6 = 368;
const $62b79b702763d93f$export$46acf8758e9e2636 = 20;
const $62b79b702763d93f$export$70740f5ad8360a78 = 16;
const $62b79b702763d93f$export$991d5285ad765a3d = 240;
const $62b79b702763d93f$export$6949d4f32b161684 = 200;
const $62b79b702763d93f$export$d6e7e8af042815bb = 350;
const $62b79b702763d93f$export$3749e1104328fde4 = 300;
const $62b79b702763d93f$export$1074d925b0b82be5 = 200;
const $62b79b702763d93f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $62b79b702763d93f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $62b79b702763d93f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $62b79b702763d93f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $62b79b702763d93f$export$48a43f91e4becf4e = 'data-grab-area';
const $62b79b702763d93f$export$dac2fb31a9f6844d = 'data-resize-button';
const $62b79b702763d93f$export$9ecd22db14e6c70e = 'data-resize-control';
const $62b79b702763d93f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $62b79b702763d93f$export$206a08f7f8beb554 = 'Skip to:';
const $62b79b702763d93f$export$659ee746b31b360d = 'data-layout-container';
const $62b79b702763d93f$export$f963aecf2d4465bd = `var(--${$62b79b702763d93f$export$cbfb0f5b2869b17b}, 0px)`;
const $62b79b702763d93f$export$750459958906793 = `var(--${$62b79b702763d93f$export$fa34f417972d6341}, 0px)`;
const $62b79b702763d93f$export$f897e1ed9f8ed251 = `var(--${$62b79b702763d93f$export$a30f2e00489a8957}, 0px)`;
const $62b79b702763d93f$export$b44ab66843c05a69 = `var(--${$62b79b702763d93f$export$c103b605cd368aed}, 0px)`;
const $62b79b702763d93f$export$aeff86a16f13529 = `var(--${$62b79b702763d93f$export$3a6a779d9181047c}, 0px)`;
const $62b79b702763d93f$export$ed7cc0d417ee89e = `var(--${$62b79b702763d93f$export$bcd94a6a792e7f96}, 0px)`;
const $62b79b702763d93f$export$d2fa14f05b61e66 = `var(--${$62b79b702763d93f$export$b6744d31294864fd}, ${$62b79b702763d93f$export$991d5285ad765a3d}px)`;

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $5353fba28a8bf24a$export$a7801e29f563faad = 400;

const $2167065bf0672fed$export$3288b14b6745c572 = 204;
const $2167065bf0672fed$export$c09e7ea0fc79f34f = 409;
const $2167065bf0672fed$export$974c37534b0191b1 = 503;

// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $537cb35f009e92c2$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $537cb35f009e92c2$export$64aee74ba59709e5 = 439; // px
const $537cb35f009e92c2$export$1c07393c5bb1bc27 = 439; // px
const $537cb35f009e92c2$export$aa3478deee7adbeb = 350; // px
const $537cb35f009e92c2$export$21e515a86cd1733b = 'Chat';


$parcel$global.rlb("fr9NE")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.4a8648be.js.map
